export default {
    "de": {
        "INSURANCE_FLAT": "Administrationspauschale",
        "lessons": "Fahrlektionen",
        "vku": "VKU Kurse",
        "insurance": "Versicherung",
        "app": "Theorie App",
        "voice_status_start": "Start",
        "voice_status_end": "Beendet",
        "voice_status_taken": "im Gespräch",
        "voice_status_missed": "Verpasst",
        "voice_status_initiated": "Willkommen",
        "voice_status_queue": "Warteschlange",
        "voice_status_out-of-office": "Out-of-Office",
        "voice_status_voicemail": "Sprachnachricht",
        "absences": "Absenzes",
        "exams": "Prüfungen",
        "students": "Schüler",
        "locations": "Standorte",
        "comments": "Kommentare",
        "employment": "Anstellung",
        "course_documents": "Kursdokumente",
        "course_manuals": "Kursanleitungen",
        "All": "Alle",
        "Instructors": "Kursleitung",
        "Teachers": "Fahrlehrer:innen",
        "The {attribute} must contain at least one letter.": "{attribute} muss aus mindestens einem Zeichen bestehen.",
        "The {attribute} must contain at least one number.": "{attribute} muss aus mindestens einer Zahl bestehen.",
        "The {attribute} must contain at least one symbol.": "{attribute} muss aus mindestens einem Sonderzeichen bestehen.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "{attribute} muss aus mindestens einem Gross- und einem Kleinbuchstaben bestehen.",
        "{attribute} ist keine gültige Sprache.": "{attribute} ist keine gültige Sprache.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Das {attribute} ist bereits in einem Datenleck aufgetaucht. Bitte wähle ein anderes {attribute}.",
        "Anmelden": "Anmelden",
        "E-Mail": "E-Mail",
        "Passwort": "Passwort",
        "Passwort vergessen?": "Passwort vergessen?",
        "Eine Woche lang angemeldet bleiben": "Eine Woche lang angemeldet bleiben",
        "Deine Lizenz": "Deine Lizenz",
        " 🎁": "Geschenklizenz einlösen 🎁",
        "Wie schön, du wurdest beschenkt! Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Wie schön, du wurdest beschenkt! Löse deinen Code ein und erfahre, was für dich bereitsteht.",
        "Code eingeben und persönlichen Zugang aktivieren": "Code eingeben und persönlichen Zugang aktivieren",
        "Code eingeben": "Code eingeben",
        "Einlösen": "Einlösen",
        "Code entfernen": "Code entfernen",
        "Benötigst du Hilfe?": "Benötigst du Hilfe?",
        "Wir helfen dir gerne per E-Mail oder Telefon.": "Wir helfen dir gerne per E-Mail oder Telefon.",
        "Bitte gib deinen Geschenkcode ein.": "Bitte gib deinen Geschenkcode ein.",
        "Dieser Geschenkcode konnte nicht gefunden werden.": "Dieser Geschenkcode konnte nicht gefunden werden.",
        "Etwas ist schiefgelaufen. Bitte versuche es erneut.": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        "Code gültig für {product}": "Code gültig für {product}",
        "Für {name}": "Für {name}",
        "Willkommen bei": "Willkommen bei",
        "Passwort zurücksetzen": "Passwort zurücksetzen",
        "Du bekommst von uns einen Link per E-Mail zugesendet, um dein Passwort zurückzusetzen. Bitte gib deine E-Mail-Adresse ein, die du zum Login im Sanio Kundenportal verwendest.": "Du bekommst von uns einen Link per E-Mail zugesendet, um dein Passwort zurückzusetzen. Bitte gib deine E-Mail-Adresse ein, die du zum Login im Sanio Kundenportal verwendest.",
        "Zurück zur Anmeldung": "Zurück zur Anmeldung",
        "Zurück zum Kurs": "Zurück zum Kurs",
        "Fenster auf den Beamer ziehen und die Anzeige auf Erweitert stellen.": "Fenster auf den Beamer ziehen und die Anzeige auf Erweitert stellen.",
        "Vollbild": "Vollbild",
        "Vollbild beenden": "Vollbild beenden",
        "Radierer": "Radierer",
        "Rückgängig": "Rückgängig",
        "Leeren": "Leeren",
        "Zuschauer-QR": "Zuschauer-QR",
        "QR ausblenden": "QR ausblenden",
        "Weisse Seite": "Weisse Seite",
        "Sprache wählbar": "Sprache wählbar",
        "Präsentation anpassen": "Präsentation anpassen",
        "Die Präsentation wird gerade erstellt oder vorgeführt.": "Die Präsentation wird gerade erstellt oder vorgeführt.",
        "Die Kurspräsentation wird neu erstellt.": "Die Kurspräsentation wird neu erstellt.",
        "Die Vorlage wurde gespeichert.": "Die Vorlage wurde gespeichert.",
        "Die Vorlage wurde gelöscht.": "Die Vorlage wurde gelöscht.",
        "Vorlage laden": "Vorlage laden",
        "Vorlage speichern": "Vorlage speichern",
        "Vorlage löschen": "Vorlage löschen",
        "Name der Vorlage": "Name der Vorlage",
        "Link anfordern": "Link anfordern",
        "zurück": "zurück",
        "Liste exportieren": "Liste exportieren",
        "Anmeldungen": "Anmeldungen",
        "Abmeldungen": "Abmeldungen",
        "Vorname": "Vorname",
        "Nachname": "Nachname",
        "Kurssprache": "Kurssprache",
        "Beschreibung": "Beschreibung",
        "Link ist aktiv": "Link ist aktiv",
        "Kurs freigeben": "Kurs freigeben",
        "Es existieren keine Daten.": "Es existieren keine Daten.",
        "Willkommen": "Willkommen",
        "Teilnehmende": "Teilnehmende",
        "Sortieren nach": "Sortieren nach",
        "Datum": "Datum",
        "Adresse": "Adresse",
        "Link für gesamte Kursliste kopieren": "Link für gesamte Kursliste kopieren",
        "Link für diese Kursgruppe kopieren": "Link für diese Kursgruppe kopieren",
        "Plätze frei": "Plätze frei",
        "ausgebucht": "ausgebucht",
        "Vielen Dank! Wir haben deine Angaben erhalten.": "Vielen Dank! Wir haben deine Angaben erhalten.",
        "Weitere Person anmelden": "Weitere Person anmelden",
        "An-/Abmeldung": "An-/Abmeldung",
        "Ja, ich nehme teil": "Ja, ich nehme teil",
        "Nein, ich bin verhindert": "Nein, ich bin verhindert",
        "Absenden": "Absenden",
        "Du musst die AGB akzeptieren!": "Du musst die AGB akzeptieren!",
        "Fragen oder Probleme?": "Fragen oder Probleme?",
        "Deine Ansprechperson:": "Deine Ansprechperson:",
        "Deine Ansprechpersonen:": "Deine Ansprechpersonen:",
        "Hallo": "Hallo",
        "Anmeldebestätigung": "Anmeldebestätigung",
        "Erste Hilfe Kurs": "Erste Hilfe Kurs",
        "Vielen Dank für deine Anmeldung zum Erste Hilfe Kurs. Hier nochmals die wichtigsten Infos": "Vielen Dank für deine Anmeldung zum Erste Hilfe Kurs. Hier nochmals die wichtigsten Infos",
        "Liebe Grüsse": "Liebe Grüsse",
        "Dein Sanio-Team": "Dein Sanio-Team",
        "Copyright": "Copyright",
        "Umbuchungsbestätigung": "Umbuchungsbestätigung",
        "Terminerinnerung": "Terminerinnerung",
        "Mitarbeitende": "Mitarbeitende",
        "Deutsch": "Deutsch",
        "Französisch": "Französisch",
        "Italienisch": "Italienisch",
        "Englisch": "Englisch",
        "Spanisch": "Spanisch",
        "Portugiesisch": "Portugiesisch",
        "In Kurs verschieben": "In Kurs verschieben",
        "Abbrechen": "Abbrechen",
        "Applikation autorisieren": "Applikation autorisieren",
        "{name} autorisieren": "{name} autorisieren",
        "Diese Applikation möchte auf deinen MCP-Server zugreifen.": "Diese Applikation möchte auf deinen MCP-Server zugreifen.",
        "Angemeldet als": "Angemeldet als",
        "Berechtigungen": "Berechtigungen",
        "Autorisieren": "Autorisieren",
        "Autorisieren...": "Autorisieren...",
        "Du wirst zu {name} zurückgeleitet, sobald du autorisiert hast.": "Du wirst zu {name} zurückgeleitet, sobald du autorisiert hast.",
        "Abmelden": "Abmelden",
        "Kurse": "Kurse",
        "Impersonation beenden": "Impersonation beenden",
        "Du bist als diese Person angemeldet.": "Du bist als diese Person angemeldet.",
        "Zur Teilnehmer:in": "Zur Teilnehmer:in",
        "Zum Shop-Kunden": "Zum Shop-Kunden",
        "Die Datei {fileName} wurde {statusHint} importiert.": "Die Datei {fileName} wurde {statusHint} importiert.",
        "teilweise": "teilweise",
        "erfolgreich": "erfolgreich",
        "Zeile": "Zeile",
        "Spalte": "Spalte",
        "Fehlermeldung": "Fehlermeldung",
        "Folgende Zeilen konnten aufgrund ungültiger (<span class=\"text-red\">rot markiert</span>) Daten nicht importiert werden:": "Folgende Zeilen konnten aufgrund ungültiger (<span class=\"text-red\">rot markiert</span>) Daten nicht importiert werden:",
        "Kontaktdaten": "Kontaktdaten",
        "Kontaktaufnahme: In Abklärung": "Kontaktaufnahme: In Abklärung",
        "Kontaktaufnahme erforderlich": "Kontaktaufnahme erforderlich",
        "Keine Kontaktaufnahme erforderlich": "Keine Kontaktaufnahme erforderlich",
        "Noch offen": "Noch offen",
        "Ähnliche TN": "Ähnliche TN",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert.": "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert.",
        "Teilnehmerübersicht öffnen": "Teilnehmerübersicht öffnen",
        "Falls du Excel für den Import verwendest, achte darauf, dass Spalten wie z.B. das Geburtsdatum als Text formatiert sind.": "Falls du Excel für den Import verwendest, achte darauf, dass Spalten wie z.B. das Geburtsdatum als Text formatiert sind.",
        "Email": "E-Mail",
        "Handynummer": "Handynummer",
        "certificates.not-yet-known": "Noch nicht bekannt",
        "certificates.sanio": "Teilnahmebestätigung Sanio",
        "certificates.src": "SRC Zertifikat",
        "certificates.none": "Kein Zertifikat",
        "Kursübersicht": "Kursübersicht",
        "Zurück zum Login": "Zurück zum Login",
        "Passwort bestätigen": "Passwort bestätigen",
        "Dashboard": "Dashboard",
        "In welchen Kurs soll {participantName} verschoben werden?": "In welchen Kurs soll {participantName} verschoben werden?",
        "Es sind keine anderen Kurse verfügbar.": "Es sind keine anderen Kurse verfügbar.",
        "Mehr anzeigen": "Mehr anzeigen",
        "Gesamten Text anzeigen": "Gesamten Text anzeigen",
        "Weniger anzeigen": "Weniger anzeigen",
        "{participantName} in Kurs {courseName} verschieben?": "{participantName} in Kurs {courseName} verschieben?",
        "Zum Kurs": "Zum Kurs",
        "Umbuchungsbestätigung senden": "Umbuchungsbestätigung senden",
        "Es wird keine Umbuchungsbestätigung gesendet, da der Kurs beendet ist.": "Es wird keine Umbuchungsbestätigung gesendet, da der Kurs beendet ist.",
        "Zurück": "Zurück",
        "Verschieben": "Verschieben",
        "Willkommen {name} 👋": "Willkommen {name} 👋",
        "Diese Anmeldemaske wurde deaktiviert.": "Diese Anmeldemaske wurde deaktiviert.",
        "errors.4xx.title": "Unerwarteter Fehler",
        "errors.4xx.head": "Uups...",
        "errors.4xx.hint": "Ein Fehler ist aufgetreten. Deine Anfrage konnte nicht verarbeitet werden. Bitte überprüfe deine Eingaben oder versuche es später erneut. Der Fehler wurde uns gemeldet.",
        "errors.5xx.title": "Interner Serverfehler",
        "errors.5xx.head": "Ou ou...",
        "errors.5xx.hint": "Ein unerwarteter Fehler ist aufgetreten. Gehe zurück zur Startseite oder versuche es später erneut. Der Fehler wurde uns gemeldet.",
        "errors.401.title": "Zugriff verweigert",
        "errors.401.head": "Oops…",
        "errors.401.hint": "Du bist nicht berechtigt, auf diese Seite zuzugreifen. Bitte melde dich an und versuche es erneut.",
        "errors.403.title": "Zugriff verweigert",
        "errors.403.head": "Oops…",
        "errors.403.hint": "Zugriff verweigert. Du hast keine Berechtigung, diese Seite zu besuchen. Bitte wende dich an uns, wenn du glaubst, dass dies ein Fehler ist.",
        "errors.404.title": "Seite nicht gefunden",
        "errors.404.head": "Uups...",
        "errors.404.hint": "Die von Ihnen aufgerufene Seite existiert nicht. Gehe zurück oder klicke auf den Button, um auf die Startseite zu gelangen.",
        "errors.500.title": "Interner Serverfehler",
        "errors.500.head": "Ou ou...",
        "errors.500.hint": "Ein unerwarteter Fehler ist aufgetreten. Gehe zurück zur Startseite oder versuche es später erneut. Der Fehler wurde uns gemeldet.",
        "errors.503.title": "Wartungsmodus",
        "errors.503.head": "Einen Moment bitte...",
        "errors.503.hint": "Wir führen derzeit Wartungsarbeiten durch, um Verbesserungen und Fehlerbehebungen für eine bessere Nutzererfahrung vorzunehmen. Bitte versuche es in Kürze erneut. Vielen Dank für dein Verständnis.",
        "errors.503.hint2": "In dringenden Fällen sind wir per E-Mail unter <a href=\"mailto:contact@sanio.ch\">contact@sanio.ch</a> oder telefonisch unter <a href=\"tel:+41315212409\">031 521 24 09</a> erreichbar.",
        "errors.503.status_prefix": "Aktueller Systemstatus:",
        "errors.504.title": "Timeout",
        "errors.504.head": "Timeout…",
        "errors.504.hint": "Die Anfrage hat zu lange gedauert. Bitte versuche es später erneut. Der Fehler wurde uns gemeldet.",
        "errors.back-to-start": "Zur Startseite",
        "Fehler beim Laden der Kurse": "Fehler beim Laden der Kurse",
        "Du wurdest in den Kurs «{courseName}» umgebucht.": "Du wurdest in den Kurs «{courseName}» umgebucht.",
        "Hier die neuen Infos:": "Hier die neuen Infos:",
        "Wenn du Fragen hast, melde dich bitte direkt bei {name} unter:": "Wenn du Fragen hast, melde dich bitte direkt bei {name} unter:",
        "oder": "oder",
        "Kursort:": "Kursort:",
        "Kursdaten": "Kursdaten",
        "Vielen Dank für deine Anmeldung zum Kurs. Hier nochmals die wichtigsten Infos:": "Vielen Dank für deine Anmeldung zum Kurs. Hier nochmals die wichtigsten Infos:",
        "Bald ist es soweit und der Kurs «{courseName}» findet statt.": "Bald ist es soweit und der Kurs «{courseName}» findet statt.",
        "Hier nochmals die wichtigsten Infos:": "Hier nochmals die wichtigsten Infos:",
        "Du wurdest erfolgreich am Kurs «{courseName}» angemeldet 🎉": "Du wurdest erfolgreich am Kurs «{courseName}» angemeldet 🎉",
        "Kurs-ID": "Kurs-ID",
        "Zum Kalender hinzufügen": "Zum Kalender hinzufügen",
        "Es wurde keine E-Mail-Adresse oder Handynummer angegeben.": "Es wurde keine E-Mail-Adresse oder Handynummer angegeben.",
        "Die E-Mail-Adresse ist ungültig.": "Die E-Mail-Adresse ist ungültig.",
        "Die Handynummer ist ungültig.": "Die Handynummer ist ungültig.",
        "Wir konnten dich mit diesen Angaben nicht anmelden.": "Wir konnten dich mit diesen Angaben nicht anmelden.",
        "Der Code ist ungültig.": "Der Code ist ungültig.",
        "Du musst die AGB akzeptieren, um fortfahren zu können.": "Du musst die AGB akzeptieren, um fortfahren zu können.",
        "Bitte gib eine gültige Handynummer ein.": "Bitte gib eine gültige Handynummer ein.",
        "Text wurde in die Zwischenablage kopiert": "Text wurde in die Zwischenablage kopiert",
        "Text konnte nicht in die Zwischenablage kopiert werden": "Text konnte nicht in die Zwischenablage kopiert werden",
        "Der Katalog wurde erstellt.": "Der Katalog wurde erstellt.",
        "Der Katalog wurde aktualisiert.": "Der Katalog wurde aktualisiert.",
        "Der Katalog wurde entfernt.": "Der Katalog wurde entfernt.",
        "Das Thema wurde erstellt.": "Das Thema wurde erstellt.",
        "Das Thema wurde aktualisiert.": "Das Thema wurde aktualisiert.",
        "Das Thema wurde entfernt.": "Das Thema wurde entfernt.",
        "Der Kurs wurde dupliziert 🎉": "Der Kurs wurde dupliziert 🎉",
        "Kurs": "Kurs",
        "Story wurde erfolgreich kopiert 🎉": "Story wurde erfolgreich kopiert 🎉",
        "Eine Variante|{count} Varianten": "Eine Variante|{count} Varianten",
        "Für diesen Kunden steht der eLearning Bereich nicht zur Verfügung.": "Für diesen Kunden steht der eLearning Bereich nicht zur Verfügung.",
        "Geschlecht": "Geschlecht",
        "Männlich": "Männlich",
        "Weiblich": "Weiblich",
        "Divers": "Divers",
        "Projektstandort": "Projektstandort",
        "Wohnkanton": "Wohnkanton",
        "Sanio Logo": "Sanio Logo",
        "Falls du keine weiteren E-Mails von dieser Liste erhalten möchtest, kannst du dich <a href=\"{unsubscribeListUrl}\" target=\"_blank\">hier</a> abmelden.": "Falls du keine weiteren E-Mails von dieser Liste erhalten möchtest, kannst du dich <a href=\"{unsubscribeListUrl}\" target=\"_blank\">hier</a> abmelden.",
        "Möchtest du gar keine Angebote mehr von uns erhalten? Dann kannst du dich <a href=\"{unsubscribeUrl}\" target=\"_blank\">hier</a> abmelden.": "Möchtest du gar keine Angebote mehr von uns erhalten? Dann kannst du dich <a href=\"{unsubscribeUrl}\" target=\"_blank\">hier</a> abmelden.",
        "hier": "hier",
        "Hier geht es zu unseren <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> und zu unserer <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>.": "Hier geht es zu unseren <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> und zu unserer <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>.",
        "Dein Sanio Team": "Dein Sanio Team",
        "Hallo {name} 👋": "Hallo {name} 👋",
        "Hier sind nochmals die wichtigsten Details:": "Hier sind nochmals die wichtigsten Details:",
        "Teilnehmer:innen": "Teilnehmer:innen",
        "Name": "Name",
        "Letzter Kurs": "Letzter Kurs",
        "Nächster Kurs": "Nächster Kurs",
        "Hinzufügen": "Hinzufügen",
        "Exportieren": "Exportieren",
        "Exportieren als CSV": "Exportieren als CSV",
        "Exportieren als Excel": "Exportieren als Excel",
        "Zu Kurs zugeordnet": "Zu Kurs zugeordnet",
        "Keinem Kurs zugeordnet": "Keinem Kurs zugeordnet",
        "Suchbegriff": "Suchbegriff",
        "Alle": "Alle",
        "Ungruppierte Kurse": "Ungruppierte Kurse",
        "Es wurden mehrere Konten für diese Angaben gefunden. Bitte wähle den gewünschten Kunden aus.": "Es wurden mehrere Konten für diese Angaben gefunden. Bitte wähle den gewünschten Kunden aus.",
        "Anmeldebestätigung erneut zustellen": "Anmeldebestätigung erneut zustellen",
        "Einladung zum eLearning": "Einladung zum eLearning",
        "Wir freuen uns, dir mitzuteilen, dass das eLearning für dich nun bereitsteht! Du kannst ab sofort mit dem Lernen beginnen. 🎉": "Wir freuen uns, dir mitzuteilen, dass das eLearning für dich nun bereitsteht! Du kannst ab sofort mit dem Lernen beginnen. 🎉",
        "Bis zum <strong>{courseName}</strong> am <strong>{courseStart}</strong> in <strong>{coursePlace}</strong> musst du das eLearning unbedingt abgeschlossen haben. Es dient als Grundlage für den praktischen Kurs.": "Bis zum <strong>{courseName}</strong> am <strong>{courseStart}</strong> in <strong>{coursePlace}</strong> musst du das eLearning unbedingt abgeschlossen haben. Es dient als Grundlage für den praktischen Kurs.",
        "Du kannst das eLearning entweder in einem Durchgang oder in mehreren Etappen absolvieren.": "Du kannst das eLearning entweder in einem Durchgang oder in mehreren Etappen absolvieren.",
        "Am Ende gibt es eine kurze Lernkontrolle. Daher lohnt es sich, die Inhalte aufmerksam durchzuarbeiten!": "Am Ende gibt es eine kurze Lernkontrolle. Daher lohnt es sich, die Inhalte aufmerksam durchzuarbeiten!",
        "Teilnehmer:in abmelden / aus Kurs entfernen": "Teilnehmer:in abmelden / aus Kurs entfernen",
        "Möchtest du den/die Teilnehmer:in wirklich vom Kurs abmelden / aus dem Kurs entfernen?": "Möchtest du den/die Teilnehmer:in wirklich vom Kurs abmelden / aus dem Kurs entfernen?",
        "Abmelden / entfernen": "Abmelden / entfernen",
        "Willst du wirklich eine eLearning Einladung verschicken?": "Willst du wirklich eine eLearning Einladung verschicken?",
        "Einladung verschicken": "Einladung verschicken",
        "Willst du wirklich die Anmeldebestätigung erneut zustellen?": "Willst du wirklich die Anmeldebestätigung erneut zustellen?",
        "Bestätigung erneut verschicken": "Bestätigung erneut verschicken",
        "Teilnehmer:in abmelden": "Teilnehmer:in abmelden",
        "Bemerkungen": "Bemerkungen",
        "Wert fehlt!": "Wert fehlt!",
        "{0} Es wurden keine Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.|{1} Es wurde ein:e Teilnehmer:in angelegt und {totalUpdated} aktualisiert.|[2,*] Es wurden {count} Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.": "{0} Es wurden keine Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.|{1} Es wurde ein:e Teilnehmer:in angelegt und {totalUpdated} aktualisiert.|[2,*] Es wurden {count} Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.",
        "Zu Kursgruppe hinzufügen": "Zu Kursgruppe hinzufügen",
        "Neue Kursgruppe erstellen": "Neue Kursgruppe erstellen",
        "Möchtest du den Kurs wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Möchtest du den Kurs wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
        "Möchtest du den Kurs wirklich archivieren? Der Kurs ist danach nicht mehr sichtbar, kann aber durch einen Admin wiederhergestellt werden.": "Möchtest du den Kurs wirklich archivieren? Der Kurs ist danach nicht mehr sichtbar, kann aber durch einen Admin wiederhergestellt werden.",
        "Freigabelink löschen": "Freigabelink löschen",
        "Möchtest du den Freigabelink wirklich löschen?": "Möchtest du den Freigabelink wirklich löschen?",
        "Archivieren": "Archivieren",
        "Archivierte Kurse": "Archivierte Kurse",
        "Endgültig löschen": "Endgültig löschen",
        "Gruppe löschen": "Gruppe löschen",
        "Möchtest du diese Gruppe wirklich löschen?": "Möchtest du diese Gruppe wirklich löschen?",
        "Kurs aus Gruppe entfernen": "Kurs aus Gruppe entfernen",
        "Kurs duplizieren": "Kurs duplizieren",
        "Kurs archivieren": "Kurs archivieren",
        "Kurs löschen": "Kurs löschen",
        "Der Link wurde in die Zwischenablage kopiert! 🎉": "Der Link wurde in die Zwischenablage kopiert! 🎉",
        "Der Freigabelink wurde gelöscht! 🎉": "Der Freigabelink wurde gelöscht! 🎉",
        "Link teilen": "Link teilen",
        "Gruppe bearbeiten": "Gruppe bearbeiten",
        "Neue:n Teilnehmer:in anmelden": "Neue:n Teilnehmer:in anmelden",
        "nimmt teil": "nimmt teil",
        "Speichern": "Speichern",
        "Ähnliche Teilnehmer:innen": "Ähnliche Teilnehmer:innen",
        "Ein unerwarteter Fehler ist aufgetreten": "Ein unerwarteter Fehler ist aufgetreten",
        "Bereits in diesem Kurs vorhanden": "Bereits in diesem Kurs vorhanden",
        "Es wurden keine ähnlichen Teilnehmer:innen gefunden.": "Es wurden keine ähnlichen Teilnehmer:innen gefunden.",
        "Fülle das Formular aus und die Suche wird gestartet.": "Fülle das Formular aus und die Suche wird gestartet.",
        "Suche ähnliche Teilnehmer:innen...": "Suche ähnliche Teilnehmer:innen...",
        "eLearning nicht gefunden": "eLearning nicht gefunden",
        "Wie hat dir das eLearning allgemein gefallen?": "Wie hat dir das eLearning allgemein gefallen?",
        "🤩 Sehr gut!": "🤩 Sehr gut!",
        "😊 Gut": "😊 Gut",
        "😐 Ok": "😐 Ok",
        "😕 Nicht so gut": "😕 Nicht so gut",
        "😩 Schlecht": "😩 Schlecht",
        "Bitte wähle eine Antwort aus.": "Bitte wähle eine Antwort aus.",
        "Wie verständlich waren für dich die Lerninhalte?": "Wie verständlich waren für dich die Lerninhalte?",
        "🤩 Sehr verständlich!": "🤩 Sehr verständlich!",
        "😊 Verständlich": "😊 Verständlich",
        "😕 Nicht so verständlich": "😕 Nicht so verständlich",
        "😩 Gar nicht verständlich": "😩 Gar nicht verständlich",
        "Wie waren die Aufgaben in den Notfällen für dich?": "Wie waren die Aufgaben in den Notfällen für dich?",
        "🤩 Sehr einfach!": "🤩 Sehr einfach!",
        "😊 einfach": "😊 einfach",
        "😐 Nicht so einfach": "😐 Nicht so einfach",
        "😕 Schwierig": "😕 Schwierig",
        "😩 Sehr schwierig": "😩 Sehr schwierig",
        "Wie beurteilst du die Benutzerfreundlichkeit des eLearnings?": "Wie beurteilst du die Benutzerfreundlichkeit des eLearnings?",
        "🤩 Super einfache Bedienung!": "🤩 Super einfache Bedienung!",
        "😊 Einfach zu bedienen": "😊 Einfach zu bedienen",
        "😐 Teilweise etwas mühsam": "😐 Teilweise etwas mühsam",
        "😩 Richtig mühsame Bedienung": "😩 Richtig mühsame Bedienung",
        "Wie schwierig war für dich die Lernkontrolle am Ende?": "Wie schwierig war für dich die Lernkontrolle am Ende?",
        "Warum war die Lernkontrolle für dich einfach?": "Warum war die Lernkontrolle für dich einfach?",
        "Überspringen": "Überspringen",
        "Warum war die Lernkontrolle für dich schwierig?": "Warum war die Lernkontrolle für dich schwierig?",
        "Wie können wir das eLearning verbessern? Was hat dir gefehlt?": "Wie können wir das eLearning verbessern? Was hat dir gefehlt?",
        "Würdest du das eLearning weiterempfehlen?": "Würdest du das eLearning weiterempfehlen?",
        "🤩 Ja klar!": "🤩 Ja klar!",
        "😊 Ja, wahrscheinlich schon": "😊 Ja, wahrscheinlich schon",
        "😐 Weiss nicht recht": "😐 Weiss nicht recht",
        "😕 Eher nicht": "😕 Eher nicht",
        "😩 Nein, auf keinen Fall": "😩 Nein, auf keinen Fall",
        "Vielen Dank für deine Antworten!": "Vielen Dank für deine Antworten!",
        "Cool hast du dir die Zeit genommen!": "Cool hast du dir die Zeit genommen!",
        "Fehler beim Laden der Suchergebnisse": "Fehler beim Laden der Suchergebnisse",
        "Jetzt mit dem eLearning starten": "Jetzt mit dem eLearning starten",
        "Es wird Zeit, mit dem eLearning zu beginnen! Bitte schliesse es bis zum Kursbeginn am <strong>{courseStart}</strong>, ab, da es die wichtige Grundlage für unseren Kurs bildet. Plane dafür etwa {duration} ein, damit du gut vorbereitet bist und das Beste aus dem Kurs mitnehmen kannst. Wir freuen uns auf dich!": "Es wird Zeit, mit dem eLearning zu beginnen! Bitte schliesse es bis zum Kursbeginn am <strong>{courseStart}</strong>, ab, da es die wichtige Grundlage für unseren Kurs bildet. Plane dafür etwa {duration} ein, damit du gut vorbereitet bist und das Beste aus dem Kurs mitnehmen kannst. Wir freuen uns auf dich!",
        "Dein Verifizierungscode lautet: <strong>{code}</strong>": "Dein Verifizierungscode lautet: <strong>{code}</strong>",
        "Teilnehmer:innen {company}": "Teilnehmer:innen {company}",
        "{firstname}, eLearning für den Kurs von {company} nicht vergessen!": "{firstname}, eLearning für den Kurs von {company} nicht vergessen!",
        "Dein my.sanio Verifizierungscode": "Dein my.sanio Verifizierungscode",
        "Dein Sanio-Verifizierungscode": "Dein Sanio-Verifizierungscode",
        "allgemeinen Geschäftsbedingungen": "allgemeinen Geschäftsbedingungen",
        "Datenschutzerklärung": "Datenschutzerklärung",
        "Ich akzeptiere die {tos} und habe die {privacyPolicy} gelesen und verstanden.": "Ich akzeptiere die {tos} und habe die {privacyPolicy} gelesen und verstanden.",
        "AGB und Datenschutz müssen akzeptiert werden.": "AGB und Datenschutz müssen akzeptiert werden.",
        "Der Kurs ist leider bereits ausgebucht.": "Der Kurs ist leider bereits ausgebucht.",
        "🚫 Wir konnten dich leider nicht am Kurs anmelden.": "🚫 Wir konnten dich leider nicht am Kurs anmelden.",
        "Persönliche Daten": "Persönliche Daten",
        "Profil": "Profil",
        "Zukünftige Kurse": "Zukünftige Kurse",
        "{name} ist noch für keine Kurse angemeldet.": "{name} ist noch für keine Kurse angemeldet.",
        "Abgeschlossene Kurse": "Abgeschlossene Kurse",
        "Handlung nötig": "Handlung nötig",
        "eLearning": "eLearning",
        "Fortschritt:": "Fortschritt:",
        "Dauer:": "Dauer:",
        "Kommunikation": "Kommunikation",
        "unbekannter Betreff": "unbekannter Betreff",
        "Zeit": "Zeit",
        "Status": "Status",
        "Kanal": "Kanal",
        "Inhalt": "Inhalt",
        "Von:": "Von:",
        "An:": "An:",
        "CC:": "CC:",
        "BCC:": "BCC:",
        "Antwort an:": "Antwort an:",
        "Anhänge": "Anhänge",
        "Nicht dargestellte Kursdaten": "Nicht dargestellte Kursdaten",
        "Benutzerbild": "Benutzerbild",
        "Meine Kurse": "Meine Kurse",
        "Dashboard Instruktor:innen": "Dashboard Instruktor:innen",
        "Wenn wir für diese E-Mail Adresse ein Konto gefunden haben, erhältst du in Kürze eine E-Mail mit einem Link zum Einloggen (Bitte überprüfe auch deinen Spam-Ordner).": "Wenn wir für diese E-Mail Adresse ein Konto gefunden haben, erhältst du in Kürze eine E-Mail mit einem Link zum Einloggen (Bitte überprüfe auch deinen Spam-Ordner).",
        "Jetzt einloggen": "Jetzt einloggen",
        "Link zum Einloggen": "Link zum Einloggen",
        "Teilnahme-Status erfolgreich aktualisiert.": "Teilnahme-Status erfolgreich aktualisiert.",
        "Team": "Team",
        "Anwesenheit": "Anwesenheit",
        "Anwesenheiten fehlen!": "Anwesenheiten fehlen!",
        "Anwesenheiten vollständig": "Anwesenheiten vollständig",
        "Materialset fehlt!": "Materialset fehlt!",
        "Materialset: {name}": "Materialset: {name}",
        "Materialset zugewiesen": "Materialset zugewiesen",
        "Hinweis zu Materialset beachten": "Hinweis zu Materialset beachten",
        "Nur für bereite Kurse relevant": "Nur für bereite Kurse relevant",
        "Nur für laufende oder durchgeführte Kurse relevant": "Nur für laufende oder durchgeführte Kurse relevant",
        "Präsentation fehlt!": "Präsentation fehlt!",
        "Präsentation vorhanden": "Präsentation vorhanden",
        "Gemäss Kursleitung anwesend": "Gemäss Kursleitung anwesend",
        "Gemäss Kursleitung abwesend": "Gemäss Kursleitung abwesend",
        "🧘 Du hast diese Woche keine Kurse.": "🧘 Du hast diese Woche keine Kurse.",
        "🌴 Du hast keine zukünftigen Kurse.": "🌴 Du hast keine zukünftigen Kurse.",
        "😌 Du hast keine abgeschlossenen Kurse.": "😌 Du hast keine abgeschlossenen Kurse.",
        "Diese Woche": "Diese Woche",
        "und": "und",
        "Geschäftsführerin Sanio AG": "Geschäftsführerin Sanio AG",
        "Zertifikat": "Zertifikat",
        "Teilnahmebestätigung": "Teilnahmebestätigung",
        "am <strong>{date}</strong>": "am <strong>{date}</strong>",
        "am <strong>{dateStart}</strong> und <strong>{dateEnd}</strong>": "am <strong>{dateStart}</strong> und <strong>{dateEnd}</strong>",
        "vom <strong>{dateStart}</strong> bis <strong>{dateEnd}</strong>": "vom <strong>{dateStart}</strong> bis <strong>{dateEnd}</strong>",
        "Kursleitung:": "Kursleitung:",
        "Dieses Zertifikat ist bis am {date} gültig.": "Dieses Zertifikat ist bis am {date} gültig.",
        "Eine Auffrischung der Erste Hilfe Grundlagen alle 2 Jahre wird empfohlen.": "Eine Auffrischung der Erste Hilfe Grundlagen alle 2 Jahre wird empfohlen.",
        "Download wird gestartet...": "Download wird gestartet...",
        "Download erfolgreich abgeschlossen.": "Download erfolgreich abgeschlossen.",
        "Download fehlgeschlagen.": "Download fehlgeschlagen.",
        "Generiere Teilnahmebestätigungen...": "Generiere Teilnahmebestätigungen...",
        "Teilnahmebestätigungen wurden erfolgreich generiert und heruntergeladen.": "Teilnahmebestätigungen wurden erfolgreich generiert und heruntergeladen.",
        "Fehler beim Erstellen der Teilnahmebestätigungen.": "Fehler beim Erstellen der Teilnahmebestätigungen.",
        "Generiere Teilnahmebestätigung...": "Generiere Teilnahmebestätigung...",
        "Teilnahmebestätigung wurde erfolgreich generiert und heruntergeladen.": "Teilnahmebestätigung wurde erfolgreich generiert und heruntergeladen.",
        "Fehler beim Erstellen der Teilnahmebestätigung.": "Fehler beim Erstellen der Teilnahmebestätigung.",
        "Teilnehmerliste exportieren": "Teilnehmerliste exportieren",
        "Teilnahmebestätigungen als PDF": "Teilnahmebestätigungen als PDF",
        "Teilnahmebestätigungen als ZIP": "Teilnahmebestätigungen als ZIP",
        "wurde erstellt": "wurde erstellt",
        "kommentierte": "kommentierte",
        "Bearbeiten": "Bearbeiten",
        "Löschen": "Löschen",
        "Schreibe deinen Kommentar...": "Schreibe deinen Kommentar...",
        "Zurücksetzen": "Zurücksetzen",
        "Kommentieren": "Kommentieren",
        "Kommentar bearbeiten": "Kommentar bearbeiten",
        "Aktivität": "Aktivität",
        "Teilnehmer:in hinzufügen": "Teilnehmer:in hinzufügen",
        "Für die Kursteilnahme sind nur Vor- und Nachname erforderlich. Weitere Angaben sind freiwillig.": "Für die Kursteilnahme sind nur Vor- und Nachname erforderlich. Weitere Angaben sind freiwillig.",
        "Teilnehmer:in bereits im System?": "Teilnehmer:in bereits im System?",
        "Passende Personen werden während der Eingabe automatisch hier angezeigt. Bitte übernimm bestehende Personen, anstatt sie neu anzulegen.": "Passende Personen werden während der Eingabe automatisch hier angezeigt. Bitte übernimm bestehende Personen, anstatt sie neu anzulegen.",
        "Teilnahmebestätigung herunterladen": "Teilnahmebestätigung herunterladen",
        "Teilnehmer abgleichen": "Teilnehmer abgleichen",
        "Dieses Objekt": "Dieses Objekt",
        "Der Kurs ist ausgebucht.": "Der Kurs ist ausgebucht.",
        "abgeschlossen": "abgeschlossen",
        "Der Kurs ist bereits beendet.": "Der Kurs ist bereits beendet.",
        "Keine Teilnehmenden|ein:e Teilnehmer:in|{capacity} Teilnehmende": "Keine Teilnehmenden|ein:e Teilnehmer:in|{capacity} Teilnehmende",
        "{availableSpots} Plätze frei": "{availableSpots} Plätze frei",
        "Teilnehmer wurde in neuen Kurs verschoben.": "Teilnehmer wurde in neuen Kurs verschoben.",
        "Beendete Kurse können nicht mehr bearbeitet werden.": "Beendete Kurse können nicht mehr bearbeitet werden.",
        "Kurstyp wurde erfolgreich aktualisiert.": "Kurstyp wurde erfolgreich aktualisiert.",
        "Kurse wurden der Gruppe hinzugefügt.": "Kurse wurden der Gruppe hinzugefügt.",
        "Der Benutzer wurde erfolgreich erstellt.": "Der Benutzer wurde erfolgreich erstellt.",
        "vollständig": "vollständig",
        "Möchtest du das Element wirklich löschen?": "Möchtest du das Element wirklich löschen?",
        "Auswählen": "Auswählen",
        "Teilnehmer:in anzeigen": "Teilnehmer:in anzeigen",
        "Nachrichtenverlauf": "Nachrichtenverlauf",
        "Kurs erstellen": "Kurs erstellen",
        "Kurstypen": "Kurstypen",
        "Keine Daten gefunden.": "Keine Daten gefunden.",
        "Kurstyp bearbeiten": "Kurstyp bearbeiten",
        "Kurs hat noch nicht begonnen.": "Kurs hat noch nicht begonnen.",
        "Kurs ist abgeschlossen.": "Kurs ist abgeschlossen.",
        "Kurs ist abgesagt.": "Kurs ist abgesagt.",
        "Kurs ist archiviert.": "Kurs ist archiviert.",
        "Kurs bearbeiten": "Kurs bearbeiten",
        "HINWEIS:": "HINWEIS:",
        "Die Offerte wurde erstellt.": "Die Offerte wurde erstellt.",
        "Das Angebot wurde aktualisiert.": "Das Angebot wurde aktualisiert.",
        "Das Angebot wurde entfernt.": "Das Angebot wurde entfernt.",
        "Der Import wurde gestartet und wird im Hintergrund ausgeführt.": "Der Import wurde gestartet und wird im Hintergrund ausgeführt.",
        "Teilnehmer erfolgreich gespeichert!": "Teilnehmer erfolgreich gespeichert!",
        "Teilnehmer wurde gelöscht!": "Teilnehmer wurde gelöscht!",
        "Nachricht wurde erneut zugestellt 🎉": "Nachricht wurde erneut zugestellt 🎉",
        "Das Login wurde erstellt! 🎉": "Das Login wurde erstellt! 🎉",
        "Das Login wurde gelöscht! 🎉": "Das Login wurde gelöscht! 🎉",
        "Der Kundenbereich wurde gespeichert! 🎉": "Der Kundenbereich wurde gespeichert! 🎉",
        "Nachricht wurde verschickt 🎉": "Nachricht wurde verschickt 🎉",
        "Kursgruppe erfolgreich erstellt 🎉": "Kursgruppe erfolgreich erstellt 🎉",
        "Kursgruppe erfolgreich aktualisiert 🎉": "Kursgruppe erfolgreich aktualisiert 🎉",
        "Kursgruppe wurde gelöscht!": "Kursgruppe wurde gelöscht!",
        "Geteilter Link gelöscht!": "Geteilter Link gelöscht!",
        "Teilnehmer wurde in den neuen Kurs verschoben.": "Teilnehmer wurde in den neuen Kurs verschoben.",
        "Der Kurs wurde gespeichert 🎉": "Der Kurs wurde gespeichert 🎉",
        "Der Kurs wurde gespeichert": "Der Kurs wurde gespeichert",
        "Der Kurs wurde erfolgreich gelöscht!": "Der Kurs wurde erfolgreich gelöscht!",
        "Der Kurs wurde erfolgreich archiviert!": "Der Kurs wurde erfolgreich archiviert!",
        "Teilnehmer:in erfolgreich abgemeldet.": "Teilnehmer:in erfolgreich abgemeldet.",
        "Der Benutzer wurde erfolgreich aktualisiert.": "Der Benutzer wurde erfolgreich aktualisiert.",
        "Der Benutzer wurde erfolgreich gelöscht.": "Der Benutzer wurde erfolgreich gelöscht.",
        "Die Weiterleitung wurde erstellt!": "Die Weiterleitung wurde erstellt!",
        "Die Weiterleitung wurde aktualisiert!": "Die Weiterleitung wurde aktualisiert!",
        "Die Weiterleitung wurde gelöscht!": "Die Weiterleitung wurde gelöscht!",
        "Mail Statusinformationen wurden aktualisiert.": "Mail Statusinformationen wurden aktualisiert.",
        "Das Unternehmen wurde erstellt.": "Das Unternehmen wurde erstellt.",
        "Das Unternehmen wurde aktualisiert.": "Das Unternehmen wurde aktualisiert.",
        "Das Unternehmen wurde gelöscht!": "Das Unternehmen wurde gelöscht!",
        "Das Unternehmen kann nicht gelöscht werden, solange noch ein Kundenbereich existiert.": "Das Unternehmen kann nicht gelöscht werden, solange noch ein Kundenbereich existiert.",
        "Der Kontakt wurde aktualisiert.": "Der Kontakt wurde aktualisiert.",
        "Der Kontakt wurde entfernt.": "Der Kontakt wurde entfernt.",
        "Der Kundenbereich wurde eröffnet! 🎉": "Der Kundenbereich wurde eröffnet! 🎉",
        "Der Kommentar wurde gespeichert.": "Der Kommentar wurde gespeichert.",
        "Der Kommentar wurde aktualisiert.": "Der Kommentar wurde aktualisiert.",
        "Der Kommentar wurde entfernt.": "Der Kommentar wurde entfernt.",
        "Der Kontakt wurde erstellt.": "Der Kontakt wurde erstellt.",
        "Willkommen im": "Willkommen im",
        "Instruktor:innen Bereich": "Instruktor:innen Bereich",
        "Der Login-Link ist ungültig oder abgelaufen.": "Der Login-Link ist ungültig oder abgelaufen.",
        "weiter": "weiter",
        "+{more} weitere": "+{more} weitere",
        "Telefonzeiten": "Telefonzeiten",
        "Montag bis Freitag": "Montag bis Freitag",
        "9.00 bis 12.00 Uhr": "9.00 bis 12.00 Uhr",
        "13.00 bis 16.00 Uhr": "13.00 bis 16.00 Uhr",
        "Notfallnummer (für Kurse)": "Notfallnummer (für Kurse)",
        "Link für diesen Kurs kopieren": "Link für diesen Kurs kopieren",
        "Link für Anmeldung teilen": "Link für Anmeldung teilen",
        "🤔 Es sind keine Kurse geplant.": "🤔 Es sind keine Kurse geplant.",
        "Suchen...": "Suchen...",
        "Kursinstruktor:in": "Kursinstruktor:in",
        "Management": "Management",
        "Büro": "Büro",
        "Schule": "Schule",
        "Berufsschule": "Berufsschule",
        "Gymnasium": "Gymnasium",
        "Kita": "Kita",
        "Betrieb": "Betrieb",
        "Vereine": "Vereine",
        "Sonstiges": "Sonstiges",
        "Teilnahmebestätigung Erste Hilfe Kurs": "Teilnahmebestätigung Erste Hilfe Kurs",
        "Zertifikat BLS AED SRC Kurs": "Zertifikat BLS AED SRC Kurs",
        "Wir freuen uns, dir dein Zertifikat für den <strong>{courseName}</strong> zu übermitteln.": "Wir freuen uns, dir dein Zertifikat für den <strong>{courseName}</strong> zu übermitteln.",
        "Wir freuen uns, dir deine Teilnahmebestätigung für den <strong>{courseName}</strong> zu übermitteln.": "Wir freuen uns, dir deine Teilnahmebestätigung für den <strong>{courseName}</strong> zu übermitteln.",
        "Die Datei findest du im Anhang dieser E-Mail.": "Die Datei findest du im Anhang dieser E-Mail.",
        "Herzlichen Glückwunsch und weiterhin viel Erfolg!": "Herzlichen Glückwunsch und weiterhin viel Erfolg!",
        "Zertifikate werden nun generiert und an die Teilnehmer:innen verschickt 🎉": "Zertifikate werden nun generiert und an die Teilnehmer:innen verschickt 🎉",
        "Zertifikat wird nun generiert und an den/die Teilnehmer:in verschickt 🎉": "Zertifikat wird nun generiert und an den/die Teilnehmer:in verschickt 🎉",
        "Teilnahmebestätigungen an Teilnehmende versenden": "Teilnahmebestätigungen an Teilnehmende versenden",
        "Teilnahmebestätigungen per Mail zustellen": "Teilnahmebestätigungen per Mail zustellen",
        "Möchtest du die Teilnahmebestätigungen an alle Teilnehmer:innen zustellen?": "Möchtest du die Teilnahmebestätigungen an alle Teilnehmer:innen zustellen?",
        "ACHTUNG:": "ACHTUNG:",
        "Für einige Teilnehmer:innen, die Anspruch auf eine Teilnahmebestätigung haben, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Für einige Teilnehmer:innen, die Anspruch auf eine Teilnahmebestätigung haben, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:",
        "Bestätigung zustellen": "Bestätigung zustellen",
        "Teilnahmebestätigung per Mail versenden": "Teilnahmebestätigung per Mail versenden",
        "Willst du wirklich die Teilnahmebestätigung per Mail versenden?": "Willst du wirklich die Teilnahmebestätigung per Mail versenden?",
        "Füge deine individuelle E-Mail-Adresse (keine allgemeine info@-Adresse) ein, um eine Anmeldebestätigung und ein Erinnerungsmail zu erhalten.": "Füge deine individuelle E-Mail-Adresse (keine allgemeine info@-Adresse) ein, um eine Anmeldebestätigung und ein Erinnerungsmail zu erhalten.",
        "Gib für die Korrespondenz deine persönliche E-Mail-Adresse an (keine allgemeine Adresse wie info@).": "Gib für die Korrespondenz deine persönliche E-Mail-Adresse an (keine allgemeine Adresse wie info@).",
        "Füge eine persönliche E-Mail-Adresse ein, damit der:die Teilnehmer:in alle kursbezogenen Mitteilungen (z. B. Anmeldebestätigung, Erinnerung, Teilnahmebestätigung) direkt per Mail erhält.": "Füge eine persönliche E-Mail-Adresse ein, damit der:die Teilnehmer:in alle kursbezogenen Mitteilungen (z. B. Anmeldebestätigung, Erinnerung, Teilnahmebestätigung) direkt per Mail erhält.",
        "Sanio Kundenbereich": "Sanio Kundenbereich",
        "Liebe Geschäftskund:innen, unser Portal für die Kursverwaltung hat einen neuen Namen. Das {portalName} erreicht ihr ab sofort unter {sanioPortalLink}.": "Liebe Geschäftskund:innen, unser Portal für die Kursverwaltung hat einen neuen Namen. Das {portalName} erreicht ihr ab sofort unter {sanioPortalLink}.",
        "Teilnahmebestätigungen herunterladen": "Teilnahmebestätigungen herunterladen",
        "Hier dein persönlicher Zugang, um dich im my.sanio einzuloggen:": "Hier dein persönlicher Zugang, um dich im my.sanio einzuloggen:",
        "Wichtige Hinweise:": "Wichtige Hinweise:",
        "Der Link kann nur einmal verwendet werden.": "Der Link kann nur einmal verwendet werden.",
        "Er ist zeitlich begrenzt gültig.": "Er ist zeitlich begrenzt gültig.",
        "Falls das Login nicht funktioniert, kannst du jederzeit einen neuen Link auf der <a href=\"{loginPageUrl}\">Anmeldeseite</a> anfordern.": "Falls das Login nicht funktioniert, kannst du jederzeit einen neuen Link auf der <a href=\"{loginPageUrl}\">Anmeldeseite</a> anfordern.",
        "Hier dein persönlicher Zugang, um dich im Sanio Kundenportal einzuloggen:": "Hier dein persönlicher Zugang, um dich im Sanio Kundenportal einzuloggen:",
        "Hier dein persönlicher Zugang, um dich im Sanio Instruktor:innen Bereich einzuloggen:": "Hier dein persönlicher Zugang, um dich im Sanio Instruktor:innen Bereich einzuloggen:",
        "in Planung": "in Planung",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im Sanio Kundenportal mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Ist ein Passwort hinterlegt, kann sich der Kontakt im Sanio Kundenportal mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im team.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Ist ein Passwort hinterlegt, kann sich der Kontakt im team.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im my.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Ist ein Passwort hinterlegt, kann sich der Kontakt im my.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.",
        "Shop-Kund:in wurde erfolgreich erstellt.": "Shop-Kund:in wurde erfolgreich erstellt.",
        "Shop-Kund:in erfassen": "Shop-Kund:in erfassen",
        "Shop-Kund:in bearbeiten": "Shop-Kund:in bearbeiten",
        "Allgemeine Informationen": "Allgemeine Informationen",
        "Rechte": "Rechte",
        "Rollen": "Rollen",
        "Rollen auswählen": "Rollen auswählen",
        "Authentifizierung": "Authentifizierung",
        "Passwort (optional)": "Passwort (optional)",
        "Wechseln": "Wechseln",
        "Sprache": "Sprache",
        "Benutzeroberfläche": "Benutzeroberfläche",
        "total": "total",
        "übersetzt": "übersetzt",
        "ausstehend": "ausstehend",
        "Übersetzungsstatistiken werden geladen": "Übersetzungsstatistiken werden geladen",
        "Übersetzungsstatistiken konnten nicht geladen werden.": "Übersetzungsstatistiken konnten nicht geladen werden.",
        "Mögliche Gründe:": "Mögliche Gründe:",
        "Die Story wurde noch nicht ins Weblate übertragen.": "Die Story wurde noch nicht ins Weblate übertragen.",
        "Es gab ein technisches Problem.": "Es gab ein technisches Problem.",
        "Übersetzungsstatistiken": "Übersetzungsstatistiken",
        "Es gibt bereits {count} ähnliche:n Teilnehmer:in. Schalte das Matching aus um den Teilnehmer trotzdem zu erstellen.": "Es gibt bereits {count} ähnliche:n Teilnehmer:in. Schalte das Matching aus um den Teilnehmer trotzdem zu erstellen.",
        "Möchtest du die Variante wirklich duplizieren?": "Möchtest du die Variante wirklich duplizieren?",
        "Preis": "Preis",
        "Produkt erfassen": "Produkt erfassen",
        "Produkt bearbeiten": "Produkt bearbeiten",
        "Produktstatus": "Produktstatus",
        "Produktart (Bexio)": "Produktart (Bexio)",
        "Preis in CHF": "Preis in CHF",
        "MwSt. in Prozent": "MwSt. in Prozent",
        "Produktmedien": "Produktmedien",
        "Produktbild": "Produktbild",
        "Produkte": "Produkte",
        "Produkt wurde erstellt.": "Produkt wurde erstellt.",
        "Produkt wurde aktualisiert.": "Produkt wurde aktualisiert.",
        "Produktgruppen": "Produktgruppen",
        "Produktgruppe erfassen": "Produktgruppe erfassen",
        "Produktgruppe bearbeiten": "Produktgruppe bearbeiten",
        "Es gibt noch keine Einträge.": "Es gibt noch keine Einträge.",
        "Medien": "Medien",
        "Produktgruppenbild": "Produktgruppenbild",
        "Produktgruppe wurde erstellt.": "Produktgruppe wurde erstellt.",
        "Produktgruppe wurde aktualisiert.": "Produktgruppe wurde aktualisiert.",
        "Produktgruppe": "Produktgruppe",
        "Produkte werden im Hintergrund aktualisiert.": "Produkte werden im Hintergrund aktualisiert.",
        "Jetzt aktualisieren": "Jetzt aktualisieren",
        "Die Produktdaten werden aus Bexio regelmässig importiert und mit den bestehenden abgeglichen.": "Die Produktdaten werden aus Bexio regelmässig importiert und mit den bestehenden abgeglichen.",
        "Kürzel (Slug)": "Kürzel (Slug)",
        "Shop wurde erstellt.": "Shop wurde erstellt.",
        "Shop wurde aktualisiert.": "Shop wurde aktualisiert.",
        "Shop wurde gelöscht.": "Shop wurde gelöscht.",
        "Shop erfassen": "Shop erfassen",
        "Shop bearbeiten": "Shop bearbeiten",
        "Shops": "Shops",
        "Aktiv": "Aktiv",
        "Produktgruppen auswählen": "Produktgruppen auswählen",
        "Titel": "Titel",
        "Mit der Registrierung akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Mit der Registrierung akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.",
        "Es muss eine gültige Handynummer angegeben werden.": "Es muss eine gültige Handynummer angegeben werden.",
        "inkl. {taxPercentage}% MwSt.": "inkl. {taxPercentage}% MwSt.",
        "Preis (inkl. {taxPercentage}% MwSt)": "Preis (inkl. {taxPercentage}% MwSt)",
        "Bestelldatum: {orderDate}": "Bestelldatum: {orderDate}",
        "Bestellnummer: {orderReference}": "Bestellnummer: {orderReference}",
        "Kursmodi": "Kursmodi",
        "Kein Datum definiert": "Kein Datum definiert",
        "Anmeldefrist abgelaufen": "Anmeldefrist abgelaufen",
        "Anmeldefrist:": "Anmeldefrist:",
        "Anmeldefrist": "Anmeldefrist",
        "Die Anmeldefrist ist abgelaufen.": "Die Anmeldefrist ist abgelaufen.",
        "Kunde": "Kunde",
        "Termine": "Termine",
        "Link": "Link",
        "eLearning öffnen": "eLearning öffnen",
        "Du hast dich erfolgreich für das Erste Hilfe eLearning von {customer} angemeldet! 🎉": "Du hast dich erfolgreich für das Erste Hilfe eLearning von {customer} angemeldet! 🎉",
        "Es steht dir nun zur Verfügung und du kannst ab sofort mit dem Lernen beginnen.": "Es steht dir nun zur Verfügung und du kannst ab sofort mit dem Lernen beginnen.",
        "Du hast dich für das Erste Hilfe eLearning angemeldet, aber noch nicht gestartet. Nutze die Chance, dein Wissen aufzufrischen.": "Du hast dich für das Erste Hilfe eLearning angemeldet, aber noch nicht gestartet. Nutze die Chance, dein Wissen aufzufrischen.",
        "Starte jetzt dein Erste Hilfe eLearning! 🚀": "Starte jetzt dein Erste Hilfe eLearning! 🚀",
        "Nachricht konnte nicht erneut zugestellt werden!": "Nachricht konnte nicht erneut zugestellt werden!",
        "Der Kommentar konnte nicht gespeichert werden.": "Der Kommentar konnte nicht gespeichert werden.",
        "{firstname}, dein Erste Hilfe eLearning von {company} wartet auf dich! ⏳": "{firstname}, dein Erste Hilfe eLearning von {company} wartet auf dich! ⏳",
        "Glückwunsch, {firstname}! Dein Erste Hilfe eLearning von {company} ist abgeschlossen 🎓": "Glückwunsch, {firstname}! Dein Erste Hilfe eLearning von {company} ist abgeschlossen 🎓",
        "{firstname}, dein Zugang zum Erste Hilfe eLearning von {company} ist da!": "{firstname}, dein Zugang zum Erste Hilfe eLearning von {company} ist da!",
        "Twint": "Twint",
        "Visa": "Visa",
        "MasterCard": "MasterCard",
        "PostFinance Pay": "PostFinance Pay",
        "Rechnung": "Rechnung",
        "Vorkasse": "Vorkasse",
        "Keine Zahlung erforderlich": "Keine Zahlung erforderlich",
        "Shop-Kund:in wurde erfolgreich aktualisiert.": "Shop-Kund:in wurde erfolgreich aktualisiert.",
        "Shop-Kund:in wurde erfolgreich gelöscht.": "Shop-Kund:in wurde erfolgreich gelöscht.",
        "Möchtest du die Teilnahmebestätigungen herunterladen?": "Möchtest du die Teilnahmebestätigungen herunterladen?",
        "Shop-Kund:innen": "Shop-Kund:innen",
        "Shop-Kund:innen erfassen": "Shop-Kund:innen erfassen",
        "Das eLearning dauert rund {onlineCourseDuration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "Das eLearning dauert rund {onlineCourseDuration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!",
        "Du hast das Erste Hilfe eLearning von {customer} erfolgreich abgeschlossen – grossartig!": "Du hast das Erste Hilfe eLearning von {customer} erfolgreich abgeschlossen – grossartig!",
        "Danke, dass du dich für Erste Hilfe weitergebildet hast. Bleib sicher!": "Danke, dass du dich für Erste Hilfe weitergebildet hast. Bleib sicher!",
        "{firstname}, starte jetzt dein Erste Hilfe eLearning! 🚀": "{firstname}, starte jetzt dein Erste Hilfe eLearning! 🚀",
        "Viel Erfolg! 🚀": "Viel Erfolg! 🚀",
        "Du hast bereits {courseProgress}% vom Erste Hilfe eLearning geschafft – super! 🎉": "Du hast bereits {courseProgress}% vom Erste Hilfe eLearning geschafft – super! 🎉",
        "Bleib dran und lerne weiter, damit du den Kurs erfolgreich abschliessen kannst.": "Bleib dran und lerne weiter, damit du den Kurs erfolgreich abschliessen kannst.",
        "Weiterlernen": "Weiterlernen",
        "Keine Kursleitung definiert": "Keine Kursleitung definiert",
        "Wir freuen uns, dir deine Teilnahmebestätigung für diesen Onlinekurs zu übermitteln. Die Datei findest du im Anhang dieser E-Mail.": "Wir freuen uns, dir deine Teilnahmebestätigung für diesen Onlinekurs zu übermitteln. Die Datei findest du im Anhang dieser E-Mail.",
        "hat am <strong>{dateText}</strong> am {durationText} {courseTypeName} {guideline} teilgenommen.": "hat am <strong>{dateText}</strong> am {durationText} {courseTypeName} {guideline} teilgenommen.",
        "hat am <strong>{dateText}</strong> das {durationText} {courseTypeName} {guideline} erfolgreich abgeschlossen.": "hat am <strong>{dateText}</strong> das {durationText} {courseTypeName} {guideline} erfolgreich abgeschlossen.",
        "{minutes}-minütige": "{minutes}-minütige",
        "{hours}-stündige": "{hours}-stündige",
        "{hours}-stündigen": "{hours}-stündigen",
        "Teilnehmerliste importieren": "Teilnehmerliste importieren",
        "Teilnehmer:innen wurden {statusHint} aus Datei {fileName} in Kurs {course} importiert.": "Teilnehmer:innen wurden {statusHint} aus Datei {fileName} in Kurs {course} importiert.",
        "Sortierung": "Sortierung",
        "Kategorie-Label": "Kategorie-Label",
        "Die Teilnehmer:innen aus der Datei \"{fileName}\"\" wurden {statusHint} im Kurs {course} erfasst.": "Die Teilnehmer:innen aus der Datei \"{fileName}\"\" wurden {statusHint} im Kurs {course} erfasst.",
        "Es wurden total:": "Es wurden total:",
        "<strong>{count}</strong> neu angelegt": "<strong>{count}</strong> neu angelegt",
        "<strong>{count}</strong> aktualisiert": "<strong>{count}</strong> aktualisiert",
        "<strong>{count}</strong> am Kurs angemeldet": "<strong>{count}</strong> am Kurs angemeldet",
        "Die Teilnehmer:innen haben eine Anmeldebestätigung erhalten.": "Die Teilnehmer:innen haben eine Anmeldebestätigung erhalten.",
        "Folgende Zeilen konnten aufgrund ungültiger Daten (<span class=\"text-red\">rot markiert</span>) nicht importiert werden:": "Folgende Zeilen konnten aufgrund ungültiger Daten (<span class=\"text-red\">rot markiert</span>) nicht importiert werden:",
        "Der Kurs ist nicht verfügbar.": "Der Kurs ist nicht verfügbar.",
        "Dieser Kurs ist noch nicht bereit für Anmeldungen!": "Dieser Kurs ist noch nicht bereit für Anmeldungen!",
        "Abteilung": "Abteilung",
        "Stationäre Wohngruppen": "Stationäre Wohngruppen",
        "Betriebe": "Betriebe",
        "Bildung": "Bildung",
        "Andere": "Andere",
        "Die Anmeldebestätigungen werden an die Teilnehmer:innen verschickt 🎉": "Die Anmeldebestätigungen werden an die Teilnehmer:innen verschickt 🎉",
        "Anmeldebestätigungen verschicken": "Anmeldebestätigungen verschicken",
        "Anmeldebestätigungen per Mail zustellen": "Anmeldebestätigungen per Mail zustellen",
        "Bestätigungen zustellen": "Bestätigungen zustellen",
        "Zertifikate können für diesen Kurs nicht generiert werden.": "Zertifikate können für diesen Kurs nicht generiert werden.",
        "Zertifikate können nicht automatisch verschickt werden, wenn der Zertifikat-Generator nicht aktiviert ist!": "Zertifikate können nicht automatisch verschickt werden, wenn der Zertifikat-Generator nicht aktiviert ist!",
        "ACHTUNG": "ACHTUNG",
        "Verifizierungscode eingeben": "Verifizierungscode eingeben",
        "Wir haben einen 6-stelligen Code an {maskedIdentifier} geschickt.": "Wir haben einen 6-stelligen Code an {maskedIdentifier} geschickt.",
        "Keinen Code erhalten?": "Keinen Code erhalten?",
        "Erneut senden": "Erneut senden",
        "E-Mail konnte nicht korrekt zugestellt werden": "E-Mail konnte nicht korrekt zugestellt werden",
        "Bestätigen": "Bestätigen",
        "Bestellung: {id}": "Bestellung: {id}",
        "Bezahlstatus: {status}": "Bezahlstatus: {status}",
        "Wenn wir nicht wissen, wer du bist, kann es sein, dass wir dich nach deiner <strong>Sanio ID</strong> fragen. Du findest diese hier:": "Wenn wir nicht wissen, wer du bist, kann es sein, dass wir dich nach deiner <strong>Sanio ID</strong> fragen. Du findest diese hier:",
        "Erneut senden ({timeTillResend} s)": "Erneut senden ({timeTillResend} s)",
        "Mit dem Kauf akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Mit dem Kauf akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.",
        "Lade weitere Kurse": "Lade weitere Kurse",
        "Keine weiteren Kurse gefunden.": "Keine weiteren Kurse gefunden.",
        "Kurs suchen": "Kurs suchen",
        "Kein Kurs ausgewählt": "Kein Kurs ausgewählt",
        "Kurs auswählen": "Kurs auswählen",
        "Ausgewählter Kurs": "Ausgewählter Kurs",
        "Zugriffsdauer in Tagen": "Zugriffsdauer in Tagen",
        "Willkommen in deinem persönlichen Bereich, {name}! Hier findest du alle deine gebuchten Online-Kurse, deine Bestellungen und kannst dein Profil verwalten. Viel Spass beim Lernen!": "Willkommen in deinem persönlichen Bereich, {name}! Hier findest du alle deine gebuchten Online-Kurse, deine Bestellungen und kannst dein Profil verwalten. Viel Spass beim Lernen!",
        "Jetzt eLearning starten": "Jetzt eLearning starten",
        "Leider stehen dir im Moment keine Online-Kurse zur Verfügung. Bitte kontaktiere uns, wenn du Fragen hast.": "Leider stehen dir im Moment keine Online-Kurse zur Verfügung. Bitte kontaktiere uns, wenn du Fragen hast.",
        "Bestellungen": "Bestellungen",
        "Online Kurse": "Online Kurse",
        "Benötigst Du Hilfe?": "Benötigst Du Hilfe?",
        "Wir helfen Dir gerne per E-Mail oder Telefon": "Wir helfen Dir gerne per E-Mail oder Telefon",
        "Erste Hilfe lernen. Wo du willst. Wann du willst.": "Erste Hilfe lernen. Wo du willst. Wann du willst.",
        "Schön, dass du dich für unser Erste Hilfe eLearning entschieden hast! 😊": "Schön, dass du dich für unser Erste Hilfe eLearning entschieden hast! 😊",
        "Den Beleg zu deiner Bestellung findest du im Anhang.": "Den Beleg zu deiner Bestellung findest du im Anhang.",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡",
        "Bestellbestätigung für {orderNumber}": "Bestellbestätigung für {orderNumber}",
        "Wir haben deine Zahlung erhalten und dein Zugang zum eLearning ist jetzt freigeschaltet.": "Wir haben deine Zahlung erhalten und dein Zugang zum eLearning ist jetzt freigeschaltet.",
        "Danke für deine Bestellung, {name}! 🎉": "Danke für deine Bestellung, {name}! 🎉",
        "Rechnungsadresse": "Rechnungsadresse",
        "Lieferadresse": "Lieferadresse",
        "Abweichende Lieferadresse": "Abweichende Lieferadresse",
        "Optional. Empfohlen, wenn Gutscheine per Post verschickt werden.": "Optional. Empfohlen, wenn Gutscheine per Post verschickt werden.",
        "Der Vorname der Lieferadresse ist erforderlich.": "Der Vorname der Lieferadresse ist erforderlich.",
        "Der Nachname der Lieferadresse ist erforderlich.": "Der Nachname der Lieferadresse ist erforderlich.",
        "Die Strasse der Lieferadresse ist erforderlich.": "Die Strasse der Lieferadresse ist erforderlich.",
        "Die Hausnummer der Lieferadresse ist erforderlich.": "Die Hausnummer der Lieferadresse ist erforderlich.",
        "Die PLZ der Lieferadresse ist erforderlich.": "Die PLZ der Lieferadresse ist erforderlich.",
        "Der Ort der Lieferadresse ist erforderlich.": "Der Ort der Lieferadresse ist erforderlich.",
        "Bestellbestätigung": "Bestellbestätigung",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr in einen anderen Kurs verschoben werden.": "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr in einen anderen Kurs verschoben werden.",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr abgemeldet werden.": "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr abgemeldet werden.",
        "Kontaktperson Kunde": "Kontaktperson Kunde",
        "Die Zertifikate werden im Hintergrund vorbereitet. Sie erhalten eine Benachrichtigung, sobald die Zertifikate zum Download bereitstehen.": "Die Zertifikate werden im Hintergrund vorbereitet. Sie erhalten eine Benachrichtigung, sobald die Zertifikate zum Download bereitstehen.",
        "Die Zertifikate für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "Die Zertifikate für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.",
        "Jetzt herunterladen": "Jetzt herunterladen",
        "Zertifikate für Kurs {course} wurden generiert!": "Zertifikate für Kurs {course} wurden generiert!",
        "Die Zertifikate werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du die Zertifikate herunterladen kannst.": "Die Zertifikate werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du die Zertifikate herunterladen kannst.",
        "Möchtest du die Teilnahmebestätigungen trotzdem generieren?": "Möchtest du die Teilnahmebestätigungen trotzdem generieren?",
        "Die Zertifikate werden im Hintergrund vorbereitet. Bitte habe einen Moment Geduld.": "Die Zertifikate werden im Hintergrund vorbereitet. Bitte habe einen Moment Geduld.",
        "Teilnahmebestätigungen generieren": "Teilnahmebestätigungen generieren",
        "Der angegebene Freigabelink wird noch nicht unterstützt.": "Der angegebene Freigabelink wird noch nicht unterstützt.",
        "Persönlicher Zugangscode (QR) anzeigen": "Persönlicher Zugangscode (QR) anzeigen",
        "Persönliche Zugangscodes (QR) als PDF": "Persönliche Zugangscodes (QR) als PDF",
        "Persönlicher eLearning Zugang {name}": "Persönlicher eLearning Zugang {name}",
        "Das Dokument wird im Hintergrund generiert. Du wirst benachrichtigt, sobald es fertig ist.": "Das Dokument wird im Hintergrund generiert. Du wirst benachrichtigt, sobald es fertig ist.",
        "Die Zugangs-QR-Codes für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "Die Zugangs-QR-Codes für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.",
        "Das eLearning steht für dich bereitsteht und du kannst ab sofort mit dem Lernen beginnen. Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "Das eLearning steht für dich bereitsteht und du kannst ab sofort mit dem Lernen beginnen. Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!",
        "Persönlicher Zugang": "Persönlicher Zugang",
        "eLearning {customerName}": "eLearning {customerName}",
        "Viel Erfolg!": "Viel Erfolg!",
        "QR Code": "QR Code",
        "Gültig bis {expire}": "Gültig bis {expire}",
        "eLearning Zugang {customerName}": "eLearning Zugang {customerName}",
        "eLearning QR-Zugänge generieren": "eLearning QR-Zugänge generieren",
        "Die QR-Zugänge werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du sie herunterladen kannst.": "Die QR-Zugänge werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du sie herunterladen kannst.",
        "QR Code wird geladen": "QR Code wird geladen",
        "QR-Code mit Smartphone Kamera scannen": "QR-Code mit Smartphone Kamera scannen",
        "QR-Code drucken": "QR-Code drucken",
        "QR Zugänge für Kurs {course} wurden generiert!": "QR Zugänge für Kurs {course} wurden generiert!",
        "Super, du bist erfolgreich für den Erste Hilfe Kurs angemeldet – wir freuen uns! 🎉": "Super, du bist erfolgreich für den Erste Hilfe Kurs angemeldet – wir freuen uns! 🎉",
        "Teil 1: eLearning": "Teil 1: eLearning",
        "Das <strong>eLearning</strong> ist ab sofort für dich freigeschaltet – du kannst direkt loslegen:": "Das <strong>eLearning</strong> ist ab sofort für dich freigeschaltet – du kannst direkt loslegen:",
        "<strong>Bitte beachte:</strong> Das eLearning muss bis spätestens vor dem Präsenzkurs am <strong>{courseDate}</strong> abgeschlossen sein. Es ist die Grundlage für den praktischen Teil des Kurses.": "<strong>Bitte beachte:</strong> Das eLearning muss bis spätestens vor dem Präsenzkurs am <strong>{courseDate}</strong> abgeschlossen sein. Es ist die Grundlage für den praktischen Teil des Kurses.",
        "Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!",
        "Teil 2: Präsenzkurs": "Teil 2: Präsenzkurs",
        "eLearning URL": "eLearning URL",
        "kopieren": "kopieren",
        "eLearning QR-Zugänge generieren und E-Mail an ({email}) senden": "eLearning QR-Zugänge generieren und E-Mail an ({email}) senden",
        "<strong>ACHTUNG:</strong> Du bist als eine andere Person angemeldet. Die E-Mail wird aber an die E-Mail-Adresse der aktuell angemeldeten Person gesendet.": "<strong>ACHTUNG:</strong> Du bist als eine andere Person angemeldet. Die E-Mail wird aber an die E-Mail-Adresse der aktuell angemeldeten Person gesendet.",
        "Teilnahmebestätigungen an Teilnehmer:innen versenden": "Teilnahmebestätigungen an Teilnehmer:innen versenden",
        "Teilnahmebestätigungen generieren und E-Mail an ({email}) senden": "Teilnahmebestätigungen generieren und E-Mail an ({email}) senden",
        "Programm": "Programm",
        "Unternehmen": "Unternehmen",
        "Kundenbereiche": "Kundenbereiche",
        "Offerte": "Offerte",
        "Benutzer:innen": "Benutzer:innen",
        "Kontakte": "Kontakte",
        "Kursanfragen": "Kursanfragen",
        "Kontaktanfragen": "Kontaktanfragen",
        "Erste Hilfe eLearning": "Erste Hilfe eLearning",
        "Die Eingabe ist ungültig.": "Die Eingabe ist ungültig.",
        "Zu viele Versuche. Bitte versuche es später erneut.": "Zu viele Versuche. Bitte versuche es später erneut.",
        "Teilnehmer:in aus Kundenbereich löschen": "Teilnehmer:in aus Kundenbereich löschen",
        "Standard": "Standard",
        "Ist aktiv": "Ist aktiv",
        "Ist der Standard Shop": "Ist der Standard Shop",
        "Kurs Zuweisung": "Kurs Zuweisung",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails.": "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails.",
        "Zum my.sanio": "Zum my.sanio",
        "Bestellnummer": "Bestellnummer",
        "Datum & Uhrzeit": "Datum & Uhrzeit",
        "Lizenz": "Lizenz",
        "Zugriffszeitraum": "Zugriffszeitraum",
        "inkl. {taxPercentage}% MwSt": "inkl. {taxPercentage}% MwSt",
        "Hi {name}! 🎉": "Hi {name}! 🎉",
        "Zahlungsart": "Zahlungsart",
        "Du kannst diesen/diese Teilnehmer:in nicht mehr bearbeiten, da ein verknüpfter Kurs bereits begonnen hat oder abgeschlossen ist.": "Du kannst diesen/diese Teilnehmer:in nicht mehr bearbeiten, da ein verknüpfter Kurs bereits begonnen hat oder abgeschlossen ist.",
        "Der Kurs hat bereits begonnen.": "Der Kurs hat bereits begonnen.",
        "Vielen Dank für deine Anmeldung!": "Vielen Dank für deine Anmeldung!",
        "Du erhältst in Kürze eine Bestätigung per E-Mail mit allen wichtigen Infos zum Kurs. Bitte wirf auch einen Blick in deinen Spam-Ordner, falls keine Mail eintrifft. 📩": "Du erhältst in Kürze eine Bestätigung per E-Mail mit allen wichtigen Infos zum Kurs. Bitte wirf auch einen Blick in deinen Spam-Ordner, falls keine Mail eintrifft. 📩",
        "Deine Anmeldung ist bei uns eingegangen. Alle weiteren Informationen zum Kurs erhältst du zu einem späteren Zeitpunkt. 📩": "Deine Anmeldung ist bei uns eingegangen. Alle weiteren Informationen zum Kurs erhältst du zu einem späteren Zeitpunkt. 📩",
        "Du musst nichts mitbringen. Wir empfehlen dir praktische und bequeme Kleidung zu tragen, die genügend Bewegungsfreiheit bietet. Denn während des Kurses führen wir praktische Übungen auf dem Boden durch, welche teilweise physisch etwas anspruchsvoll sind. 😊": "Du musst nichts mitbringen. Wir empfehlen dir praktische und bequeme Kleidung zu tragen, die genügend Bewegungsfreiheit bietet. Denn während des Kurses führen wir praktische Übungen auf dem Boden durch, welche teilweise physisch etwas anspruchsvoll sind. 😊",
        "<strong>Bei Fragen oder Abmeldungen vor dem Kurstag</strong> wende dich bitte direkt an {name}:": "<strong>Bei Fragen oder Abmeldungen vor dem Kurstag</strong> wende dich bitte direkt an {name}:",
        "Leider bist du nicht berechtigt, ein Zertifikat für diesen Kurs zu erhalten.": "Leider bist du nicht berechtigt, ein Zertifikat für diesen Kurs zu erhalten.",
        "Sanio": "Sanio",
        "Am Kurstag selbst, z.B. bei Verspätung oder kurzfristiger Abmeldung, erreichst du uns schriftlich via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.": "Am Kurstag selbst, z.B. bei Verspätung oder kurzfristiger Abmeldung, erreichst du uns schriftlich via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.",
        "Produktgutschein": "Produktgutschein",
        "Empfänger": "Empfänger",
        "1 Lizenz zur Selbstnutzung": "1 Lizenz zur Selbstnutzung",
        "{count} Geschenk ({type})": "{count} Geschenk ({type})",
        "digital": "digital",
        "1 Lizenz zum Verschenken ({type})|{count} Lizenzen zum Verschenken ({type})": "1 Lizenz zum Verschenken ({type})|{count} Lizenzen zum Verschenken ({type})",
        "Anzahl Lizenzen": "Anzahl Lizenzen",
        "Für {recipient} von {giver}": "Für {recipient} von {giver}",
        "Unbekannt": "Unbekannt",
        "Sie sind eingeloggt als: {name}": "Sie sind eingeloggt als: {name}",
        "Gutschein {number} herunterladen": "Gutschein {number} herunterladen",
        "Gutschein-Link {number} kopieren (inkl. Code)": "Gutschein-Link {number} kopieren (inkl. Code)",
        "Eingelöst": "Eingelöst",
        "Eingelöst von": "Eingelöst von",
        "Eingelöst am": "Eingelöst am",
        "Gutschein oder Rabatt einlösen": "Gutschein oder Rabatt einlösen",
        "Trage hier deinen Rabattcode für diesen Kurs ein.": "Trage hier deinen Rabattcode für diesen Kurs ein.",
        "Rabatt entfernen": "Rabatt entfernen",
        "Code ungültig": "Code ungültig",
        "Dieser Code ist nur für eLearning Geschenke gültig.": "Dieser Code ist nur für eLearning Geschenke gültig.",
        "Gutscheincode ist ungültig.": "Gutscheincode ist ungültig.",
        "Dieser Gutschein kann nur für das Produkt {name} verwendet werden.": "Dieser Gutschein kann nur für das Produkt {name} verwendet werden.",
        "Alle Produkte": "Alle Produkte",
        "Optional. Ohne Auswahl gilt der Gutschein für alle Produkte. Ein fester Betrag wird je Stück des gewählten Produkts abgezogen.": "Optional. Ohne Auswahl gilt der Gutschein für alle Produkte. Ein fester Betrag wird je Stück des gewählten Produkts abgezogen.",
        "Hast du ein eLearning geschenkt bekommen? Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Hast du ein eLearning geschenkt bekommen? Dann löse deinen Gutschein bitte unter {redeemUrl} ein.",
        "Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Dann löse deinen Gutschein bitte unter {redeemUrl} ein.",
        "Rabatt": "Rabatt",
        "Code": "Code",
        "Produktgutschein erfassen": "Produktgutschein erfassen",
        "Kunde & Produkt": "Kunde & Produkt",
        "Kunde auswählen": "Kunde auswählen",
        "Produkt wählen": "Produkt wählen",
        "Shop-Konfiguration": "Shop-Konfiguration",
        "Shop auswählen": "Shop auswählen",
        "Anzahl Gutscheine": "Anzahl Gutscheine",
        "Geschenkinformationen": "Geschenkinformationen",
        "Empfänger:in": "Empfänger:in",
        "Von (Absender:in)": "Von (Absender:in)",
        "Nachricht an die/den Beschenkte:n (optional)": "Nachricht an die/den Beschenkte:n (optional)",
        "Persönliche Beschriftung auf dem Gutschein hinzufügen": "Persönliche Beschriftung auf dem Gutschein hinzufügen",
        "Produktgutscheine erstellen": "Produktgutscheine erstellen",
        "Produktgutscheine wurden erstellt.": "Produktgutscheine wurden erstellt.",
        "Produktgutscheine": "Produktgutscheine",
        "Versandart": "Versandart",
        "Digital & Versand": "Digital & Versand",
        "Von {sender}": "Von {sender}",
        "Empfänger:in (optional)": "Empfänger:in (optional)",
        "Von (Absender:in, optional)": "Von (Absender:in, optional)",
        "{who} hat dir eine Lizenz für dieses eLearning geschenkt 🎉": "{who} hat dir eine Lizenz für dieses eLearning geschenkt 🎉",
        "Viel Spass beim Lernen, {name}! 🎉": "Viel Spass beim Lernen, {name}! 🎉",
        "Nur digital": "Nur digital",
        "Produkt": "Produkt",
        "Gutschein wurde erstellt.": "Gutschein wurde erstellt.",
        "Gutschein wurde aktualisiert.": "Gutschein wurde aktualisiert.",
        "Gutschein wurde gelöscht.": "Gutschein wurde gelöscht.",
        "📅 Erinnerung an deinen Kurs morgen": "📅 Erinnerung an deinen Kurs morgen",
        "manuell via admin": "manuell via admin",
        "systemgeneriert": "systemgeneriert",
        "Kundenservice": "Kundenservice",
        "Aktion": "Aktion",
        "PDF": "PDF",
        "Physisch": "Physisch",
        "Rabattgutschein": "Rabattgutschein",
        "Wertgutschein": "Wertgutschein",
        "Offen": "Offen",
        "Inaktiv": "Inaktiv",
        "Verwendet": "Verwendet",
        "Abgelaufen": "Abgelaufen",
        "Formatierung kann von effektiv versendeter Nachricht abweichen.": "Formatierung kann von effektiv versendeter Nachricht abweichen.",
        "Gesendet:": "Gesendet",
        "Kanal:": "Kanal:",
        "Absender Nummer:": "Absender Nummer:",
        "Quadratisches Produktbild": "Quadratisches Produktbild",
        "Gutschein-Konfiguration": "Gutschein-Konfiguration",
        "Shop-Beschreibung": "Shop-Beschreibung",
        "Beschreibung die im Shop beim Kauf angezeigt wird": "Beschreibung die im Shop beim Kauf angezeigt wird",
        "Shop-Bedingungen": "Shop-Bedingungen",
        "Bedingungen die im Shop beim Kauf angezeigt werden": "Bedingungen die im Shop beim Kauf angezeigt werden",
        "Einlöse-Beschreibung": "Einlöse-Beschreibung",
        "Beschreibung die beim Einlösen des Gutscheins angezeigt wird": "Beschreibung die beim Einlösen des Gutscheins angezeigt wird",
        "Einlöse-Anweisungen": "Einlöse-Anweisungen",
        "Anweisungen die beim Einlösen des Gutscheins angezeigt werden": "Anweisungen die beim Einlösen des Gutscheins angezeigt werden",
        "Im Shop verfügbar": "Im Shop verfügbar",
        "Gutschein Anwendungen": "Gutschein Anwendungen",
        "Verfügbar": "Verfügbar",
        "Pro Benutzer": "Pro Benutzer",
        "Keine Verwendungen": "Keine Verwendungen",
        "Dieser Gutschein wurde noch nicht verwendet.": "Dieser Gutschein wurde noch nicht verwendet.",
        "Benutzer": "Benutzer",
        "Bestellung": "Bestellung",
        "Wert": "Wert",
        "Suche Code …": "Suche Code …",
        "Suchen": "Suchen",
        "Erstellt am": "Erstellt am",
        "Rabattgutscheine": "Rabattgutscheine",
        "Kunde wählen": "Kunde wählen",
        "Gutscheine": "Gutscheine",
        "Rabattgutschein erfassen": "Rabattgutschein erfassen",
        "Suche Code oder Name …": "Suche Code oder Name …",
        "Gültig bis": "Gültig bis",
        "Kunden": "Kunden",
        "Shop-Kund:in": "Shop-Kund:in",
        "Grundinformationen": "Grundinformationen",
        "Gutschein für": "Gutschein für",
        "Ursprung": "Ursprung",
        "Rabattwert": "Rabattwert",
        "Rabatt-Typ": "Rabatt-Typ",
        "Betrag in Rappen oder Prozentpunkte x100 (z.B. 1500 = 15.00%)": "Betrag in Rappen oder Prozentpunkte x100 (z.B. 1500 = 15.00%)",
        "Anwendungen": "Anwendungen",
        "Beschränkte Anzahl": "Beschränkte Anzahl",
        "Anwendungen pro Benutzer": "Anwendungen pro Benutzer",
        "Rabattgutschein bearbeiten": "Rabattgutschein bearbeiten",
        "Gutschein Details": "Gutschein Details",
        "Max. Verwendungen": "Max. Verwendungen",
        "Max. pro Nutzer:in": "Max. pro Nutzer:in",
        "Dies ist eine kurze Erinnerung: Du leitest morgen den Kurs {courseType}, {courseDuration} bei {company}.": "Dies ist eine kurze Erinnerung: Du leitest morgen den Kurs {courseType}, {courseDuration} bei {company}.",
        "Kurszeiten:": "Kurszeiten:",
        "Ort:": "Ort:",
        "Bitte sei 30 Minuten vor Kursbeginn vor Ort und überprüfe, ob du alles Material dabeihast.": "Bitte sei 30 Minuten vor Kursbeginn vor Ort und überprüfe, ob du alles Material dabeihast.",
        "Alle weiteren Informationen zum Kurs und zu den Teilnehmenden findest du hier:": "Alle weiteren Informationen zum Kurs und zu den Teilnehmenden findest du hier:",
        "Bei Fragen oder Problemen kannst du dich gerne an Tanja wenden.": "Bei Fragen oder Problemen kannst du dich gerne an Tanja wenden.",
        "Danke für deinen Einsatz!": "Danke für deinen Einsatz!",
        "Gutschein {code}": "Gutschein {code}",
        "Gutschein {code} ({value})": "Gutschein {code} ({value})",
        "Gutschein {code} ({value}%)": "Gutschein {code} ({value}%)",
        "Empfänger:": "Empfänger:",
        "Absender:": "Absender:",
        "Einlösen unter:": "Einlösen unter:",
        "Code als QR": "Code als QR",
        "Gutschein {number}": "Gutschein {number}",
        "Mit dem Einlösen akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Mit dem Einlösen akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.",
        "Gutschein einlösen": "Gutschein einlösen",
        "Du besitzt bereits eine aktive Lizenz für diesen Kurs. Eine weitere Einlösung ist nicht möglich.": "Du besitzt bereits eine aktive Lizenz für diesen Kurs. Eine weitere Einlösung ist nicht möglich.",
        "Andere Lizenz einlösen": "Andere Lizenz einlösen",
        "Hast du ein eLearning geschenkt bekommen?": "Hast du ein eLearning geschenkt bekommen?",
        "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        "Menge": "Menge",
        "Jede Lizenz berechtigt zu einem Jahr Nutzung des eLearnings.": "Jede Lizenz berechtigt zu einem Jahr Nutzung des eLearnings.",
        "Abschluss": "Abschluss",
        "Sie haben bereits eine aktive Lizenz für dieses Produkt. Sie können nur Geschenklizenzen kaufen.": "Sie haben bereits eine aktive Lizenz für dieses Produkt. Sie können nur Geschenklizenzen kaufen.",
        "Ungültiger Anmeldeversuch.": "Ungültiger Anmeldeversuch.",
        "Preisberechnung fehlgeschlagen": "Preisberechnung fehlgeschlagen",
        "Fehler": "Fehler",
        "Über uns": "Über uns",
        "Kontakt": "Kontakt",
        "AGBs": "AGBs",
        "Datenschutz": "Datenschutz",
        "Impressum": "Impressum",
        "Rechnungsadresse bearbeiten": "Rechnungsadresse bearbeiten",
        "Strasse": "Strasse",
        "PLZ": "PLZ",
        "Ort": "Ort",
        "E-Mail und Telefonnummer können nur im Profil bearbeitet werden.": "E-Mail und Telefonnummer können nur im Profil bearbeitet werden.",
        "Benötigen Sie Hilfe?": "Benötigen Sie Hilfe?",
        "Wir helfen Ihnen gerne per E-Mail oder Telefon": "Wir helfen Ihnen gerne per E-Mail oder Telefon",
        "Telefon": "Telefon",
        "Ihre Bestellung": "Ihre Bestellung",
        "Gesamtbetrag": "Gesamtbetrag",
        "Zwischensumme": "Zwischensumme",
        "Jetzt kaufen": "Jetzt kaufen",
        "Mögliche Zahlungsarten": "Mögliche Zahlungsarten",
        "Uups, Ihre Bestellung konnte nicht abgeschlossen werden.": "Uups, Ihre Bestellung konnte nicht abgeschlossen werden.",
        "Sie haben die Zahlung abgebrochen. Bitte versuchen Sie es erneut.": "Sie haben die Zahlung abgebrochen. Bitte versuchen Sie es erneut.",
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "Wir haben deine Bestellung erhalten 🥳": "Wir haben deine Bestellung erhalten 🥳",
        "Zahlung wird verarbeitet": "Zahlung wird verarbeitet",
        "Dein Zugang zum eLearning ist jetzt bereit. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Dein Zugang zum eLearning ist jetzt bereit. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡",
        "Zu my.sanio": "Zu my.sanio",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist bereits eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist bereits eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.",
        "Deine Geschenklizenz 🎁": "Deine Geschenklizenz 🎁",
        "Deine Geschenklizenzen 🎁": "Deine Geschenklizenzen 🎁",
        "Deine Geschenklizenz findest du unten in den Bestelldetails. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Deine Geschenklizenz findest du unten in den Bestelldetails. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.",
        "Deine Geschenklizenzen findest du unten in den Bestelldetails. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Deine Geschenklizenzen findest du unten in den Bestelldetails. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.",
        "Bestelldetails": "Bestelldetails",
        "Lizenzen": "Lizenzen",
        "Geschenklizenzen": "Geschenklizenzen",
        "Link wurde kopiert.": "Link wurde kopiert.",
        "Link konnte nicht kopiert werden.": "Link konnte nicht kopiert werden.",
        "Übersicht": "Übersicht",
        "Deine Angaben": "Deine Angaben",
        "Geschenklizenz Übersicht": "Geschenklizenz Übersicht",
        "Neu bei Sanio?": "Neu bei Sanio?",
        "Erstellen Sie Ihr Sanio-Konto und los geht's!": "Erstellen Sie Ihr Sanio-Konto und los geht's!",
        "Jetzt Konto erstellen": "Jetzt Konto erstellen",
        "Haben Sie schon ein Sanio Konto?": "Haben Sie schon ein Sanio Konto?",
        "Melden Sie sich mit Ihrer E-Mail oder Handynummer an und schon geht's los!": "Melden Sie sich mit Ihrer E-Mail oder Handynummer an und schon geht's los!",
        "E-Mail oder Handynummer": "E-Mail oder Handynummer",
        "Weiter": "Weiter",
        "Wird verarbeitet...": "Wird verarbeitet...",
        "Zum verschenken": "Zum verschenken",
        "Wird auf Geschenklizenz gedruckt": "Wird auf Geschenklizenz gedruckt",
        "Wenn Sie diese angeben, können Sie sich später auch per SMS einloggen.": "Wenn Sie diese angeben, können Sie sich später auch per SMS einloggen.",
        "Handynummer (optional)": "Handynummer (optional)",
        "Nr.": "Nr.",
        "Erstelle dein Sanio-Konto": "Erstelle dein Sanio-Konto",
        "Erstellen Sie Ihr Sanio-Konto": "Erstellen Sie Ihr Sanio-Konto",
        "Sie sind bereits bei Sanio?": "Sie sind bereits bei Sanio?",
        "Du hast bereits ein Konto?": "Du hast bereits ein Konto?",
        "Geschenklizenz eingelöst": "Geschenklizenz eingelöst",
        "Geschenklizenz einlösen 🎁": "Geschenklizenz einlösen 🎁",
        "Geschenklizenz für": "Geschenklizenz für",
        "Geschenklizenz personalisieren": "Geschenklizenz personalisieren",
        "Geschenklizenz von": "Geschenklizenz von",
        "Geschenklizenz": "Geschenklizenz",
        "Geschenklizenzen personalisieren": "Geschenklizenzen personalisieren",
        "Ihr Name für alle übernehmen": "Ihr Name für alle übernehmen",
        "Ihr Name": "Ihr Name",
        "Name des Empfängers": "Name des Empfängers",
        "Digital & Physisch (per Post)": "Digital & Physisch (per Post)",
        "Nur digital (PDF)": "Nur digital (PDF)",
        "Registrieren": "Registrieren",
        "Deine Gutscheine": "Deine Gutscheine",
        "Lizenz aktiviert": "Lizenz aktiviert",
        "Jemand": "Jemand",
        "Wie schön, du wurdest beschenkt 🎉": "Wie schön, du wurdest beschenkt 🎉",
        "Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Löse deinen Code ein und erfahre, was für dich bereitsteht.",
        "Wie viele Lizenzen möchten Sie kaufen? ": "Wie viele Lizenzen möchten Sie kaufen? ",
        "Wird gespeichert...": "Wird gespeichert...",
        "Nicht {name}?": "Nicht {name}?",
        "Hausnummer": "Hausnummer",
        "Als Firma können Sie keine Lizenz für sich selbst kaufen. Sie können nur Geschenklizenzen kaufen.": "Als Firma können Sie keine Lizenz für sich selbst kaufen. Sie können nur Geschenklizenzen kaufen.",
        "Als Firma registrieren": "Als Firma registrieren",
        "Firma muss ausgefüllt werden, wenn Sie sich als Firma registrieren möchten.": "Firma muss ausgefüllt werden, wenn Sie sich als Firma registrieren möchten.",
        "Firma": "Firma",
        "Für wen sind die Lizenzen?": "Für wen sind die Lizenzen?",
        "Eine Lizenz für mich, andere zum Verschenken": "Eine Lizenz für mich, andere zum Verschenken",
        "Alle Lizenzen zum Verschenken": "Alle Lizenzen zum Verschenken",
        "Sie besitzen bereits eine aktive Lizenz für diesen Kurs. Sie können nur Geschenklizenzen kaufen.": "Sie besitzen bereits eine aktive Lizenz für diesen Kurs. Sie können nur Geschenklizenzen kaufen.",
        "Für wen ist die Lizenz?": "Für wen ist die Lizenz?",
        "Für mich": "Für mich",
        "Geschenkt von": "Geschenkt von",
        "Für alle übernehmen": "Für alle übernehmen",
        "Wird geprüft.": "Wird geprüft.",
        "Deine Geschenklizenz findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Deine Geschenklizenz findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.",
        "Deine Geschenklizenzen findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Deine Geschenklizenzen findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.",
        "Geschenklizenz eingelöst, eLearning bereit": "Geschenklizenz eingelöst, eLearning bereit",
        "Ihre Kosten": "Ihre Kosten",
        "Produktgutschein wurde aktualisiert.": "Produktgutschein wurde aktualisiert.",
        "Gutschein wurde deaktiviert.": "Gutschein wurde deaktiviert.",
        "Ein Gutschein mit diesem Code existiert bereits im Status Aktiv oder Ausstehend. Bitte deaktivieren Sie den bestehenden Gutschein oder verwenden Sie einen anderen Code.": "Ein Gutschein mit diesem Code existiert bereits im Status Aktiv oder Ausstehend. Bitte deaktivieren Sie den bestehenden Gutschein oder verwenden Sie einen anderen Code.",
        "Test": "Test",
        "Rabatt (Code: {code})": "Rabatt (Code: {code})",
        "Dieser Code ist ein Produktgutschein und kann hier nicht eingelöst werden.": "Dieser Code ist ein Produktgutschein und kann hier nicht eingelöst werden.",
        "Gutscheincode ist noch nicht gültig.": "Gutscheincode ist noch nicht gültig.",
        "Gutscheincode wurde bereits verwendet.": "Gutscheincode wurde bereits verwendet.",
        "Gutscheincode ist abgelaufen.": "Gutscheincode ist abgelaufen.",
        "Produktgutschein bearbeiten": "Produktgutschein bearbeiten",
        "Optionen öffnen": "Optionen öffnen",
        "Deaktivieren": "Deaktivieren",
        "Absender:in": "Absender:in",
        "Speichern...": "Speichern...",
        "Gültig ab": "Gültig ab",
        "Ausstehend": "Ausstehend",
        "Bezeichnung": "Bezeichnung",
        "Prozent als ganze Zahl (z.B. 15 = 15%)": "Prozent als ganze Zahl (z.B. 15 = 15%)",
        "Betrag in Franken (z.B. 20 = CHF 20.-)": "Betrag in Franken (z.B. 20 = CHF 20.-)",
        "Firma (optional)": "Firma (optional)",
        "Um das Lernen persönlicher und praxisnäher zu gestalten, sprechen wir dich ab hier direkt in der Du-Form an. Schön, dass du dich für unseren Erste Hilfe Online Kurs entschieden hast! 😊": "Um das Lernen persönlicher und praxisnäher zu gestalten, sprechen wir dich ab hier direkt in der Du-Form an. Schön, dass du dich für unseren Erste Hilfe Online Kurs entschieden hast! 😊",
        "💌 Zusätzlich wirst du in den nächsten Tagen die gedruckten Gutscheine per Post erhalten.": "💌 Zusätzlich wirst du in den nächsten Tagen die gedruckten Gutscheine per Post erhalten.",
        "Dein Zugang zum eLearning ist jetzt freigeschaltet.": "Dein Zugang zum eLearning ist jetzt freigeschaltet.",
        "In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🧑‍🏫💡": "In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🧑‍🏫💡",
        "Einzellizenz (für eine:n Benutzer:in)": "Einzellizenz (für eine:n Benutzer:in)",
        "Gutschein für {name}": "Gutschein für {name}",
        "Gutschein": "Gutschein",
        "Dauer": "Dauer",
        "Zirka": "Zirka",
        "Ein Geschenk von": "Ein Geschenk von",
        "Gutscheincode": "Gutscheincode",
        "Geschenkgutschein deaktivieren?": "Geschenkgutschein deaktivieren?",
        "Möchtest du den Gutschein wirklich deaktivieren?": "Möchtest du den Gutschein wirklich deaktivieren?",
        "Gutschein deaktivieren": "Gutschein deaktivieren",
        "Rabattcode deaktivieren?": "Rabattcode deaktivieren",
        "Möchtest du den Rabattcode wirklich deaktivieren?": "Möchtest du den Rabattcode wirklich deaktivieren?",
        "Rabattcode deaktivieren": "Rabattcode deaktivieren",
        "Selbstnutzung": "Selbstnutzung",
        "Als Geschenk": "Als Geschenk",
        "Teilnahmebestätigung versendet am {date}": "Teilnahmebestätigung versendet am {date}",
        "Abschlussquiz bestanden am {date}": "Abschlussquiz bestanden am {date}",
        "Abschlussquiz zuletzt nicht bestanden am {date}": "Abschlussquiz zuletzt nicht bestanden am {date}",
        "Abschlussquiz noch offen": "Abschlussquiz noch offen",
        "Abschlussquiz im letzten eLearning bestanden am {date}": "Abschlussquiz im letzten eLearning bestanden am {date}",
        "Abschlussquiz im letzten eLearning zuletzt nicht bestanden am {date}": "Abschlussquiz im letzten eLearning zuletzt nicht bestanden am {date}",
        "Deaktivierte Gutscheine können nicht bearbeitet werden.": "Deaktivierte Gutscheine können nicht bearbeitet werden.",
        "Die E-Mail-Adresse ist bereits in diesem Login-Bereich vorhanden.": "Die E-Mail-Adresse ist bereits in diesem Login-Bereich vorhanden.",
        "Referenzierte Entität kann nicht gefunden werden.": "Referenzierte Entität kann nicht gefunden werden.",
        "Die Bestellung wurde archiviert.": "Die Bestellung wurde archiviert.",
        "Die Bestellung wurde wiederhergestellt.": "Die Bestellung wurde wiederhergestellt.",
        "Abschlussquiz im letzten eLearning noch offen": "Abschlussquiz im letzten eLearning noch offen",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung für die folgenden Personen nicht generiert werden:": "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung für die folgenden Personen nicht generiert werden:",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:",
        "Für einige Teilnehmer:innen, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Für einige Teilnehmer:innen, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:",
        "Kurszusammenfassung": "Kurszusammenfassung",
        "Lädt...": "Lädt...",
        "nicht ausgewählt": "nicht ausgewählt",
        "Ja": "Ja",
        "Nein": "Nein",
        "Versendet": "Versendet",
        "Tage vor Kursbeginn": "Tage vor Kursbeginn",
        "Tage": "Tage",
        "bei bestandenem eLearning-Abschlussquiz": "bei bestandenem eLearning-Abschlussquiz",
        "Beim Kurs Abschluss an Teilnehmer mit Status «teilgenommen» und hinterlegter E-Mail-Adresse.": "Beim Kurs Abschluss an Teilnehmer mit Status «teilgenommen» und hinterlegter E-Mail-Adresse.",
        "Im eLearning öffnen": "Im eLearning öffnen",
        "Schliessen": "Schliessen",
        "Fehler beim Laden der Zusammenfassung": "Fehler beim Laden der Zusammenfassung",
        "Rechnung in bexio öffnen": "Rechnung in bexio öffnen",
        "{attribute} is keine gültige Sprache.": "{attribute} is keine gültige Sprache.",
        "Feedbacks": "Feedbacks",
        "E-Learning / Online": "E-Learning / Online",
        "Zeitraum": "Zeitraum",
        "Als Excel herunterladen": "Als Excel herunterladen",
        "Bewertung": "Bewertung",
        "Antworten": "Antworten",
        "Teilnehmer:in": "Teilnehmer:in",
        "Keine Feedbacks für diese Freigabe.": "Keine Feedbacks für diese Freigabe.",
        "Der Kursstatus wurde aktualisiert.": "Der Kursstatus wurde aktualisiert.",
        "Der Status von {count} Kurs wurde aktualisiert.|Der Status von {count} Kursen wurde aktualisiert.": "Der Status von {count} Kurs wurde aktualisiert.|Der Status von {count} Kursen wurde aktualisiert.",
        "Mindestens einer der ausgewählten Kurse wurde nicht gefunden.": "Mindestens einer der ausgewählten Kurse wurde nicht gefunden.",
        "Statuswechsel ist nur möglich, wenn alle ausgewählten Kurse denselben Status haben.": "Statuswechsel ist nur möglich, wenn alle ausgewählten Kurse denselben Status haben.",
        "\"{course}\": {message}": "\"{course}\": {message}",
        "{count} Kurs ausgewählt|{count} Kurse ausgewählt": "{count} Kurs ausgewählt|{count} Kurse ausgewählt",
        "Statuswechsel nicht möglich, da die ausgewählten Kurse unterschiedliche Status haben.": "Statuswechsel nicht möglich, da die ausgewählten Kurse unterschiedliche Status haben.",
        "Auswahlmodus beenden": "Auswahlmodus beenden",
        "Auswahlmodus": "Auswahlmodus",
        "Möchtest du den Status von {count} Kurs wirklich ändern?|Möchtest du den Status von {count} Kursen wirklich ändern?": "Möchtest du den Status von {count} Kurs wirklich ändern?|Möchtest du den Status von {count} Kursen wirklich ändern?",
        "Alle Kurse in dieser Liste auswählen": "Alle Kurse in dieser Liste auswählen",
        "Kurstyp wurde erfolgreich erstellt.": "Kurstyp wurde erfolgreich erstellt.",
        "System-Kurstypen können nicht gelöscht werden.": "System-Kurstypen können nicht gelöscht werden.",
        "Der Kurstyp kann nicht gelöscht werden, da er bereits verwendet wird.": "Der Kurstyp kann nicht gelöscht werden, da er bereits verwendet wird.",
        "Kurstyp wurde erfolgreich gelöscht.": "Kurstyp wurde erfolgreich gelöscht.",
        "Der OAuth-Client wurde widerrufen.": "Der OAuth-Client wurde widerrufen.",
        "Anmeldungen sind für diesen Kurs nicht möglich (Status \"{status}\").": "Anmeldungen sind für diesen Kurs nicht möglich (Status \"{status}\").",
        "Der Kurs kann nicht von \"{from}\" auf \"{to}\" gesetzt werden.": "Der Kurs kann nicht von \"{from}\" auf \"{to}\" gesetzt werden.",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange Systemprüfungen fehlschlagen: {checks}": "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange Systemprüfungen fehlschlagen: {checks}",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange keine Termine definiert sind. E-Learning-Kurse sind hiervon ausgenommen.": "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange keine Termine definiert sind. E-Learning-Kurse sind hiervon ausgenommen.",
        "Bestanden": "Bestanden",
        "Fehlgeschlagen": "Fehlgeschlagen",
        "Übersprungen": "Übersprungen",
        "Tippen zum Suchen": "Tippen zum Suchen",
        "Keine Einträge gefunden.": "Keine Einträge gefunden.",
        "Keine Unternehmen gefunden.": "Keine Unternehmen gefunden.",
        "Keine Kunden gefunden.": "Keine Kunden gefunden.",
        "Kunde suchen…": "Kunde suchen…",
        "Dieser Kurs hat fehlgeschlagene Systemprüfungen!": "Dieser Kurs hat fehlgeschlagene Systemprüfungen!",
        "Kursstatus ändern": "Kursstatus ändern",
        "Angemeldet": "Angemeldet",
        "Teilgenommen": "Teilgenommen",
        "Entschuldigt abwesend": "Entschuldigt abwesend",
        "Unentschuldigt abwesend": "Unentschuldigt abwesend",
        "Abgemeldet: Teilnahme abgelehnt": "Abgemeldet: Teilnahme abgelehnt",
        "Abgemeldet: Vorzeitig storniert": "Abgemeldet: Vorzeitig storniert",
        "Abgemeldet: Entschuldigt": "Abgemeldet: Entschuldigt",
        "Abgemeldet: Unentschuldigt": "Abgemeldet: Unentschuldigt",
        "Warteliste": "Warteliste",
        "entschuldigt": "entschuldigt",
        "unentschuldigt": "unentschuldigt",
        "{firstName} {lastName} war {reason} abwesend weil: {note}": "{firstName} {lastName} war {reason} abwesend weil: {note}",
        "Produktgruppe ist aktiv": "Produktgruppe ist aktiv",
        "Produktgruppe ist nicht aktiv": "Produktgruppe ist nicht aktiv",
        "Kurstyp erstellen": "Kurstyp erstellen",
        "Systemprüfungen": "Systemprüfungen",
        "Zuletzt geprüft": "Zuletzt geprüft",
        "Noch keine Prüfungen durchgeführt.": "Noch keine Prüfungen durchgeführt.",
        "Wird geprüft...": "Wird geprüft...",
        "Jetzt prüfen": "Jetzt prüfen",
        "Keine Prüfungsergebnisse vorhanden. Klicke auf \"Jetzt prüfen\" um die Systemprüfungen auszuführen.": "Keine Prüfungsergebnisse vorhanden. Klicke auf \"Jetzt prüfen\" um die Systemprüfungen auszuführen.",
        "abhängig": "abhängig",
        "Hinweis: Für den Versand der Anmeldebestätigung ist in jeder Zeile der Datei eine gültige E-Mail-Adresse erforderlich.": "Hinweis: Für den Versand der Anmeldebestätigung ist in jeder Zeile der Datei eine gültige E-Mail-Adresse erforderlich.",
        "Im Anhang findest du die von dir importierte Datei.": "Im Anhang findest du die von dir importierte Datei.",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert und am Kurs angemeldet.": "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert und am Kurs angemeldet.",
        "Aargau": "Aargau",
        "Als Firma können Sie keine Lizenz einlösen.": "Als Firma können Sie keine Lizenz einlösen.",
        "Als Firma können Sie keine Lizenz einlösen. Sie können nur Geschenklizenzen kaufen.": "Als Firma können Sie keine Lizenz einlösen. Sie können nur Geschenklizenzen kaufen.",
        "Amt": "Amt",
        "Anmeldungen sind für diesen Kurs derzeit nicht möglich.": "Anmeldungen sind für diesen Kurs derzeit nicht möglich.",
        "Appenzell Ausserrhoden": "Appenzell Ausserrhoden",
        "Appenzell Innerrhoden": "Appenzell Innerrhoden",
        "Auswahl als Excel exportieren": "Auswahl als Excel exportieren",
        "Basel-Landschaft": "Basel-Landschaft",
        "Basel-Stadt": "Basel-Stadt",
        "Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten. Bitte versuche es später erneut.": "Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
        "Bern": "Bern",
        "Bezahlstatus": "Bezahlstatus",
        "Bezahlt": "Bezahlt",
        "Bis": "Bis",
        "Bitte geben Sie die Empfänger-Informationen für die Geschenklizenzen ein.": "Bitte geben Sie die Empfänger-Informationen für die Geschenklizenzen ein.",
        "Bitte melde dich an, um fortzufahren.": "Bitte melde dich an, um fortzufahren.",
        "Bitte wählen Sie aus, für wen die Lizenz(en) bestimmt sind.": "Bitte wählen Sie aus, für wen die Lizenz(en) bestimmt sind.",
        "Bitte wählen Sie eine Versandart aus.": "Bitte wählen Sie eine Versandart aus.",
        "Das Kapitel wurde gelöscht.": "Das Kapitel wurde gelöscht.",
        "Das Produkt für diesen Gutschein wurde nicht gefunden.": "Das Produkt für diesen Gutschein wurde nicht gefunden.",
        "Das Profil wurde erfolgreich aktualisiert.": "Das Profil wurde erfolgreich aktualisiert.",
        "Das Themengebiet wurde aktualisieren.": "Das Themengebiet wurde aktualisieren.",
        "Das Themengebiet wurde erstellt. 🎉": "Das Themengebiet wurde erstellt. 🎉",
        "Datei erfolgreich aktualisiert.": "Datei erfolgreich aktualisiert.",
        "Datei erfolgreich erstellt! 🎉": "Datei erfolgreich erstellt! 🎉",
        "Datei wurde gelöscht.": "Datei wurde gelöscht.",
        "Dein Zugang zum eLearning ist jetzt aktiviert. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Details und den direkten Kurszugang. Viel Erfolg beim Lernen! 🚑💡": "Dein Zugang zum eLearning ist jetzt aktiviert. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Details und den direkten Kurszugang. Viel Erfolg beim Lernen! 🚑💡",
        "Deine Online Kurse": "Deine Online Kurse",
        "Deine Sanio ID": "Deine Sanio ID",
        "Der Kurs wurde aktualisieren.": "Der Kurs wurde aktualisieren.",
        "Der Kurs wurde erstellt. 🎉": "Der Kurs wurde erstellt. 🎉",
        "Der Kurs wurde gelöscht.": "Der Kurs wurde gelöscht.",
        "Der Nachname ist erforderlich.": "Der Nachname ist erforderlich.",
        "Der Ort ist erforderlich.": "Der Ort ist erforderlich.",
        "Der Teilnehmer wurde vom Kurs entfernt!": "Der Teilnehmer wurde vom Kurs entfernt!",
        "Der Vorname ist erforderlich.": "Der Vorname ist erforderlich.",
        "Die Anmeldefrist ist leider abgelaufen.": "Die Anmeldefrist ist leider abgelaufen.",
        "Die Handynummer ist optional. Wenn Sie diese angeben, können Sie sich später auch per per SMS einloggen.": "Die Handynummer ist optional. Wenn Sie diese angeben, können Sie sich später auch per per SMS einloggen.",
        "Die Karte wurde gelöscht.": "Die Karte wurde gelöscht.",
        "Die PLZ ist erforderlich.": "Die PLZ ist erforderlich.",
        "Die Story wurde dupliziert.": "Die Story wurde dupliziert.",
        "Die Story wurde gelöscht.": "Die Story wurde gelöscht.",
        "Die Strasse ist erforderlich.": "Die Strasse ist erforderlich.",
        "Die Übersetzungen werden nun exportiert.": "Die Übersetzungen werden nun exportiert.",
        "Die Übersetzungen werden nun importiert.": "Die Übersetzungen werden nun importiert.",
        "Dieser Code ist kein Rabattcode, sondern schaltet dein eLearning direkt frei. Du kannst ihn jetzt sofort im Einlöse-Bereich nutzen - ohne erneutes Login oder weitere Schritte.": "Dieser Code ist kein Rabattcode, sondern schaltet dein eLearning direkt frei. Du kannst ihn jetzt sofort im Einlöse-Bereich nutzen - ohne erneutes Login oder weitere Schritte.",
        "Dieser Geschenkcode ist ungültig oder wurde bereits eingelöst.": "Dieser Geschenkcode ist ungültig oder wurde bereits eingelöst.",
        "Dieser Geschenkcode wurde bereits eingelöst.": "Dieser Geschenkcode wurde bereits eingelöst.",
        "Digital & physisch per Post": "Digital & physisch per Post",
        "Direktion": "Direktion",
        "Dokumente": "Dokumente",
        "Du hast keine Berechtigung, diesen Teilnehmer zu sehen.": "Du hast keine Berechtigung, diesen Teilnehmer zu sehen.",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist schon eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist schon eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.",
        "Du kannst diese:n Teilnehmer:in nicht mehr bearbeiten. Bitte wende dich an deine Ansprechperson bei Sanio.": "Du kannst diese:n Teilnehmer:in nicht mehr bearbeiten. Bitte wende dich an deine Ansprechperson bei Sanio.",
        "E-Learning-Kurs suchen…": "E-Learning-Kurs suchen…",
        "Empfänger ändern": "Empfänger ändern",
        "Filter zurücksetzen": "Filter zurücksetzen",
        "Filtern": "Filtern",
        "Freiburg": "Freiburg",
        "Funktion": "Funktion",
        "Geburtsdatum": "Geburtsdatum",
        "Geburtsdatum (TT.MM.JJJJ)": "Geburtsdatum (TT.MM.JJJJ)",
        "Genf": "Genf",
        "Geschenklizenz einlösen": "Geschenklizenz einlösen",
        "Glarus": "Glarus",
        "Graubünden": "Graubünden",
        "Gutschein gefunden!": "Gutschein gefunden!",
        "Gutschein jetzt einlösen": "Gutschein jetzt einlösen",
        "Gutscheine werden vorbereitet": "Gutscheine werden vorbereitet",
        "Hier dein persönlicher Zugang, um dich im shop.sanio einzuloggen:": "Hier dein persönlicher Zugang, um dich im shop.sanio einzuloggen:",
        "Instruktor:in": "Instruktor:in",
        "Jura": "Jura",
        "Kaufbeleg / Rechnung als PDF": "Kaufbeleg / Rechnung als PDF",
        "Keine Feedbacks für die aktuellen Filter.": "Keine Feedbacks für die aktuellen Filter.",
        "Klasse": "Klasse",
        "Klassenstufe": "Klassenstufe",
        "Kontext": "Kontext",
        "Kundenberater": "Kundenberater",
        "Kundenportal Gruppenadmin": "Kundenportal Gruppenadmin",
        "Kundenportal Superadmin": "Kundenportal Superadmin",
        "Kurs abgeschlossen, Prüfung ausstehend": "Kurs abgeschlossen, Prüfung ausstehend",
        "Kurs suchen…": "Kurs suchen…",
        "Kursfortschritt": "Kursfortschritt",
        "Kurszugang nicht gefunden.": "Kurszugang nicht gefunden.",
        "Luzern": "Luzern",
        "Mein Profil": "Mein Profil",
        "Meine Bestellungen": "Meine Bestellungen",
        "Melde dich mit deiner Handynummer oder E-Mail an und schon geht’s los!": "Melde dich mit deiner Handynummer oder E-Mail an und schon geht’s los!",
        "MidnightSports": "MidnightSports",
        "Mindestens ein Empfänger muss angegeben werden.": "Mindestens ein Empfänger muss angegeben werden.",
        "MiniMove": "MiniMove",
        "Name des Empfängers darf maximal 255 Zeichen lang sein.": "Name des Empfängers darf maximal 255 Zeichen lang sein.",
        "Name des Empfängers ist erforderlich.": "Name des Empfängers ist erforderlich.",
        "Name des Schenkers darf maximal 255 Zeichen lang sein.": "Name des Schenkers darf maximal 255 Zeichen lang sein.",
        "Name des Schenkers ist erforderlich.": "Name des Schenkers ist erforderlich.",
        "Neuenburg": "Neuenburg",
        "Nicht Bezahlt": "Nicht Bezahlt",
        "Nidwalden": "Nidwalden",
        "Obwalden": "Obwalden",
        "OpenSunday": "OpenSunday",
        "Prüfung bestanden": "Prüfung bestanden",
        "Sanio Kundenportal": "Sanio Kundenportal",
        "Schaffhausen": "Schaffhausen",
        "Schuleinheit": "Schuleinheit",
        "Schwyz": "Schwyz",
        "Shop Kunde ID": "Shop Kunde ID",
        "Solothurn": "Solothurn",
        "St. Gallen": "St. Gallen",
        "Standort": "Standort",
        "Standort/Fachbereich": "Standort/Fachbereich",
        "Store": "Store",
        "Super Admin": "Super Admin",
        "Teilnahmebestätigung als PDF": "Teilnahmebestätigung als PDF",
        "Teilnehmer": "Teilnehmer",
        "Teilnehmer nicht gefunden.": "Teilnehmer nicht gefunden.",
        "Teilnehmer:in konnte nicht hinzugefügt werden": "Teilnehmer:in konnte nicht hinzugefügt werden",
        "Teilnehmer:in wurde erfolgreich angemeldet.": "Teilnehmer:in wurde erfolgreich angemeldet.",
        "Teilnehmer:in wurde erfolgreich hinzugefügt": "Teilnehmer:in wurde erfolgreich hinzugefügt",
        "Tessin": "Tessin",
        "Thurgau": "Thurgau",
        "Ungültige Auswahl für Lizenzempfänger.": "Ungültige Auswahl für Lizenzempfänger.",
        "Ungültige Versandart ausgewählt.": "Ungültige Versandart ausgewählt.",
        "Uri": "Uri",
        "Von": "Von",
        "Waadt": "Waadt",
        "Wallis": "Wallis",
        "Zug": "Zug",
        "Zyklus": "Zyklus",
        "Zürich": "Zürich",
        "andere": "andere",
        "bearbeitungsbedürftig": "bearbeitungsbedürftig",
        "my.sanio Kunde": "my.sanio Kunde",
        "n/A": "n/A",
        "nicht übersetzt": "nicht übersetzt",
        "🤔 Es sind keine Kurse geplant": "🤔 Es sind keine Kurse geplant",
        "Die Kursinformationen wurden versendet.": "Die Kursinformationen wurden versendet.",
        "Änderungen zu deinem Kurs": "Änderungen zu deinem Kurs",
        "Kurszuteilung": "Kurszuteilung",
        "Du wurdest von einem Kurs entfernt": "Du wurdest von einem Kurs entfernt",
        "Der Kurs muss bereit sein.": "Der Kurs muss bereit sein.",
        "Diese Person ist keine Kursleitung.": "Diese Person ist keine Kursleitung.",
        "Diese Kursleitung ist keinem Termin dieses Kurses zugeteilt.": "Diese Kursleitung ist keinem Termin dieses Kurses zugeteilt.",
        "Der Kurs ist bereits vorbei und kann nicht auf \"Bereit\" gesetzt werden. Der Kurs würde innert wenigen Augenblicken auf \"Durchgeführt\" gestellt werden.": "Der Kurs ist bereits vorbei und kann nicht auf \"Bereit\" gesetzt werden. Der Kurs würde innert wenigen Augenblicken auf \"Durchgeführt\" gestellt werden.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange Anwesenheiten fehlen.": "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange Anwesenheiten fehlen.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange anwesende Teilnehmende das E-Learning nicht bestanden haben.": "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange anwesende Teilnehmende das E-Learning nicht bestanden haben.",
        "Kurstyp": "Kurstyp",
        "Datum/Zeit": "Datum/Zeit",
        "Kontaktperson": "Kontaktperson",
        "Kontaktaufnahme": "Kontaktaufnahme",
        "Infos zu Kontaktaufnahme": "Infos zu Kontaktaufnahme",
        "Beschreibung Kursleitung": "Beschreibung Kursleitung",
        "Präsentation": "Präsentation",
        "Präsentieren": "Präsentieren",
        "Kurspräsentation": "Kurspräsentation",
        "Weitere Links": "Weitere Links",
        "Auswahl entfernen: {option}": "Auswahl entfernen: {option}",
        "Keine Optionen gefunden": "Keine Optionen gefunden",
        "Abgelehnt am": "Abgelehnt am",
        "Bestätigt am": "Bestätigt am",
        "Mail versendet, Bestätigung offen": "Mail versendet, Bestätigung offen",
        "Kursort": "Kursort",
        "Modus": "Modus",
        "Typ & Dauer": "Typ & Dauer",
        "Kursleitung": "Kursleitung",
        "Belegung": "Belegung",
        "Materialset": "Materialset",
        "Fehlende Kursleitung": "Fehlende Kursleitung",
        "Initialer Mailversand offen": "Initialer Mailversand offen",
        "Nicht versendete Kursleitungs-Infos vorhanden": "Nicht versendete Kursleitungs-Infos vorhanden",
        "Kontaktperson für Kursleitung": "Kontaktperson für Kursleitung",
        "Infos offen": "Infos offen",
        "Infos veraltet": "Infos veraltet",
        "Kursleitungs-Infos senden": "Kursleitungs-Infos senden",
        "Springer": "Springer",
        "Springereinsatz": "Springereinsatz",
        "Änderungen zu deinem Springereinsatz": "Änderungen zu deinem Springereinsatz",
        "Springer auswählen": "Springer auswählen",
        "Springer-Infos senden": "Springer-Infos senden",
        "Springer bestätigt": "Springer bestätigt",
        "Springer noch nicht bestätigt": "Springer noch nicht bestätigt",
        "Vielen Dank, dass du dich als Springer:in für diesen Kurs zur Verfügung stellst! 🙌": "Vielen Dank, dass du dich als Springer:in für diesen Kurs zur Verfügung stellst! 🙌",
        "Falls die regulär eingeteilte Kursleitung kurzfristig ausfällt, würden wir dich gerne einsetzen.": "Falls die regulär eingeteilte Kursleitung kurzfristig ausfällt, würden wir dich gerne einsetzen.",
        "Aktuell musst du nichts unternehmen.": "Aktuell musst du nichts unternehmen.",
        "Bitte halte dir den Termin frei und stelle sicher, dass du kurzfristig erreichbar bist. Sollte ein Einsatz nötig werden, melden wir uns so früh wie möglich bei dir.": "Bitte halte dir den Termin frei und stelle sicher, dass du kurzfristig erreichbar bist. Sollte ein Einsatz nötig werden, melden wir uns so früh wie möglich bei dir.",
        "Weitere Informationen zum Kurs findest du": "Weitere Informationen zum Kurs findest du",
        "Bitte beachte die aktualisierten Kursinformationen.": "Bitte beachte die aktualisierten Kursinformationen.",
        "Diese Person hat die initialen Kursinformationen noch nicht erhalten.": "Diese Person hat die initialen Kursinformationen noch nicht erhalten.",
        "Diese Person hat noch nicht alle aktuellen Kursinformationen erhalten.": "Diese Person hat noch nicht alle aktuellen Kursinformationen erhalten.",
        "Diese Kursleitung hat die initialen Kursinformationen noch nicht erhalten.": "Diese Kursleitung hat die initialen Kursinformationen noch nicht erhalten.",
        "Diese Kursleitung hat noch nicht alle aktuellen Kursinformationen erhalten.": "Diese Kursleitung hat noch nicht alle aktuellen Kursinformationen erhalten.",
        "Zu versendende Änderungen": "Zu versendende Änderungen",
        "Alt": "Alt",
        "Neu": "Neu",
        "Senden": "Senden",
        "Automatischer Versand bei Abschluss ist in den E-Mail-Einstellungen deaktiviert.": "Automatischer Versand bei Abschluss ist in den E-Mail-Einstellungen deaktiviert.",
        "Abwesend": "Abwesend",
        "Abwesenheit erfassen": "Abwesenheit erfassen",
        "Wie war {name} abwesend?": "Wie war {name} abwesend?",
        "Notiz (optional)": "Notiz (optional)",
        "Grund der Abwesenheit": "Grund der Abwesenheit",
        "Wird eine Notiz erfasst, wird automatisch ein Kommentar zum Kurs hinzugefügt.": "Wird eine Notiz erfasst, wird automatisch ein Kommentar zum Kurs hinzugefügt.",
        "Abschliessen": "Abschliessen",
        "Es gab Änderungen zu deinem zugeteilten Kurs:": "Es gab Änderungen zu deinem zugeteilten Kurs:",
        "Folgende Informationen wurden aktualisiert:": "Folgende Informationen wurden aktualisiert:",
        "Bitte prüfe die aktuellen Kursdetails und bestätige uns, dass du den Kurs weiterhin leiten kannst.": "Bitte prüfe die aktuellen Kursdetails und bestätige uns, dass du den Kurs weiterhin leiten kannst.",
        "Kursinfos prüfen und bestätigen": "Kursinfos prüfen und bestätigen",
        "Kurszuteilung bestätigen": "Kurszuteilung bestätigen",
        "Du wurdest von folgendem Kurs entfernt.": "Du wurdest von folgendem Kurs entfernt.",
        "Kurssprache:": "Kurssprache:",
        "Kurs-ID:": "Kurs-ID:",
        "Die Absage für deinen Kalender findest du im Anhang. Weitere Informationen zum Kurs findest du": "Die Absage für deinen Kalender findest du im Anhang. Weitere Informationen zum Kurs findest du",
        "Du wurdest folgendem Kurs zugeteilt 🎉": "Du wurdest folgendem Kurs zugeteilt 🎉",
        "Bitte 30 Minuten vor Kursstart am Kursort eintreffen. Prüfe die Kursinformationen und bestätige uns, dass du den Kurs leiten kannst.": "Bitte 30 Minuten vor Kursstart am Kursort eintreffen. Prüfe die Kursinformationen und bestätige uns, dass du den Kurs leiten kannst.",
        "Die Kalenderdatei findest du im Anhang.": "Die Kalenderdatei findest du im Anhang.",
        "Termin {n}": "Termin {n}",
        "Termin {n} entfernen": "Termin {n} entfernen",
        "eine Kursleiter:in": "eine Kursleiter:in",
        "{count} Kursleiter:innen": "{count} Kursleiter:innen",
        "eine Springer:in": "eine Springer:in",
        "{count} Springer:innen": "{count} Springer:innen",
        "{count} ohne Materialset": "{count} ohne Materialset",
        "Zeit und Personal festlegen": "Zeit und Personal festlegen",
        "Materialset fehlt": "Materialset fehlt",
        "Pro Termin Kursleiter:innen und optional Springer festlegen. Materialset und Abholhinweis werden pro Kursleiter:in zugewiesen.": "Pro Termin Kursleiter:innen und optional Springer festlegen. Materialset und Abholhinweis werden pro Kursleiter:in zugewiesen.",
        "Noch keine Termine": "Noch keine Termine",
        "Füge den ersten Kurstermin hinzu.": "Füge den ersten Kurstermin hinzu.",
        "Termin hinzufügen": "Termin hinzufügen",
        "Kursleiter:innen": "Kursleiter:innen",
        "Noch keine Kursleiter:in zugewiesen.": "Noch keine Kursleiter:in zugewiesen.",
        "Abholhinweis": "Abholhinweis",
        "Aktionen": "Aktionen",
        "fehlt": "fehlt",
        "Kursleiter:in bearbeiten": "Kursleiter:in bearbeiten",
        "Kursleiter:in entfernen": "Kursleiter:in entfernen",
        "Als Kursleiter:in übernehmen": "Als Kursleiter:in übernehmen",
        "Kursleiter:in zuweisen": "Kursleiter:in zuweisen",
        "Kursleiter:in": "Kursleiter:in",
        "Kursleiter:in auswählen": "Kursleiter:in auswählen",
        "Materialset auswählen": "Materialset auswählen",
        "optional": "optional",
        "z. B. Lager West, Schlüssel bei Empfang": "z. B. Lager West, Schlüssel bei Empfang",
        "Zuweisen": "Zuweisen",
        "Bitte eine Kursleiter:in auswählen.": "Bitte eine Kursleiter:in auswählen.",
        "Bitte Kurszuteilung bestätigen": "Bitte Kurszuteilung bestätigen",
        "Springer:in auswählen": "Springer:in auswählen",
        "Springer:in bearbeiten": "Springer:in bearbeiten",
        "Springer:in zuweisen": "Springer:in zuweisen",
        "Entwurf": "Entwurf",
        "Angefragt": "Angefragt",
        "Zuteilung bestätigt": "Zuteilung bestätigt",
        "Zuteilung abgelehnt": "Zuteilung abgelehnt",
        "Zuteilung bestätigen": "Zuteilung bestätigen",
        "Zuteilung ablehnen": "Zuteilung ablehnen",
        "Du hast diese Kurszuteilung abgelehnt.": "Du hast diese Kurszuteilung abgelehnt.",
        "Speichern & weitere Person hinzufügen": "Speichern & weitere Person hinzufügen",
        "Alle {count} Teilnehmer:innen anzeigen": "Alle {count} Teilnehmer:innen anzeigen",
        "{shown} von {total}": "{shown} von {total}",
        "Weitere Treffer werden geladen…": "Weitere Treffer werden geladen…",
        "Nachfassen": "Nachfassen",
        "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.": "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.",
        "Aktuell können nur Teilnehmende hinzugefügt oder entfernt werden. Andere Kursdetails können nicht bearbeitet werden.": "Aktuell können nur Teilnehmende hinzugefügt oder entfernt werden. Andere Kursdetails können nicht bearbeitet werden.",
        "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.": "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.",
        "Folien am Griff ziehen, um ihre Reihenfolge zu ändern.": "Folien am Griff ziehen, um ihre Reihenfolge zu ändern.",
        "{count} Folien ausgewählt": "{count} Folien ausgewählt",
        "Alle {count} Folien auswählen": "Alle {count} Folien auswählen",
        "Alle Folien sind ausgewählt": "Alle Folien sind ausgewählt",
        "Auswahl aufheben": "Auswahl aufheben",
        "Folie verschieben": "Folie verschieben",
        "Folie auswählen": "Folie auswählen",
        "Folie {position} auswählen": "Folie {position} auswählen",
        "Kursleiter:innen-Notiz vorhanden": "Kursleiter:innen-Notiz vorhanden",
        "Keine Notizen": "Keine Notizen",
        "Folien löschen": "Folien löschen",
        "Möchtest du die {count} ausgewählten Folien wirklich löschen?": "Möchtest du die {count} ausgewählten Folien wirklich löschen?",
        "Folienbibliothek": "Folienbibliothek",
        "Folien, Sprachversionen und Tags verwalten": "Folien, Sprachversionen und Tags verwalten",
        "Foliensatz importieren": "Foliensatz importieren",
        "Noch keine Folien importiert.": "Noch keine Folien importiert.",
        "Importiere einen Foliensatz, um deine Folienbibliothek aufzubauen.": "Importiere einen Foliensatz, um deine Folienbibliothek aufzubauen.",
        "Folien werden importiert…": "Folien werden importiert…",
        "Folienbibliothek-Einstellungen": "Folienbibliothek-Einstellungen",
        "Kurspräsentation aus Folienbibliothek": "Kurspräsentation aus Folienbibliothek",
        "Der Foliensatz wird importiert.": "Der Foliensatz wird importiert.",
        "Der Upload ist fehlgeschlagen.": "Der Upload ist fehlgeschlagen.",
        "Der Upload ist unvollständig. Bitte erneut versuchen.": "Der Upload ist unvollständig. Bitte erneut versuchen.",
        "Die Datei muss eine PDF-Datei sein.": "Die Datei muss eine PDF-Datei sein.",
        "Einzelne Folien müssen genau eine PDF-Seite enthalten.": "Einzelne Folien müssen genau eine PDF-Seite enthalten.",
        "Diese PDF-Datei kann nicht gelesen werden. Exportiere sie bitte erneut als PDF 1.4.": "Diese PDF-Datei kann nicht gelesen werden. Exportiere sie bitte erneut als PDF 1.4.",
        "Folientitel": "Folientitel",
        "Foliensätze": "Foliensätze",
        "Folienbibliotheken nach Kurstyp verwalten": "Folienbibliotheken nach Kurstyp verwalten",
        "Foliensatz hinzufügen": "Foliensatz hinzufügen",
        "Noch keine Foliensätze vorhanden.": "Noch keine Foliensätze vorhanden.",
        "Foliensatz: Folien, Sprachversionen und Tags verwalten": "Foliensatz: Folien, Sprachversionen und Tags verwalten",
        "Alle Foliensätze": "Alle Foliensätze",
        "Foliensatz": "Foliensatz",
        "Verwendung": "Verwendung",
        "Kurse, die Folien aus diesem Foliensatz verwenden": "Kurse, die Folien aus diesem Foliensatz verwenden",
        "Dieser Foliensatz wird in keinem Kurs verwendet.": "Dieser Foliensatz wird in keinem Kurs verwendet.",
        "Für diesen Kurstyp ist noch kein Foliensatz vorhanden.": "Für diesen Kurstyp ist noch kein Foliensatz vorhanden.",
        "Foliensatz erstellen": "Foliensatz erstellen",
        "Der Foliensatz wurde erstellt.": "Der Foliensatz wurde erstellt.",
        "Mindestens eine Folie gehört nicht zu diesem Foliensatz.": "Mindestens eine Folie gehört nicht zu diesem Foliensatz.",
        "Mindestens eine Folie gehört nicht zu dieser Präsentation.": "Mindestens eine Folie gehört nicht zu dieser Präsentation.",
        "Mindestens ein Tag gehört nicht zum Foliensatz dieses Kurstyps.": "Mindestens ein Tag gehört nicht zum Foliensatz dieses Kurstyps.",
        "Folienpakete": "Folienpakete",
        "Folienpaket": "Folienpaket",
        "Folienpakete für Kurstypen verwalten": "Folienpakete für Kurstypen verwalten",
        "Folienpaket hinzufügen": "Folienpaket hinzufügen",
        "Noch keine Folienpakete vorhanden.": "Noch keine Folienpakete vorhanden.",
        "Alle Folienpakete": "Alle Folienpakete",
        "Das Folienpaket wurde erstellt.": "Das Folienpaket wurde erstellt.",
        "Das Folienpaket wurde gelöscht.": "Das Folienpaket wurde gelöscht.",
        "Ohne Tag-Auswahl werden alle Folien einbezogen.": "Ohne Tag-Auswahl werden alle Folien einbezogen.",
        "Dieses Folienpaket enthält noch keine Folien.": "Dieses Folienpaket enthält noch keine Folien.",
        "Keine Folien passen zu den gewählten Tags.": "Keine Folien passen zu den gewählten Tags.",
        "Optional Tags und Sprachen auswählen. Ohne Tags werden alle Folien einbezogen. Die erzeugten PDFs sind unabhängige Kopien.": "Optional Tags und Sprachen auswählen. Ohne Tags werden alle Folien einbezogen. Die erzeugten PDFs sind unabhängige Kopien.",
        "Präsentation bearbeiten": "Präsentation bearbeiten",
        "Folienpaket löschen": "Folienpaket löschen",
        "Möchtest du das Folienpaket «{name}» wirklich löschen? Die Folien werden entfernt. Bereits erstellte Kurspräsentationen bleiben erhalten.": "Möchtest du das Folienpaket «{name}» wirklich löschen? Die Folien werden entfernt. Bereits erstellte Kurspräsentationen bleiben erhalten.",
        "Foliensatz umbenennen": "Foliensatz umbenennen",
        "Der Foliensatz wurde umbenannt.": "Der Foliensatz wurde umbenannt.",
        "Für diesen Kurstyp ist noch kein Folienpaket vorhanden.": "Für diesen Kurstyp ist noch kein Folienpaket vorhanden.",
        "Folienpaket erstellen": "Folienpaket erstellen",
        "Folienpaket wählen": "Folienpaket wählen",
        "Name und Datum einfügen": "Name und Datum einfügen",
        "Name auf der Folie": "Name auf der Folie",
        "Kurspräsentation entfernen": "Kurspräsentation entfernen",
        "Kurspräsentation wirklich entfernen?": "Kurspräsentation wirklich entfernen?",
        "Die Kurspräsentation wurde entfernt.": "Die Kurspräsentation wurde entfernt.",
        "Das Folienpaket gehört nicht zum Kurstyp dieses Kurses.": "Das Folienpaket gehört nicht zum Kurstyp dieses Kurses.",
        "Mindestens ein Tag gehört nicht zum gewählten Folienpaket.": "Mindestens ein Tag gehört nicht zum gewählten Folienpaket.",
        "Tags suchen oder neu erstellen…": "Tags suchen oder neu erstellen…",
        "„{name}“ erstellen": "„{name}“ erstellen",
        "{name} entfernen": "{name} entfernen",
        "Tag konnte nicht erstellt werden.": "Tag konnte nicht erstellt werden.",
        "Tag bearbeiten": "Tag bearbeiten",
        "Farbe": "Farbe",
        "Tag wurde aktualisiert.": "Tag wurde aktualisiert.",
        "Deutsch (Fallback)": "Deutsch (Fallback)",
        "Deutsch bestimmt die Anzahl Folien. Weitere Sprachen werden ab Seite 1 zugeordnet und dürfen weniger Seiten enthalten.": "Deutsch bestimmt die Anzahl Folien. Weitere Sprachen werden ab Seite 1 zugeordnet und dürfen weniger Seiten enthalten.",
        "PDF, maximal 350 MB pro Sprache. Der Import wird im Hintergrund verarbeitet.": "PDF, maximal 350 MB pro Sprache. Der Import wird im Hintergrund verarbeitet.",
        "Ersetzen": "Ersetzen",
        "Tags bearbeiten": "Tags bearbeiten",
        "Zum Bearbeiten klicken": "Zum Bearbeiten klicken",
        "Zurück zum Foliensatz": "Zurück zum Foliensatz",
        "Vorhanden": "Vorhanden",
        "Fehlt": "Fehlt",
        "PDF ersetzen": "PDF ersetzen",
        "PDF hinzufügen": "PDF hinzufügen",
        "Tags suchen…": "Tags suchen…",
        "{selected} von {total} passenden Folien ausgewählt": "{selected} von {total} passenden Folien ausgewählt",
        "Alle passenden Folien auswählen": "Alle passenden Folien auswählen",
        "Tags auswählen": "Tags auswählen",
        "Sprachen erzeugen": "Sprachen erzeugen",
        "{available}/{total} Folie verfügbar|{available}/{total} Folien verfügbar": "{available}/{total} Folie verfügbar|{available}/{total} Folien verfügbar",
        "Nicht alle gewählten Folien sind in jeder Sprache vorhanden.": "Nicht alle gewählten Folien sind in jeder Sprache vorhanden.",
        "{count} fehlend|{count} fehlend": "{count} fehlend|{count} fehlend",
        "Wird erstellt…": "Wird erstellt…",
        "Kurspräsentation erstellen": "Kurspräsentation erstellen",
        "Jetzt zu Presio senden": "Jetzt zu Presio senden",
        "Folie": "Folie",
        "Fehlende Übersetzungen": "Fehlende Übersetzungen",
        "Fehlende Folien überspringen": "Fehlende Folien überspringen",
        "Deutsche Folie verwenden": "Deutsche Folie verwenden",
        "Folienvorschau": "Folienvorschau",
        "{count} Folie wird für diese Sprache erzeugt.|{count} Folien werden für diese Sprache erzeugt.": "{count} Folie wird für diese Sprache erzeugt.|{count} Folien werden für diese Sprache erzeugt.",
        "Wähle Tags aus, um die passenden Folien zu sehen.": "Wähle Tags aus, um die passenden Folien zu sehen.",
        "Alle passenden Folien wurden entfernt.": "Alle passenden Folien wurden entfernt.",
        "Folie entfernen": "Folie entfernen",
        "Wird in dieser Sprache übersprungen": "Wird in dieser Sprache übersprungen",
        "Deutsch als Fallback": "Deutsch als Fallback",
        "Erstellt": "Erstellt",
        "{processed} von {total} Folie|{processed} von {total} Folien": "{processed} von {total} Folie|{processed} von {total} Folien",
        "Die Folien werden zusammengeführt.": "Die Folien werden zusammengeführt.",
        "Präsentation wird erstellt": "Präsentation wird erstellt",
        "Du kannst diese Seite verlassen, die Erstellung läuft im Hintergrund weiter.": "Du kannst diese Seite verlassen, die Erstellung läuft im Hintergrund weiter.",
        "Präsentation erstellt": "Präsentation erstellt",
        "Die PDFs stehen zum Herunterladen bereit.": "Die PDFs stehen zum Herunterladen bereit.",
        "Erstellung abgebrochen": "Erstellung abgebrochen",
        "Erstellung fehlgeschlagen": "Erstellung fehlgeschlagen",
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.": "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        "Zuletzt erstellte Version": "Zuletzt erstellte Version",
        "Die Erstellung wurde abgebrochen.": "Die Erstellung wurde abgebrochen.",
        "Mindestens eine ausgewählte Folie gehört nicht zur aktuellen Tag-Auswahl.": "Mindestens eine ausgewählte Folie gehört nicht zur aktuellen Tag-Auswahl.",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Präsentieren würde eine veraltete Version zeigen.": "Die aktuelle Kurspräsentation ist noch nicht in Presio. Präsentieren würde eine veraltete Version zeigen.",
        "FEHLT": "FEHLT",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Bitte bei Admin melden.": "Die aktuelle Kurspräsentation ist noch nicht in Presio. Bitte bei Admin melden.",
        "Der Versand an Presio ist fehlgeschlagen.": "Der Versand an Presio ist fehlgeschlagen.",
        "Die Präsentation wird gerade an Presio gesendet. Bitte versuche es in einem Moment erneut.": "Die Präsentation wird gerade an Presio gesendet. Bitte versuche es in einem Moment erneut.",
        "Die Kurspräsentation konnte nicht erstellt werden.": "Die Kurspräsentation konnte nicht erstellt werden.",
        "Die Kurspräsentation konnte nicht an Presio gesendet werden.": "Die Kurspräsentation konnte nicht an Presio gesendet werden.",
        "Die Kurspräsentation für {course} konnte nicht erstellt werden.": "Die Kurspräsentation für {course} konnte nicht erstellt werden.",
        "Die Kurspräsentation für {course} ({language}) konnte nicht an Presio gesendet werden.": "Die Kurspräsentation für {course} ({language}) konnte nicht an Presio gesendet werden.",
        "Kurs öffnen": "Kurs öffnen",
        "PDF herunterladen": "PDF herunterladen",
        "Kursleiter:innen-Notiz bearbeiten": "Kursleiter:innen-Notiz bearbeiten",
        "Diese Notiz wird der Kursleitung beim Präsentieren in Presio angezeigt.": "Diese Notiz wird der Kursleitung beim Präsentieren in Presio angezeigt.",
        "Notiz aus Folienbibliothek verwenden": "Notiz aus Folienbibliothek verwenden",
        "Kursspezifisch": "Kursspezifisch",
        "Mindestens eine Notiz gehört nicht zu den ausgewählten Folien.": "Mindestens eine Notiz gehört nicht zu den ausgewählten Folien.",
        "Die Präsentation konnte nicht gestartet werden. Bitte versuche es in einem Moment erneut.": "Die Präsentation konnte nicht gestartet werden. Bitte versuche es in einem Moment erneut.",
        "Die Präsentation wird an Presio gesendet.": "Die Präsentation wird an Presio gesendet.",
        "Wird an Presio gesendet…": "Wird an Presio gesendet…",
        "deine Zeit": "deine Zeit",
        "Nicht gesetzt": "Nicht gesetzt",
        "Dieses Produkt kann nicht bestellt werden.": "Dieses Produkt kann nicht bestellt werden.",
        "Dein Warenkorb ist leer.": "Dein Warenkorb ist leer.",
        "Dein Warenkorb enthält Produkte, die nicht mehr bestellt werden können. Bitte entferne sie.": "Dein Warenkorb enthält Produkte, die nicht mehr bestellt werden können. Bitte entferne sie.",
        "Der Status kann nicht von «{from}» auf «{to}» geändert werden.": "Der Status kann nicht von «{from}» auf «{to}» geändert werden.",
        "Stück": "Stück",
        "Abholung im Büro": "Abholung im Büro",
        "Versand": "Versand",
        "Verpackt": "Verpackt",
        "Erledigt": "Erledigt",
        "Das Produkt wurde bereits bestellt und kann nicht gelöscht werden. Deaktiviere es stattdessen.": "Das Produkt wurde bereits bestellt und kann nicht gelöscht werden. Deaktiviere es stattdessen.",
        "Die Kategorie enthält noch Produkte und kann nicht gelöscht werden.": "Die Kategorie enthält noch Produkte und kann nicht gelöscht werden.",
        "Die Kategorie wurde erstellt.": "Die Kategorie wurde erstellt.",
        "Die Kategorie wurde aktualisiert.": "Die Kategorie wurde aktualisiert.",
        "Die Kategorie wurde gelöscht.": "Die Kategorie wurde gelöscht.",
        "Der Status wurde auf «{status}» geändert.": "Der Status wurde auf «{status}» geändert.",
        "Das Produkt wurde erstellt.": "Das Produkt wurde erstellt.",
        "Das Produkt wurde aktualisiert.": "Das Produkt wurde aktualisiert.",
        "Das Produkt wurde gelöscht.": "Das Produkt wurde gelöscht.",
        "Das Produkt wurde in den Warenkorb gelegt.": "Das Produkt wurde in den Warenkorb gelegt.",
        "Der Warenkorb wurde aktualisiert.": "Der Warenkorb wurde aktualisiert.",
        "Das Produkt wurde aus dem Warenkorb entfernt.": "Das Produkt wurde aus dem Warenkorb entfernt.",
        "Vielen Dank! Deine Bestellung ist eingegangen.": "Vielen Dank! Deine Bestellung ist eingegangen.",
        "Warenkorb": "Warenkorb",
        "Shop": "Shop",
        "Weiter einkaufen": "Weiter einkaufen",
        "Material auswählen": "Material auswählen",
        "Dieses Produkt kann nicht mehr bestellt werden.": "Dieses Produkt kann nicht mehr bestellt werden.",
        "Entfernen": "Entfernen",
        "Zur Bestellung": "Zur Bestellung",
        "Bestellung abschliessen": "Bestellung abschliessen",
        "Zurück zum Warenkorb": "Zurück zum Warenkorb",
        "Lieferung": "Lieferung",
        "Details": "Details",
        "Benötigt bis": "Benötigt bis",
        "Bemerkung": "Bemerkung",
        "Deine Bestellung": "Deine Bestellung",
        "Bestellung absenden": "Bestellung absenden",
        "Material bestellen": "Material bestellen",
        "Wähle das Kursmaterial aus, das du für deine Kurse benötigst.": "Wähle das Kursmaterial aus, das du für deine Kurse benötigst.",
        "Aktuell kann kein Material bestellt werden.": "Aktuell kann kein Material bestellt werden.",
        "In den Warenkorb": "In den Warenkorb",
        "{quantity} im Warenkorb": "{quantity} im Warenkorb",
        "Menge verringern": "Menge verringern",
        "Menge erhöhen": "Menge erhöhen",
        "Entferne die nicht mehr bestellbaren Artikel, um fortzufahren.": "Entferne die nicht mehr bestellbaren Artikel, um fortzufahren.",
        "Storniert": "Storniert",
        "Storniert am": "Storniert am",
        "Stornieren": "Stornieren",
        "Bestellung stornieren": "Bestellung stornieren",
        "Möchtest du diese Bestellung wirklich stornieren?": "Möchtest du diese Bestellung wirklich stornieren?",
        "Deine Bestellung wurde storniert.": "Deine Bestellung wurde storniert.",
        "Diese Bestellung wurde am {date} storniert.": "Diese Bestellung wurde am {date} storniert.",
        "Diese Bestellung wird bereits bearbeitet und kann nicht mehr direkt storniert werden.": "Diese Bestellung wird bereits bearbeitet und kann nicht mehr direkt storniert werden.",
        "Begründung": "Begründung",
        "Stornierungsanfrage": "Stornierungsanfrage",
        "Stornierungsanfragen": "Stornierungsanfragen",
        "Stornierungsanfrage senden": "Stornierungsanfrage senden",
        "Stornierungsanfrage vom {date}": "Stornierungsanfrage vom {date}",
        "Stornierungsanfrage gesendet am {date}. Wir melden uns bei dir.": "Stornierungsanfrage gesendet am {date}. Wir melden uns bei dir.",
        "Stornierung angefragt": "Stornierung angefragt",
        "Stornierung bestätigen": "Stornierung bestätigen",
        "Anfrage ablehnen": "Anfrage ablehnen",
        "Abgelehnte Stornierungsanfrage": "Abgelehnte Stornierungsanfrage",
        "Deine Bestellung wird bereits bearbeitet. Bitte begründe, warum du sie stornieren möchtest.": "Deine Bestellung wird bereits bearbeitet. Bitte begründe, warum du sie stornieren möchtest.",
        "Deine Stornierungsanfrage wurde gesendet.": "Deine Stornierungsanfrage wurde gesendet.",
        "Deine Stornierungsanfrage wurde abgelehnt.": "Deine Stornierungsanfrage wurde abgelehnt.",
        "Die Stornierungsanfrage wurde abgelehnt.": "Die Stornierungsanfrage wurde abgelehnt.",
        "Für diese Bestellung kann keine Stornierungsanfrage gesendet werden.": "Für diese Bestellung kann keine Stornierungsanfrage gesendet werden.",
        "Für diese Bestellung gibt es keine offene Stornierungsanfrage.": "Für diese Bestellung gibt es keine offene Stornierungsanfrage.",
        "Zum Shop": "Zum Shop",
        "Du hast noch kein Material bestellt.": "Du hast noch kein Material bestellt.",
        "Bestellung {number}": "Bestellung {number}",
        "{count} Artikel": "{count} Artikel",
        "Artikel": "Artikel",
        "Bestellt am": "Bestellt am",
        "Kategorie erstellen": "Kategorie erstellen",
        "Kategorie bearbeiten": "Kategorie bearbeiten",
        "Interner Shop – Kategorien": "Interner Shop – Kategorien",
        "Kategorien": "Kategorien",
        "Materialbestellungen": "Materialbestellungen",
        "Als «{status}» markieren": "Als «{status}» markieren",
        "Produkt erstellen": "Produkt erstellen",
        "Interner Shop – Produkte": "Interner Shop – Produkte",
        "Kategorie": "Kategorie",
        "Einheit": "Einheit",
        "Wird im Shop neben der Menge angezeigt, zum Beispiel Stück.": "Wird im Shop neben der Menge angezeigt, zum Beispiel Stück.",
        "Aktiv (bestellbar)": "Aktiv (bestellbar)",
        "Bild": "Bild",
        "Das Feld {field} wird für die Teilnehmenden-Erkennung benötigt und kann nicht archiviert werden.": "Das Feld {field} wird für die Teilnehmenden-Erkennung benötigt und kann nicht archiviert werden.",
        "Übernimm zuerst die bestehende Feldkonfiguration, bevor du Felder hinzufügst.": "Übernimm zuerst die bestehende Feldkonfiguration, bevor du Felder hinzufügst.",
        "Für diesen Login-Bereich sind bereits Felder konfiguriert.": "Für diesen Login-Bereich sind bereits Felder konfiguriert.",
        "Die Reihenfolge enthält Felder, die nicht zu diesem Login-Bereich gehören.": "Die Reihenfolge enthält Felder, die nicht zu diesem Login-Bereich gehören.",
        "Bezeichnung (Deutsch)": "Bezeichnung (Deutsch)",
        "Feldtyp": "Feldtyp",
        "Import-Spalte": "Import-Spalte",
        "Option (Deutsch)": "Option (Deutsch)",
        "Öffentliche Anmeldung": "Öffentliche Anmeldung",
        "Persönliche Angaben": "Persönliche Angaben",
        "B2B-Portal": "B2B-Portal",
        "in.sanio": "in.sanio",
        "Import / Export": "Import / Export",
        "Übersichten": "Übersichten",
        "Kursdetail": "Kursdetail",
        "Text": "Text",
        "Mehrzeiliger Text": "Mehrzeiliger Text",
        "Auswahl": "Auswahl",
        "Das Feld {field} darf nicht in «{context}» verwendet werden.": "Das Feld {field} darf nicht in «{context}» verwendet werden.",
        "Eine Auswahl braucht mindestens eine aktive Option.": "Eine Auswahl braucht mindestens eine aktive Option.",
        "Die Import-Spalte {name} wird bereits von einem anderen Feld verwendet.": "Die Import-Spalte {name} wird bereits von einem anderen Feld verwendet.",
        "Feld wurde archiviert.": "Feld wurde archiviert.",
        "Feld wurde wiederhergestellt.": "Feld wurde wiederhergestellt.",
        "Einstellungen wurden gespeichert.": "Einstellungen wurden gespeichert.",
        "Reihenfolge wurde gespeichert.": "Reihenfolge wurde gespeichert.",
        "Die bestehende Feldkonfiguration wurde übernommen.": "Die bestehende Feldkonfiguration wurde übernommen.",
        "Feld wurde hinzugefügt.": "Feld wurde hinzugefügt.",
        "Feld wurde gespeichert.": "Feld wurde gespeichert.",
        "Der Schlüssel {key} ist bereits vergeben.": "Der Schlüssel {key} ist bereits vergeben.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten und muss mit einem Buchstaben beginnen.": "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten und muss mit einem Buchstaben beginnen.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten.": "Der Schlüssel darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten.",
        "Technischer Schlüssel": "Technischer Schlüssel",
        "Schlüssel": "Schlüssel",
        "Entschuldige, ich helfe nur Sanio-Mitarbeitenden mit einem passenden Benutzerkonto.": "Entschuldige, ich helfe nur Sanio-Mitarbeitenden mit einem passenden Benutzerkonto.",
        "Da ist leider etwas schiefgelaufen. Bitte versuche es später nochmals.": "Da ist leider etwas schiefgelaufen. Bitte versuche es später nochmals.",
        "Darf ich einen Cursor-Agent einen Bugfix-Pull-Request vorbereiten lassen?": "Darf ich einen Cursor-Agent einen Bugfix-Pull-Request vorbereiten lassen?",
        "Darf ich die Aktion {tool} ausführen?": "Darf ich die Aktion {tool} ausführen?",
        "Freigeben": "Freigeben",
        "Ablehnen": "Ablehnen",
        "Freigegeben von {name}.": "Freigegeben von {name}.",
        "Abgelehnt von {name}.": "Abgelehnt von {name}.",
        "Diese Freigabe ist nicht mehr gültig.": "Diese Freigabe ist nicht mehr gültig.",
        "Du darfst diese Aktion nicht freigeben.": "Du darfst diese Aktion nicht freigeben.",
        "{server} ist jetzt mit Henry verbunden.": "{server} ist jetzt mit Henry verbunden.",
        "Repository": "Repository",
        "Linear-Ticket": "Linear-Ticket",
        "Neue Datei hochladen": "Neue Datei hochladen",
        "oder per Drag & Drop hierher ziehen": "oder per Drag & Drop hierher ziehen",
        "Datei {current} von {total} wird hochgeladen…": "Datei {current} von {total} wird hochgeladen…",
        "Die Datei {name} hat einen ungültigen Dateityp.": "Die Datei {name} hat einen ungültigen Dateityp.",
        "Video-Folie hinzufügen": "Video-Folie hinzufügen",
        "YouTube-URL": "YouTube-URL",
        "Laser": "Laser",
        "Zeichnen": "Zeichnen",
        "Beamer": "Beamer",
        "Zuschauer-Link": "Zuschauer-Link",
        "Handy koppeln": "Handy koppeln",
        "Offline vorbereiten": "Offline vorbereiten",
        "Wird vorbereitet…": "Wird vorbereitet…",
        "Präsentation wird geladen…": "Präsentation wird geladen…",
        "Die Präsentation konnte nicht geladen werden.": "Die Präsentation konnte nicht geladen werden.",
        "Verbunden": "Verbunden",
        "Nur lokal verbunden": "Nur lokal verbunden",
        "Beendet": "Beendet",
        "Offline bereit": "Offline bereit",
        "Beamer öffnen": "Beamer öffnen",
        "Aktuelle Folie": "Aktuelle Folie",
        "Präsentationswerkzeuge": "Präsentationswerkzeuge",
        "Nächste Folie": "Nächste Folie",
        "Ende der Präsentation": "Ende der Präsentation",
        "Kleinere Schrift": "Kleinere Schrift",
        "Grössere Schrift": "Grössere Schrift",
        "Folien": "Folien",
        "Video pausieren": "Video pausieren",
        "Video abspielen": "Video abspielen",
        "Folie {number}": "Folie {number}",
        "Werkzeugleiste verschieben": "Werkzeugleiste verschieben",
        "Letzten Strich rückgängig machen": "Letzten Strich rückgängig machen",
        "Zeichnungen auf dieser Folie löschen": "Zeichnungen auf dieser Folie löschen",
        "Zeiger (kein Werkzeug)": "Zeiger (kein Werkzeug)",
        "Laserpointer": "Laserpointer",
        "Markieren": "Markieren",
        "Präsentation beenden?": "Präsentation beenden?",
        "Die Verbindung zu allen Zuschauern wird getrennt.": "Die Verbindung zu allen Zuschauern wird getrennt.",
        "Notizen zu dieser Folie hinzufügen…": "Notizen zu dieser Folie hinzufügen…",
        "Klicken, um die Notizen zu bearbeiten": "Klicken, um die Notizen zu bearbeiten",
        "Klicken, um Notizen hinzuzufügen.": "Klicken, um Notizen hinzuzufügen.",
        "Folien pro Sprache": "Folien pro Sprache",
        "{count} von {total} Folien in dieser Sprache": "{count} von {total} Folien in dieser Sprache",
        "Notizen vergrössern": "Notizen vergrössern",
        "Notizen verkleinern": "Notizen verkleinern",
        "Teilnehmende scannen den QR-Code, um die Folien live auf ihrem Gerät mitzuverfolgen.": "Teilnehmende scannen den QR-Code, um die Folien live auf ihrem Gerät mitzuverfolgen.",
        "Scanne den QR-Code mit deinem Handy, um die Präsentation damit zu steuern und deine Notizen zu sehen.": "Scanne den QR-Code mit deinem Handy, um die Präsentation damit zu steuern und deine Notizen zu sehen.",
        "Präsentation beenden": "Präsentation beenden",
        "Diese Präsentation ist beendet.": "Diese Präsentation ist beendet.",
        "Du bist abgemeldet": "Du bist abgemeldet",
        "Deine Sitzung ist abgelaufen. Melde dich erneut an.": "Deine Sitzung ist abgelaufen. Melde dich erneut an.",
        "Zur Anmeldung": "Zur Anmeldung",
        "Notizen": "Notizen",
        "Timer": "Timer",
        "Start": "Start",
        "Pause": "Pause",
        "Video": "Video",
        "Ton aus": "Ton aus",
        "Ton an": "Ton an",
        "Diese Folie ist in dieser Sprache nicht verfügbar.": "Diese Folie ist in dieser Sprache nicht verfügbar.",
        "Der YouTube-Link ist ungültig.": "Der YouTube-Link ist ungültig.",
        "Mindestens ein YouTube-Link ist erforderlich.": "Mindestens ein YouTube-Link ist erforderlich.",
        "Für diesen Kurs gibt es noch keine Präsentation.": "Für diesen Kurs gibt es noch keine Präsentation.",
        "Diese Folie gehört nicht zur Präsentation.": "Diese Folie gehört nicht zur Präsentation.",
        "Der Laserpunkt ist ungültig.": "Der Laserpunkt ist ungültig.",
        "Die Abspielposition ist ungültig.": "Die Abspielposition ist ungültig.",
        "Video-Folie wurde hinzugefügt.": "Video-Folie wurde hinzugefügt.",
        "Diese Notiz wird der Kursleitung beim Präsentieren angezeigt.": "Diese Notiz wird der Kursleitung beim Präsentieren angezeigt.",
        "messages": {
            "general": {
                "duration": {
                    "days": "ein Tag|{count} Tage",
                    "months": "ein Monat|{count} Monate",
                    "years": "ein Jahr|{count} Jahre"
                }
            },
            "feedback": {
                "moods": {
                    "positive": "Positiv",
                    "neutral": "Neutral",
                    "negative": "Negativ"
                }
            },
            "communication": {
                "notifications": {
                    "channel": {
                        "mail": "E-Mail",
                        "database": "Datenbank",
                        "twilio": "SMS",
                        "whatsapp": "WhatsApp"
                    },
                    "status": {
                        "sent": "Gesendet",
                        "sending": "Wird versendet...",
                        "skipped": "Übersprungen",
                        "failed": "Fehlgeschlagen"
                    }
                }
            },
            "elearning": {
                "online_course": {
                    "status": {
                        "in_progress": "In Arbeit",
                        "test": "In Prüfung",
                        "online": "Online",
                        "inactive": "Inaktiv",
                        "archived": "Archiviert"
                    },
                    "type": {
                        "customer": "Kunde",
                        "marketing": "Marketing",
                        "content_test": "Content Test",
                        "demo": "Demo",
                        "internal": "Intern"
                    }
                },
                "stories": {
                    "status": {
                        "draft": "In Arbeit",
                        "review": "Erfasst",
                        "in-review": "In Review",
                        "review-done": "Korrigiert",
                        "translation": "In Übersetzung",
                        "done": "Fertig"
                    },
                    "subject_focus_list": {
                        "adults": "Erwachsene",
                        "teenagers": "Jugendliche (10-15)",
                        "children": "Kinder (4-9)",
                        "babies": "Babys (0-3)"
                    }
                }
            },
            "shop": {
                "products": {
                    "type": {
                        "service": "Dienstleistung",
                        "goods": "Ware"
                    },
                    "status": {
                        "active": "Aktiv",
                        "inactive": "Inaktiv",
                        "archived": "Archiviert"
                    }
                },
                "orders": {
                    "status": {
                        "new": "Neu",
                        "pending": "Pendent",
                        "paid": "Bezahlt",
                        "shipped": "Versendet",
                        "completed": "Abgeschlossen"
                    }
                },
                "invoices": {
                    "status": {
                        "new": "Neu",
                        "paid": "Bezahlt",
                        "overpaid": "Überbezahlt",
                        "partially_paid": "Teilweise bezahlt",
                        "overdue": "Überfällig",
                        "cancelled": "Storniert",
                        "refunded": "Rückerstattet",
                        "partially_refunded": "Teilweise rückerstattet"
                    }
                },
                "vouchers": {
                    "status": {
                        "pending": "Ausstehend",
                        "active": "Aktiv",
                        "used": "Verwendet",
                        "expired": "Abgelaufen",
                        "inactive": "Inaktiv"
                    }
                },
                "payments": {
                    "status": {
                        "pending": "Ausstehend",
                        "paid": "Bezahlt",
                        "failed": "Fehlgeschlagen",
                        "refunded": "Rückerstattet",
                        "partially-refunded": "Teilweise rückerstattet",
                        "refund-pending": "Rückerstattung ausstehend"
                    }
                }
            },
            "course_overview": {
                "modes": {
                    "presence": "Präsenz Kurse",
                    "elearning": "eLearning",
                    "blended-learning": "Blended Learning"
                },
                "groups": {
                    "past_unclosed": "Vergangene und noch nicht abgeschlossen",
                    "running": "Aktuell laufende Kurse",
                    "starting_this_week": "Startet in den nächsten 7 Tagen",
                    "future": "Zukünftige Kurse"
                },
                "collapse_group": "Gruppe einklappen",
                "expand_group": "Gruppe ausklappen"
            },
            "course_management": {
                "status": {
                    "draft": "Entwurf",
                    "ready": "Bereit",
                    "to_be_moved": "Wird verschoben",
                    "running": "Findet statt",
                    "conducted": "Durchgeführt",
                    "completed": "Abgeschlossen",
                    "cancelled": "Abgesagt",
                    "archived": "Archiviert",
                    "follow_up": "Nachfassen"
                },
                "transition_actions": {
                    "reset_to_draft": "Auf Entwurf zurücksetzen",
                    "reopen": "Kurs wieder öffnen",
                    "not_ready": "Nicht mehr bereit",
                    "mark_ready": "Kurs bereit",
                    "mark_to_be_moved": "Kurs verschieben",
                    "complete": "Kurs abschliessen",
                    "cancel": "Kurs absagen",
                    "archive": "Kurs archivieren",
                    "follow_up": "Nachfassen",
                    "revert_completion": "Abschluss rückgängig machen"
                },
                "transition_confirmations": {
                    "reset_to_draft": "Möchtest du den Kurs zurück auf \"Entwurf\" setzen? Anmeldungen sind danach nicht mehr möglich.",
                    "complete": "Möchtest du den Kurs abschliessen? Dies löst den Versand der Kursbestätigungen aus, sofern E-Mail-Adresse bei den Teilnehmenden hinterlegt sind.",
                    "cancel": "Möchtest du den Kurs wirklich absagen?",
                    "archive": "Möchtest du den Kurs archivieren?",
                    "follow_up": "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.",
                    "reopen": "Möchtest du den abgesagten Kurs wieder öffnen?",
                    "revert_completion": "Möchtest du den Abschluss rückgängig machen? Der Kurs wird zurück auf \"Durchgeführt\" gesetzt. Bereits versendete Bestätigungen und Zertifikate werden bei einem erneuten Abschluss nicht nochmals verschickt."
                },
                "transition_warnings": {
                    "follow_up_restrictions": "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.",
                    "blended_pending_elearning": "Beim Abschluss erhalten nur anwesende Teilnehmende, die das eLearning bereits bestanden haben, eine Kursbestätigung. Die übrigen anwesenden Teilnehmenden erhalten ihre Kursbestätigung automatisch, sobald sie das eLearning bestehen.",
                    "no_confirmations_both": "Es werden beim Abschluss KEINE Kursbestätigungen versendet, da der Generator für Teilnahmebestätigungen und die Einstellung «Kursbestätigungen bei Abschluss automatisch versenden» deaktiviert sind. Aktiviere beide in den Kurseinstellungen, wenn die Teilnehmenden eine Bestätigung erhalten sollen.",
                    "no_confirmations_certificate_generator": "Es werden beim Abschluss KEINE Kursbestätigungen versendet, da der Generator für Teilnahmebestätigungen deaktiviert ist. Aktiviere ihn in den Kurseinstellungen, wenn die Teilnehmenden eine Bestätigung erhalten sollen.",
                    "no_confirmations_mail_setting": "Es werden beim Abschluss KEINE Kursbestätigungen versendet, da die Einstellung «Kursbestätigungen bei Abschluss automatisch versenden» in den E-Mail-Einstellungen deaktiviert ist. Aktiviere sie, wenn die Teilnehmenden eine Bestätigung erhalten sollen."
                }
            }
        }
    },
    "en": {
        "Anmelden": "Log in",
        "E-Mail": "Email",
        "Passwort": "Password",
        "Passwort vergessen?": "Forgot your password?",
        "Eine Woche lang angemeldet bleiben": "Stay signed in for a week",
        "Wie schön, du wurdest beschenkt! Löse deinen Code ein und erfahre, was für dich bereitsteht.": "How lovely, you have been gifted! Redeem your code here and discover what awaits you.",
        "Code eingeben und persönlichen Zugang aktivieren": "Enter your code and activate personal access",
        "Code eingeben": "Enter code",
        "Einlösen": "Redeem",
        "Code entfernen": "Remove code",
        "Benötigst du Hilfe?": "Need help?",
        "Wir helfen dir gerne per E-Mail oder Telefon.": "We're happy to help by email or phone.",
        "Deine Lizenz": "Your license",
        "Bitte gib deinen Geschenkcode ein.": "Please enter your gift code.",
        "Dieser Geschenkcode konnte nicht gefunden werden.": "We couldn't find this gift code.",
        "Etwas ist schiefgelaufen. Bitte versuche es erneut.": "Something went wrong. Please try again.",
        "Code gültig für {product}": "Code valid for {product}",
        "Für {name}": "For {name}",
        "Willkommen bei": "Welcome to",
        "Passwort zurücksetzen": "Reset password",
        "Zurück zur Anmeldung": "Return to sign in",
        "Zurück zum Kurs": "Back to course",
        "Fenster auf den Beamer ziehen und die Anzeige auf Erweitert stellen.": "Drag the window onto the projector and set the display to Extend.",
        "Vollbild": "Fullscreen",
        "Vollbild beenden": "Exit fullscreen",
        "Radierer": "Eraser",
        "Rückgängig": "Undo",
        "Leeren": "Clear",
        "Zuschauer-QR": "Audience QR",
        "QR ausblenden": "Hide QR",
        "Weisse Seite": "Blank page",
        "Sprache wählbar": "Language can be chosen",
        "Präsentation anpassen": "Adjust presentation",
        "Die Präsentation wird gerade erstellt oder vorgeführt.": "The presentation is being created or is currently running.",
        "Die Kurspräsentation wird neu erstellt.": "The course presentation is being created again.",
        "Die Vorlage wurde gespeichert.": "The template was saved.",
        "Die Vorlage wurde gelöscht.": "The template was deleted.",
        "Vorlage laden": "Load template",
        "Vorlage speichern": "Save template",
        "Vorlage löschen": "Delete template",
        "Name der Vorlage": "Template name",
        "Link anfordern": "Request link",
        "zurück": "back",
        "Liste exportieren": "Export list",
        "Anmeldungen": "Registrations",
        "Abmeldungen": "Cancellations",
        "Vorname": "First name",
        "Nachname": "Last name",
        "Kurssprache": "Course language",
        "Beschreibung": "Description",
        "Link ist aktiv": "Link is active",
        "Kurs freigeben": "Share course",
        "Es existieren keine Daten.": "No existing data.",
        "Willkommen": "Welcome",
        "Teilnehmende": "Participants",
        "Sortieren nach": "Sort by",
        "Datum": "Date",
        "Adresse": "Address",
        "Plätze frei": "Remaining slots",
        "ausgebucht": "fully booked",
        "Weitere Person anmelden": "Register additional person",
        "An-/Abmeldung": "Registration/cancellation",
        "Ja, ich nehme teil": "Yes, I will participate",
        "Nein, ich bin verhindert": "No, I'm unable to attend",
        "allgemeinen Geschäftsbedingungen": "Terms and Conditions",
        "Datenschutzerklärung": "Privacy policy",
        "Absenden": "Send",
        "Fragen oder Probleme?": "Questions or problems?",
        "Hallo": "Hello",
        "Anmeldebestätigung": "Registration Confirmation",
        "Erste Hilfe Kurs": "First Aid Course",
        "Vielen Dank für deine Anmeldung zum Erste Hilfe Kurs. Hier nochmals die wichtigsten Infos": "Thank you for your registration for the First Aid Course. Here are the most important details again",
        "Liebe Grüsse": "Best regards",
        "Dein Sanio-Team": "Your Sanio Team",
        "Copyright": "Copyright",
        "Umbuchungsbestätigung": "Booking confirmation",
        "Terminerinnerung": "Appointment reminder",
        "Zurück zum Login": "Back to login",
        "Passwort bestätigen": "Confirm password",
        "Deutsch": "German",
        "Französisch": "French",
        "Italienisch": "Italian",
        "Englisch": "English",
        "Spanisch": "Spanish",
        "Portugiesisch": "Portuguese",
        "Kurse": "Courses",
        "Impersonation beenden": "Stop impersonation",
        "Du bist als diese Person angemeldet.": "You are signed in as this person.",
        "Zur Teilnehmer:in": "Open participant",
        "Zum Shop-Kunden": "Open shop customer",
        "INSURANCE_FLAT": "Administration fee",
        "lessons": "Driving lessons",
        "Teachers": "Driving instructors",
        "In Kurs verschieben": "Change course",
        "Abbrechen": "Cancel",
        "Applikation autorisieren": "Authorize application",
        "{name} autorisieren": "Authorize {name}",
        "Diese Applikation möchte auf deinen MCP-Server zugreifen.": "This application is requesting access to your MCP server.",
        "Angemeldet als": "Logged in as",
        "Berechtigungen": "Permissions",
        "Autorisieren": "Authorize",
        "Autorisieren...": "Authorizing...",
        "Du wirst zu {name} zurückgeleitet, sobald du autorisiert hast.": "You will be redirected back to {name} once you authorize.",
        "Abmelden": "Log out",
        "absences": "Absences",
        "All": "All",
        "app": "Theory app",
        "certificates.not-yet-known": "Not yet known",
        "certificates.sanio": "Confirmation of participation Sanio",
        "certificates.src": "SRC certificate",
        "comments": "Comments",
        "course_documents": "Course documents",
        "course_manuals": "Course instructions",
        "Die Datei {fileName} wurde {statusHint} importiert.": "The file {fileName} was imported {statusHint}.",
        "employment": "Employment",
        "erfolgreich": "Successful",
        "exams": "Examinations",
        "Fehlermeldung": "Error message",
        "Folgende Zeilen konnten aufgrund ungültiger (<span class=\"text-red\">rot markiert</span>) Daten nicht importiert werden:": "The following lines could not be imported due to invalid (<span class=\"text-red\">marked in red</span>) data:",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert.": "The following lines were nevertheless imported due to unclear assignment.",
        "Handynummer": "Cell phone number",
        "Instructors": "Course Instructors",
        "insurance": "Insurance",
        "Kontaktdaten": "Contact details",
        "Kontaktaufnahme: In Abklärung": "Contact: Pending clarification",
        "Kontaktaufnahme erforderlich": "Contact required",
        "Keine Kontaktaufnahme erforderlich": "No contact required",
        "Noch offen": "Pending",
        "locations": "Locations",
        "Mitarbeitende": "Employees",
        "Spalte": "Column",
        "students": "Pupils",
        "Teilnehmerübersicht öffnen": "Open participant overview",
        "teilweise": "Partly",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "The {attribute} has already appeared in a data leak. Please choose another {attribute}.",
        "The {attribute} must contain at least one letter.": "{attribute} must consist of at least one character.",
        "The {attribute} must contain at least one number.": "{attribute} must consist of at least one number.",
        "The {attribute} must contain at least one symbol.": "{attribute} must consist of at least one special character.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "{attribute} must consist of at least one uppercase and one lowercase letter.",
        "vku": "VKU courses",
        "voice_status_end": "Finished",
        "voice_status_missed": "Missed",
        "voice_status_out-of-office": "Out-of-Office",
        "voice_status_queue": "Queue",
        "voice_status_start": "Start",
        "voice_status_taken": "in conversation",
        "voice_status_voicemail": "Voice message",
        "Zeile": "Line",
        "Ähnliche TN": "Similar TN",
        "Email": "Email",
        "voice_status_initiated": "Welcome",
        "Dashboard": "Dashboard",
        "Mehr anzeigen": "Show more",
        "Gesamten Text anzeigen": "Show all text",
        "Weniger anzeigen": "Show less",
        "{participantName} in Kurs {courseName} verschieben?": "Move {participantName} to course {courseName}?",
        "Zum Kurs": "To the course",
        "Umbuchungsbestätigung senden": "Send rebooking confirmation",
        "Es wird keine Umbuchungsbestätigung gesendet, da der Kurs beendet ist.": "No change confirmation will be sent because the course has ended.",
        "Zurück": "Back",
        "Verschieben": "Move",
        "Willkommen {name} 👋": "Welcome {name} 👋",
        "Kursübersicht": "Course overview",
        "In welchen Kurs soll {participantName} verschoben werden?": "Which course should {participantName} be moved to?",
        "Diese Anmeldemaske wurde deaktiviert.": "This login screen has been deactivated.",
        "errors.4xx.title": "Unexpected error",
        "errors.4xx.head": "Oops...",
        "errors.5xx.head": "Ou ou...",
        "errors.4xx.hint": "An error has occurred. Your request could not be processed. Please check your entries or try again later. The error has been reported to us.",
        "errors.5xx.title": "Internal server error",
        "errors.5xx.hint": "An unexpected error has occurred. Go back to the home page or try again later. The error has been reported to us.",
        "errors.401.title": "Access denied",
        "errors.401.head": "Oops…",
        "errors.401.hint": "You are not authorized to access this page. Please log in and try again.",
        "errors.403.title": "Access denied",
        "errors.403.head": "Oops…",
        "errors.403.hint": "Access denied. You do not have permission to visit this page. Please contact us if you believe this is an error.",
        "errors.404.title": "Page not found",
        "errors.404.head": "Oops...",
        "errors.404.hint": "The page you have called up does not exist. Go back or click on the button to return to the start page.",
        "errors.500.title": "Internal server error",
        "errors.500.head": "Ou ou...",
        "errors.500.hint": "An unexpected error has occurred. Go back to the home page or try again later. The error has been reported to us.",
        "errors.503.title": "Maintenance mode",
        "errors.503.head": "One moment please...",
        "errors.503.hint": "We are currently performing maintenance to make improvements and fix bugs for a better user experience. Please try again shortly. Thank you for your understanding.",
        "errors.503.hint2": "In urgent cases, you can reach us by e-mail at <a href=\"mailto:contact@sanio.ch\">contact@sanio.ch</a> or by telephone at <a href=\"tel:+41315212409\">031 521 24 09</a>.",
        "errors.504.title": "Timeout",
        "errors.504.head": "Timeout…",
        "errors.504.hint": "The request took too long. Please try again later. The error has been reported to us.",
        "errors.back-to-start": "To the homepage",
        "{attribute} is keine gültige Sprache.": "{attribute} is not a valid language.",
        "Fehler beim Laden der Kurse": "Error loading the courses",
        "oder": "or",
        "Zum Kalender hinzufügen": "Add to calendar",
        "Der Code ist ungültig.": "The code is invalid.",
        "Du wurdest in den Kurs «{courseName}» umgebucht.": "You have been rebooked into the course \"{courseName}\".",
        "Hier die neuen Infos:": "Here is the new information:",
        "Wenn du Fragen hast, melde dich bitte direkt bei {name} unter:": "If you have any questions, please contact {name} directly:",
        "Kursort:": "Course location:",
        "Kursdaten": "Course dates",
        "Bald ist es soweit und der Kurs «{courseName}» findet statt.": "Soon the time will come and the course \"{courseName}\" will take place.",
        "Hier nochmals die wichtigsten Infos:": "Here is the most important information again:",
        "Du wurdest erfolgreich am Kurs «{courseName}» angemeldet 🎉": "You have been successfully enrolled on the course \"{courseName}\" 🎉",
        "Kurs-ID": "Course ID",
        "Es wurde keine E-Mail-Adresse oder Handynummer angegeben.": "No e-mail address or cell phone number was provided.",
        "Die E-Mail-Adresse ist ungültig.": "The e-mail address is invalid",
        "Die Handynummer ist ungültig.": "The cell phone number is invalid.",
        "Vielen Dank für deine Anmeldung zum Kurs. Hier nochmals die wichtigsten Infos:": "Thank you for your registration for the First Aid Course. Here are the most important details again:",
        "Text wurde in die Zwischenablage kopiert": "Text has been copied to the clipboard",
        "Text konnte nicht in die Zwischenablage kopiert werden": "Text could not be copied to the clipboard",
        "Der Katalog wurde erstellt.": "The catalog was created.",
        "Der Katalog wurde aktualisiert.": "The catalog has been updated.",
        "Der Katalog wurde entfernt.": "The catalog has been removed.",
        "Das Thema wurde erstellt.": "The topic was created.",
        "Das Thema wurde aktualisiert.": "The topic has been updated.",
        "Das Thema wurde entfernt.": "The topic has been removed.",
        "Der Kurs wurde dupliziert 🎉": "The course has been duplicated 🎉",
        "Kurs": "Course",
        "Story wurde erfolgreich kopiert 🎉": "Story was successfully copied 🎉",
        "Eine Variante|{count} Varianten": "One variant|{count} Variants",
        "Für diesen Kunden steht der eLearning Bereich nicht zur Verfügung.": "The eLearning area is not available for this customer.",
        "Geschlecht": "Gender",
        "Männlich": "male",
        "Keinem Kurs zugeordnet": "Not assigned to a course",
        "Suchbegriff": "Search term",
        "Weiblich": "female",
        "Divers": "other",
        "Projektstandort": "Project location",
        "Wohnkanton": "Canton of residence",
        "Sanio Logo": "Sanio logo",
        "hier": "here",
        "Hier geht es zu unseren <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> und zu unserer <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>.": "Click here for our <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">general terms and conditions</a> and our <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">privacy policy</a>.",
        "Hallo {name} 👋": "Hello {name} 👋",
        "Hier sind nochmals die wichtigsten Details:": "Here are the most important details again:",
        "Teilnehmer:innen": "Participants",
        "Name": "Name",
        "Letzter Kurs": "Last course",
        "Nächster Kurs": "Next course",
        "Hinzufügen": "Add",
        "Exportieren": "Export",
        "Dein Sanio Team": "Your Sanio Team",
        "Alle": "All",
        "Falls du keine weiteren E-Mails von dieser Liste erhalten möchtest, kannst du dich <a href=\"{unsubscribeListUrl}\" target=\"_blank\">hier</a> abmelden.": "If you no longer wish to receive emails from this list, you can unsubscribe at <a href=\"{unsubscribeListUrl}\" target=\"_blank\">here</a>.",
        "Möchtest du gar keine Angebote mehr von uns erhalten? Dann kannst du dich <a href=\"{unsubscribeUrl}\" target=\"_blank\">hier</a> abmelden.": "Do you no longer wish to receive offers from us? Then you can unsubscribe at <a href=\"{unsubscribeUrl}\" target=\"_blank\">here</a>.",
        "Ungruppierte Kurse": "Ungrouped courses",
        "Es wurden mehrere Konten für diese Angaben gefunden. Bitte wähle den gewünschten Kunden aus.": "Several accounts were found for these credentials. Please select the desired customer.",
        "Anmeldebestätigung erneut zustellen": "Resend registration confirmation",
        "Einladung zum eLearning": "Invitation to eLearning",
        "Wir freuen uns, dir mitzuteilen, dass das eLearning für dich nun bereitsteht! Du kannst ab sofort mit dem Lernen beginnen. 🎉": "We are pleased to inform you that the eLearning is now available for you! You can start learning now. 🎉",
        "Bis zum <strong>{courseName}</strong> am <strong>{courseStart}</strong> in <strong>{coursePlace}</strong> musst du das eLearning unbedingt abgeschlossen haben. Es dient als Grundlage für den praktischen Kurs.": "You must complete the eLearning by the time of the <strong>{courseName}</strong> on <strong>{courseStart}</strong> at <strong>{coursePlace}</strong>. It serves as the foundation for the practical course.",
        "Du kannst das eLearning entweder in einem Durchgang oder in mehreren Etappen absolvieren.": "You can complete the eLearning either in one go or in several stages.",
        "Am Ende gibt es eine kurze Lernkontrolle. Daher lohnt es sich, die Inhalte aufmerksam durchzuarbeiten!": "There is a short learning check at the end. It is therefore worth working through the content carefully!",
        "Teilnehmer:in abmelden / aus Kurs entfernen": "Participant:in unsubscribe / remove from course",
        "Möchtest du den/die Teilnehmer:in wirklich vom Kurs abmelden / aus dem Kurs entfernen?": "Do you really want to deregister / remove the participant from the course?",
        "Abmelden / entfernen": "Log out / remove",
        "Willst du wirklich eine eLearning Einladung verschicken?": "Do you really want to send an eLearning invitation?",
        "Einladung verschicken": "Send invitation",
        "Willst du wirklich die Anmeldebestätigung erneut zustellen?": "Do you really want to resend the registration confirmation?",
        "Bestätigung erneut verschicken": "Send confirmation again",
        "Teilnehmer:in abmelden": "Unsubscribe Participant:in",
        "Bemerkungen": "Remarks",
        "Wert fehlt!": "missing value!",
        "{0} Es wurden keine Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.|{1} Es wurde ein:e Teilnehmer:in angelegt und {totalUpdated} aktualisiert.|[2,*] Es wurden {count} Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.": "{0} No participants were created and {totalUpdated} was updated.|{1} One participant was created and {totalUpdated} was updated.|[2,*] {count} participants were created and {totalUpdated} was updated.",
        "Gruppe bearbeiten": "Edit group",
        "Neue:n Teilnehmer:in anmelden": "Register new participants",
        "Zu Kursgruppe hinzufügen": "Add course to group",
        "Neue Kursgruppe erstellen": "Create new course group",
        "Möchtest du den Kurs wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Do you really want to delete the course permanently? This action cannot be undone.",
        "Möchtest du den Kurs wirklich archivieren? Der Kurs ist danach nicht mehr sichtbar, kann aber durch einen Admin wiederhergestellt werden.": "Do you really want to archive the course? The course is then no longer visible, but can be restored by an admin.",
        "Freigabelink löschen": "Delete share link",
        "Möchtest du den Freigabelink wirklich löschen?": "Do you really want to delete the share link?",
        "Archivieren": "Archive",
        "Endgültig löschen": "Delete permanently",
        "Gruppe löschen": "Delete group",
        "Möchtest du diese Gruppe wirklich löschen?": "Do you really want to delete this group?",
        "Kurs aus Gruppe entfernen": "Remove course from group",
        "Kurs duplizieren": "Duplicate course",
        "Kurs archivieren": "Archive course",
        "Kurs löschen": "Delete course",
        "Der Link wurde in die Zwischenablage kopiert! 🎉": "The link has been copied to the clipboard! 🎉",
        "Der Freigabelink wurde gelöscht! 🎉": "The share link has been deleted! 🎉",
        "Link teilen": "Share link",
        "nimmt teil": "participates",
        "Ähnliche Teilnehmer:innen": "Similar participants",
        "Ein unerwarteter Fehler ist aufgetreten": "An unexpected error has occurred",
        "Bereits in diesem Kurs vorhanden": "Already available in this course",
        "Es wurden keine ähnlichen Teilnehmer:innen gefunden.": "No similar participants were found.",
        "Fülle das Formular aus und die Suche wird gestartet.": "Fill out the form to start the search.",
        "Suche ähnliche Teilnehmer:innen...": "Looking for similar participants...",
        "eLearning nicht gefunden": "eLearning not found",
        "Wie hat dir das eLearning allgemein gefallen?": "How did you like the eLearning in general?",
        "🤩 Sehr gut!": "🤩 Very good!",
        "😊 Gut": "😊 Good",
        "😐 Ok": "😐 Ok",
        "😕 Nicht so gut": "😕 Not so good",
        "😩 Schlecht": "😩 Bad",
        "Bitte wähle eine Antwort aus.": "Please select an answer.",
        "Wie verständlich waren für dich die Lerninhalte?": "How comprehensible was the learning content for you?",
        "🤩 Sehr verständlich!": "🤩 Very understandable!",
        "😊 Verständlich": "😊 Understandable",
        "😕 Nicht so verständlich": "😕 Not so understandable",
        "😩 Gar nicht verständlich": "😩 Not understandable at all",
        "🤩 Sehr einfach!": "🤩 Very simple!",
        "😊 einfach": "😊 simple",
        "😐 Nicht so einfach": "😐 Not that simple",
        "😕 Schwierig": "😕 Difficult",
        "😩 Sehr schwierig": "😩 Very difficult",
        "Wie beurteilst du die Benutzerfreundlichkeit des eLearnings?": "How would you rate the user-friendliness of eLearning?",
        "🤩 Super einfache Bedienung!": "🤩 Super simple operation!",
        "😊 Einfach zu bedienen": "😊 Easy to operate",
        "😐 Teilweise etwas mühsam": "😐 Sometimes a bit tedious",
        "😩 Richtig mühsame Bedienung": "😩 Really tedious operation",
        "Wie schwierig war für dich die Lernkontrolle am Ende?": "How difficult was the learning check at the end for you?",
        "Warum war die Lernkontrolle für dich einfach?": "Why was the learning check easy for you?",
        "Überspringen": "Skip",
        "Warum war die Lernkontrolle für dich schwierig?": "Why was the learning check difficult for you?",
        "Wie können wir das eLearning verbessern? Was hat dir gefehlt?": "How can we improve eLearning? What did you miss?",
        "Würdest du das eLearning weiterempfehlen?": "Would you recommend eLearning to others?",
        "🤩 Ja klar!": "🤩 Yes, of course!",
        "😊 Ja, wahrscheinlich schon": "😊 Yes, probably",
        "😐 Weiss nicht recht": "😐 Don't really know",
        "😕 Eher nicht": "😕 Rather not",
        "😩 Nein, auf keinen Fall": "😩 No, definitely not",
        "Vielen Dank für deine Antworten!": "Thank you very much for your answers!",
        "Cool hast du dir die Zeit genommen!": "Cool that you took the time!",
        "Fehler beim Laden der Suchergebnisse": "Error loading the search results",
        "Speichern": "Save",
        "Jetzt mit dem eLearning starten": "Start eLearning now",
        "Zu Kurs zugeordnet": "Assigned to course",
        "Teilnehmer:innen {company}": "Participants {company}",
        "{firstname}, eLearning für den Kurs von {company} nicht vergessen!": "{firstname}, don't forget the eLearning for the course from {company}!",
        "Dein my.sanio Verifizierungscode": "Your my.sanio verification code",
        "Ich akzeptiere die {tos} und habe die {privacyPolicy} gelesen und verstanden.": "I accept the {tos} and have read and understood the {privacyPolicy}.",
        "AGB und Datenschutz müssen akzeptiert werden.": "The terms and conditions and the privacy policy must be accepted.",
        "Der Kurs ist leider bereits ausgebucht.": "The course is unfortunately already fully booked.",
        "🚫 Wir konnten dich leider nicht am Kurs anmelden.": "🚫 Unfortunately we were unable to register you for the course.",
        "Von:": "From:",
        "An:": "To:",
        "CC:": "CC:",
        "BCC:": "BCC:",
        "Antwort an:": "Reply to:",
        "Anhänge": "Attachments",
        "unbekannter Betreff": "unknown subject",
        "Status": "Status",
        "Kanal": "Channel",
        "Inhalt": "Contents",
        "Persönliche Daten": "Personal data",
        "Zukünftige Kurse": "Future courses",
        "{name} ist noch für keine Kurse angemeldet.": "{name} is not registered for any courses yet.",
        "Abgeschlossene Kurse": "Completed courses",
        "Handlung nötig": "Action required",
        "eLearning": "eLearning",
        "Fortschritt:": "Progress:",
        "Dauer:": "Duration:",
        "Kommunikation": "Communication",
        "Zeit": "Time",
        "Profil": "Profile",
        "Nicht dargestellte Kursdaten": "Not displayed course data",
        "Benutzerbild": "User image",
        "Meine Kurse": "My courses",
        "Dashboard Instruktor:innen": "Instructor dashboard",
        "Wenn wir für diese E-Mail Adresse ein Konto gefunden haben, erhältst du in Kürze eine E-Mail mit einem Link zum Einloggen (Bitte überprüfe auch deinen Spam-Ordner).": "If we found an account for this email address, you will receive an email shortly with a login link (Please also check your spam folder).",
        "Jetzt einloggen": "Log in now",
        "Link zum Einloggen": "Login link",
        "Teilnahme-Status erfolgreich aktualisiert.": "Participation status successfully updated.",
        "Team": "Team",
        "Anwesenheit": "Presence",
        "Anwesenheiten fehlen!": "Attendance records missing!",
        "Anwesenheiten vollständig": "Attendance complete",
        "Materialset fehlt!": "Material set missing!",
        "Materialset: {name}": "Material set: {name}",
        "Materialset zugewiesen": "Material set assigned",
        "Hinweis zu Materialset beachten": "Pay attention to material set note",
        "Nur für bereite Kurse relevant": "Only relevant for ready courses",
        "Nur für laufende oder durchgeführte Kurse relevant": "Only relevant for running or conducted courses",
        "Präsentation fehlt!": "Presentation missing!",
        "Präsentation vorhanden": "Presentation available",
        "Gemäss Kursleitung anwesend": "Present according to instructor",
        "Gemäss Kursleitung abwesend": "Absent according to instructor",
        "🧘 Du hast diese Woche keine Kurse.": "🧘 You have no courses this week.",
        "🌴 Du hast keine zukünftigen Kurse.": "🌴 You have no upcoming courses.",
        "😌 Du hast keine abgeschlossenen Kurse.": "😌 You have no completed courses.",
        "Diese Woche": "This week",
        "und": "and",
        "Geschäftsführerin Sanio AG": "CEO Sanio AG",
        "Zertifikat": "Certificate",
        "Teilnahmebestätigung": "Certificate of Course Completion",
        "Kursleitung:": "Instructed by:",
        "Dieses Zertifikat ist bis am {date} gültig.": "This certificate is valid until {date}.",
        "Eine Auffrischung der Erste Hilfe Grundlagen alle 2 Jahre wird empfohlen.": "A refresher course in first aid basics is recommended every 2 years.",
        "Download wird gestartet...": "Download is started...",
        "Download erfolgreich abgeschlossen.": "Download successfully completed.",
        "Download fehlgeschlagen.": "Download failed.",
        "Generiere Teilnahmebestätigungen...": "Generate confirmations of participation...",
        "Teilnahmebestätigungen wurden erfolgreich generiert und heruntergeladen.": "Confirmations of participation have been successfully generated and downloaded.",
        "Fehler beim Erstellen der Teilnahmebestätigungen.": "Error when creating the confirmation of participation.",
        "Generiere Teilnahmebestätigung...": "Generate confirmation of participation...",
        "Teilnahmebestätigung wurde erfolgreich generiert und heruntergeladen.": "Confirmation of participation was successfully generated and downloaded.",
        "Fehler beim Erstellen der Teilnahmebestätigung.": "Error when creating the confirmation of participation.",
        "Teilnehmerliste exportieren": "Export participant list",
        "Teilnahmebestätigungen als PDF": "Confirmation of participation as PDF",
        "Teilnahmebestätigungen als ZIP": "Confirmation of participation as ZIP",
        "wurde erstellt": "was created",
        "kommentierte": "commented",
        "Schreibe deinen Kommentar...": "Write your comment...",
        "Zurücksetzen": "Reset",
        "Kommentieren": "Comment",
        "Kommentar bearbeiten": "Edit comment",
        "Bearbeiten": "Edit",
        "Löschen": "Delete",
        "Aktivität": "Activity",
        "Teilnehmer:in hinzufügen": "Add participant",
        "Für die Kursteilnahme sind nur Vor- und Nachname erforderlich. Weitere Angaben sind freiwillig.": "Only first and last name are required for course participation. Further details are optional.",
        "Teilnehmer:in bereits im System?": "Participant already in the system?",
        "Passende Personen werden während der Eingabe automatisch hier angezeigt. Bitte übernimm bestehende Personen, anstatt sie neu anzulegen.": "Matching people are shown here automatically as you type. Please use existing people instead of creating them again.",
        "Teilnahmebestätigung herunterladen": "Download confirmation of participation",
        "Teilnehmer abgleichen": "Synchronize participants",
        "Dieses Objekt": "This object",
        "Der Kurs ist ausgebucht.": "The course is fully booked.",
        "abgeschlossen": "completed",
        "Der Kurs ist bereits beendet.": "The course has already ended.",
        "{availableSpots} Plätze frei": "{availableSpots} Seats free",
        "Es sind keine anderen Kurse verfügbar.": "There are no other courses available.",
        "Teilnehmer wurde in neuen Kurs verschoben.": "Participant was moved to a new course.",
        "Beendete Kurse können nicht mehr bearbeitet werden.": "Completed courses can no longer be edited.",
        "certificates.none": "No certificate",
        "Der Benutzer wurde erfolgreich erstellt.": "The user has been successfully created.",
        "Teilnehmer:in anzeigen": "Show participant",
        "Nachrichtenverlauf": "Message history",
        "Kurs erstellen": "Create course",
        "Kurstypen": "Course types",
        "Keine Daten gefunden.": "No data found.",
        "Kurstyp bearbeiten": "Edit course type",
        "Kurs bearbeiten": "Edit course",
        "Die Offerte wurde erstellt.": "The offer has been prepared.",
        "Das Angebot wurde aktualisiert.": "The offer has been updated.",
        "Das Angebot wurde entfernt.": "The offer has been removed.",
        "Teilnehmer erfolgreich gespeichert!": "Participant successfully saved!",
        "Teilnehmer wurde gelöscht!": "Participant has been deleted!",
        "Nachricht wurde erneut zugestellt 🎉": "Message has been delivered again 🎉",
        "Kursgruppe erfolgreich erstellt 🎉": "Course group successfully created 🎉",
        "Kursgruppe erfolgreich aktualisiert 🎉": "Course group successfully updated 🎉",
        "Kursgruppe wurde gelöscht!": "Course group has been deleted!",
        "Geteilter Link gelöscht!": "Shared link deleted!",
        "Teilnehmer wurde in den neuen Kurs verschoben.": "Participant was moved to the new course.",
        "Der Kurs wurde erfolgreich gelöscht!": "The course has been successfully deleted!",
        "Der Kurs wurde erfolgreich archiviert!": "The course has been successfully archived!",
        "Teilnehmer:in erfolgreich abgemeldet.": "Participant successfully deregistered.",
        "Der Benutzer wurde erfolgreich aktualisiert.": "The user has been successfully updated.",
        "Der Benutzer wurde erfolgreich gelöscht.": "The user has been successfully deleted.",
        "Die Weiterleitung wurde erstellt!": "The course has been successfully archived!",
        "Die Weiterleitung wurde aktualisiert!": "The forwarding has been updated!",
        "Die Weiterleitung wurde gelöscht!": "The forwarding has been deleted!",
        "Mail Statusinformationen wurden aktualisiert.": "Mail status information has been updated.",
        "Der Kontakt wurde aktualisiert.": "The contact has been updated.",
        "Kurse wurden der Gruppe hinzugefügt.": "Courses have been added to the group.",
        "Auswählen": "Select",
        "Kurs hat noch nicht begonnen.": "Course has not yet started.",
        "Kurs ist abgeschlossen.": "Course is completed.",
        "Kurs ist abgesagt.": "Course is cancelled.",
        "Kurs ist archiviert.": "Course is archived.",
        "HINWEIS:": "NOTE:",
        "Das Login wurde gelöscht! 🎉": "The login has been deleted! 🎉",
        "Der Kundenbereich wurde gespeichert! 🎉": "The customer area has been saved! 🎉",
        "Nachricht wurde verschickt 🎉": "Message has been sent 🎉",
        "Der Kurs wurde gespeichert": "The course has been saved",
        "Das Unternehmen wurde aktualisiert.": "The company has been updated.",
        "Das Unternehmen wurde gelöscht!": "The company has been deleted!",
        "Das Unternehmen kann nicht gelöscht werden, solange noch ein Kundenbereich existiert.": "The company cannot be deleted while a customer area still exists.",
        "Kurstyp wurde erfolgreich aktualisiert.": "Course type has been successfully updated.",
        "vollständig": "complete",
        "Der Import wurde gestartet und wird im Hintergrund ausgeführt.": "The import has been started and is running in the background.",
        "Möchtest du das Element wirklich löschen?": "Do you really want to delete the element?",
        "Das Login wurde erstellt! 🎉": "The login has been created! 🎉",
        "Der Kurs wurde gespeichert 🎉": "The course has been saved 🎉",
        "Das Unternehmen wurde erstellt.": "The company was created.",
        "Der Kontakt wurde entfernt.": "The contact has been removed.",
        "Der Kundenbereich wurde eröffnet! 🎉": "The customer area has been opened! 🎉",
        "Der Kommentar wurde gespeichert.": "The comment has been saved.",
        "Der Kommentar wurde aktualisiert.": "The comment has been updated.",
        "Der Kommentar wurde entfernt.": "The comment has been removed.",
        "Der Kontakt wurde erstellt.": "The contact was created.",
        "Link für gesamte Kursliste kopieren": "Copy link for complete course list",
        "Link für diese Kursgruppe kopieren": "Copy link for this course group",
        "Willkommen im": "Welcome to the",
        "Instruktor:innen Bereich": "Instructors area",
        "Der Login-Link ist ungültig oder abgelaufen.": "The login link is invalid or expired.",
        "weiter": "continue",
        "+{more} weitere": "+{more} more",
        "Telefonzeiten": "Telephone hours",
        "Montag bis Freitag": "Monday to Friday",
        "9.00 bis 12.00 Uhr": "9.00 to 12.00",
        "13.00 bis 16.00 Uhr": "13.00 to 16.00",
        "Notfallnummer (für Kurse)": "Emergency number (for courses)",
        "Link für diesen Kurs kopieren": "Copy link for this course",
        "Link für Anmeldung teilen": "Share link for registration",
        "🤔 Es sind keine Kurse geplant.": "🤔 No courses are planned.",
        "Suchen...": "Search...",
        "Gymnasium": "High school",
        "Vereine": "Clubs",
        "Sonstiges": "Miscellaneous",
        "Teilnahmebestätigung Erste Hilfe Kurs": "Confirmation of participation in first aid course",
        "Zertifikat BLS AED SRC Kurs": "BLS AED SRC course certificate",
        "Kursinstruktor:in": "Course instructor",
        "Management": "Management",
        "Büro": "Office",
        "Schule": "School",
        "Berufsschule": "Vocational school",
        "Kita": "Daycare center",
        "Betrieb": "Company",
        "Die Datei findest du im Anhang dieser E-Mail.": "You will find the file attached to this e-mail.",
        "Herzlichen Glückwunsch und weiterhin viel Erfolg!": "Congratulations and continued success!",
        "Wir freuen uns, dir dein Zertifikat für den <strong>{courseName}</strong> zu übermitteln.": "We are pleased to send you your certificate for the <strong>{courseName}</strong>.",
        "Wir freuen uns, dir deine Teilnahmebestätigung für den <strong>{courseName}</strong> zu übermitteln.": "We are pleased to send you your confirmation of participation for the <strong>{courseName}</strong>.",
        "Zertifikate werden nun generiert und an die Teilnehmer:innen verschickt 🎉": "Certificates are now generated and sent to the participants 🎉",
        "Zertifikat wird nun generiert und an den/die Teilnehmer:in verschickt 🎉": "Certificate is now generated and sent to the participant 🎉",
        "Teilnahmebestätigungen per Mail zustellen": "Send confirmation of participation by e-mail",
        "Möchtest du die Teilnahmebestätigungen an alle Teilnehmer:innen zustellen?": "Would you like to send the confirmation of participation to all participants?",
        "ACHTUNG:": "ATTENTION:",
        "Für einige Teilnehmer:innen, die Anspruch auf eine Teilnahmebestätigung haben, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "For some participants who are entitled to a confirmation of participation, no e-mail address is available. Therefore, the confirmation cannot be sent to the following persons by e-mail:",
        "Bestätigung zustellen": "Send confirmation",
        "Teilnahmebestätigung per Mail versenden": "Send confirmation of participation by e-mail",
        "Willst du wirklich die Teilnahmebestätigung per Mail versenden?": "Do you really want to send the confirmation of participation by e-mail?",
        "Sanio Kundenbereich": "Sanio customer area",
        "Du bekommst von uns einen Link per E-Mail zugesendet, um dein Passwort zurückzusetzen. Bitte gib deine E-Mail-Adresse ein, die du zum Login im Sanio Kundenportal verwendest.": "We will send you a link by e-mail to reset your password. Please enter the e-mail address you use to log in to the Sanio customer portal.",
        "Liebe Geschäftskund:innen, unser Portal für die Kursverwaltung hat einen neuen Namen. Das {portalName} erreicht ihr ab sofort unter {sanioPortalLink}.": "Dear business customers, our portal for course management has a new name. You can now reach the {portalName} at {sanioPortalLink}.",
        "Teilnahmebestätigungen herunterladen": "Download confirmations of participation",
        "Hier dein persönlicher Zugang, um dich im my.sanio einzuloggen:": "Here is your personal access to log in to my.sanio:",
        "Wichtige Hinweise:": "Important notes:",
        "Der Link kann nur einmal verwendet werden.": "The link can only be used once.",
        "Er ist zeitlich begrenzt gültig.": "It is valid for a limited period of time.",
        "Falls das Login nicht funktioniert, kannst du jederzeit einen neuen Link auf der <a href=\"{loginPageUrl}\">Anmeldeseite</a> anfordern.": "If the login does not work, you can request a new link on the <a href=\"{loginPageUrl}\">login page</a> at any time.",
        "Hier dein persönlicher Zugang, um dich im Sanio Kundenportal einzuloggen:": "Here is your personal access to log in to the Sanio customer portal:",
        "Hier dein persönlicher Zugang, um dich im Sanio Instruktor:innen Bereich einzuloggen:": "Here is your personal access to log in to the Sanio Instructor area:",
        "in Planung": "in planning",
        "Füge eine persönliche E-Mail-Adresse ein, damit der:die Teilnehmer:in alle kursbezogenen Mitteilungen (z. B. Anmeldebestätigung, Erinnerung, Teilnahmebestätigung) direkt per Mail erhält.": "Enter a personal e-mail address so that the participant receives all course-related messages (e.g. registration confirmation, reminder, confirmation of participation) directly by e-mail.",
        "vom <strong>{dateStart}</strong> bis <strong>{dateEnd}</strong>": "from <strong>{dateStart}</strong> to <strong>{dateEnd}</strong>",
        "am <strong>{date}</strong>": "on <strong>{date}</strong>",
        "am <strong>{dateStart}</strong> und <strong>{dateEnd}</strong>": "at <strong>{dateStart}</strong> and <strong>{dateEnd}</strong>",
        "Dein Verifizierungscode lautet: <strong>{code}</strong>": "Your verification code is: <strong>{code}</strong>",
        "Dein Sanio-Verifizierungscode": "Your Sanio verification code",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im Sanio Kundenportal mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "If a password is stored, the contact can log in to the Sanio customer portal with their e-mail and password. Otherwise, a login link will be sent.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im team.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "If a password is stored, the contact can log in to team.sanio with their e-mail and password. Otherwise a login link will be sent.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im my.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "If a password is stored, the contact can log in to my.sanio with their e-mail and password. Otherwise a login link will be sent.",
        "Allgemeine Informationen": "General information",
        "Rechte": "Permissions",
        "Rollen": "Roles",
        "Rollen auswählen": "Select roles",
        "Authentifizierung": "Authentication",
        "Passwort (optional)": "Password (optional)",
        "Wechseln": "Change",
        "Benutzeroberfläche": "User interface",
        "Sprache": "Language",
        "total": "total",
        "übersetzt": "translated",
        "ausstehend": "pending",
        "Übersetzungsstatistiken werden geladen": "Translation statistics are being loaded",
        "Übersetzungsstatistiken konnten nicht geladen werden.": "Translation statistics could not be loaded.",
        "Mögliche Gründe:": "Possible reasons:",
        "Die Story wurde noch nicht ins Weblate übertragen.": "The story has not yet been transferred to Weblate.",
        "Es gab ein technisches Problem.": "There was a technical problem.",
        "Übersetzungsstatistiken": "Translation statistics",
        "Du musst die AGB akzeptieren!": "You must accept the terms and conditions!",
        "Falls du Excel für den Import verwendest, achte darauf, dass Spalten wie z.B. das Geburtsdatum als Text formatiert sind.": "If you use Excel for the import, make sure that columns such as the date of birth are formatted as text.",
        "Du musst die AGB akzeptieren, um fortfahren zu können.": "You must accept the terms and conditions in order to continue.",
        "Bitte gib eine gültige Handynummer ein.": "Please enter a valid cell phone number.",
        "Es gibt bereits {count} ähnliche:n Teilnehmer:in. Schalte das Matching aus um den Teilnehmer trotzdem zu erstellen.": "There are already {count} similar participants. Switch off matching to create the participant anyway.",
        "Möchtest du die Variante wirklich duplizieren?": "Do you really want to duplicate the variant?",
        "Vielen Dank! Wir haben deine Angaben erhalten.": "Thank you very much! We have received your details.",
        "Deine Ansprechperson:": "Your contact person:",
        "Deine Ansprechpersonen:": "Your contact persons:",
        "Preis": "Price",
        "Produkt erfassen": "Enter product",
        "Produkt bearbeiten": "Edit product",
        "Produktstatus": "Product status",
        "Preis in CHF": "Price in CHF",
        "MwSt. in Prozent": "VAT in percent",
        "Produktmedien": "Product media",
        "Produktbild": "Product image",
        "Produkte": "Products",
        "Produkt wurde erstellt.": "Product was created.",
        "Produkt wurde aktualisiert.": "Product has been updated.",
        "Produktgruppen": "Product groups",
        "Produktgruppe erfassen": "Enter product group",
        "Produktgruppe bearbeiten": "Edit product group",
        "Es gibt noch keine Einträge.": "There are no entries yet.",
        "Medien": "Media",
        "Produktgruppenbild": "Product group picture",
        "Produktgruppe wurde erstellt.": "Product group was created.",
        "Produktgruppe wurde aktualisiert.": "Product group has been updated.",
        "Produktgruppe": "Product group",
        "Produkte werden im Hintergrund aktualisiert.": "Products are updated in the background.",
        "Jetzt aktualisieren": "Update now",
        "Die Produktdaten werden aus Bexio regelmässig importiert und mit den bestehenden abgeglichen.": "The product data is regularly imported from Bexio and compared with the existing data.",
        "Kürzel (Slug)": "Abbreviation (Slug)",
        "Produktart (Bexio)": "Product type (Bexio)",
        "Shop erfassen": "Enter store",
        "Shop wurde erstellt.": "Store was created.",
        "Shop wurde aktualisiert.": "Store has been updated.",
        "Shop wurde gelöscht.": "Store has been deleted.",
        "Shop bearbeiten": "Edit store",
        "Shops": "Stores",
        "Aktiv": "Active",
        "Produktgruppen auswählen": "Select product groups",
        "Titel": "Title",
        "Mit der Registrierung akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "By registering, I accept the {tos}. I have read and understood the {privacyPolicy}.",
        "Es muss eine gültige Handynummer angegeben werden.": "A valid cell phone number must be provided.",
        "inkl. {taxPercentage}% MwSt.": "incl. {taxPercentage}% VAT.",
        "Preis (inkl. {taxPercentage}% MwSt)": "Price (incl. {taxPercentage}% VAT)",
        "Bestelldatum: {orderDate}": "Order date: {orderDate}",
        "Bestellnummer: {orderReference}": "Order number: {orderReference}",
        "Keine Teilnehmenden|ein:e Teilnehmer:in|{capacity} Teilnehmende": "No participants|one participant|{capacity} participants",
        "Kursmodi": "Course modes",
        "Die Anmeldefrist ist abgelaufen.": "The registration deadline has expired.",
        "Kunde": "Customer",
        "Termine": "Dates",
        "Kein Datum definiert": "No date defined",
        "Anmeldefrist abgelaufen": "Registration deadline expired",
        "Anmeldefrist:": "Registration deadline:",
        "Anmeldefrist": "Registration deadline",
        "Link": "Link",
        "eLearning öffnen": "Open eLearning",
        "Du hast dich erfolgreich für das Erste Hilfe eLearning von {customer} angemeldet! 🎉": "You have successfully registered for the First Aid eLearning from {customer}! 🎉",
        "Es steht dir nun zur Verfügung und du kannst ab sofort mit dem Lernen beginnen.": "It is now available to you, and you can start learning immediately.",
        "Starte jetzt dein Erste Hilfe eLearning! 🚀": "Start your First Aid eLearning now! 🚀",
        "Nachricht konnte nicht erneut zugestellt werden!": "Message could not be delivered again!",
        "Der Kommentar konnte nicht gespeichert werden.": "The comment could not be saved.",
        "{firstname}, dein Erste Hilfe eLearning von {company} wartet auf dich! ⏳": "{firstname}, your First Aid eLearning from {company} is waiting for you! ⏳",
        "{firstname}, starte jetzt dein Erste Hilfe eLearning! 🚀": "{firstname}, start your first aid eLearning now! 🚀",
        "Glückwunsch, {firstname}! Dein Erste Hilfe eLearning von {company} ist abgeschlossen 🎓": "Congratulations, {firstname}! Your first aid eLearning from {company} has been completed 🎓",
        "{firstname}, dein Zugang zum Erste Hilfe eLearning von {company} ist da!": "{firstname}, your access to the First Aid eLearning from {company} is here!",
        "Twint": "Twint",
        "Visa": "Visa",
        "MasterCard": "MasterCard",
        "PostFinance Pay": "PostFinance Pay",
        "Rechnung": "Invoice",
        "Vorkasse": "Prepayment",
        "Keine Zahlung erforderlich": "No payment required",
        "Möchtest du die Teilnahmebestätigungen herunterladen?": "Would you like to download the certificates of participation?",
        "Das eLearning dauert rund {onlineCourseDuration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "The eLearning takes around {onlineCourseDuration}. There is a short learning assessment at the end of the eLearning. It is therefore worthwhile not simply clicking through the theory!",
        "Du hast das Erste Hilfe eLearning von {customer} erfolgreich abgeschlossen – grossartig!": "You have successfully completed the First Aid eLearning from {customer} - great!",
        "Danke, dass du dich für Erste Hilfe weitergebildet hast. Bleib sicher!": "Thank you for your First Aid training. Stay safe!",
        "Wie waren die Aufgaben in den Notfällen für dich?": "How did you find the tasks in the emergencies?",
        "Viel Erfolg! 🚀": "Good luck! 🚀",
        "Es wird Zeit, mit dem eLearning zu beginnen! Bitte schliesse es bis zum Kursbeginn am <strong>{courseStart}</strong>, ab, da es die wichtige Grundlage für unseren Kurs bildet. Plane dafür etwa {duration} ein, damit du gut vorbereitet bist und das Beste aus dem Kurs mitnehmen kannst. Wir freuen uns auf dich!": "It's time to start your eLearning! Please complete it by the start of the course on <strong>{courseStart}</strong>, as it forms the important basis for our course. Allocate approximately {duration} for it, so you are well-prepared and can get the most out of the course. We look forward to seeing you!",
        "Du hast bereits {courseProgress}% vom Erste Hilfe eLearning geschafft – super! 🎉": "You have already completed {courseProgress}% of the First Aid eLearning - great! 🎉",
        "Bleib dran und lerne weiter, damit du den Kurs erfolgreich abschliessen kannst.": "Keep at it and keep learning so that you can successfully complete the course.",
        "Weiterlernen": "Continue learning",
        "Keine Kursleitung definiert": "No course instructor defined",
        "Wir freuen uns, dir deine Teilnahmebestätigung für diesen Onlinekurs zu übermitteln. Die Datei findest du im Anhang dieser E-Mail.": "We are pleased to send you your confirmation of participation for this online course. You will find the file attached to this e-mail.",
        "hat am <strong>{dateText}</strong> am {durationText} {courseTypeName} {guideline} teilgenommen.": "took part in <strong>{dateText}</strong> on {durationText} {courseTypeName} {guideline}.",
        "hat am <strong>{dateText}</strong> das {durationText} {courseTypeName} {guideline} erfolgreich abgeschlossen.": "has successfully completed the {durationText} {courseTypeName} {guideline} on <strong>{dateText}</strong>.",
        "{minutes}-minütige": "{minutes}-minute",
        "{hours}-stündige": "{hours}-hour",
        "{hours}-stündigen": "{hours}-hours",
        "Es wurden total:": "A total of:",
        "Teilnehmerliste importieren": "Import list of participants",
        "Teilnehmer:innen wurden {statusHint} aus Datei {fileName} in Kurs {course} importiert.": "Participants were imported {statusHint} from file {fileName} in course {course}.",
        "Sortierung": "Sorting",
        "Kategorie-Label": "Category label",
        "Die Teilnehmer:innen aus der Datei \"{fileName}\"\" wurden {statusHint} im Kurs {course} erfasst.": "The participants from the file \"{fileName}\"\" were entered {statusHint} in the course {course}.",
        "<strong>{count}</strong> neu angelegt": "<strong>{count}</strong> newly created",
        "<strong>{count}</strong> aktualisiert": "<strong>{count}</strong> updated",
        "<strong>{count}</strong> am Kurs angemeldet": "<strong>{count}</strong> registered for the course",
        "Die Teilnehmer:innen haben eine Anmeldebestätigung erhalten.": "The participants have received a registration confirmation.",
        "Folgende Zeilen konnten aufgrund ungültiger Daten (<span class=\"text-red\">rot markiert</span>) nicht importiert werden:": "The following rows could not be imported due to invalid data (<span class=\"text-red\">marked in red</span>):",
        "Der Kurs ist nicht verfügbar.": "The course is not available.",
        "Dieser Kurs ist noch nicht bereit für Anmeldungen!": "This course is not yet ready for registrations!",
        "Abteilung": "Department",
        "Stationäre Wohngruppen": "Residential Living Groups",
        "Betriebe": "Businesses",
        "Bildung": "Education",
        "Andere": "Other",
        "Die Anmeldebestätigungen werden an die Teilnehmer:innen verschickt 🎉": "The registration confirmations are being sent to the participants 🎉",
        "Anmeldebestätigungen verschicken": "Send registration confirmations",
        "Anmeldebestätigungen per Mail zustellen": "Deliver registration confirmations by email",
        "Bestätigungen zustellen": "Deliver confirmations",
        "ACHTUNG": "ATTENTION",
        "Verifizierungscode eingeben": "Enter verification code",
        "Wir haben einen 6-stelligen Code an {maskedIdentifier} geschickt.": "We have sent a 6-digit code to {maskedIdentifier}.",
        "Keinen Code erhalten?": "Didn't receive a code?",
        "Erneut senden": "Resend",
        "E-Mail konnte nicht korrekt zugestellt werden": "The email could not be delivered",
        "Bestätigen": "Confirm",
        "Bestellung: {id}": "Order: {id}",
        "Bezahlstatus: {status}": "Payment status: {status}",
        "Wenn wir nicht wissen, wer du bist, kann es sein, dass wir dich nach deiner <strong>Sanio ID</strong> fragen. Du findest diese hier:": "If we don't know who you are, we may ask you for your <strong>Sanio ID</strong>. You can find it here:",
        "Mit dem Kauf akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "By purchasing, I accept the {tos}. I have read and understood the {privacyPolicy}.",
        "Lade weitere Kurse": "Load more courses",
        "Keine weiteren Kurse gefunden.": "No further courses found.",
        "Kurs suchen": "Search course",
        "Kein Kurs ausgewählt": "No course selected",
        "Kurs auswählen": "Select course",
        "Ausgewählter Kurs": "Selected course",
        "Zugriffsdauer in Tagen": "Access duration in days",
        "Willkommen in deinem persönlichen Bereich, {name}! Hier findest du alle deine gebuchten Online-Kurse, deine Bestellungen und kannst dein Profil verwalten. Viel Spass beim Lernen!": "Welcome to your personal area, {name}! Here you will find all your booked online courses, your orders, and you can manage your profile. Have fun learning!",
        "Jetzt eLearning starten": "Start eLearning now",
        "Leider stehen dir im Moment keine Online-Kurse zur Verfügung. Bitte kontaktiere uns, wenn du Fragen hast.": "Unfortunately, you currently have no online courses available. Please contact us if you have any questions.",
        "Bestellungen": "Orders",
        "Online Kurse": "Online Courses",
        "Zertifikate können für diesen Kurs nicht generiert werden.": "Certificates cannot be generated for this course.",
        "Zertifikate können nicht automatisch verschickt werden, wenn der Zertifikat-Generator nicht aktiviert ist!": "Certificates cannot be sent automatically when the certificate generator is not activated!",
        "Erneut senden ({timeTillResend} s)": "Resend ({timeTillResend} s)",
        "Benötigst Du Hilfe?": "Do you need help?",
        "Wir helfen Dir gerne per E-Mail oder Telefon": "We are happy to help you by email or phone",
        "Erste Hilfe lernen. Wo du willst. Wann du willst.": "Learn first aid. Where you want. When you want.",
        "Den Beleg zu deiner Bestellung findest du im Anhang.": "You will find the receipt for your order in the attachment.",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "In your personal area my.sanio you will find all order details as well as direct access to the course. Good luck with your learning! 🚑💡",
        "Bestellbestätigung für {orderNumber}": "Order confirmation for {orderNumber}",
        "Wir haben deine Zahlung erhalten und dein Zugang zum eLearning ist jetzt freigeschaltet.": "We have received your payment and your access to the eLearning is now activated.",
        "Danke für deine Bestellung, {name}! 🎉": "Thank you for your order, {name}! 🎉",
        "Rechnungsadresse": "Billing address",
        "Lieferadresse": "Delivery address",
        "Abweichende Lieferadresse": "Different delivery address",
        "Optional. Empfohlen, wenn Gutscheine per Post verschickt werden.": "Optional. Recommended when vouchers are sent by post.",
        "Der Vorname der Lieferadresse ist erforderlich.": "The delivery address first name is required.",
        "Der Nachname der Lieferadresse ist erforderlich.": "The delivery address last name is required.",
        "Die Strasse der Lieferadresse ist erforderlich.": "The delivery address street is required.",
        "Die Hausnummer der Lieferadresse ist erforderlich.": "The delivery address street number is required.",
        "Die PLZ der Lieferadresse ist erforderlich.": "The delivery address postcode is required.",
        "Der Ort der Lieferadresse ist erforderlich.": "The delivery address city is required.",
        "Wir konnten dich mit diesen Angaben nicht anmelden.": "We could not log you in with these credentials.",
        "Bestellbestätigung": "Order confirmation",
        "Exportieren als CSV": "Export as CSV",
        "Exportieren als Excel": "Export as Excel",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr in einen anderen Kurs verschoben werden.": "The participant has already started the eLearning and can no longer be moved to another course.",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr abgemeldet werden.": "The participant has already started the eLearning and can no longer be unregistered.",
        "Du hast dich für das Erste Hilfe eLearning angemeldet, aber noch nicht gestartet. Nutze die Chance, dein Wissen aufzufrischen.": "You have registered for the first aid eLearning but have not yet started. Take the opportunity to refresh your knowledge.",
        "Jetzt herunterladen": "Download now",
        "Zertifikate für Kurs {course} wurden generiert!": "Certificates for course {course} have been generated!",
        "Die Zertifikate werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du die Zertifikate herunterladen kannst.": "The certificates are being generated in the background. You will be notified by email as soon as you can download the certificates.",
        "Möchtest du die Teilnahmebestätigungen trotzdem generieren?": "Do you still want to generate the certificates of attendance?",
        "Die Zertifikate werden im Hintergrund vorbereitet. Bitte habe einen Moment Geduld.": "The certificates are being prepared in the background. Please be patient for a moment.",
        "Teilnahmebestätigungen generieren": "Generate certificates of attendance",
        "Kontaktperson Kunde": "Customer contact person",
        "Die Zertifikate werden im Hintergrund vorbereitet. Sie erhalten eine Benachrichtigung, sobald die Zertifikate zum Download bereitstehen.": "The certificates are being prepared in the background. You will receive a notification as soon as the certificates are ready for download.",
        "Die Zertifikate für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "The certificates for the course {course} have been generated and are ready for download.",
        "Der angegebene Freigabelink wird noch nicht unterstützt.": "The specified share link is not yet supported.",
        "Persönlicher Zugangscode (QR) anzeigen": "Show personal access code (QR)",
        "QR Code": "QR code",
        "Persönliche Zugangscodes (QR) als PDF": "Personal access codes (QR) as PDF",
        "Persönlicher eLearning Zugang {name}": "Personal eLearning access {name}",
        "Das Dokument wird im Hintergrund generiert. Du wirst benachrichtigt, sobald es fertig ist.": "The document is being generated in the background. You will be notified as soon as it is ready.",
        "Die Zugangs-QR-Codes für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "The access QR codes for course {course} have been generated and are ready for download.",
        "Das eLearning steht für dich bereitsteht und du kannst ab sofort mit dem Lernen beginnen. Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "The eLearning is available for you and you can start learning immediately. The eLearning takes around {duration}. At the end of the eLearning there is a short assessment. So it is worth not just clicking through the theory!",
        "Persönlicher Zugang": "Personal access",
        "eLearning {customerName}": "eLearning {customerName}",
        "Gültig bis {expire}": "Valid until {expire}",
        "eLearning Zugang {customerName}": "eLearning access {customerName}",
        "Viel Erfolg!": "Good luck!",
        "eLearning QR-Zugänge generieren": "Generate eLearning QR accesses",
        "Die QR-Zugänge werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du sie herunterladen kannst.": "The QR accesses are being generated in the background. You will be notified by email as soon as you can download them.",
        "QR Code wird geladen": "Loading QR code",
        "QR-Code mit Smartphone Kamera scannen": "Scan QR code with smartphone camera",
        "QR-Code drucken": "Print QR code",
        "QR Zugänge für Kurs {course} wurden generiert!": "QR access codes for course {course} have been generated!",
        "Teilnahmebestätigungen an Teilnehmende versenden": "Send certificates of attendance to participants",
        "Super, du bist erfolgreich für den Erste Hilfe Kurs angemeldet – wir freuen uns! 🎉": "Great, you have successfully registered for the first aid course – we look forward to seeing you! 🎉",
        "<strong>Bitte beachte:</strong> Das eLearning muss bis spätestens vor dem Präsenzkurs am <strong>{courseDate}</strong> abgeschlossen sein. Es ist die Grundlage für den praktischen Teil des Kurses.": "<strong>Please note:</strong> The eLearning must be completed by <strong>{courseDate}</strong> at the latest, before the in-person course. It is the foundation for the practical part of the course.",
        "Das <strong>eLearning</strong> ist ab sofort für dich freigeschaltet – du kannst direkt loslegen:": "The <strong>eLearning</strong> is now available for you – you can start right away:",
        "Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "The eLearning takes approximately {duration}. At the end of the eLearning there is a short learning assessment. So it's worth not simply clicking through the theory!",
        "Teil 2: Präsenzkurs": "Part 2: In-person course",
        "eLearning URL": "eLearning URL",
        "kopieren": "copy",
        "Teil 1: eLearning": "Part 1: eLearning",
        "eLearning QR-Zugänge generieren und E-Mail an ({email}) senden": "Generate eLearning QR access codes and send email to ({email})",
        "<strong>ACHTUNG:</strong> Du bist als eine andere Person angemeldet. Die E-Mail wird aber an die E-Mail-Adresse der aktuell angemeldeten Person gesendet.": "<strong>ATTENTION:</strong> You are logged in as a different person. However, the email will be sent to the email address of the currently logged-in person.",
        "Teilnahmebestätigungen generieren und E-Mail an ({email}) senden": "Generate certificates of attendance and send email to ({email})",
        "Programm": "Program",
        "Teilnahmebestätigungen an Teilnehmer:innen versenden": "Send certificates of attendance to participants",
        "Unternehmen": "Company",
        "Kundenbereiche": "Customer areas",
        "Offerte": "Quote",
        "Benutzer:innen": "Users",
        "Kontakte": "Contacts",
        "Kursanfragen": "Course requests",
        "Kontaktanfragen": "Contact requests",
        "Zu viele Versuche. Bitte versuche es später erneut.": "Too many attempts. Please try again later.",
        "Teilnehmer:in aus Kundenbereich löschen": "Delete participant from customer area",
        "Standard": "Default",
        "Ist aktiv": "Is active",
        "Ist der Standard Shop": "Is the default shop",
        "Kurs Zuweisung": "Course assignment",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails.": "In your personal area my.sanio you will find all order details.",
        "Zum my.sanio": "To my.sanio",
        "Bestellnummer": "Order number",
        "Datum & Uhrzeit": "Date & time",
        "Lizenz": "License",
        "Zugriffszeitraum": "Access period",
        "Hi {name}! 🎉": "Hi {name}! 🎉",
        "Zahlungsart": "Payment method",
        "Erste Hilfe eLearning": "First Aid eLearning",
        "Die Eingabe ist ungültig.": "The input is invalid.",
        "inkl. {taxPercentage}% MwSt": "incl. {taxPercentage}% VAT",
        "Du kannst diesen/diese Teilnehmer:in nicht mehr bearbeiten, da ein verknüpfter Kurs bereits begonnen hat oder abgeschlossen ist.": "You can no longer edit this participant because a linked course has already started or is completed",
        "Der Kurs hat bereits begonnen.": "The course has already started.",
        "Vielen Dank für deine Anmeldung!": "Thank you for your registration!",
        "Du erhältst in Kürze eine Bestätigung per E-Mail mit allen wichtigen Infos zum Kurs. Bitte wirf auch einen Blick in deinen Spam-Ordner, falls keine Mail eintrifft. 📩": "You will shortly receive a confirmation email with all the important information about the course. Please also check your spam folder if no email arrives. 📩",
        "Deine Anmeldung ist bei uns eingegangen. Alle weiteren Informationen zum Kurs erhältst du zu einem späteren Zeitpunkt. 📩": "Your registration has been received. You will get all further information about the course at a later time. 📩",
        "<strong>Bei Fragen oder Abmeldungen vor dem Kurstag</strong> wende dich bitte direkt an {name}:": "<strong>For questions or cancellations before the course day</strong> please contact {name} directly:",
        "Du musst nichts mitbringen. Wir empfehlen dir praktische und bequeme Kleidung zu tragen, die genügend Bewegungsfreiheit bietet. Denn während des Kurses führen wir praktische Übungen auf dem Boden durch, welche teilweise physisch etwas anspruchsvoll sind. 😊": "You don't need to bring anything. We recommend wearing practical and comfortable clothing that allows sufficient freedom of movement. During the course, we carry out practical exercises on the floor, which are sometimes physically demanding. 😊",
        "Leider bist du nicht berechtigt, ein Zertifikat für diesen Kurs zu erhalten.": "Unfortunately, you are not authorised to receive a certificate for this course.",
        "Sanio": "Sanio",
        "Am Kurstag selbst, z.B. bei Verspätung oder kurzfristiger Abmeldung, erreichst du uns schriftlich via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.": "On the course day itself, e.g. if you are late or need to cancel at short notice, you can reach us in writing via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.",
        "Empfänger": "Recipient",
        "1 Lizenz zur Selbstnutzung": "1 License for Self-Use",
        "{count} Geschenk ({type})": "{count} Gift ({type})",
        "digital": "digital",
        "Anzahl Lizenzen": "Number of licenses",
        "Für {recipient} von {giver}": "For {recipient} from {giver}",
        "Unbekannt": "Unknown",
        " 🎁": "Redeem gift license 🎁",
        "Produktgutschein": "Product voucher",
        "Gutschein {number} herunterladen": "Download voucher {number}",
        "Gutschein-Link {number} kopieren (inkl. Code)": "Copy voucher link {number} (incl. code)",
        "Eingelöst": "Redeemed",
        "Gutschein oder Rabatt einlösen": "Redeem voucher or discount",
        "Trage hier deinen Rabattcode für diesen Kurs ein.": "Enter your discount code for this course here.",
        "Rabatt entfernen": "Remove discount",
        "Code ungültig": "Invalid code",
        "Dieser Code ist nur für eLearning Geschenke gültig.": "This code is only valid for eLearning gifts.",
        "Hast du ein eLearning geschenkt bekommen? Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Have you received an eLearning as a gift? Then please redeem your voucher at {redeemUrl}.",
        "Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Then please redeem your voucher at {redeemUrl}.",
        "Rabatt": "Discount",
        "Code": "Code",
        "Produktgutschein erfassen": "Create Product Voucher",
        "Kunde & Produkt": "Customer & Product",
        "Kunde auswählen": "Select Customer",
        "Produkt wählen": "Select Product",
        "Shop-Konfiguration": "Shop Configuration",
        "Shop auswählen": "Select Shop",
        "Anzahl Gutscheine": "Number of Vouchers",
        "Geschenkinformationen": "Gift Information",
        "Empfänger:in": "Recipient",
        "Von (Absender:in)": "From (Sender)",
        "Nachricht an die/den Beschenkte:n (optional)": "Message to the Recipient (optional)",
        "Persönliche Beschriftung auf dem Gutschein hinzufügen": "Add Personal Label to the Voucher",
        "Produktgutscheine erstellen": "Create Product Vouchers",
        "Produktgutscheine wurden erstellt.": "Product vouchers have been created.",
        "Produktgutscheine": "Product Vouchers",
        "Versandart": "Delivery Method",
        "Digital & Versand": "Digital & Delivery",
        "Von {sender}": "From {sender}",
        "Empfänger:in (optional)": "Recipient (optional)",
        "Von (Absender:in, optional)": "From (Sender, optional)",
        "{who} hat dir eine Lizenz für dieses eLearning geschenkt 🎉": "{who} has gifted you a license for this eLearning 🎉",
        "Viel Spass beim Lernen, {name}! 🎉": "Have fun learning, {name}! 🎉",
        "Nur digital": "Digital only",
        "Produkt": "Product",
        "Gutschein wurde erstellt.": "Voucher has been created.",
        "Gutschein wurde aktualisiert.": "Voucher has been updated.",
        "Gutschein wurde gelöscht.": "Voucher has been deleted.",
        "📅 Erinnerung an deinen Kurs morgen": "📅 Reminder for your course tomorrow",
        "manuell via admin": "manually via admin",
        "systemgeneriert": "system-generated",
        "Kundenservice": "Customer service",
        "PDF": "PDF",
        "Physisch": "Physical",
        "Rabattgutschein": "Discount voucher",
        "Wertgutschein": "Value voucher",
        "Verwendet": "Used",
        "Abgelaufen": "Expired",
        "Formatierung kann von effektiv versendeter Nachricht abweichen.": "Formatting may differ from the actually sent message.",
        "Absender Nummer:": "Sender number:",
        "Quadratisches Produktbild": "Square product image",
        "Gutschein-Konfiguration": "Voucher configuration",
        "Shop-Beschreibung": "Shop description",
        "Beschreibung die im Shop beim Kauf angezeigt wird": "Description displayed in the shop during purchase",
        "Shop-Bedingungen": "Shop terms",
        "Bedingungen die im Shop beim Kauf angezeigt werden": "Terms displayed in the shop during purchase",
        "Einlöse-Beschreibung": "Redemption description",
        "Beschreibung die beim Einlösen des Gutscheins angezeigt wird": "Description displayed when redeeming the voucher",
        "Einlöse-Anweisungen": "Redemption instructions",
        "Anweisungen die beim Einlösen des Gutscheins angezeigt werden": "Instructions displayed when redeeming the voucher",
        "Im Shop verfügbar": "Available in shop",
        "Gutschein Anwendungen": "Voucher uses",
        "Verfügbar": "Available",
        "Pro Benutzer": "Per user",
        "Keine Verwendungen": "No uses",
        "Dieser Gutschein wurde noch nicht verwendet.": "This voucher has not been used yet.",
        "Bestellung": "Order",
        "Wert": "Value",
        "Suche Code …": "Search code …",
        "Erstellt am": "Created on",
        "Rabattgutscheine": "Discount vouchers",
        "Kunde wählen": "Select customer",
        "Gutscheine": "Vouchers",
        "Rabattgutschein erfassen": "Create discount voucher",
        "Suche Code oder Name …": "Search code or name …",
        "Gültig bis": "Valid until",
        "Kunden": "Customers",
        "Grundinformationen": "Basic information",
        "Gutschein für": "Voucher for",
        "Ursprung": "Origin",
        "Rabattwert": "Discount value",
        "Rabatt-Typ": "Discount type",
        "Betrag in Rappen oder Prozentpunkte x100 (z.B. 1500 = 15.00%)": "Amount in centimes or percentage points x100 (e.g. 1500 = 15.00%)",
        "Anwendungen": "Uses",
        "Beschränkte Anzahl": "Limited quantity",
        "Anwendungen pro Benutzer": "Uses per user",
        "Rabattgutschein bearbeiten": "Edit discount voucher",
        "Gutschein Details": "Voucher details",
        "Max. Verwendungen": "Max. uses",
        "Max. pro Nutzer:in": "Max. per user",
        "Dies ist eine kurze Erinnerung: Du leitest morgen den Kurs {courseType}, {courseDuration} bei {company}.": "This is a short reminder: You are leading the course {courseType}, {courseDuration} at {company} tomorrow.",
        "Kurszeiten:": "Course times:",
        "Ort:": "Location:",
        "Bitte sei 30 Minuten vor Kursbeginn vor Ort und überprüfe, ob du alles Material dabeihast.": "Please be on site 30 minutes before the course starts and check that you have all the materials.",
        "Alle weiteren Informationen zum Kurs und zu den Teilnehmenden findest du hier:": "You can find all further information about the course and the participants here:",
        "Bei Fragen oder Problemen kannst du dich gerne an Tanja wenden.": "If you have any questions or problems, please feel free to contact Tanja.",
        "Danke für deinen Einsatz!": "Thank you for your commitment!",
        "Gutschein {code}": "Voucher {code}",
        "Gutschein {code} ({value})": "Voucher {code} ({value})",
        "Gutschein {code} ({value}%)": "Voucher {code} ({value}%)",
        "Absender:": "Sender:",
        "Einlösen unter:": "Redeem at:",
        "Code als QR": "Code as QR",
        "Aktion": "Action",
        "Offen": "Open",
        "Benutzer": "User",
        "Suchen": "Search",
        "Inaktiv": "Inactive",
        "Gesendet:": "Sent",
        "Kanal:": "Channel",
        "Empfänger:": "Recipient:",
        "Gutscheincode ist ungültig.": "Voucher code is invalid.",
        "Dieser Gutschein kann nur für das Produkt {name} verwendet werden.": "This voucher can only be used for the product {name}.",
        "Alle Produkte": "All products",
        "Optional. Ohne Auswahl gilt der Gutschein für alle Produkte. Ein fester Betrag wird je Stück des gewählten Produkts abgezogen.": "Optional. Without a selection, the voucher applies to all products. A fixed amount is deducted for each unit of the selected product.",
        "Gutschein {number}": "Voucher {number}",
        "Mit dem Einlösen akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "By redeeming, I accept the {tos}. I have read and understood the {privacyPolicy}.",
        "Gutschein einlösen": "Redeem voucher",
        "Du besitzt bereits eine aktive Lizenz für diesen Kurs. Eine weitere Einlösung ist nicht möglich.": "You already have an active license for this course. Redeeming another license is not possible.",
        "Andere Lizenz einlösen": "Redeem another license",
        "Schön, dass du dich für unser Erste Hilfe eLearning entschieden hast! 😊": "Great that you chose our first aid eLearning! 😊",
        "Hast du ein eLearning geschenkt bekommen?": "Did you receive an eLearning as a gift?",
        "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.": "An error occurred. Please try again.",
        "Menge": "Quantity",
        "Jede Lizenz berechtigt zu einem Jahr Nutzung des eLearnings.": "Each license entitles you to one year of eLearning use.",
        "Abschluss": "Completion",
        "Ungültiger Anmeldeversuch.": "Invalid login attempt.",
        "Preisberechnung fehlgeschlagen": "Price calculation failed",
        "Über uns": "About us",
        "Kontakt": "Contact",
        "AGBs": "Terms and Conditions",
        "Rechnungsadresse bearbeiten": "Edit billing address",
        "Strasse": "Street",
        "PLZ": "Postal code",
        "Ort": "City",
        "E-Mail und Telefonnummer können nur im Profil bearbeitet werden.": "Email and phone number can only be edited in the profile.",
        "Benötigen Sie Hilfe?": "Do you need help?",
        "Wir helfen Ihnen gerne per E-Mail oder Telefon": "We are happy to help you by email or phone",
        "Telefon": "Phone",
        "Ihre Bestellung": "Your order",
        "Gesamtbetrag": "Total amount",
        "Zwischensumme": "Subtotal",
        "Jetzt kaufen": "Buy now",
        "Mögliche Zahlungsarten": "Available payment methods",
        "Uups, Ihre Bestellung konnte nicht abgeschlossen werden.": "Oops, your order could not be completed.",
        "Sie haben die Zahlung abgebrochen. Bitte versuchen Sie es erneut.": "You have cancelled the payment. Please try again.",
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.": "An error has occurred. Please try again.",
        "Wir haben deine Bestellung erhalten 🥳": "We have received your order 🥳",
        "Zahlung wird verarbeitet": "Payment is being processed",
        "Dein Zugang zum eLearning ist jetzt bereit. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Your access to eLearning is now ready. In your personal area <strong>my.sanio</strong> you will find all order details as well as direct access to the course. Good luck with your learning! 🚑💡",
        "Zu my.sanio": "Go to my.sanio",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist bereits eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "You can download the vouchers as PDF or copy the direct redemption link. The code is already included – perfect for sending via WhatsApp, email or SMS.",
        "Deine Geschenklizenz 🎁": "Your gift licence 🎁",
        "Deine Geschenklizenzen 🎁": "Your gift licences 🎁",
        "Deine Geschenklizenz findest du unten in den Bestelldetails. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "You will find your gift licence below in the order details. There you can also download the PDF to give as a gift. Alternatively, simply copy the link to the redemption page – the code is already included. Ideal for WhatsApp, email or SMS.",
        "Deine Geschenklizenzen findest du unten in den Bestelldetails. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "You'll find your gift licences below in the order details. There you can also download the PDFs to give as gifts. Alternatively, simply copy the links to the redemption page – the codes are already included. Ideal for WhatsApp, email or SMS.",
        "Bestelldetails": "Order details",
        "Lizenzen": "Licences",
        "Geschenklizenzen": "Gift licences",
        "Link wurde kopiert.": "Link copied.",
        "Link konnte nicht kopiert werden.": "Link could not be copied.",
        "Übersicht": "Overview",
        "Deine Angaben": "Your details",
        "Geschenklizenz Übersicht": "Gift licence overview",
        "Neu bei Sanio?": "New to Sanio?",
        "Erstellen Sie Ihr Sanio-Konto und los geht's!": "Create your Sanio account and get started!",
        "Jetzt Konto erstellen": "Create account now",
        "Haben Sie schon ein Sanio Konto?": "Already have a Sanio account?",
        "Melden Sie sich mit Ihrer E-Mail oder Handynummer an und schon geht's los!": "Log in with your email or mobile number and get started!",
        "E-Mail oder Handynummer": "Email or mobile number",
        "Wird verarbeitet...": "Processing...",
        "Zum verschenken": "To give as a gift",
        "Wird auf Geschenklizenz gedruckt": "Will be printed on gift licence",
        "Wenn Sie diese angeben, können Sie sich später auch per SMS einloggen.": "If you provide this, you can also log in via SMS later.",
        "Handynummer (optional)": "Mobile number (optional)",
        "Nr.": "No.",
        "Erstelle dein Sanio-Konto": "Create your Sanio account",
        "Erstellen Sie Ihr Sanio-Konto": "Create your Sanio account",
        "Sie sind bereits bei Sanio?": "Already with Sanio?",
        "Du hast bereits ein Konto?": "Already have an account?",
        "Geschenklizenz eingelöst": "Gift licence redeemed",
        "Geschenklizenz einlösen 🎁": "Redeem gift licence 🎁",
        "Geschenklizenz für": "Gift licence for",
        "Geschenklizenz personalisieren": "Personalise gift licence",
        "Geschenklizenz von": "Gift licence from",
        "Geschenklizenz": "Gift licence",
        "Geschenklizenzen personalisieren": "Personalise gift licences",
        "Ihr Name für alle übernehmen": "Apply your name to all",
        "Ihr Name": "Your name",
        "Name des Empfängers": "Recipient's name",
        "Digital & Physisch (per Post)": "Digital & Physical (by post)",
        "Nur digital (PDF)": "Digital only (PDF)",
        "Deine Gutscheine": "Your vouchers",
        "Lizenz aktiviert": "Licence activated",
        "Jemand": "Someone",
        "Wie schön, du wurdest beschenkt 🎉": "How wonderful, you've received a gift 🎉",
        "Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Redeem your code and find out what's waiting for you.",
        "Wie viele Lizenzen möchten Sie kaufen? ": "How many licences would you like to purchase? ",
        "Wird gespeichert...": "Saving...",
        "Nicht {name}?": "Not {name}?",
        "Hausnummer": "House number",
        "Fehler": "Error",
        "Datenschutz": "Privacy",
        "Impressum": "Imprint",
        "Weiter": "Continue",
        "Registrieren": "Register",
        "1 Lizenz zum Verschenken ({type})|{count} Lizenzen zum Verschenken ({type})": "1 licence to give away ({type})|{count} licences to give away ({type})",
        "Sie sind eingeloggt als: {name}": "You are logged in as: {name}",
        "Shop-Kund:in": "Shop customer",
        "Als Firma können Sie keine Lizenz für sich selbst kaufen. Sie können nur Geschenklizenzen kaufen.": "As a company, you cannot purchase a licence for yourself. You can only purchase gift licences.",
        "Als Firma registrieren": "Register as a company",
        "Firma muss ausgefüllt werden, wenn Sie sich als Firma registrieren möchten.": "Company must be filled in if you wish to register as a company.",
        "Firma": "Company",
        "Shop-Kund:in wurde erfolgreich erstellt.": "Shop customer successfully created.",
        "Shop-Kund:in erfassen": "Create shop customer",
        "Shop-Kund:in bearbeiten": "Edit shop customer",
        "Shop-Kund:in wurde erfolgreich aktualisiert.": "Shop customer successfully updated.",
        "Shop-Kund:in wurde erfolgreich gelöscht.": "Shop customer successfully deleted.",
        "Shop-Kund:innen": "Shop customers",
        "Shop-Kund:innen erfassen": "Create shop customers",
        "Für wen sind die Lizenzen?": "Who are the licences for?",
        "Eine Lizenz für mich, andere zum Verschenken": "One licence for me, others as gifts",
        "Alle Lizenzen zum Verschenken": "All licences as gifts",
        "Sie besitzen bereits eine aktive Lizenz für diesen Kurs. Sie können nur Geschenklizenzen kaufen.": "You already have an active licence for this course. You can only purchase gift licences.",
        "Für wen ist die Lizenz?": "Who is the licence for?",
        "Für mich": "For me",
        "Geschenkt von": "Gift from",
        "Für alle übernehmen": "Apply to all",
        "Wird geprüft.": "Being checked.",
        "Eingelöst von": "Redeemed by",
        "Eingelöst am": "Redeemed on",
        "Deine Geschenklizenz findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "You can find your gift licence in the <a href=\"{orderLink}\">order details in my.sanio</a>. There you can also download the PDF to give as a gift. Alternatively, simply copy the link to the redemption page – the code is already included. Ideal for WhatsApp, email or SMS.",
        "Deine Geschenklizenzen findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "You can find your gift licences in the <a href=\"{orderLink}\">order details in my.sanio</a>. There you can also download the PDFs to give as gifts. Alternatively, simply copy the links to the redemption page – the codes are already included. Ideal for WhatsApp, email or SMS.",
        "Geschenklizenz eingelöst, eLearning bereit": "Gift licence redeemed, eLearning ready",
        "Ihre Kosten": "Your costs",
        "Speichern...": "Saving...",
        "Gültig ab": "Valid from",
        "Produktgutschein wurde aktualisiert.": "Product voucher has been updated.",
        "{attribute} ist keine gültige Sprache.": "{attribute} is not a valid language.",
        "Gutschein wurde deaktiviert.": "Voucher has been deactivated.",
        "Gutscheincode wurde bereits verwendet.": "Voucher code has already been used.",
        "Gutscheincode ist abgelaufen.": "Voucher code has expired.",
        "Produktgutschein bearbeiten": "Edit product voucher",
        "Deaktivieren": "Deactivate",
        "Ausstehend": "Pending",
        "Bezeichnung": "Description",
        "Betrag in Franken (z.B. 20 = CHF 20.-)": "Amount in francs (e.g. 20 = CHF 20.-)",
        "Firma (optional)": "Company (optional)",
        "Um das Lernen persönlicher und praxisnäher zu gestalten, sprechen wir dich ab hier direkt in der Du-Form an. Schön, dass du dich für unseren Erste Hilfe Online Kurs entschieden hast! 😊": "To make learning more personal and practical, from here on we will address you informally. Great that you have chosen our First Aid Online Course! 😊",
        "💌 Zusätzlich wirst du in den nächsten Tagen die gedruckten Gutscheine per Post erhalten.": "💌 In addition, you will receive the printed vouchers by post in the next few days.",
        "Dein Zugang zum eLearning ist jetzt freigeschaltet.": "Your access to eLearning is now activated.",
        "In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🧑‍🏫💡": "In your personal area <strong>my.sanio</strong> you will find all order details and direct access to the course. Good luck with your learning! 🧑‍🏫💡",
        "Einzellizenz (für eine:n Benutzer:in)": "Single license (for one user)",
        "Gutschein": "Voucher",
        "Dauer": "Duration",
        "Zirka": "Approximately",
        "Ein Geschenk von": "A gift from",
        "Gutscheincode": "Voucher code",
        "Gutscheincode ist noch nicht gültig.": "Voucher code is not yet valid.",
        "Absender:in": "Sender",
        "Prozent als ganze Zahl (z.B. 15 = 15%)": "Percentage as a whole number (e.g. 15 = 15%)",
        "Optionen öffnen": "Open options",
        "Test": "Test",
        "Rabatt (Code: {code})": "Discount (Code: {code})",
        "Dieser Code ist ein Produktgutschein und kann hier nicht eingelöst werden.": "This code is a product voucher and cannot be redeemed here.",
        "Ein Gutschein mit diesem Code existiert bereits im Status Aktiv oder Ausstehend. Bitte deaktivieren Sie den bestehenden Gutschein oder verwenden Sie einen anderen Code.": "A voucher with this code already exists with Active or Pending status. Please deactivate the existing voucher or use a different code.",
        "Gutschein für {name}": "Voucher for {name}",
        "Geschenkgutschein deaktivieren?": "Deactivate gift voucher?",
        "Möchtest du den Gutschein wirklich deaktivieren?": "Do you really want to deactivate the voucher?",
        "Gutschein deaktivieren": "Deactivate voucher",
        "Rabattcode deaktivieren?": "Deactivate discount code",
        "Möchtest du den Rabattcode wirklich deaktivieren?": "Do you really want to deactivate the discount code?",
        "Rabattcode deaktivieren": "Deactivate discount code",
        "Sie haben bereits eine aktive Lizenz für dieses Produkt. Sie können nur Geschenklizenzen kaufen.": "You already have an active license for this product. You can only purchase gift licenses.",
        "Füge deine individuelle E-Mail-Adresse (keine allgemeine info@-Adresse) ein, um eine Anmeldebestätigung und ein Erinnerungsmail zu erhalten.": "Enter your personal email address (not a general info@ address) to receive a registration confirmation and a reminder email.",
        "Gib für die Korrespondenz deine persönliche E-Mail-Adresse an (keine allgemeine Adresse wie info@).": "Enter your personal email address for correspondence (not a general address such as info@).",
        "Selbstnutzung": "Personal use",
        "Als Geschenk": "As a gift",
        "Teilnahmebestätigung versendet am {date}": "Certificate of attendance sent on {date}",
        "Abschlussquiz bestanden am {date}": "Final quiz passed on {date}",
        "Abschlussquiz zuletzt nicht bestanden am {date}": "Final quiz last failed on {date}",
        "Abschlussquiz noch offen": "Final quiz still pending",
        "Abschlussquiz im letzten eLearning bestanden am {date}": "Final quiz in last eLearning passed on {date}",
        "Abschlussquiz im letzten eLearning zuletzt nicht bestanden am {date}": "Final quiz in last eLearning last failed on {date}",
        "Deaktivierte Gutscheine können nicht bearbeitet werden.": "Deactivated vouchers cannot be edited.",
        "Die E-Mail-Adresse ist bereits in diesem Login-Bereich vorhanden.": "The email address already exists in this login area.",
        "Referenzierte Entität kann nicht gefunden werden.": "Referenced entity cannot be found.",
        "Die Bestellung wurde archiviert.": "The order has been archived.",
        "Die Bestellung wurde wiederhergestellt.": "The order has been restored.",
        "Abschlussquiz im letzten eLearning noch offen": "Final quiz in last eLearning still pending",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung für die folgenden Personen nicht generiert werden:": "Some participants who attended the course have not yet completed the eLearning. Therefore, the certificate cannot be generated for the following persons:",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Some participants who attended the course have not yet completed the eLearning. Therefore, the certificate cannot be sent by email to the following persons:",
        "Für einige Teilnehmer:innen, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "For some participants, no email address is available. Therefore, the certificate cannot be sent by email to the following persons:",
        "Kurszusammenfassung": "Course summary",
        "Lädt...": "Loading...",
        "nicht ausgewählt": "not selected",
        "Ja": "Yes",
        "Nein": "No",
        "Versendet": "Sent",
        "Tage vor Kursbeginn": "Days before course start",
        "Tage": "Days",
        "bei bestandenem eLearning-Abschlussquiz": "upon passing the eLearning final quiz",
        "Beim Kurs Abschluss an Teilnehmer mit Status «teilgenommen» und hinterlegter E-Mail-Adresse.": "Upon course completion, to participants with the status «attended» and a stored email address.",
        "Im eLearning öffnen": "Open in eLearning",
        "Schliessen": "Close",
        "Fehler beim Laden der Zusammenfassung": "Error loading summary",
        "Rechnung in bexio öffnen": "Open invoice in bexio",
        "Feedbacks": "Feedback",
        "E-Learning / Online": "E-Learning / Online",
        "Zeitraum": "Period",
        "Als Excel herunterladen": "Download as Excel",
        "Bewertung": "Rating",
        "Antworten": "Responses",
        "Teilnehmer:in": "Participant",
        "Keine Feedbacks für diese Freigabe.": "No feedback for this release.",
        "Der Kursstatus wurde aktualisiert.": "The course status has been updated.",
        "Der Status von {count} Kurs wurde aktualisiert.|Der Status von {count} Kursen wurde aktualisiert.": "The status of {count} course has been updated.|The status of {count} courses has been updated.",
        "Mindestens einer der ausgewählten Kurse wurde nicht gefunden.": "At least one of the selected courses was not found.",
        "Statuswechsel ist nur möglich, wenn alle ausgewählten Kurse denselben Status haben.": "A status change is only possible when all selected courses have the same status.",
        "\"{course}\": {message}": "\"{course}\": {message}",
        "{count} Kurs ausgewählt|{count} Kurse ausgewählt": "{count} course selected|{count} courses selected",
        "Statuswechsel nicht möglich, da die ausgewählten Kurse unterschiedliche Status haben.": "Status change is not possible because the selected courses have different statuses.",
        "Auswahlmodus beenden": "Exit selection mode",
        "Auswahlmodus": "Selection mode",
        "Möchtest du den Status von {count} Kurs wirklich ändern?|Möchtest du den Status von {count} Kursen wirklich ändern?": "Do you really want to change the status of {count} course?|Do you really want to change the status of {count} courses?",
        "Alle Kurse in dieser Liste auswählen": "Select all courses in this list",
        "Kurstyp wurde erfolgreich erstellt.": "Course type has been successfully created.",
        "System-Kurstypen können nicht gelöscht werden.": "System course types cannot be deleted.",
        "Der Kurstyp kann nicht gelöscht werden, da er bereits verwendet wird.": "The course type cannot be deleted because it is already in use.",
        "Kurstyp wurde erfolgreich gelöscht.": "Course type has been successfully deleted.",
        "Der OAuth-Client wurde widerrufen.": "The OAuth client has been revoked.",
        "Anmeldungen sind für diesen Kurs nicht möglich (Status \"{status}\").": "Registrations are not possible for this course (status \"{status}\").",
        "Der Kurs kann nicht von \"{from}\" auf \"{to}\" gesetzt werden.": "The course cannot be changed from \"{from}\" to \"{to}\".",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange Systemprüfungen fehlschlagen: {checks}": "The course cannot be set to \"Ready\" while system checks are failing: {checks}",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange keine Termine definiert sind. E-Learning-Kurse sind hiervon ausgenommen.": "The course cannot be set to \"Ready\" without defined timeslots. E-learning courses are exempt.",
        "Bestanden": "Passed",
        "Fehlgeschlagen": "Failed",
        "Übersprungen": "Skipped",
        "Tippen zum Suchen": "Tap to search",
        "Keine Einträge gefunden.": "No entries found.",
        "Keine Unternehmen gefunden.": "No companies found.",
        "Keine Kunden gefunden.": "No customers found.",
        "Kunde suchen…": "Search customer…",
        "Dieser Kurs hat fehlgeschlagene Systemprüfungen!": "This course has failed system checks!",
        "Kursstatus ändern": "Change course status",
        "Angemeldet": "Registered",
        "Teilgenommen": "Attended",
        "Entschuldigt abwesend": "Excused absence",
        "Unentschuldigt abwesend": "Unexcused absence",
        "Produktgruppe ist aktiv": "Product group is active",
        "Produktgruppe ist nicht aktiv": "Product group is not active",
        "Kurstyp erstellen": "Create course type",
        "Systemprüfungen": "System checks",
        "Zuletzt geprüft": "Last checked",
        "Noch keine Prüfungen durchgeführt.": "No checks performed yet.",
        "Wird geprüft...": "Checking...",
        "Jetzt prüfen": "Check now",
        "Keine Prüfungsergebnisse vorhanden. Klicke auf \"Jetzt prüfen\" um die Systemprüfungen auszuführen.": "No check results available. Click \"Check now\" to run the system checks.",
        "abhängig": "dependent",
        "Hinweis: Für den Versand der Anmeldebestätigung ist in jeder Zeile der Datei eine gültige E-Mail-Adresse erforderlich.": "Note: A valid email address is required in each line of the file to send the registration confirmation.",
        "Im Anhang findest du die von dir importierte Datei.": "Attached you will find the file you imported.",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert und am Kurs angemeldet.": "The following lines were imported and registered for the course despite unclear assignment.",
        "Aargau": "Aargau",
        "Als Firma können Sie keine Lizenz einlösen.": "As a company, you cannot redeem a licence.",
        "Als Firma können Sie keine Lizenz einlösen. Sie können nur Geschenklizenzen kaufen.": "As a company, you cannot redeem a licence. You can only purchase gift licences.",
        "Amt": "Office",
        "Anmeldungen sind für diesen Kurs derzeit nicht möglich.": "Registration is currently not possible for this course.",
        "Appenzell Ausserrhoden": "Appenzell Ausserrhoden",
        "Appenzell Innerrhoden": "Appenzell Innerrhoden",
        "Auswahl als Excel exportieren": "Export selection as Excel",
        "Basel-Landschaft": "Basel-Landschaft",
        "Basel-Stadt": "Basel-Stadt",
        "Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten. Bitte versuche es später erneut.": "An error occurred while redeeming the gift code. Please try again later.",
        "Bern": "Bern",
        "Bezahlstatus": "Payment status",
        "Bezahlt": "Paid",
        "Bis": "To",
        "Bitte geben Sie die Empfänger-Informationen für die Geschenklizenzen ein.": "Please enter the recipient information for the gift licenses.",
        "Bitte melde dich an, um fortzufahren.": "Please log in to continue.",
        "Bitte wählen Sie aus, für wen die Lizenz(en) bestimmt sind.": "Please select who the license(s) are intended for.",
        "Bitte wählen Sie eine Versandart aus.": "Please select a shipping method.",
        "Das Kapitel wurde gelöscht.": "The chapter has been deleted.",
        "Das Produkt für diesen Gutschein wurde nicht gefunden.": "The product for this voucher was not found.",
        "Das Profil wurde erfolgreich aktualisiert.": "The profile has been successfully updated.",
        "Das Themengebiet wurde aktualisieren.": "The topic area has been updated.",
        "Das Themengebiet wurde erstellt. 🎉": "The topic area has been created. 🎉",
        "Datei erfolgreich aktualisiert.": "File successfully updated.",
        "Datei erfolgreich erstellt! 🎉": "File successfully created! 🎉",
        "Datei wurde gelöscht.": "File has been deleted.",
        "Dein Zugang zum eLearning ist jetzt aktiviert. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Details und den direkten Kurszugang. Viel Erfolg beim Lernen! 🚑💡": "Your access to eLearning is now activated. In your personal area <strong>my.sanio</strong> you will find all details and direct course access. Good luck with your learning! 🚑💡",
        "Deine Online Kurse": "Your Online Courses",
        "Deine Sanio ID": "Your Sanio ID",
        "Der Kurs wurde aktualisieren.": "The course has been updated.",
        "Der Kurs wurde erstellt. 🎉": "The course has been created. 🎉",
        "Der Kurs wurde gelöscht.": "The course has been deleted.",
        "Der Nachname ist erforderlich.": "The last name is required.",
        "Der Ort ist erforderlich.": "The location is required.",
        "Der Teilnehmer wurde vom Kurs entfernt!": "The participant has been removed from the course!",
        "Der Vorname ist erforderlich.": "The first name is required.",
        "Die Anmeldefrist ist leider abgelaufen.": "The registration deadline has unfortunately expired.",
        "Die Handynummer ist optional. Wenn Sie diese angeben, können Sie sich später auch per per SMS einloggen.": "The mobile number is optional. If you provide it, you can also log in via SMS later.",
        "Die Karte wurde gelöscht.": "The card has been deleted.",
        "Die PLZ ist erforderlich.": "The postcode is required.",
        "Die Story wurde dupliziert.": "The story has been duplicated.",
        "Die Story wurde gelöscht.": "The story has been deleted.",
        "Die Strasse ist erforderlich.": "The street is required.",
        "Die Übersetzungen werden nun exportiert.": "The translations are now being exported.",
        "Die Übersetzungen werden nun importiert.": "The translations are now being imported.",
        "Dieser Code ist kein Rabattcode, sondern schaltet dein eLearning direkt frei. Du kannst ihn jetzt sofort im Einlöse-Bereich nutzen - ohne erneutes Login oder weitere Schritte.": "This code is not a discount code, but unlocks your eLearning directly. You can use it right now in the redemption area - without logging in again or any further steps.",
        "Dieser Geschenkcode ist ungültig oder wurde bereits eingelöst.": "This gift code is invalid or has already been redeemed.",
        "Dieser Geschenkcode wurde bereits eingelöst.": "This gift code has already been redeemed.",
        "Digital & physisch per Post": "Digital & physical by post",
        "Direktion": "Management",
        "Dokumente": "Documents",
        "Du hast keine Berechtigung, diesen Teilnehmer zu sehen.": "You do not have permission to view this participant.",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist schon eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "You can download the vouchers as PDF or copy the direct redemption link. The code is already inserted – perfect for sending via WhatsApp, email or SMS.",
        "Du kannst diese:n Teilnehmer:in nicht mehr bearbeiten. Bitte wende dich an deine Ansprechperson bei Sanio.": "You can no longer edit this participant. Please contact your Sanio contact person.",
        "E-Learning-Kurs suchen…": "Search e-learning course…",
        "Empfänger ändern": "Change recipient",
        "Filter zurücksetzen": "Reset filter",
        "Filtern": "Filter",
        "Freiburg": "Fribourg",
        "Funktion": "Function",
        "Geburtsdatum": "Date of birth",
        "Geburtsdatum (TT.MM.JJJJ)": "Date of birth (DD.MM.YYYY)",
        "Genf": "Geneva",
        "Geschenklizenz einlösen": "Redeem gift licence",
        "Glarus": "Glarus",
        "Graubünden": "Grisons",
        "Gutschein gefunden!": "Voucher found!",
        "Gutschein jetzt einlösen": "Redeem voucher now",
        "Gutscheine werden vorbereitet": "Vouchers are being prepared",
        "Hier dein persönlicher Zugang, um dich im shop.sanio einzuloggen:": "Here is your personal access to log in to shop.sanio:",
        "Instruktor:in": "Instructor",
        "Jura": "Jura",
        "Kaufbeleg / Rechnung als PDF": "Proof of purchase / Invoice as PDF",
        "Keine Feedbacks für die aktuellen Filter.": "No feedback for the current filters.",
        "Klasse": "Class",
        "Klassenstufe": "Grade level",
        "Kontext": "Context",
        "Kundenberater": "Customer advisor",
        "Kundenportal Gruppenadmin": "Customer portal group admin",
        "Kundenportal Superadmin": "Customer portal superadmin",
        "Kurs abgeschlossen, Prüfung ausstehend": "Course completed, exam pending",
        "Kurs suchen…": "Search course…",
        "Kursfortschritt": "Course progress",
        "Kurszugang nicht gefunden.": "Course access not found.",
        "Luzern": "Lucerne",
        "Mein Profil": "My profile",
        "Meine Bestellungen": "My orders",
        "Melde dich mit deiner Handynummer oder E-Mail an und schon geht’s los!": "Log in with your mobile number or email and get started!",
        "MidnightSports": "MidnightSports",
        "Mindestens ein Empfänger muss angegeben werden.": "At least one recipient must be specified.",
        "MiniMove": "MiniMove",
        "Name des Empfängers darf maximal 255 Zeichen lang sein.": "Recipient name must not exceed 255 characters.",
        "Name des Empfängers ist erforderlich.": "Recipient name is required.",
        "Name des Schenkers darf maximal 255 Zeichen lang sein.": "Donor name must not exceed 255 characters.",
        "Name des Schenkers ist erforderlich.": "Donor name is required.",
        "Neuenburg": "Neuchâtel",
        "Nicht Bezahlt": "Not Paid",
        "Nidwalden": "Nidwalden",
        "Obwalden": "Obwalden",
        "OpenSunday": "OpenSunday",
        "Prüfung bestanden": "Exam passed",
        "Sanio Kundenportal": "Sanio Customer Portal",
        "Schaffhausen": "Schaffhausen",
        "Schuleinheit": "School unit",
        "Schwyz": "Schwyz",
        "Shop Kunde ID": "Shop Customer ID",
        "Solothurn": "Solothurn",
        "St. Gallen": "St. Gallen",
        "Standort": "Location",
        "Standort/Fachbereich": "Location/Department",
        "Store": "Store",
        "Super Admin": "Super Admin",
        "Teilnahmebestätigung als PDF": "Certificate of Participation as PDF",
        "Teilnehmer": "Participant",
        "Teilnehmer nicht gefunden.": "Participant not found.",
        "Teilnehmer:in konnte nicht hinzugefügt werden": "Participant could not be added",
        "Teilnehmer:in wurde erfolgreich angemeldet.": "Participant successfully registered.",
        "Teilnehmer:in wurde erfolgreich hinzugefügt": "Participant successfully added",
        "Tessin": "Ticino",
        "Thurgau": "Thurgau",
        "Ungültige Auswahl für Lizenzempfänger.": "Invalid selection for license recipient.",
        "Ungültige Versandart ausgewählt.": "Invalid shipping method selected.",
        "Uri": "Uri",
        "Von": "From",
        "Waadt": "Vaud",
        "Wallis": "Valais",
        "Zug": "Zug",
        "Zyklus": "Cycle",
        "Zürich": "Zurich",
        "andere": "other",
        "bearbeitungsbedürftig": "requires editing",
        "my.sanio Kunde": "my.sanio customer",
        "n/A": "n/a",
        "nicht übersetzt": "not translated",
        "🤔 Es sind keine Kurse geplant": "🤔 No courses are scheduled",
        "Archivierte Kurse": "Archived courses",
        "Abgemeldet: Teilnahme abgelehnt": "Unregistered: Participation declined",
        "Abgemeldet: Vorzeitig storniert": "Unregistered: Cancelled early",
        "Abgemeldet: Entschuldigt": "Unregistered: Excused",
        "Abgemeldet: Unentschuldigt": "Unregistered: Unexcused",
        "Warteliste": "Waiting list",
        "entschuldigt": "excused",
        "unentschuldigt": "unexcused",
        "{firstName} {lastName} war {reason} abwesend weil: {note}": "{firstName} {lastName} was {reason} absent because: {note}",
        "errors.503.status_prefix": "Current system status:",
        "Kursort": "Course location",
        "Kursleitung": "Course instructor",
        "Kurssprache:": "Course language:",
        "Kurs-ID:": "Course ID:",
        "Neu": "New",
        "Abschliessen": "Complete",
        "Die Kursinformationen wurden versendet.": "The course information has been sent.",
        "Änderungen zu deinem Kurs": "Changes to your course",
        "Kurszuteilung": "Course assignment",
        "Du wurdest von einem Kurs entfernt": "You have been removed from a course",
        "Der Kurs muss bereit sein.": "The course must be ready.",
        "Diese Person ist keine Kursleitung.": "This person is not a course instructor.",
        "Diese Kursleitung ist keinem Termin dieses Kurses zugeteilt.": "This course instructor is not assigned to any session of this course.",
        "Der Kurs ist bereits vorbei und kann nicht auf \"Bereit\" gesetzt werden. Der Kurs würde innert wenigen Augenblicken auf \"Durchgeführt\" gestellt werden.": "The course has already ended and cannot be set to \"Ready\". The course would be set to \"Completed\" within a few moments.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange Anwesenheiten fehlen.": "The course cannot be set to \"Completed\" as long as attendances are missing.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange anwesende Teilnehmende das E-Learning nicht bestanden haben.": "The course cannot be set to \"Completed\" as long as participants who attended have not passed the e-learning.",
        "Kurstyp": "Course type",
        "Datum/Zeit": "Date/Time",
        "Kontaktperson": "Contact person",
        "Kontaktaufnahme": "Contact",
        "Infos zu Kontaktaufnahme": "Contact information",
        "Beschreibung Kursleitung": "Course instructor description",
        "Präsentation": "Presentation",
        "Präsentieren": "Present",
        "Kurspräsentation": "Course presentation",
        "Weitere Links": "Additional links",
        "Auswahl entfernen: {option}": "Remove selection: {option}",
        "Keine Optionen gefunden": "No options found",
        "Abgelehnt am": "Declined on",
        "Bestätigt am": "Confirmed on",
        "Mail versendet, Bestätigung offen": "Email sent, confirmation pending",
        "Modus": "Mode",
        "Typ & Dauer": "Type & Duration",
        "Belegung": "Occupancy",
        "Materialset": "Material set",
        "Fehlende Kursleitung": "Missing course instructor",
        "Initialer Mailversand offen": "Initial email dispatch pending",
        "Nicht versendete Kursleitungs-Infos vorhanden": "Unsent course instructor information available",
        "Kontaktperson für Kursleitung": "Contact person for course instructor",
        "Infos offen": "Information pending",
        "Infos veraltet": "Information outdated",
        "Kursleitungs-Infos senden": "Send course instructor information",
        "Diese Kursleitung hat die initialen Kursinformationen noch nicht erhalten.": "This course instructor has not yet received the initial course information.",
        "Diese Kursleitung hat noch nicht alle aktuellen Kursinformationen erhalten.": "This course instructor has not yet received all current course information.",
        "Zu versendende Änderungen": "Changes to be sent",
        "Alt": "Old",
        "Senden": "Send",
        "Automatischer Versand bei Abschluss ist in den E-Mail-Einstellungen deaktiviert.": "Automatic dispatch on completion is disabled in the email settings.",
        "Abwesend": "Absent",
        "Abwesenheit erfassen": "Record absence",
        "Wie war {name} abwesend?": "How was {name} absent?",
        "Notiz (optional)": "Note (optional)",
        "Grund der Abwesenheit": "Reason for absence",
        "Wird eine Notiz erfasst, wird automatisch ein Kommentar zum Kurs hinzugefügt.": "If a note is entered, a comment will automatically be added to the course.",
        "Es gab Änderungen zu deinem zugeteilten Kurs:": "There have been changes to your assigned course:",
        "Folgende Informationen wurden aktualisiert:": "The following information has been updated:",
        "Bitte prüfe die aktuellen Kursdetails und bestätige uns, dass du den Kurs weiterhin leiten kannst.": "Please review the current course details and confirm that you can still lead the course.",
        "Kursinfos prüfen und bestätigen": "Review and confirm course information",
        "Kurszuteilung bestätigen": "Confirm course assignment",
        "Du wurdest von folgendem Kurs entfernt.": "You have been removed from the following course.",
        "Die Absage für deinen Kalender findest du im Anhang. Weitere Informationen zum Kurs findest du": "The cancellation for your calendar can be found in the attachment. Further information about the course can be found",
        "Du wurdest folgendem Kurs zugeteilt 🎉": "You have been assigned to the following course 🎉",
        "Bitte 30 Minuten vor Kursstart am Kursort eintreffen. Prüfe die Kursinformationen und bestätige uns, dass du den Kurs leiten kannst.": "Please arrive at the course location 30 minutes before the course starts. Review the course information and confirm that you can lead the course.",
        "Die Kalenderdatei findest du im Anhang.": "The calendar file can be found in the attachment.",
        "Termin {n}": "Timeslot {n}",
        "Termin {n} entfernen": "Remove timeslot {n}",
        "eine Kursleiter:in": "one instructor",
        "{count} Kursleiter:innen": "{count} instructors",
        "eine Springer:in": "one standby instructor",
        "{count} Springer:innen": "{count} standby instructors",
        "{count} ohne Materialset": "{count} without material set",
        "Zeit und Personal festlegen": "Set time and staff",
        "Materialset fehlt": "Material set missing",
        "Pro Termin Kursleiter:innen und optional Springer festlegen. Materialset und Abholhinweis werden pro Kursleiter:in zugewiesen.": "Assign instructors and optional standby instructors per timeslot. Material set and pickup note are set per instructor.",
        "Noch keine Termine": "No timeslots yet",
        "Füge den ersten Kurstermin hinzu.": "Add the first course timeslot.",
        "Termin hinzufügen": "Add timeslot",
        "Kursleiter:innen": "Instructors",
        "Noch keine Kursleiter:in zugewiesen.": "No instructor assigned yet.",
        "Abholhinweis": "Pickup note",
        "Aktionen": "Actions",
        "fehlt": "missing",
        "Kursleiter:in bearbeiten": "Edit instructor",
        "Kursleiter:in entfernen": "Remove instructor",
        "Als Kursleiter:in übernehmen": "Promote to instructor",
        "Kursleiter:in zuweisen": "Assign instructor",
        "Kursleiter:in": "Instructor",
        "Kursleiter:in auswählen": "Select instructor",
        "Materialset auswählen": "Select material set",
        "optional": "optional",
        "z. B. Lager West, Schlüssel bei Empfang": "e.g. Warehouse West, key at reception",
        "Zuweisen": "Assign",
        "Bitte eine Kursleiter:in auswählen.": "Please select an instructor.",
        "Springer": "Substitute",
        "Springereinsatz": "Substitute assignment",
        "Änderungen zu deinem Springereinsatz": "Changes to your substitute assignment",
        "Springer auswählen": "Select substitute",
        "Springer-Infos senden": "Send substitute information",
        "Springer bestätigt": "Substitute confirmed",
        "Springer noch nicht bestätigt": "Substitute not yet confirmed",
        "Vielen Dank, dass du dich als Springer:in für diesen Kurs zur Verfügung stellst! 🙌": "Thank you for making yourself available as a substitute instructor for this course! 🙌",
        "Falls die regulär eingeteilte Kursleitung kurzfristig ausfällt, würden wir dich gerne einsetzen.": "If the regularly assigned course instructor is unable to attend at short notice, we would like to deploy you.",
        "Aktuell musst du nichts unternehmen.": "Currently, you do not need to take any action.",
        "Bitte halte dir den Termin frei und stelle sicher, dass du kurzfristig erreichbar bist. Sollte ein Einsatz nötig werden, melden wir uns so früh wie möglich bei dir.": "Please keep the date free and ensure that you are reachable at short notice. Should deployment become necessary, we will contact you as early as possible.",
        "Weitere Informationen zum Kurs findest du": "You can find further information about the course",
        "Bitte beachte die aktualisierten Kursinformationen.": "Please note the updated course information.",
        "Diese Person hat die initialen Kursinformationen noch nicht erhalten.": "This person has not yet received the initial course information.",
        "Diese Person hat noch nicht alle aktuellen Kursinformationen erhalten.": "This person has not yet received all current course information.",
        "Bitte Kurszuteilung bestätigen": "Please confirm course assignment",
        "Springer:in auswählen": "Select substitute",
        "Springer:in bearbeiten": "Edit substitute",
        "Springer:in zuweisen": "Assign substitute",
        "Entwurf": "Draft",
        "Angefragt": "Requested",
        "Zuteilung bestätigt": "Assignment confirmed",
        "Zuteilung abgelehnt": "Assignment declined",
        "Zuteilung bestätigen": "Confirm assignment",
        "Zuteilung ablehnen": "Decline assignment",
        "Du hast diese Kurszuteilung abgelehnt.": "You declined this course assignment.",
        "Speichern & weitere Person hinzufügen": "Save & add another person",
        "Alle {count} Teilnehmer:innen anzeigen": "Show all {count} participants",
        "{shown} von {total}": "{shown} of {total}",
        "Weitere Treffer werden geladen…": "Loading more matches…",
        "Nachfassen": "Follow-up",
        "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.": "Do you want to open the course for follow-up? The course remains closed.",
        "Aktuell können nur Teilnehmende hinzugefügt oder entfernt werden. Andere Kursdetails können nicht bearbeitet werden.": "Currently only participants can be added or removed. No other course details can be edited.",
        "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.": "Currently participants can be added or removed and attendances can be edited. No other course details can be edited.",
        "Folien am Griff ziehen, um ihre Reihenfolge zu ändern.": "Drag slides by the handle to change their order.",
        "{count} Folien ausgewählt": "{count} slides selected",
        "Alle {count} Folien auswählen": "Select all {count} slides",
        "Alle Folien sind ausgewählt": "All slides are selected",
        "Auswahl aufheben": "Clear selection",
        "Folie verschieben": "Move slide",
        "Folie auswählen": "Select slide",
        "Folie {position} auswählen": "Select slide {position}",
        "Kursleiter:innen-Notiz vorhanden": "Presenter note available",
        "Keine Notizen": "No notes",
        "Folien löschen": "Delete slides",
        "Möchtest du die {count} ausgewählten Folien wirklich löschen?": "Do you really want to delete the {count} selected slides?",
        "Folienbibliothek": "Slide library",
        "Folien, Sprachversionen und Tags verwalten": "Manage slides, language versions and tags",
        "Foliensatz importieren": "Import slide deck",
        "Noch keine Folien importiert.": "No slides imported yet.",
        "Importiere einen Foliensatz, um deine Folienbibliothek aufzubauen.": "Import a slide deck to build your slide library.",
        "Folien werden importiert…": "Slides are being imported…",
        "Folienbibliothek-Einstellungen": "Slide library settings",
        "Kurspräsentation aus Folienbibliothek": "Course presentation from slide library",
        "Der Foliensatz wird importiert.": "The slide deck is being imported.",
        "Der Upload ist fehlgeschlagen.": "The upload failed.",
        "Der Upload ist unvollständig. Bitte erneut versuchen.": "The upload is incomplete. Please try again.",
        "Die Datei muss eine PDF-Datei sein.": "The file must be a PDF.",
        "Einzelne Folien müssen genau eine PDF-Seite enthalten.": "Individual slides must contain exactly one PDF page.",
        "Diese PDF-Datei kann nicht gelesen werden. Exportiere sie bitte erneut als PDF 1.4.": "This PDF file cannot be read. Please export it again as PDF 1.4.",
        "Folientitel": "Slide title",
        "Foliensätze": "Slide decks",
        "Folienbibliotheken nach Kurstyp verwalten": "Manage slide libraries by course type",
        "Foliensatz hinzufügen": "Add slide deck",
        "Noch keine Foliensätze vorhanden.": "No slide decks available yet.",
        "Foliensatz: Folien, Sprachversionen und Tags verwalten": "Slide deck: manage slides, language versions and tags",
        "Alle Foliensätze": "All slide decks",
        "Foliensatz": "Slide deck",
        "Verwendung": "Usage",
        "Kurse, die Folien aus diesem Foliensatz verwenden": "Courses that use slides from this slide deck",
        "Dieser Foliensatz wird in keinem Kurs verwendet.": "This slide deck is not used in any course.",
        "Für diesen Kurstyp ist noch kein Foliensatz vorhanden.": "No slide deck exists for this course type yet.",
        "Foliensatz erstellen": "Create slide deck",
        "Der Foliensatz wurde erstellt.": "The slide deck was created.",
        "Mindestens eine Folie gehört nicht zu diesem Foliensatz.": "At least one slide does not belong to this slide deck.",
        "Mindestens eine Folie gehört nicht zu dieser Präsentation.": "At least one slide does not belong to this presentation.",
        "Mindestens ein Tag gehört nicht zum Foliensatz dieses Kurstyps.": "At least one tag does not belong to this course type's slide deck.",
        "Folienpakete": "Slide packages",
        "Folienpaket": "Slide package",
        "Folienpakete für Kurstypen verwalten": "Manage slide packages for course types",
        "Folienpaket hinzufügen": "Add slide package",
        "Noch keine Folienpakete vorhanden.": "No slide packages available yet.",
        "Alle Folienpakete": "All slide packages",
        "Das Folienpaket wurde erstellt.": "The slide package was created.",
        "Das Folienpaket wurde gelöscht.": "The slide package was deleted.",
        "Ohne Tag-Auswahl werden alle Folien einbezogen.": "If no tags are selected, all slides are included.",
        "Dieses Folienpaket enthält noch keine Folien.": "This slide package does not contain any slides yet.",
        "Keine Folien passen zu den gewählten Tags.": "No slides match the selected tags.",
        "Optional Tags und Sprachen auswählen. Ohne Tags werden alle Folien einbezogen. Die erzeugten PDFs sind unabhängige Kopien.": "Optionally select tags and languages. Without tags, all slides are included. The generated PDFs are independent copies.",
        "Präsentation bearbeiten": "Edit presentation",
        "Folienpaket löschen": "Delete slide package",
        "Möchtest du das Folienpaket «{name}» wirklich löschen? Die Folien werden entfernt. Bereits erstellte Kurspräsentationen bleiben erhalten.": "Do you really want to delete the slide package “{name}”? Its slides will be removed. Course presentations that were already created will be kept.",
        "Foliensatz umbenennen": "Rename slide deck",
        "Der Foliensatz wurde umbenannt.": "The slide deck was renamed.",
        "Für diesen Kurstyp ist noch kein Folienpaket vorhanden.": "No slide package exists for this course type yet.",
        "Folienpaket erstellen": "Create slide package",
        "Folienpaket wählen": "Choose a slide package",
        "Name und Datum einfügen": "Insert name and date",
        "Name auf der Folie": "Name on the slide",
        "Kurspräsentation entfernen": "Remove course presentation",
        "Kurspräsentation wirklich entfernen?": "Really remove the course presentation?",
        "Die Kurspräsentation wurde entfernt.": "The course presentation was removed.",
        "Das Folienpaket gehört nicht zum Kurstyp dieses Kurses.": "The slide package does not belong to this course's type.",
        "Mindestens ein Tag gehört nicht zum gewählten Folienpaket.": "At least one tag does not belong to the selected slide package.",
        "Tags suchen oder neu erstellen…": "Search or create tags…",
        "„{name}“ erstellen": "Create “{name}”",
        "{name} entfernen": "Remove {name}",
        "Tag konnte nicht erstellt werden.": "The tag could not be created.",
        "Tag bearbeiten": "Edit tag",
        "Farbe": "Color",
        "Tag wurde aktualisiert.": "The tag was updated.",
        "Deutsch (Fallback)": "German (fallback)",
        "Deutsch bestimmt die Anzahl Folien. Weitere Sprachen werden ab Seite 1 zugeordnet und dürfen weniger Seiten enthalten.": "German determines the number of slides. Additional languages are mapped from page 1 and may contain fewer pages.",
        "PDF, maximal 350 MB pro Sprache. Der Import wird im Hintergrund verarbeitet.": "PDF, up to 350 MB per language. The import is processed in the background.",
        "Ersetzen": "Replace",
        "Tags bearbeiten": "Edit tags",
        "Zum Bearbeiten klicken": "Click to edit",
        "Zurück zum Foliensatz": "Back to slide deck",
        "Vorhanden": "Available",
        "Fehlt": "Missing",
        "PDF ersetzen": "Replace PDF",
        "PDF hinzufügen": "Add PDF",
        "Tags suchen…": "Search tags…",
        "{selected} von {total} passenden Folien ausgewählt": "{selected} of {total} matching slides selected",
        "Alle passenden Folien auswählen": "Select all matching slides",
        "Tags auswählen": "Select tags",
        "Sprachen erzeugen": "Generate languages",
        "{available}/{total} Folie verfügbar|{available}/{total} Folien verfügbar": "{available}/{total} slide available|{available}/{total} slides available",
        "Nicht alle gewählten Folien sind in jeder Sprache vorhanden.": "Not all selected slides are available in every language.",
        "{count} fehlend|{count} fehlend": "{count} missing|{count} missing",
        "Wird erstellt…": "Generating…",
        "Kurspräsentation erstellen": "Create course presentation",
        "Jetzt zu Presio senden": "Send to Presio now",
        "Folie": "Slide",
        "Fehlende Übersetzungen": "Missing translations",
        "Fehlende Folien überspringen": "Skip missing slides",
        "Deutsche Folie verwenden": "Use German slide",
        "Folienvorschau": "Slide preview",
        "{count} Folie wird für diese Sprache erzeugt.|{count} Folien werden für diese Sprache erzeugt.": "{count} slide will be generated for this language.|{count} slides will be generated for this language.",
        "Wähle Tags aus, um die passenden Folien zu sehen.": "Select tags to see the matching slides.",
        "Alle passenden Folien wurden entfernt.": "All matching slides have been removed.",
        "Folie entfernen": "Remove slide",
        "Wird in dieser Sprache übersprungen": "Skipped in this language",
        "Deutsch als Fallback": "German fallback",
        "Erstellt": "Generated",
        "{processed} von {total} Folie|{processed} von {total} Folien": "{processed} of {total} slide|{processed} of {total} slides",
        "Die Folien werden zusammengeführt.": "The slides are being merged.",
        "Präsentation wird erstellt": "Presentation is being generated",
        "Du kannst diese Seite verlassen, die Erstellung läuft im Hintergrund weiter.": "You can leave this page, generation continues in the background.",
        "Präsentation erstellt": "Presentation generated",
        "Die PDFs stehen zum Herunterladen bereit.": "The PDFs are ready to download.",
        "Erstellung abgebrochen": "Generation cancelled",
        "Erstellung fehlgeschlagen": "Generation failed",
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.": "An error occurred. Please try again.",
        "Zuletzt erstellte Version": "Last generated version",
        "Die Erstellung wurde abgebrochen.": "Generation was cancelled.",
        "Mindestens eine ausgewählte Folie gehört nicht zur aktuellen Tag-Auswahl.": "At least one selected slide does not belong to the current tag selection.",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Präsentieren würde eine veraltete Version zeigen.": "The latest course presentation has not been sent to Presio yet. Presenting would show an outdated version.",
        "FEHLT": "MISSING",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Bitte bei Admin melden.": "The latest course presentation is not in Presio yet. Please tell an admin.",
        "Der Versand an Presio ist fehlgeschlagen.": "Sending to Presio failed.",
        "Die Präsentation wird gerade an Presio gesendet. Bitte versuche es in einem Moment erneut.": "The presentation is being sent to Presio. Please try again in a moment.",
        "Die Kurspräsentation konnte nicht erstellt werden.": "The course presentation could not be created.",
        "Die Kurspräsentation konnte nicht an Presio gesendet werden.": "The course presentation could not be sent to Presio.",
        "Die Kurspräsentation für {course} konnte nicht erstellt werden.": "The course presentation for {course} could not be created.",
        "Die Kurspräsentation für {course} ({language}) konnte nicht an Presio gesendet werden.": "The course presentation for {course} ({language}) could not be sent to Presio.",
        "Kurs öffnen": "Open course",
        "PDF herunterladen": "Download PDF",
        "Kursleiter:innen-Notiz bearbeiten": "Edit presenter note",
        "Diese Notiz wird der Kursleitung beim Präsentieren in Presio angezeigt.": "This note is shown to the instructor while presenting in Presio.",
        "Notiz aus Folienbibliothek verwenden": "Use note from slide library",
        "Kursspezifisch": "Course-specific",
        "Mindestens eine Notiz gehört nicht zu den ausgewählten Folien.": "At least one note does not belong to the selected slides.",
        "Die Präsentation konnte nicht gestartet werden. Bitte versuche es in einem Moment erneut.": "The presentation could not be started. Please try again in a moment.",
        "Die Präsentation wird an Presio gesendet.": "The presentation is being sent to Presio.",
        "Wird an Presio gesendet…": "Sending to Presio…",
        "deine Zeit": "your time",
        "Nicht gesetzt": "Not set",
        "Dieses Produkt kann nicht bestellt werden.": "This product cannot be ordered.",
        "Dein Warenkorb ist leer.": "Your cart is empty.",
        "Dein Warenkorb enthält Produkte, die nicht mehr bestellt werden können. Bitte entferne sie.": "Your cart contains products that can no longer be ordered. Please remove them.",
        "Der Status kann nicht von «{from}» auf «{to}» geändert werden.": "The status cannot be changed from «{from}» to «{to}».",
        "Stück": "pcs.",
        "Abholung im Büro": "Pickup at the office",
        "Versand": "Shipping",
        "Verpackt": "Packed",
        "Erledigt": "Done",
        "Das Produkt wurde bereits bestellt und kann nicht gelöscht werden. Deaktiviere es stattdessen.": "The product has already been ordered and cannot be deleted. Deactivate it instead.",
        "Die Kategorie enthält noch Produkte und kann nicht gelöscht werden.": "The category still contains products and cannot be deleted.",
        "Die Kategorie wurde erstellt.": "The category has been created.",
        "Die Kategorie wurde aktualisiert.": "The category has been updated.",
        "Die Kategorie wurde gelöscht.": "The category has been deleted.",
        "Der Status wurde auf «{status}» geändert.": "The status has been changed to «{status}».",
        "Das Produkt wurde erstellt.": "The product has been created.",
        "Das Produkt wurde aktualisiert.": "The product has been updated.",
        "Das Produkt wurde gelöscht.": "The product has been deleted.",
        "Das Produkt wurde in den Warenkorb gelegt.": "The product has been added to the cart.",
        "Der Warenkorb wurde aktualisiert.": "The cart has been updated.",
        "Das Produkt wurde aus dem Warenkorb entfernt.": "The product has been removed from the cart.",
        "Vielen Dank! Deine Bestellung ist eingegangen.": "Thank you! Your order has been received.",
        "Warenkorb": "Cart",
        "Shop": "Shop",
        "Weiter einkaufen": "Continue shopping",
        "Material auswählen": "Choose supplies",
        "Dieses Produkt kann nicht mehr bestellt werden.": "This product can no longer be ordered.",
        "Entfernen": "Remove",
        "Zur Bestellung": "Proceed to order",
        "Bestellung abschliessen": "Complete order",
        "Zurück zum Warenkorb": "Back to cart",
        "Lieferung": "Delivery",
        "Details": "Details",
        "Benötigt bis": "Needed by",
        "Bemerkung": "Note",
        "Deine Bestellung": "Your order",
        "Bestellung absenden": "Submit order",
        "Material bestellen": "Order supplies",
        "Wähle das Kursmaterial aus, das du für deine Kurse benötigst.": "Choose the course supplies you need for your courses.",
        "Aktuell kann kein Material bestellt werden.": "No supplies can be ordered at the moment.",
        "In den Warenkorb": "Add to cart",
        "{quantity} im Warenkorb": "{quantity} in cart",
        "Menge verringern": "Decrease quantity",
        "Menge erhöhen": "Increase quantity",
        "Entferne die nicht mehr bestellbaren Artikel, um fortzufahren.": "Remove the items that can no longer be ordered to continue.",
        "Storniert": "Cancelled",
        "Storniert am": "Cancelled on",
        "Stornieren": "Cancel",
        "Bestellung stornieren": "Cancel order",
        "Möchtest du diese Bestellung wirklich stornieren?": "Do you really want to cancel this order?",
        "Deine Bestellung wurde storniert.": "Your order has been cancelled.",
        "Diese Bestellung wurde am {date} storniert.": "This order was cancelled on {date}.",
        "Diese Bestellung wird bereits bearbeitet und kann nicht mehr direkt storniert werden.": "This order is already being processed and can no longer be cancelled directly.",
        "Begründung": "Reason",
        "Stornierungsanfrage": "Cancellation request",
        "Stornierungsanfragen": "Cancellation requests",
        "Stornierungsanfrage senden": "Send cancellation request",
        "Stornierungsanfrage vom {date}": "Cancellation request from {date}",
        "Stornierungsanfrage gesendet am {date}. Wir melden uns bei dir.": "Cancellation request sent on {date}. We will get back to you.",
        "Stornierung angefragt": "Cancellation requested",
        "Stornierung bestätigen": "Confirm cancellation",
        "Anfrage ablehnen": "Decline request",
        "Abgelehnte Stornierungsanfrage": "Declined cancellation request",
        "Deine Bestellung wird bereits bearbeitet. Bitte begründe, warum du sie stornieren möchtest.": "Your order is already being processed. Please explain why you want to cancel it.",
        "Deine Stornierungsanfrage wurde gesendet.": "Your cancellation request has been sent.",
        "Deine Stornierungsanfrage wurde abgelehnt.": "Your cancellation request was declined.",
        "Die Stornierungsanfrage wurde abgelehnt.": "The cancellation request was declined.",
        "Für diese Bestellung kann keine Stornierungsanfrage gesendet werden.": "A cancellation request cannot be sent for this order.",
        "Für diese Bestellung gibt es keine offene Stornierungsanfrage.": "There is no open cancellation request for this order.",
        "Zum Shop": "To the shop",
        "Du hast noch kein Material bestellt.": "You have not ordered any supplies yet.",
        "Bestellung {number}": "Order {number}",
        "{count} Artikel": "{count} items",
        "Artikel": "Items",
        "Bestellt am": "Ordered on",
        "Kategorie erstellen": "Create category",
        "Kategorie bearbeiten": "Edit category",
        "Interner Shop – Kategorien": "Internal shop – Categories",
        "Kategorien": "Categories",
        "Materialbestellungen": "Supply orders",
        "Als «{status}» markieren": "Mark as «{status}»",
        "Produkt erstellen": "Create product",
        "Interner Shop – Produkte": "Internal shop – Products",
        "Kategorie": "Category",
        "Einheit": "Unit",
        "Wird im Shop neben der Menge angezeigt, zum Beispiel Stück.": "Shown in the shop next to the quantity, for example pcs.",
        "Aktiv (bestellbar)": "Active (orderable)",
        "Bild": "Image",
        "Das Feld {field} wird für die Teilnehmenden-Erkennung benötigt und kann nicht archiviert werden.": "The field {field} is required to identify participants and cannot be archived.",
        "Übernimm zuerst die bestehende Feldkonfiguration, bevor du Felder hinzufügst.": "Adopt the existing field configuration before adding fields.",
        "Für diesen Login-Bereich sind bereits Felder konfiguriert.": "Fields are already configured for this login area.",
        "Die Reihenfolge enthält Felder, die nicht zu diesem Login-Bereich gehören.": "The order contains fields that do not belong to this login area.",
        "Bezeichnung (Deutsch)": "Label (German)",
        "Feldtyp": "Field type",
        "Import-Spalte": "Import column",
        "Option (Deutsch)": "Option (German)",
        "Öffentliche Anmeldung": "Public registration",
        "Persönliche Angaben": "Personal information",
        "B2B-Portal": "B2B portal",
        "in.sanio": "in.sanio",
        "Import / Export": "Import / Export",
        "Übersichten": "Overviews",
        "Kursdetail": "Course detail",
        "Text": "Text",
        "Mehrzeiliger Text": "Multi-line text",
        "Auswahl": "Selection",
        "Das Feld {field} darf nicht in «{context}» verwendet werden.": "The field {field} must not be used in «{context}».",
        "Eine Auswahl braucht mindestens eine aktive Option.": "A selection needs at least one active option.",
        "Die Import-Spalte {name} wird bereits von einem anderen Feld verwendet.": "The import column {name} is already used by another field.",
        "Feld wurde archiviert.": "Field has been archived.",
        "Feld wurde wiederhergestellt.": "Field has been restored.",
        "Einstellungen wurden gespeichert.": "Settings have been saved.",
        "Reihenfolge wurde gespeichert.": "Order has been saved.",
        "Die bestehende Feldkonfiguration wurde übernommen.": "The existing field configuration has been adopted.",
        "Feld wurde hinzugefügt.": "Field has been added.",
        "Feld wurde gespeichert.": "Field has been saved.",
        "Der Schlüssel {key} ist bereits vergeben.": "The key {key} is already taken.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten und muss mit einem Buchstaben beginnen.": "The key may only contain lowercase letters, numbers and underscores and must start with a letter.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten.": "The key may only contain lowercase letters, numbers, hyphens and underscores.",
        "Technischer Schlüssel": "Technical key",
        "Schlüssel": "Key",
        "Entschuldige, ich helfe nur Sanio-Mitarbeitenden mit einem passenden Benutzerkonto.": "Sorry, I can only help Sanio staff members with a matching user account.",
        "Da ist leider etwas schiefgelaufen. Bitte versuche es später nochmals.": "Unfortunately something went wrong. Please try again later.",
        "Darf ich einen Cursor-Agent einen Bugfix-Pull-Request vorbereiten lassen?": "May I have a Cursor agent prepare a bugfix pull request?",
        "Darf ich die Aktion {tool} ausführen?": "May I run the action {tool}?",
        "Freigeben": "Approve",
        "Ablehnen": "Reject",
        "Freigegeben von {name}.": "Approved by {name}.",
        "Abgelehnt von {name}.": "Rejected by {name}.",
        "Diese Freigabe ist nicht mehr gültig.": "This approval is no longer valid.",
        "Du darfst diese Aktion nicht freigeben.": "You are not allowed to approve this action.",
        "{server} ist jetzt mit Henry verbunden.": "{server} is now connected to Henry.",
        "Repository": "Repository",
        "Linear-Ticket": "Linear ticket",
        "Neue Datei hochladen": "Upload new file",
        "oder per Drag & Drop hierher ziehen": "or drag and drop it here",
        "Datei {current} von {total} wird hochgeladen…": "Uploading file {current} of {total}…",
        "Die Datei {name} hat einen ungültigen Dateityp.": "The file {name} has an invalid file type.",
        "Video-Folie hinzufügen": "Add video slide",
        "YouTube-URL": "YouTube URL",
        "Laser": "Laser",
        "Zeichnen": "Draw",
        "Beamer": "Projector",
        "Zuschauer-Link": "Audience link",
        "Handy koppeln": "Pair phone",
        "Offline vorbereiten": "Prepare offline",
        "Wird vorbereitet…": "Preparing…",
        "Präsentation wird geladen…": "Loading presentation…",
        "Die Präsentation konnte nicht geladen werden.": "The presentation could not be loaded.",
        "Verbunden": "Connected",
        "Nur lokal verbunden": "Connected locally only",
        "Beendet": "Ended",
        "Offline bereit": "Ready offline",
        "Beamer öffnen": "Open projector",
        "Aktuelle Folie": "Current slide",
        "Präsentationswerkzeuge": "Presentation tools",
        "Nächste Folie": "Next slide",
        "Ende der Präsentation": "End of presentation",
        "Kleinere Schrift": "Smaller text",
        "Grössere Schrift": "Larger text",
        "Folien": "Slides",
        "Video pausieren": "Pause video",
        "Video abspielen": "Play video",
        "Folie {number}": "Slide {number}",
        "Werkzeugleiste verschieben": "Move toolbar",
        "Letzten Strich rückgängig machen": "Undo last stroke",
        "Zeichnungen auf dieser Folie löschen": "Clear drawings on this slide",
        "Zeiger (kein Werkzeug)": "Pointer (no tool)",
        "Laserpointer": "Laser pointer",
        "Markieren": "Highlight",
        "Präsentation beenden?": "End presentation?",
        "Die Verbindung zu allen Zuschauern wird getrennt.": "All viewers will be disconnected.",
        "Notizen zu dieser Folie hinzufügen…": "Add notes for this slide…",
        "Klicken, um die Notizen zu bearbeiten": "Click to edit the notes",
        "Klicken, um Notizen hinzuzufügen.": "Click to add notes.",
        "Folien pro Sprache": "Slides per language",
        "{count} von {total} Folien in dieser Sprache": "{count} of {total} slides in this language",
        "Notizen vergrössern": "Enlarge notes",
        "Notizen verkleinern": "Shrink notes",
        "Teilnehmende scannen den QR-Code, um die Folien live auf ihrem Gerät mitzuverfolgen.": "Participants scan the QR code to follow the slides live on their device.",
        "Scanne den QR-Code mit deinem Handy, um die Präsentation damit zu steuern und deine Notizen zu sehen.": "Scan the QR code with your phone to control the presentation and see your notes.",
        "Präsentation beenden": "End presentation",
        "Diese Präsentation ist beendet.": "This presentation has ended.",
        "Du bist abgemeldet": "You are signed out",
        "Deine Sitzung ist abgelaufen. Melde dich erneut an.": "Your session has expired. Sign in again.",
        "Zur Anmeldung": "Sign in",
        "Notizen": "Notes",
        "Timer": "Timer",
        "Start": "Start",
        "Pause": "Pause",
        "Video": "Video",
        "Ton aus": "Mute",
        "Ton an": "Unmute",
        "Diese Folie ist in dieser Sprache nicht verfügbar.": "This slide is not available in this language.",
        "Der YouTube-Link ist ungültig.": "The YouTube link is invalid.",
        "Mindestens ein YouTube-Link ist erforderlich.": "At least one YouTube link is required.",
        "Für diesen Kurs gibt es noch keine Präsentation.": "This course does not have a presentation yet.",
        "Diese Folie gehört nicht zur Präsentation.": "This slide does not belong to the presentation.",
        "Der Laserpunkt ist ungültig.": "The laser point is invalid.",
        "Die Abspielposition ist ungültig.": "The playback position is invalid.",
        "Video-Folie wurde hinzugefügt.": "Video slide added.",
        "Diese Notiz wird der Kursleitung beim Präsentieren angezeigt.": "This note is shown to the instructor while presenting.",
        "messages": {
            "communication": {
                "notifications": {
                    "status": {
                        "skipped": "Skipped",
                        "failed": "Failed",
                        "sending": "Sending...",
                        "sent": "Sent"
                    },
                    "channel": {
                        "database": "Database",
                        "twilio": "SMS",
                        "mail": "Email",
                        "whatsapp": "WhatsApp"
                    }
                }
            },
            "feedback": {
                "moods": {
                    "negative": "Negative",
                    "neutral": "Neutral",
                    "positive": "Positive"
                }
            },
            "elearning": {
                "online_course": {
                    "status": {
                        "in_progress": "In progress",
                        "test": "In review",
                        "online": "Online",
                        "inactive": "Inactive",
                        "archived": "Archived"
                    },
                    "type": {
                        "customer": "Customer",
                        "marketing": "Marketing",
                        "content_test": "Content test",
                        "demo": "Demo",
                        "internal": "Internal"
                    }
                },
                "stories": {
                    "status": {
                        "draft": "Draft",
                        "review": "To be reviewed",
                        "in-review": "In review",
                        "review-done": "Review done",
                        "translation": "In translation",
                        "done": "Done"
                    },
                    "subject_focus": {
                        "adults": "Adults",
                        "teenagers": "Teenagers (10-15)",
                        "children": "Children (4-9)",
                        "babies": "Babies (0-3)"
                    },
                    "subject_focus_list": {
                        "adults": "Adults",
                        "teenagers": "Teenagers (10-15)",
                        "children": "Children (4-9)",
                        "babies": "Babies (0-3)"
                    }
                }
            },
            "shop": {
                "products": {
                    "type": {
                        "service": "Service",
                        "goods": "Goods"
                    },
                    "status": {
                        "active": "Active",
                        "inactive": "Inactive",
                        "archived": "Archived"
                    }
                },
                "orders": {
                    "status": {
                        "new": "new",
                        "pending": "pending",
                        "paid": "paid",
                        "shipped": "shipped",
                        "completed": "completed"
                    }
                },
                "invoices": {
                    "status": {
                        "new": "New",
                        "paid": "Paid",
                        "overpaid": "Overpaid",
                        "partially_paid": "Partially Paid",
                        "overdue": "Overdue",
                        "cancelled": "Cancelled",
                        "refunded": "Refunded",
                        "partially_refunded": "Partially Refunded"
                    }
                },
                "vouchers": {
                    "status": {
                        "pending": "Pending",
                        "active": "Active",
                        "used": "Used",
                        "expired": "Expired",
                        "inactive": "Inactive"
                    }
                },
                "payments": {
                    "status": {
                        "pending": "Pending",
                        "paid": "Paid",
                        "failed": "Failed",
                        "refunded": "Refunded",
                        "partially-refunded": "Partially Refunded",
                        "refund-pending": "Refund Pending"
                    }
                }
            },
            "course_overview": {
                "modes": {
                    "presence": "Presence courses",
                    "elearning": "eLearning",
                    "blended-learning": "Blended learning"
                },
                "groups": {
                    "past_unclosed": "Past and not yet completed",
                    "running": "Currently running courses",
                    "starting_this_week": "Starting in the next 7 days",
                    "future": "Future courses"
                },
                "collapse_group": "Collapse group",
                "expand_group": "Expand group"
            },
            "course_management": {
                "status": {
                    "draft": "Draft",
                    "ready": "Ready",
                    "to_be_moved": "Being moved",
                    "running": "In progress",
                    "conducted": "Conducted",
                    "completed": "Completed",
                    "cancelled": "Cancelled",
                    "archived": "Archived",
                    "follow_up": "Follow-up"
                },
                "transition_actions": {
                    "reset_to_draft": "Reset to draft",
                    "reopen": "Reopen course",
                    "not_ready": "No longer ready",
                    "mark_ready": "Mark course ready",
                    "mark_to_be_moved": "Mark course to be moved",
                    "complete": "Complete course",
                    "cancel": "Cancel course",
                    "archive": "Archive course",
                    "follow_up": "Follow-up",
                    "revert_completion": "Revert completion"
                },
                "transition_confirmations": {
                    "reset_to_draft": "Do you want to set the course back to \"Draft\"? Registrations will no longer be possible afterwards.",
                    "complete": "Do you want to complete the course? This will trigger the sending of the course confirmations, provided email addresses are stored for the participants.",
                    "cancel": "Do you really want to cancel the course?",
                    "archive": "Do you want to archive the course?",
                    "follow_up": "Do you want to open the course for follow-up? The course remains closed.",
                    "reopen": "Do you want to reopen the cancelled course?",
                    "revert_completion": "Do you want to revert the completion? The course will be set back to \"Conducted\". Confirmations and certificates that were already sent will not be sent again when the course is completed once more."
                },
                "transition_warnings": {
                    "follow_up_restrictions": "Currently participants can be added or removed and attendances can be edited. No other course details can be edited.",
                    "blended_pending_elearning": "Upon completion, only attendees who have already passed the eLearning will receive a course confirmation. The remaining attendees will automatically receive their course confirmation as soon as they pass the eLearning.",
                    "no_confirmations_both": "NO course confirmations will be sent upon completion because the attendance confirmation generator and the setting \"Automatically send course confirmations upon completion\" are both disabled. Enable both in the course settings if participants should receive a confirmation.",
                    "no_confirmations_certificate_generator": "NO course confirmations will be sent upon completion because the attendance confirmation generator is disabled. Enable it in the course settings if participants should receive a confirmation.",
                    "no_confirmations_mail_setting": "NO course confirmations will be sent upon completion because the setting \"Automatically send course confirmations upon completion\" is disabled in the email settings. Enable it if participants should receive a confirmation."
                }
            },
            "general": {
                "duration": {
                    "days": "one day|{count} days",
                    "months": "one month|{count} months",
                    "years": "one year|{count} years"
                }
            }
        }
    },
    "fr": {
        "Anmelden": "Se connecter",
        "E-Mail": "E-mail",
        "Passwort": "Mot de passe",
        "Passwort vergessen?": "Mot de passe oublié ?",
        "Eine Woche lang angemeldet bleiben": "Rester connecté pendant une semaine",
        "Wie schön, du wurdest beschenkt! Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Quelle chance, on t'a fait un cadeau ! Utilise ton code ici et découvre ce qui t'attend.",
        "Code eingeben und persönlichen Zugang aktivieren": "Saisir le code et activer l'accès personnel",
        "Code eingeben": "Saisir le code",
        "Einlösen": "Utiliser",
        "Code entfernen": "Supprimer le code",
        "Benötigst du Hilfe?": "Besoin d'aide ?",
        "Wir helfen dir gerne per E-Mail oder Telefon.": "Nous t'aidons volontiers par e-mail ou par téléphone.",
        "Deine Lizenz": "Ta licence",
        "Bitte gib deinen Geschenkcode ein.": "Merci de saisir ton code cadeau.",
        "Dieser Geschenkcode konnte nicht gefunden werden.": "Ce code cadeau est introuvable.",
        "Etwas ist schiefgelaufen. Bitte versuche es erneut.": "Une erreur est survenue. Merci de réessayer.",
        "Code gültig für {product}": "Code valable pour {product}",
        "Für {name}": "Pour {name}",
        "Willkommen bei": "Bienvenue chez",
        "Passwort zurücksetzen": "Réinitialiser le mot de passe",
        "Zurück zur Anmeldung": "Retour à l'inscription",
        "Zurück zum Kurs": "Retour au cours",
        "Fenster auf den Beamer ziehen und die Anzeige auf Erweitert stellen.": "Glissez la fenêtre sur le projecteur et réglez l'affichage sur Étendre.",
        "Vollbild": "Plein écran",
        "Vollbild beenden": "Quitter le plein écran",
        "Radierer": "Gomme",
        "Rückgängig": "Annuler",
        "Leeren": "Effacer",
        "Zuschauer-QR": "QR public",
        "QR ausblenden": "Masquer le QR",
        "Weisse Seite": "Page blanche",
        "Sprache wählbar": "Langue au choix",
        "Präsentation anpassen": "Adapter la présentation",
        "Die Präsentation wird gerade erstellt oder vorgeführt.": "La présentation est en cours de création ou de projection.",
        "Die Kurspräsentation wird neu erstellt.": "La présentation du cours est recréée.",
        "Die Vorlage wurde gespeichert.": "Le modèle a été enregistré.",
        "Die Vorlage wurde gelöscht.": "Le modèle a été supprimé.",
        "Vorlage laden": "Charger un modèle",
        "Vorlage speichern": "Enregistrer le modèle",
        "Vorlage löschen": "Supprimer le modèle",
        "Name der Vorlage": "Nom du modèle",
        "Link anfordern": "Demander un lien",
        "zurück": "retour",
        "Liste exportieren": "Exporter la liste",
        "Anmeldungen": "Inscriptions",
        "Abmeldungen": "Désinscriptions",
        "Vorname": "Prénom",
        "Nachname": "Nom de famille",
        "Kurssprache": "Langue du cours",
        "Beschreibung": "Description",
        "Link ist aktiv": "Le lien est actif",
        "Kurs freigeben": "Valider le cours",
        "Es existieren keine Daten.": "Il n'existe pas de données.",
        "Willkommen": "Bienvenue",
        "Teilnehmende": "Participant-e-s",
        "Sortieren nach": "Trier par",
        "Datum": "Date",
        "Plätze frei": "Places libres",
        "ausgebucht": "complet",
        "Weitere Person anmelden": "Inscrire une autre personne",
        "An-/Abmeldung": "Inscription/désinscription",
        "Ja, ich nehme teil": "Oui, je participe",
        "Nein, ich bin verhindert": "Non, je suis indisponible",
        "allgemeinen Geschäftsbedingungen": "Conditions générales",
        "Datenschutzerklärung": "Déclaration de confidentialité",
        "Absenden": "Envoyer",
        "Fragen oder Probleme?": "Des questions ou des problèmes ?",
        "Hallo": "Salut",
        "Anmeldebestätigung": "Confirmation d'inscription",
        "Erste Hilfe Kurs": "Cours de premiers secours",
        "Vielen Dank für deine Anmeldung zum Erste Hilfe Kurs. Hier nochmals die wichtigsten Infos": "Merci beaucoup pour ton inscription au cours de premiers secours. Voici encore une fois les informations les plus importantes",
        "Liebe Grüsse": "Meilleures salutations",
        "Dein Sanio-Team": "Ton équipe Sanio",
        "Copyright": "Droits d'auteur",
        "Umbuchungsbestätigung": "Confirmation de modification de réservation",
        "Terminerinnerung": "Rappel de rendez-vous",
        "Deutsch": "Allemand",
        "Französisch": "Français",
        "Italienisch": "Italien",
        "Englisch": "Anglais",
        "Spanisch": "Espagnol",
        "Portugiesisch": "Portugais",
        "Kurse": "Cours",
        "Impersonation beenden": "Arrêter l'impersonation",
        "Du bist als diese Person angemeldet.": "Tu es connecté en tant que cette personne.",
        "Zur Teilnehmer:in": "Vers le participant",
        "Zum Shop-Kunden": "Vers le client boutique",
        "Instructors": "Instructeur",
        "Teachers": "Instructeur-rice-s d'auto-école",
        "The {attribute} must contain at least one letter.": "{attribute} doit contenir au moins un caractère.",
        "The {attribute} must contain at least one number.": "{attribute} doit contenir au moins un chiffre.",
        "The {attribute} must contain at least one symbol.": "{attribute} doit contenir au moins un caractère spécial.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "{attribute} doit contenir au moins une lettre majuscule et une lettre minuscule.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Le {attribute} est déjà apparu dans une fuite de données. Merci de choisir un autre {attribute}.",
        "INSURANCE_FLAT": "Frais administratifs",
        "lessons": "Leçons de conduite",
        "vku": "Cours de sensibilisation à la circulation",
        "insurance": "Assurance",
        "app": "Application théorique",
        "voice_status_start": "Début",
        "voice_status_end": "Terminé",
        "voice_status_queue": "File d'attente",
        "voice_status_taken": "en discussion",
        "voice_status_missed": "Manqué",
        "absences": "Absence",
        "exams": "Examens",
        "comments": "Commentaires",
        "employment": "Emploi",
        "course_documents": "Documents du cours",
        "course_manuals": "Instructions du cours",
        "All": "Tout-e-s",
        "Die Datei {fileName} wurde {statusHint} importiert.": "Le fichier {fileName} a été importé {statusHint}.",
        "Adresse": "Adresse",
        "Kursübersicht": "Aperçu du cours",
        "Zurück zum Login": "Retour au Login",
        "Passwort bestätigen": "Confirmer le mot de passe",
        "Dashboard": "Tableau de bord",
        "In welchen Kurs soll {participantName} verschoben werden?": "Dans quel cours {participantName} doit-il/elle être déplacé-e ?",
        "Mehr anzeigen": "Voir plus",
        "Gesamten Text anzeigen": "Afficher tout le texte",
        "Weniger anzeigen": "Afficher moins",
        "{participantName} in Kurs {courseName} verschieben?": "Déplacer {participantName} vers le cours {courseName} ?",
        "Zum Kurs": "Vers le cours",
        "Umbuchungsbestätigung senden": "Envoyer une confirmation de changement de réservation",
        "Es wird keine Umbuchungsbestätigung gesendet, da der Kurs beendet ist.": "Aucune confirmation de modification ne sera envoyée car le cours est terminé.",
        "Zurück": "Retour",
        "Verschieben": "Déplacer",
        "Willkommen {name} 👋": "Bienvenue {name} 👋",
        "Abbrechen": "Annuler",
        "Applikation autorisieren": "Autoriser l'application",
        "{name} autorisieren": "Autoriser {name}",
        "Diese Applikation möchte auf deinen MCP-Server zugreifen.": "Cette application demande l'accès à ton serveur MCP.",
        "Angemeldet als": "Connecté en tant que",
        "Berechtigungen": "Autorisations",
        "Autorisieren": "Autoriser",
        "Autorisieren...": "Autorisation...",
        "Du wirst zu {name} zurückgeleitet, sobald du autorisiert hast.": "Tu seras redirigé-e vers {name} une fois l'autorisation accordée.",
        "Ähnliche TN": "Participants similaires",
        "erfolgreich": "avec succès",
        "Abmelden": "Se déconnecter",
        "certificates.not-yet-known": "Pas encore connu",
        "certificates.sanio": "Confirmation de participation Sanio",
        "certificates.src": "Certificat SRC",
        "Fehlermeldung": "Message d'erreur",
        "Folgende Zeilen konnten aufgrund ungültiger (<span class=\"text-red\">rot markiert</span>) Daten nicht importiert werden:": "Les lignes suivantes n'ont pas pu être importées en raison de données non valables (<span class=\"text-red\">marqué en rouge</span>) :",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert.": "Les lignes suivantes ont tout de même été importées en raison d'une attribution peu claire.",
        "Handynummer": "Numéro de téléphone portable",
        "Kontaktdaten": "Coordonnées",
        "Kontaktaufnahme: In Abklärung": "Prise de contact : en cours de clarification",
        "Kontaktaufnahme erforderlich": "Prise de contact requise",
        "Keine Kontaktaufnahme erforderlich": "Aucune prise de contact requise",
        "Noch offen": "En attente",
        "In Kurs verschieben": "Changer de cours",
        "locations": "Sites",
        "Mitarbeitende": "Collaborateur-rice-s",
        "Spalte": "Colonne",
        "students": "Étudiants",
        "Teilnehmerübersicht öffnen": "Ouvrir l'aperçu des participants",
        "teilweise": "en partie",
        "voice_status_out-of-office": "Absent(e) du bureau",
        "voice_status_voicemail": "Message vocal",
        "Zeile": "Ligne",
        "Email": "E-mail",
        "voice_status_initiated": "Bienvenue",
        "errors.4xx.title": "Erreur inattendue",
        "Diese Anmeldemaske wurde deaktiviert.": "Ce masque de connexion a été désactivé.",
        "errors.4xx.head": "Oops...",
        "errors.4xx.hint": "Une erreur s'est produite. Ta demande n'a pas pu être traitée. Vérifie tes saisies ou essaie à nouveau plus tard. L'erreur nous a été signalée.",
        "errors.5xx.title": "Erreur de serveur interne",
        "errors.5xx.head": "Oh oh...",
        "errors.5xx.hint": "Une erreur inattendue s'est produite. Retourne à la page d'accueil ou réessaie plus tard. L'erreur nous a été signalée.",
        "errors.401.title": "Accès refusé",
        "errors.401.head": "Oups…",
        "errors.401.hint": "Tu n'es pas autorisé à accéder à cette page. Connecte-toi et essaie à nouveau.",
        "errors.403.title": "Accès refusé",
        "errors.403.head": "Oups…",
        "errors.403.hint": "Accès refusé. Tu n'est pas autorisé à visiter cette page. Merci de nous contacter si tu penses qu'il s'agit d'une erreur.",
        "errors.404.title": "Page non trouvée",
        "errors.404.head": "Oups...",
        "errors.404.hint": "La page que tu as demandée n'existe pas. Retourne en arrière ou clique sur le bouton pour accéder à la page d'accueil.",
        "errors.500.title": "Erreur de serveur interne",
        "errors.500.head": "Oh oh...",
        "errors.500.hint": "Une erreur inattendue s'est produite. Retourne à la page d'accueil ou réessaie plus tard. L'erreur nous a été signalée.",
        "errors.503.title": "Mode de maintenance",
        "errors.503.head": "Un instant, s'il te plaît...",
        "errors.503.hint": "Nous effectuons actuellement des travaux de maintenance pour apporter des améliorations et corriger des erreurs afin d'améliorer ton expérience utilisateur. Merci de réessayer dans un moment. Merci pour ta compréhension.",
        "errors.503.hint2": "En cas d'urgence, tu peux nous contacter par e-mail à <a href=\"mailto:contact@sanio.ch\">contact@sanio.ch</a> ou par téléphone au <a href=\"tel:+41315212409\">031 521 24 09</a>.",
        "errors.504.title": "Délai d'attente",
        "errors.504.head": "Temps d'attente…",
        "errors.504.hint": "La requête a pris trop de temps. Merci de réessayer plus tard. L'erreur nous a été signalée.",
        "errors.back-to-start": "Vers la page d'accueil",
        "Fehler beim Laden der Kurse": "Erreur lors du chargement des cours",
        "Hier die neuen Infos:": "Voici les nouvelles informations :",
        "Bald ist es soweit und der Kurs «{courseName}» findet statt.": "C'est bientôt l'heure du cours \"{courseName}\".",
        "Hier nochmals die wichtigsten Infos:": "Voici encore une fois les informations les plus importantes :",
        "Du wurdest erfolgreich am Kurs «{courseName}» angemeldet 🎉": "Tu t'es inscrit-e avec succès au cours \"{courseName}\" 🎉",
        "Kurs-ID": "ID du cours",
        "Zum Kalender hinzufügen": "Ajouter au calendrier",
        "Es wurde keine E-Mail-Adresse oder Handynummer angegeben.": "Aucune adresse e-mail ou numéro de portable n'a été fourni.",
        "Die E-Mail-Adresse ist ungültig.": "L'adresse e-mail n'est pas valide",
        "Du wurdest in den Kurs «{courseName}» umgebucht.": "Tu as été transféré-e dans le cours \"{courseName}\".",
        "Wenn du Fragen hast, melde dich bitte direkt bei {name} unter:": "Si tu as des questions, contacte directement {name} à l'adresse suivante :",
        "oder": "ou",
        "Kursort:": "Lieu du cours :",
        "Kursdaten": "Dates des cours",
        "Die Handynummer ist ungültig.": "Le numéro de portable est invalide.",
        "Der Code ist ungültig.": "Le code n'est pas valide.",
        "Vielen Dank für deine Anmeldung zum Kurs. Hier nochmals die wichtigsten Infos:": "Merci beaucoup pour ton inscription au cours. Voici encore une fois les informations les plus importantes :",
        "Der Katalog wurde erstellt.": "Le catalogue a été créé.",
        "Der Katalog wurde aktualisiert.": "Le catalogue a été mis à jour.",
        "Der Katalog wurde entfernt.": "Le catalogue a été supprimé.",
        "Das Thema wurde aktualisiert.": "Le sujet a été mis à jour.",
        "Das Thema wurde entfernt.": "Le sujet a été supprimé.",
        "Der Kurs wurde dupliziert 🎉": "Le cours a été dupliqué 🎉",
        "Kurs": "Cours",
        "Text wurde in die Zwischenablage kopiert": "Le texte a été copié dans le presse-papiers",
        "Text konnte nicht in die Zwischenablage kopiert werden": "Le texte n'a pas pu être copié dans le presse-papiers",
        "Das Thema wurde erstellt.": "Le sujet a été créé.",
        "Story wurde erfolgreich kopiert 🎉": "L'histoire a été copiée avec succès 🎉",
        "hier": "ici",
        "Name": "Nom",
        "Eine Variante|{count} Varianten": "Une variante|{count} variantes",
        "Für diesen Kunden steht der eLearning Bereich nicht zur Verfügung.": "La section eLearning n'est pas disponible pour ce client.",
        "Geschlecht": "Sexe",
        "Männlich": "masculin",
        "Weiblich": "féminin",
        "Divers": "autre",
        "Projektstandort": "Lieu du projet",
        "Wohnkanton": "Canton de résidence",
        "Sanio Logo": "Logo Sanio",
        "Hier geht es zu unseren <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> und zu unserer <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>.": "Voice le lien vers nos CG <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\"></a> et vers notre déclaration de confidentialité <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\"></a> .",
        "Hallo {name} 👋": "Salut {name} 👋",
        "Hier sind nochmals die wichtigsten Details:": "Voici à nouveau les détails les plus importants :",
        "Teilnehmer:innen": "Participant-e-s",
        "Letzter Kurs": "Dernier cours",
        "Nächster Kurs": "Prochain cours",
        "Hinzufügen": "Ajouter",
        "Exportieren": "Exporter",
        "Keinem Kurs zugeordnet": "Non attribué à un cours",
        "Suchbegriff": "Recherche de mots-clés",
        "Dein Sanio Team": "Ton équipe Sanio",
        "Alle": "Tout-e-s",
        "Falls du keine weiteren E-Mails von dieser Liste erhalten möchtest, kannst du dich <a href=\"{unsubscribeListUrl}\" target=\"_blank\">hier</a> abmelden.": "Si tu ne souhaites plus recevoir d'e-mails de cette liste, tu peux te désinscrire <a href=\"{unsubscribeListUrl}\" target=\"_blank\">ici</a>.",
        "Möchtest du gar keine Angebote mehr von uns erhalten? Dann kannst du dich <a href=\"{unsubscribeUrl}\" target=\"_blank\">hier</a> abmelden.": "Ne souhaites-tu plus recevoir d'offres de notre part ?Tu peux te désinscrire <a href=\"{unsubscribeUrl}\" target=\"_blank\">ici</a>.",
        "Ungruppierte Kurse": "Cours non groupés",
        "Es wurden mehrere Konten für diese Angaben gefunden. Bitte wähle den gewünschten Kunden aus.": "Plusieurs comptes ont été trouvés pour ces informations. Merci de sélectionner le client souhaité.",
        "Anmeldebestätigung erneut zustellen": "Renvoyer la confirmation d'inscription",
        "Am Ende gibt es eine kurze Lernkontrolle. Daher lohnt es sich, die Inhalte aufmerksam durchzuarbeiten!": "À la fin, il y aura un court contrôle d'apprentissage. Il vaut donc la peine de parcourir les contenus attentivement !",
        "Abmelden / entfernen": "Désinscrire / éliminer",
        "Einladung zum eLearning": "Invitation à l'eLearning",
        "Wir freuen uns, dir mitzuteilen, dass das eLearning für dich nun bereitsteht! Du kannst ab sofort mit dem Lernen beginnen. 🎉": "Nous sommes heureux de t'annoncer que l'eLearning est maintenant disponible pour toi ! Tu peux commencer à apprendre dès maintenant. 🎉",
        "Bis zum <strong>{courseName}</strong> am <strong>{courseStart}</strong> in <strong>{coursePlace}</strong> musst du das eLearning unbedingt abgeschlossen haben. Es dient als Grundlage für den praktischen Kurs.": "D'ici le <strong>{courseName}</strong> du <strong>{courseStart}</strong> à <strong>{coursePlace}</strong>, tu dois absolument avoir terminé l'eLearning. Il sert de base pour le cours pratique.",
        "Du kannst das eLearning entweder in einem Durchgang oder in mehreren Etappen absolvieren.": "Tu peux accomplir l'eLearning en une seule fois ou en plusieurs étapes.",
        "Teilnehmer:in abmelden / aus Kurs entfernen": "Désinscrire/éliminer le/la participant-e du cours",
        "Möchtest du den/die Teilnehmer:in wirklich vom Kurs abmelden / aus dem Kurs entfernen?": "Veux-tu vraiment désinscrire/retirer le/la participant-e du cours ?",
        "Willst du wirklich eine eLearning Einladung verschicken?": "Veux-tu vraiment envoyer une invitation à l'eLearning ?",
        "Einladung verschicken": "Envoyer une invitation",
        "Willst du wirklich die Anmeldebestätigung erneut zustellen?": "Veux-tu vraiment renvoyer la confirmation d'inscription ?",
        "Bestätigung erneut verschicken": "Renvoyer la confirmation",
        "Teilnehmer:in abmelden": "Désinscire le/la participant-e",
        "Bemerkungen": "Remarques",
        "Wert fehlt!": "Valeur manquante !",
        "{0} Es wurden keine Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.|{1} Es wurde ein:e Teilnehmer:in angelegt und {totalUpdated} aktualisiert.|[2,*] Es wurden {count} Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.": "{0} Aucun·e participant·e n'a été créé·e et {totalUpdated} mis à jour.|{1} Un-e participant-e a été créé-e et {totalUpdated} mis à jour.|[2,*] {count} participant-e-s ont été créé-e-s et {totalUpdated} mis à jour.",
        "Archivieren": "Archiver",
        "Zu Kursgruppe hinzufügen": "Ajouter au groupe",
        "Neue Kursgruppe erstellen": "Créer un nouveau groupe",
        "Möchtest du den Kurs wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Tu veux vraiment supprimer définitivement le cours ? Cette action ne peut pas être annulée.",
        "Möchtest du den Kurs wirklich archivieren? Der Kurs ist danach nicht mehr sichtbar, kann aber durch einen Admin wiederhergestellt werden.": "Tu veux vraiment archiver le cours ? Le cours n'est ensuite plus visible, mais peut être restauré par un admin.",
        "Freigabelink löschen": "Supprimer le lien de partage",
        "Möchtest du den Freigabelink wirklich löschen?": "Tu veux vraiment supprimer le lien de partage ?",
        "Endgültig löschen": "Supprimer définitivement",
        "Gruppe löschen": "Supprimer le groupe",
        "Möchtest du diese Gruppe wirklich löschen?": "Veux-tu vraiment supprimer ce groupe ?",
        "Kurs aus Gruppe entfernen": "Supprimer le cours du groupe",
        "Kurs duplizieren": "Dupliquer le cours",
        "Kurs archivieren": "Archiver le cours",
        "Kurs löschen": "Supprimer le cours",
        "Der Freigabelink wurde gelöscht! 🎉": "Le lien de partage a été supprimé ! 🎉",
        "Link teilen": "Partager le lien",
        "Gruppe bearbeiten": "Modifier le groupe",
        "Neue:n Teilnehmer:in anmelden": "Inscrire un(e) nouveau/nouvelle participant(e)",
        "nimmt teil": "participe",
        "Ähnliche Teilnehmer:innen": "Participant-e-s similaire-s",
        "Ein unerwarteter Fehler ist aufgetreten": "Une erreur inattendue s'est produite",
        "Bereits in diesem Kurs vorhanden": "Déjà présent dans ce cours",
        "Es wurden keine ähnlichen Teilnehmer:innen gefunden.": "Aucun-e participant-e similaire n'a été trouvé-e.",
        "Fülle das Formular aus und die Suche wird gestartet.": "Remplis le formulaire et la recherche commencera.",
        "Suche ähnliche Teilnehmer:innen...": "Recherche de participant-e-s similaires...",
        "eLearning nicht gefunden": "eLearning non trouvé",
        "Wie hat dir das eLearning allgemein gefallen?": "Comment as-tu trouvé l'eLearning de manière générale ?",
        "🤩 Sehr gut!": "🤩 Très bien !",
        "😊 Gut": "😊 Bien",
        "😐 Ok": "😐 Ok",
        "😕 Nicht so gut": "😕 Pas très bien",
        "😩 Schlecht": "😩 Mauvais",
        "Bitte wähle eine Antwort aus.": "Merci de choisir une réponse.",
        "Wie verständlich waren für dich die Lerninhalte?": "Dans quelle mesure les contenus de l'eLearning étaient-ils compréhensibles pour toi ?",
        "🤩 Sehr verständlich!": "🤩 Très compréhensible !",
        "😊 Verständlich": "😊 Compréhensible",
        "😕 Nicht so verständlich": "😕 Pas très compréhensible",
        "😩 Gar nicht verständlich": "😩 Pas du tout compréhensible",
        "🤩 Sehr einfach!": "🤩 Très simple !",
        "😊 einfach": "😊 simple",
        "😐 Nicht so einfach": "😐 Pas si simple que ça",
        "😕 Schwierig": "😕 Difficile",
        "😩 Sehr schwierig": "😩 Très difficile",
        "Wie beurteilst du die Benutzerfreundlichkeit des eLearnings?": "Comment évalues-tu la facilité d'utilisation de l'eLearning ?",
        "🤩 Super einfache Bedienung!": "🤩 Super facile à utiliser !",
        "😊 Einfach zu bedienen": "😊 Facile à utiliser",
        "😐 Teilweise etwas mühsam": "😐 Parfois un peu laborieux",
        "😩 Richtig mühsame Bedienung": "😩 Utilisation vraiment pénible",
        "Wie schwierig war für dich die Lernkontrolle am Ende?": "À quel point as-tu trouvé le test de connaissances à la fin difficile ?",
        "Warum war die Lernkontrolle für dich einfach?": "Pourquoi le contrôle des connaissances était-il facile pour toi ?",
        "Überspringen": "Sauter",
        "Warum war die Lernkontrolle für dich schwierig?": "Pourquoi le contrôle des connaissances était-il difficile pour toi ?",
        "Wie können wir das eLearning verbessern? Was hat dir gefehlt?": "Comment pouvons-nous améliorer l'eLearning ? Qu'est-ce qui t'a manqué ?",
        "Würdest du das eLearning weiterempfehlen?": "Recommanderais-tu l'eLearning ?",
        "🤩 Ja klar!": "🤩 Bien sûr !",
        "😊 Ja, wahrscheinlich schon": "😊 Oui, probablement",
        "😐 Weiss nicht recht": "😐 Je ne sait pas trop",
        "😕 Eher nicht": "😕 Plutôt non",
        "😩 Nein, auf keinen Fall": "😩 Non, en aucun cas",
        "Vielen Dank für deine Antworten!": "Merci beaucoup pour tes réponses !",
        "Cool hast du dir die Zeit genommen!": "C'est cool que tu aies pris le temps !",
        "Fehler beim Laden der Suchergebnisse": "Erreur lors du chargement des résultats de recherche",
        "Speichern": "Enregistrer",
        "Jetzt mit dem eLearning starten": "Commencer le eLearning maintenant",
        "Zu Kurs zugeordnet": "Attribué au cours",
        "Teilnehmer:innen {company}": "Participants {company}",
        "{firstname}, eLearning für den Kurs von {company} nicht vergessen!": "{firstname}, n’oublie pas l'eLearning pour le cours de {company} !",
        "Dein my.sanio Verifizierungscode": "Ton code de vérification my.sanio",
        "Ich akzeptiere die {tos} und habe die {privacyPolicy} gelesen und verstanden.": "J’accepte les {tos} et j’ai lu et compris la {privacyPolicy}.",
        "AGB und Datenschutz müssen akzeptiert werden.": "Les CG et la déclaration de confidentialité doivent être acceptées.",
        "Der Kurs ist leider bereits ausgebucht.": "Malheureusement, le cours est déjà complet.",
        "🚫 Wir konnten dich leider nicht am Kurs anmelden.": "🚫 Nous n'avons malheureusement pas pu t'inscrire au cours.",
        "Profil": "Profil",
        "Zukünftige Kurse": "Cours futurs",
        "{name} ist noch für keine Kurse angemeldet.": "{name} n'est encore inscrit(e) à aucun cours.",
        "Abgeschlossene Kurse": "Cours terminés",
        "Handlung nötig": "Action requise",
        "eLearning": "eLearning",
        "Fortschritt:": "Progrès :",
        "Dauer:": "Durée :",
        "Inhalt": "Contenu",
        "Von:": "De :",
        "An:": "À :",
        "CC:": "CC :",
        "BCC:": "CCI :",
        "Persönliche Daten": "Données personnelles",
        "Kommunikation": "Communication",
        "unbekannter Betreff": "Objet inconnu",
        "Zeit": "Temps",
        "Status": "Statut",
        "Kanal": "Canal",
        "Antwort an:": "Réponse à :",
        "Anhänge": "Annexes",
        "Nicht dargestellte Kursdaten": "Dates de cours non affichées",
        "Benutzerbild": "Image d'utilisateur",
        "Meine Kurse": "Mes cours",
        "Dashboard Instruktor:innen": "Tableau de bord des instructeurs",
        "Wenn wir für diese E-Mail Adresse ein Konto gefunden haben, erhältst du in Kürze eine E-Mail mit einem Link zum Einloggen (Bitte überprüfe auch deinen Spam-Ordner).": "Si nous trouvons un compte pour cette adresse e-mail, tu recevras bientôt un e-mail avec un lien pour te connecter (vérifie également ton dossier de spam).",
        "Jetzt einloggen": "Se connecter maintenant",
        "Link zum Einloggen": "Lien de connexion",
        "Teilnahme-Status erfolgreich aktualisiert.": "Statut de participation mis à jour avec succès.",
        "Team": "Équipe",
        "Anwesenheit": "Présence",
        "Anwesenheiten fehlen!": "Présences manquantes !",
        "Anwesenheiten vollständig": "Présences complètes",
        "Materialset fehlt!": "Set de matériel manquant !",
        "Materialset: {name}": "Set de matériel : {name}",
        "Materialset zugewiesen": "Set de matériel assigné",
        "Hinweis zu Materialset beachten": "Tenir compte de l’indication sur le set de matériel",
        "Nur für bereite Kurse relevant": "Pertinent uniquement pour les cours prêts",
        "Nur für laufende oder durchgeführte Kurse relevant": "Pertinent uniquement pour les cours en cours ou effectués",
        "Präsentation fehlt!": "Présentation manquante !",
        "Präsentation vorhanden": "Présentation disponible",
        "😌 Du hast keine abgeschlossenen Kurse.": "😌 Tu n'as pas de cours terminés.",
        "Gemäss Kursleitung anwesend": "Présent-e selon l’instructeur-rice",
        "Gemäss Kursleitung abwesend": "Absent-e selon l’instructeur-rice",
        "🧘 Du hast diese Woche keine Kurse.": "🧘 Tu n'as pas de cours cette semaine.",
        "🌴 Du hast keine zukünftigen Kurse.": "🌴 Tu n'as pas de cours futurs.",
        "Diese Woche": "Cette semaine",
        "und": "et",
        "Geschäftsführerin Sanio AG": "Directrice générale Sanio AG",
        "Zertifikat": "Certificat",
        "Teilnahmebestätigung": "Attestations de participation",
        "Kursleitung:": "Direction du cours :",
        "Dieses Zertifikat ist bis am {date} gültig.": "Ce certificat est valable jusqu'au {date}.",
        "Eine Auffrischung der Erste Hilfe Grundlagen alle 2 Jahre wird empfohlen.": "Un rappel des bases des premiers secours est recommandé tous les deux ans.",
        "Teilnahmebestätigung wurde erfolgreich generiert und heruntergeladen.": "L'attestation de participation a été générée et téléchargée avec succès.",
        "Fehler beim Erstellen der Teilnahmebestätigung.": "Erreur lors de la création de l'attestation de participation.",
        "Teilnehmerliste exportieren": "Exporter la liste des participants",
        "Teilnahmebestätigungen als PDF": "Attestation de participation en PDF",
        "Teilnahmebestätigungen als ZIP": "Attestation de participation en ZIP",
        "Download wird gestartet...": "Téléchargement en cours…",
        "Download erfolgreich abgeschlossen.": "Téléchargement terminé avec succès.",
        "Download fehlgeschlagen.": "Échec du téléchargement.",
        "Generiere Teilnahmebestätigungen...": "Génération des attestations de participation en cours...",
        "Teilnahmebestätigungen wurden erfolgreich generiert und heruntergeladen.": "Les attestations de participation ont été générées et téléchargées avec succès.",
        "Fehler beim Erstellen der Teilnahmebestätigungen.": "Erreur lors de la création des attestations de participation.",
        "Generiere Teilnahmebestätigung...": "Création d'une attestation de participation en cours...",
        "Bearbeiten": "Modifier",
        "Löschen": "Supprimer",
        "Schreibe deinen Kommentar...": "Écris ton commentaire…",
        "Zurücksetzen": "Réinitialiser",
        "Kommentieren": "Commenter",
        "Kommentar bearbeiten": "Modifier le commentaire",
        "wurde erstellt": "a été créée",
        "kommentierte": "a commenté",
        "Aktivität": "Activité",
        "Dieses Objekt": "Cet objet",
        "Teilnehmer:in hinzufügen": "Ajouter un participant",
        "Für die Kursteilnahme sind nur Vor- und Nachname erforderlich. Weitere Angaben sind freiwillig.": "Seuls le prénom et le nom sont requis pour la participation au cours. Les autres informations sont facultatives.",
        "Teilnehmer:in bereits im System?": "Participant déjà dans le système ?",
        "Passende Personen werden während der Eingabe automatisch hier angezeigt. Bitte übernimm bestehende Personen, anstatt sie neu anzulegen.": "Les personnes correspondantes s'affichent ici automatiquement pendant la saisie. Merci de reprendre les personnes existantes plutôt que d'en créer de nouvelles.",
        "Teilnahmebestätigung herunterladen": "Télécharger l'attestation de participation",
        "Teilnehmer abgleichen": "Faire correspondre les participants",
        "Der Kurs ist ausgebucht.": "Le cours est complet.",
        "abgeschlossen": "terminé",
        "Der Kurs ist bereits beendet.": "Le cours est déjà terminé.",
        "{availableSpots} Plätze frei": "{availableSpots} places disponibles",
        "Es sind keine anderen Kurse verfügbar.": "Il n'y a pas d'autres cours disponibles.",
        "Teilnehmer wurde in neuen Kurs verschoben.": "Le participant a été déplacé dans un nouveau cours.",
        "Beendete Kurse können nicht mehr bearbeitet werden.": "Les cours terminés ne peuvent plus être modifiés.",
        "certificates.none": "Pas de certificat",
        "Der Benutzer wurde erfolgreich erstellt.": "L'utilisateur a été créé avec succès.",
        "vollständig": "complet",
        "Auswählen": "Sélectionner",
        "Teilnehmer:in anzeigen": "Afficher le/la participant-e",
        "Kurstypen": "Types de cours",
        "Keine Daten gefunden.": "Aucune donnée trouvée.",
        "Nachricht wurde erneut zugestellt 🎉": "Le message a été renvoyé 🎉",
        "Die Weiterleitung wurde gelöscht!": "La redirection a été supprimée !",
        "Der Kontakt wurde entfernt.": "Le contact a été supprimé.",
        "Der Kundenbereich wurde eröffnet! 🎉": "L'espace client a été ouvert ! 🎉",
        "Der Import wurde gestartet und wird im Hintergrund ausgeführt.": "L'importation a été lancée et est exécutée en arrière-plan.",
        "Kurse wurden der Gruppe hinzugefügt.": "Des cours ont été ajoutés au groupe.",
        "Möchtest du das Element wirklich löschen?": "Veux-tu vraiment supprimer l'élément ?",
        "Der Benutzer wurde erfolgreich aktualisiert.": "L'utilisateur a été mis à jour avec succès.",
        "Kurs erstellen": "Créer un cours",
        "Teilnehmer wurde gelöscht!": "Le participant a été supprimé !",
        "Das Login wurde gelöscht! 🎉": "Le login a été supprimé ! 🎉",
        "Kursgruppe wurde gelöscht!": "Le groupe de cours a été supprimé !",
        "Der Kurs wurde erfolgreich gelöscht!": "Le cours a été supprimé avec succès !",
        "Kurstyp wurde erfolgreich aktualisiert.": "Le type de cours a été mis à jour avec succès.",
        "Nachrichtenverlauf": "Historique des messages",
        "Kurstyp bearbeiten": "Modifier le type de cours",
        "Kurs hat noch nicht begonnen.": "Le cours n'a pas encore commencé.",
        "Kurs ist abgeschlossen.": "Le cours est terminé.",
        "Kurs ist abgesagt.": "Le cours est annulé.",
        "Kurs ist archiviert.": "Le cours est archivé.",
        "Kurs bearbeiten": "Modifier le cours",
        "HINWEIS:": "REMARQUE :",
        "Die Offerte wurde erstellt.": "L'offre a été établie.",
        "Das Angebot wurde aktualisiert.": "L'offre a été mise à jour.",
        "Das Angebot wurde entfernt.": "L'offre a été supprimée.",
        "Teilnehmer erfolgreich gespeichert!": "Participant-e enregistrés avec succès !",
        "Das Login wurde erstellt! 🎉": "Le login a été créé ! 🎉",
        "Der Kundenbereich wurde gespeichert! 🎉": "L'espace client a été enregistré ! 🎉",
        "Nachricht wurde verschickt 🎉": "Le message a été envoyé 🎉",
        "Kursgruppe erfolgreich erstellt 🎉": "Le groupe de cours créé avec succès 🎉",
        "Kursgruppe erfolgreich aktualisiert 🎉": "Le groupe de cours mis à jour avec succès 🎉",
        "Geteilter Link gelöscht!": "Lien partagé supprimé !",
        "Teilnehmer wurde in den neuen Kurs verschoben.": "Le participant a été déplacé dans le nouveau cours.",
        "Der Kurs wurde gespeichert 🎉": "Le cours a été enregistré 🎉",
        "Der Kurs wurde gespeichert": "Le cours a été enregistré",
        "Der Kurs wurde erfolgreich archiviert!": "Le cours a été archivé avec succès !",
        "Teilnehmer:in erfolgreich abgemeldet.": "Participant-e désinscrit-e avec succès.",
        "Der Benutzer wurde erfolgreich gelöscht.": "L'utilisateur a été supprimé avec succès.",
        "Die Weiterleitung wurde erstellt!": "Le cours a été archivé avec succès !",
        "Die Weiterleitung wurde aktualisiert!": "La redirection a été mise à jour !",
        "Mail Statusinformationen wurden aktualisiert.": "Les informations sur le statut du courrier ont été mises à jour.",
        "Das Unternehmen wurde erstellt.": "L'entreprise a été créée.",
        "Das Unternehmen wurde aktualisiert.": "L'entreprise a été mise à jour.",
        "Das Unternehmen wurde gelöscht!": "L'entreprise a été supprimée !",
        "Das Unternehmen kann nicht gelöscht werden, solange noch ein Kundenbereich existiert.": "L'entreprise ne peut pas être supprimée tant qu'un espace client existe.",
        "Der Kontakt wurde aktualisiert.": "Le contact a été mis à jour.",
        "Der Kommentar wurde gespeichert.": "Le commentaire a été enregistré.",
        "Der Kommentar wurde aktualisiert.": "Le commentaire a été mis à jour.",
        "Der Kommentar wurde entfernt.": "Le commentaire a été supprimé.",
        "Der Kontakt wurde erstellt.": "Le contact a été créé.",
        "Link für gesamte Kursliste kopieren": "Copier le lien pour la liste complète des cours",
        "Link für diese Kursgruppe kopieren": "Copier le lien pour ce groupe de cours",
        "Willkommen im": "Bienvenue au",
        "Instruktor:innen Bereich": "Domaine des instructeurs",
        "Der Login-Link ist ungültig oder abgelaufen.": "Le lien de connexion est invalide ou a expiré.",
        "weiter": "continuer",
        "+{more} weitere": "+{more} d'autres",
        "Notfallnummer (für Kurse)": "Numéro d'urgence (pour les cours)",
        "Telefonzeiten": "Heures d'appel téléphonique",
        "Montag bis Freitag": "du lundi au vendredi",
        "9.00 bis 12.00 Uhr": "de 9h00 à 12h00",
        "13.00 bis 16.00 Uhr": "de 13h00 à 16h00",
        "Link für diesen Kurs kopieren": "Copier le lien pour ce cours",
        "Link für Anmeldung teilen": "Partager le lien d'inscription",
        "🤔 Es sind keine Kurse geplant.": "🤔 Aucun cours n'est prévu.",
        "Suchen...": "Chercher...",
        "Kursinstruktor:in": "Instructeur-rice de cours",
        "Management": "Gestion",
        "Büro": "Bureau",
        "Schule": "École",
        "Berufsschule": "École professionnelle",
        "Gymnasium": "Collège",
        "Kita": "Crèche",
        "Betrieb": "Entreprise",
        "Vereine": "Associations",
        "Sonstiges": "Autres",
        "Teilnahmebestätigung Erste Hilfe Kurs": "Attestation de participation au cours de premiers secours",
        "Zertifikat BLS AED SRC Kurs": "Certificat de cours BLS AED SRC",
        "Die Datei findest du im Anhang dieser E-Mail.": "Tu trouveras le fichier en annexe à cet e-mail.",
        "Herzlichen Glückwunsch und weiterhin viel Erfolg!": "Toutes nos félicitations et beaucoup de succès pour la suite !",
        "Wir freuen uns, dir dein Zertifikat für den <strong>{courseName}</strong> zu übermitteln.": "Nous avons le plaisir de te transmettre ton certificat pour le <strong>{courseName}</strong>.",
        "Wir freuen uns, dir deine Teilnahmebestätigung für den <strong>{courseName}</strong> zu übermitteln.": "Nous avons le plaisir de te transmettre ta confirmation de participation pour le <strong>{courseName}</strong>.",
        "Zertifikate werden nun generiert und an die Teilnehmer:innen verschickt 🎉": "Les certificats sont maintenant générés et envoyés aux participants 🎉",
        "ACHTUNG:": "ATTENTION :",
        "Zertifikat wird nun generiert und an den/die Teilnehmer:in verschickt 🎉": "Le certificat est maintenant généré et envoyé au participant 🎉",
        "Möchtest du die Teilnahmebestätigungen an alle Teilnehmer:innen zustellen?": "Veux-tu envoyer les attestations de participation à tous les participant-e-s ?",
        "Für einige Teilnehmer:innen, die Anspruch auf eine Teilnahmebestätigung haben, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Pour certain-e-s participant-e-s qui ont droit à une attestation de participation, aucune adresse e-mail n'est disponible. Par conséquent, la confirmation ne peut pas être envoyée par e-mail aux personnes suivantes :",
        "Bestätigung zustellen": "Envoyer la confirmation",
        "Teilnahmebestätigung per Mail versenden": "Envoyer la confirmation de participation par e-mail",
        "Willst du wirklich die Teilnahmebestätigung per Mail versenden?": "Veux-tu vraiment envoyer la confirmation de participation par e-mail ?",
        "Du bekommst von uns einen Link per E-Mail zugesendet, um dein Passwort zurückzusetzen. Bitte gib deine E-Mail-Adresse ein, die du zum Login im Sanio Kundenportal verwendest.": "Tu recevras un lien par e-mail de notre part pour réinitialiser ton mot de passe. Merci de saisir l'adresse e-mail que tu utilises pour te connecter au portail client Sanio.",
        "Sanio Kundenbereich": "Espace client Sanio",
        "Liebe Geschäftskund:innen, unser Portal für die Kursverwaltung hat einen neuen Namen. Das {portalName} erreicht ihr ab sofort unter {sanioPortalLink}.": "Chèrs clients professionnels, notre portail pour la gestion des cours a un nouveau nom. Vous pouvez désormais accéder au {portalName} à l'adresse {sanioPortalLink}.",
        "Teilnahmebestätigungen herunterladen": "Télécharger les attestations de participation",
        "Hier dein persönlicher Zugang, um dich im my.sanio einzuloggen:": "Voici ton accès personnel pour te connecter à my.sanio :",
        "Wichtige Hinweise:": "Remarques importantes :",
        "Der Link kann nur einmal verwendet werden.": "Le lien ne peut être utilisé qu'une seule fois.",
        "Er ist zeitlich begrenzt gültig.": "Il est valable pour une durée limitée.",
        "Falls das Login nicht funktioniert, kannst du jederzeit einen neuen Link auf der <a href=\"{loginPageUrl}\">Anmeldeseite</a> anfordern.": "Si l'accès ne fonctionne pas, tu peux à tout moment demander un nouveau lien à la <a href=\"{loginPageUrl}\">page de login</a>.",
        "Hier dein persönlicher Zugang, um dich im Sanio Kundenportal einzuloggen:": "Voici ton accès personnel pour te connecter au portail clients de Sanio :",
        "Hier dein persönlicher Zugang, um dich im Sanio Instruktor:innen Bereich einzuloggen:": "Voici ton accès personnel pour te connecter à l'espace instructeurs-rices de Sanio :",
        "in Planung": "en cours de planification",
        "Füge eine persönliche E-Mail-Adresse ein, damit der:die Teilnehmer:in alle kursbezogenen Mitteilungen (z. B. Anmeldebestätigung, Erinnerung, Teilnahmebestätigung) direkt per Mail erhält.": "Ajoute une adresse e-mail personnelle afin que le/la participant-e reçoive directement par e-mail toutes les communications liées au cours (par exemple, confirmation d'inscription, rappel, attestation de participation).",
        "am <strong>{dateStart}</strong> und <strong>{dateEnd}</strong>": "le <strong>{dateStart}</strong> et le <strong>{dateEnd}</strong>",
        "vom <strong>{dateStart}</strong> bis <strong>{dateEnd}</strong>": "dès le <strong>{dateStart}</strong> au <strong>{dateEnd}</strong>",
        "am <strong>{date}</strong>": "le <strong>{date}</strong>",
        "Dein Verifizierungscode lautet: <strong>{code}</strong>": "Ton code de vérification est : <strong>{code}</strong>",
        "Dein Sanio-Verifizierungscode": "Ton code de vérification Sanio",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im Sanio Kundenportal mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Si un mot de passe a été enregistré, tu peux te connecter au portail client Sanio avec ton e-mail et ton mot de passe. Sinon, sinon un lien d'accès te sera envoyé.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im team.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Si un mot de passe a été enregistré, le contact peut se connecter à team.sanio avec son e-mail et son mot de passe. Sinon, un lien d'accès lui sera envoyé.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im my.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Si un mot de passe a été enregistré, le contact peut se connecter à my.sanio avec son e-mail et son mot de passe. Sinon, un lien d'accès lui sera envoyé.",
        "Allgemeine Informationen": "Informations générales",
        "Rechte": "Droits",
        "Rollen": "Rôles",
        "Rollen auswählen": "Sélectionner les rôles",
        "Authentifizierung": "Authentification",
        "Passwort (optional)": "Mot de passe (facultatif)",
        "Wechseln": "Changer",
        "Sprache": "Langue",
        "Benutzeroberfläche": "Interface d'utilisateur",
        "total": "total",
        "übersetzt": "traduit",
        "ausstehend": "en attente",
        "Übersetzungsstatistiken werden geladen": "Chargement des statistiques de traduction",
        "Übersetzungsstatistiken konnten nicht geladen werden.": "Les statistiques de traduction n'ont pas pu être chargées.",
        "Mögliche Gründe:": "Raisons possibles :",
        "Die Story wurde noch nicht ins Weblate übertragen.": "L'histoire n'a pas encore été transférée sur le site web.",
        "Es gab ein technisches Problem.": "Il y a eu un problème technique.",
        "Übersetzungsstatistiken": "Statistiques de traduction",
        "Du musst die AGB akzeptieren!": "Tu dois accepter les Conditions Générales d'Utilisation !",
        "Falls du Excel für den Import verwendest, achte darauf, dass Spalten wie z.B. das Geburtsdatum als Text formatiert sind.": "Si tu utilises Excel pour l'importation, assure-toi que les colonnes, comme la date de naissance par exemple, sont formatées en tant que texte.",
        "Du musst die AGB akzeptieren, um fortfahren zu können.": "Tu dois accepter les CG pour pouvoir continuer.",
        "Bitte gib eine gültige Handynummer ein.": "Merci d'insérer un numéro de portable valide.",
        "Es gibt bereits {count} ähnliche:n Teilnehmer:in. Schalte das Matching aus um den Teilnehmer trotzdem zu erstellen.": "Il y a déjà {count} participant-s similaire-s. Désactive le matching pour créer le-s participant-s quand même.",
        "Möchtest du die Variante wirklich duplizieren?": "Veux-tu vraiment dupliquer la variante ?",
        "Vielen Dank! Wir haben deine Angaben erhalten.": "Merci beaucoup ! Nous avons bien reçu tes informations.",
        "Deine Ansprechperson:": "Ta personne de contact :",
        "Deine Ansprechpersonen:": "Tes interlocuteurs :",
        "Preis": "Prix",
        "Produkt erfassen": "Saisir le produit",
        "Produkt bearbeiten": "Modifier le produit",
        "Produktstatus": "Statut du produit",
        "Preis in CHF": "Prix en CHF",
        "MwSt. in Prozent": "TVA en pourcentage",
        "Produktmedien": "Médias du produit",
        "Produktbild": "Image du produit",
        "Produkte": "Produits",
        "Produkt wurde erstellt.": "Le produit a été créé.",
        "Produkt wurde aktualisiert.": "Le produit a été mis à jour.",
        "Produktgruppen": "Groupes de produits",
        "Medien": "Médias",
        "Produktgruppe erfassen": "Saisir le groupe de produits",
        "Produktgruppe bearbeiten": "Modifier le groupe de produits",
        "Es gibt noch keine Einträge.": "Il n'y a pas encore d'entrées.",
        "Produktgruppenbild": "Image du groupe de produits",
        "Produktgruppe wurde erstellt.": "Le groupe de produits a été créé.",
        "Produktgruppe wurde aktualisiert.": "Le groupe de produits a été mis à jour.",
        "Produktgruppe": "Groupe de produits",
        "Produkte werden im Hintergrund aktualisiert.": "Les produits sont mis à jour en arrière-plan.",
        "Jetzt aktualisieren": "Mettre à jour maintenant",
        "Die Produktdaten werden aus Bexio regelmässig importiert und mit den bestehenden abgeglichen.": "Les données des produits sont régulièrement importées depuis Bexio et comparées avec les données existantes.",
        "Kürzel (Slug)": "Abréviation (Slug)",
        "Produktart (Bexio)": "Type de produit (Bexio)",
        "Shop wurde erstellt.": "Le shop a été créé.",
        "Shop wurde aktualisiert.": "Le shop a été mis à jour.",
        "Shop wurde gelöscht.": "Le shop a été supprimé.",
        "Shop erfassen": "Saisir un shop",
        "Shops": "Magasins",
        "Shop bearbeiten": "Modifier le shop",
        "Aktiv": "Actif",
        "Produktgruppen auswählen": "Sélectionner les groupes de produits",
        "Titel": "Titre",
        "Mit der Registrierung akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "En m'inscrivant, j'accepte les {tos}. J'ai lu et compris la {privacyPolicy}.",
        "Es muss eine gültige Handynummer angegeben werden.": "Un numéro de portable valide doit être fourni.",
        "inkl. {taxPercentage}% MwSt.": "y compris {taxPercentage}% TVA",
        "Preis (inkl. {taxPercentage}% MwSt)": "Prix (y compris {taxPercentage}% TVA)",
        "Bestelldatum: {orderDate}": "Date de commande : {orderDate}",
        "Bestellnummer: {orderReference}": "Numéro de commande : {orderReference}",
        "Keine Teilnehmenden|ein:e Teilnehmer:in|{capacity} Teilnehmende": "Aucun participant·e|Un·e participant·e|{capacity} participant·e·s",
        "Kursmodi": "Modes de cours",
        "Kein Datum definiert": "Aucune date définie",
        "Anmeldefrist abgelaufen": "Délai d'inscription dépassé",
        "Anmeldefrist:": "Délai d'inscription :",
        "Anmeldefrist": "Délai d'inscription",
        "Die Anmeldefrist ist abgelaufen.": "Le délai d'inscription est dépassé.",
        "Kunde": "Client",
        "Termine": "Dates",
        "Der Link wurde in die Zwischenablage kopiert! 🎉": "Le lien a été copié dans le presse-papiers ! 🎉",
        "Link": "Lien",
        "eLearning öffnen": "Ouvrir l’eLearning",
        "Du hast dich erfolgreich für das Erste Hilfe eLearning von {customer} angemeldet! 🎉": "Tu t'es inscrit avec succès à l’eLearning sur le premiers secours de {customer} ! 🎉",
        "Es steht dir nun zur Verfügung und du kannst ab sofort mit dem Lernen beginnen.": "Il est désormais disponible pour toi et tu peux commencer à étudier dès maintenant.",
        "Starte jetzt dein Erste Hilfe eLearning! 🚀": "Commence dès maintenant ton eLearning sur les premiers secours ! 🚀",
        "Nachricht konnte nicht erneut zugestellt werden!": "Le message n'a pas pu être renvoyé !",
        "Der Kommentar konnte nicht gespeichert werden.": "Le commentaire n'a pas pu être enregistré.",
        "{firstname}, dein Erste Hilfe eLearning von {company} wartet auf dich! ⏳": "{firstname}, ton eLearning de premiers secours de {company} t'attend ! ⏳",
        "{firstname}, starte jetzt dein Erste Hilfe eLearning! 🚀": "{firstname}, commence dès maintenant ton apprentissage en ligne des premiers secours ! 🚀",
        "Glückwunsch, {firstname}! Dein Erste Hilfe eLearning von {company} ist abgeschlossen 🎓": "Félicitations, {firstname} ! Ton eLearning de premiers secours de {company} est terminé 🎓",
        "{firstname}, dein Zugang zum Erste Hilfe eLearning von {company} ist da!": "{firstname}, ton accès à l'apprentissage en ligne des premiers secours de {company} est arrivé !",
        "Twint": "Twint",
        "Visa": "Visa",
        "MasterCard": "MasterCard",
        "PostFinance Pay": "PostFinance Pay",
        "Rechnung": "Facture",
        "Vorkasse": "Paiement anticipé",
        "Keine Zahlung erforderlich": "Aucun paiement requis",
        "Möchtest du die Teilnahmebestätigungen herunterladen?": "Souhaites-tu télécharger les attestations de participation ?",
        "Das eLearning dauert rund {onlineCourseDuration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning dure environ {onlineCourseDuration}. À la fin de l'eLearning, il y a un bref contrôle des connaissances. Il vaut donc la peine de ne pas simplement cliquer à travers la théorie !",
        "Du hast das Erste Hilfe eLearning von {customer} erfolgreich abgeschlossen – grossartig!": "Tu as terminé avec succès l'eLearning de premiers secours de {customer} - formidable !",
        "Danke, dass du dich für Erste Hilfe weitergebildet hast. Bleib sicher!": "Merci de t'être formé aux premiers secours. Reste en sécurité !",
        "Wie waren die Aufgaben in den Notfällen für dich?": "Comment as-tu trouvé les tâches dans les situations d'urgence ?",
        "Es wird Zeit, mit dem eLearning zu beginnen! Bitte schliesse es bis zum Kursbeginn am <strong>{courseStart}</strong>, ab, da es die wichtige Grundlage für unseren Kurs bildet. Plane dafür etwa {duration} ein, damit du gut vorbereitet bist und das Beste aus dem Kurs mitnehmen kannst. Wir freuen uns auf dich!": "Il est temps de commencer l‘ eLearning ! Merci de le terminer avant le début du cours le <strong>{courseStart}</strong>, car il constitue une base importante pour notre cours. Prévois environ {duration} pour être bien préparé et tirer le meilleur parti du cours. Nous sommes impatients de te voir !",
        "Viel Erfolg! 🚀": "Nous te souhaitons beaucoup de succès ! 🚀",
        "Weiterlernen": "Continuer à apprendre",
        "Du hast bereits {courseProgress}% vom Erste Hilfe eLearning geschafft – super! 🎉": "Tu as déjà réalisé le {courseProgress}% de l'eLearning de premiers secours - super ! 🎉",
        "Bleib dran und lerne weiter, damit du den Kurs erfolgreich abschliessen kannst.": "Persévère et continue d'apprendre afin de réussir le cours.",
        "Keine Kursleitung definiert": "Aucun-e responsable de cours défini-e",
        "Wir freuen uns, dir deine Teilnahmebestätigung für diesen Onlinekurs zu übermitteln. Die Datei findest du im Anhang dieser E-Mail.": "Nous avons le plaisir de te transmettre ta confirmation de participation à ce cours en ligne. Tu trouveras le fichier en annexe de cet e-mail.",
        "hat am <strong>{dateText}</strong> am {durationText} {courseTypeName} {guideline} teilgenommen.": "a participé à <strong>{dateText}</strong> à {durationText} {courseTypeName} {guideline}.",
        "hat am <strong>{dateText}</strong> das {durationText} {courseTypeName} {guideline} erfolgreich abgeschlossen.": "a passé avec succès le <strong>{dateText}</strong> le {durationText} {courseTypeName} {guideline}.",
        "{minutes}-minütige": "{minutes}-minutes",
        "{hours}-stündige": "{hours}-heure",
        "{hours}-stündigen": "{hours}-heures",
        "Teilnehmerliste importieren": "Importer la liste des participants",
        "Teilnehmer:innen wurden {statusHint} aus Datei {fileName} in Kurs {course} importiert.": "Participants ont été importés {statusHint} du fichier {fileName} dans le cours {course}.",
        "Sortierung": "Triage",
        "Kategorie-Label": "Label de la catégorie",
        "Die Teilnehmer:innen aus der Datei \"{fileName}\"\" wurden {statusHint} im Kurs {course} erfasst.": "Les participants du fichier \"{fileName}\"\" ont été enregistrés {statusHint} dans le cours {course}.",
        "Es wurden total:": "Il y a eu au total",
        "<strong>{count}</strong> neu angelegt": "<strong>{count}</strong> nouvellement créé",
        "<strong>{count}</strong> aktualisiert": "<strong>{count}</strong> mis à jour",
        "<strong>{count}</strong> am Kurs angemeldet": "<strong>{count}</strong> inscrits au cours",
        "Die Teilnehmer:innen haben eine Anmeldebestätigung erhalten.": "Les participant(e)s ont reçu une confirmation d'inscription.",
        "Folgende Zeilen konnten aufgrund ungültiger Daten (<span class=\"text-red\">rot markiert</span>) nicht importiert werden:": "Les lignes suivantes n'ont pas pu être importées en raison de données non valables (<span class=\"text-red\">marqué en rouge</span>) :",
        "Der Kurs ist nicht verfügbar.": "Le cours n'est pas disponible.",
        "Dieser Kurs ist noch nicht bereit für Anmeldungen!": "Ce cours n'est pas encore prêt pour les inscriptions !",
        "Abteilung": "Département",
        "Stationäre Wohngruppen": "Groupes de vie stationnaires",
        "Betriebe": "Entreprises",
        "Bildung": "Éducation",
        "Andere": "Autres",
        "Die Anmeldebestätigungen werden an die Teilnehmer:innen verschickt 🎉": "Les confirmations d'inscription seront envoyées aux participant(e)s 🎉",
        "Anmeldebestätigungen verschicken": "Envoyer les confirmations d'inscription",
        "Anmeldebestätigungen per Mail zustellen": "Envoyer les confirmations d'inscription par e-mail",
        "Bestätigungen zustellen": "Envoyer des confirmations",
        "ACHTUNG": "ATTENTION",
        "Verifizierungscode eingeben": "Saisir le code de vérification",
        "Keinen Code erhalten?": "Vous n'avez pas reçu de code ?",
        "Wir haben einen 6-stelligen Code an {maskedIdentifier} geschickt.": "Nous avons envoyé un code à 6 chiffres à {maskedIdentifier}.",
        "Erneut senden": "Envoyer à nouveau",
        "E-Mail konnte nicht korrekt zugestellt werden": "L'e-mail n'a pas pu être remis correctement",
        "Bestätigen": "Confirmer",
        "Bestellung: {id}": "Commande : {id}",
        "Bezahlstatus: {status}": "Statut du paiement : {status}",
        "Wenn wir nicht wissen, wer du bist, kann es sein, dass wir dich nach deiner <strong>Sanio ID</strong> fragen. Du findest diese hier:": "Si nous ne savons pas qui tu es, il se peut que nous te demandions ton <strong>Sanio ID</strong>. Tu le trouveras ici :",
        "Mit dem Kauf akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "En effectuant cet achat, j'accepte les {tos}. J'ai lu et compris la {privacyPolicy}.",
        "Lade weitere Kurse": "Charger d'autres cours",
        "Keine weiteren Kurse gefunden.": "Aucun autre cours trouvé.",
        "Kurs suchen": "Rechercher un cours",
        "Kein Kurs ausgewählt": "Aucun cours sélectionné",
        "Kurs auswählen": "Sélectionner un cours",
        "Ausgewählter Kurs": "Cours sélectionné",
        "Zugriffsdauer in Tagen": "Durée d'accès en jours",
        "Willkommen in deinem persönlichen Bereich, {name}! Hier findest du alle deine gebuchten Online-Kurse, deine Bestellungen und kannst dein Profil verwalten. Viel Spass beim Lernen!": "Bienvenue dans ton espace personnel, {name} ! Ici, tu trouveras tous tes cours en ligne réservés, tes commandes et tu pourras gérer ton profil. Amuse-toi bien en apprenant !",
        "Jetzt eLearning starten": "Démarrer l'eLearning maintenant",
        "Leider stehen dir im Moment keine Online-Kurse zur Verfügung. Bitte kontaktiere uns, wenn du Fragen hast.": "Malheureusement, aucun cours en ligne n'est disponible pour le moment. N'hésite pas à nous contacter si tu as des questions.",
        "Bestellungen": "Commandes",
        "Online Kurse": "Cours en ligne",
        "Zertifikate können für diesen Kurs nicht generiert werden.": "Les certificats ne peuvent pas être générés pour ce cours.",
        "Zertifikate können nicht automatisch verschickt werden, wenn der Zertifikat-Generator nicht aktiviert ist!": "Les certificats ne peuvent pas être envoyés automatiquement si le générateur de certificats n'est pas activé !",
        "Erneut senden ({timeTillResend} s)": "Renvoyer ({timeTillResend} s)",
        "Benötigst Du Hilfe?": "As-tu besoin d'aide ?",
        "Wir helfen Dir gerne per E-Mail oder Telefon": "Nous nous ferons un plaisir de t'aider par e-mail ou par téléphone",
        "Erste Hilfe lernen. Wo du willst. Wann du willst.": "Apprendre les premiers secours. Où tu veux. Quand tu veux.",
        "Den Beleg zu deiner Bestellung findest du im Anhang.": "Le reçu de ta commande se trouve en pièce jointe.",
        "Bestellbestätigung für {orderNumber}": "Confirmation de commande pour {orderNumber}",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Dans ton espace personnel my.sanio, tu trouveras tous les détails de ta commande ainsi que l'accès direct au cours. Bonne formation ! 🚑💡",
        "Wir haben deine Zahlung erhalten und dein Zugang zum eLearning ist jetzt freigeschaltet.": "Nous avons reçu ton paiement et ton accès à l'eLearning est maintenant activé.",
        "Danke für deine Bestellung, {name}! 🎉": "Merci pour ta commande, {name} ! 🎉",
        "Rechnungsadresse": "Adresse de facturation",
        "Lieferadresse": "Adresse de livraison",
        "Abweichende Lieferadresse": "Adresse de livraison différente",
        "Optional. Empfohlen, wenn Gutscheine per Post verschickt werden.": "Facultatif. Recommandé lorsque des bons sont envoyés par la poste.",
        "Der Vorname der Lieferadresse ist erforderlich.": "Le prénom de l'adresse de livraison est obligatoire.",
        "Der Nachname der Lieferadresse ist erforderlich.": "Le nom de l'adresse de livraison est obligatoire.",
        "Die Strasse der Lieferadresse ist erforderlich.": "La rue de l'adresse de livraison est obligatoire.",
        "Die Hausnummer der Lieferadresse ist erforderlich.": "Le numéro de l'adresse de livraison est obligatoire.",
        "Die PLZ der Lieferadresse ist erforderlich.": "Le code postal de l'adresse de livraison est obligatoire.",
        "Der Ort der Lieferadresse ist erforderlich.": "La localité de l'adresse de livraison est obligatoire.",
        "Wir konnten dich mit diesen Angaben nicht anmelden.": "Nous n'avons pas pu t'inscrire avec ces informations.",
        "Bestellbestätigung": "Confirmation de commande",
        "Exportieren als CSV": "Exporter en CSV",
        "Exportieren als Excel": "Exporter en Excel",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr in einen anderen Kurs verschoben werden.": "Le/la participant·e a déjà commencé l'eLearning et ne peut plus être déplacé·e vers un autre cours.",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr abgemeldet werden.": "Le/la participant·e a déjà commencé l'eLearning et ne peut plus être désinscrit·e.",
        "Du hast dich für das Erste Hilfe eLearning angemeldet, aber noch nicht gestartet. Nutze die Chance, dein Wissen aufzufrischen.": "Tu t'es inscrit à l'apprentissage en ligne des premiers secours, mais tu n'as pas encore commencé. Profite de l'occasion pour rafraîchir tes connaissances.",
        "Die Zertifikate werden im Hintergrund vorbereitet. Sie erhalten eine Benachrichtigung, sobald die Zertifikate zum Download bereitstehen.": "Les certificats sont en cours de préparation en arrière-plan. Vous recevrez une notification dès que les certificats seront disponibles en téléchargement.",
        "Die Zertifikate für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "Les certificats pour le cours {course} ont été générés et sont disponibles en téléchargement.",
        "Jetzt herunterladen": "Télécharger maintenant",
        "Die Zertifikate werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du die Zertifikate herunterladen kannst.": "Les certificats sont en cours de génération en arrière-plan. Tu seras notifié·e par e-mail dès que tu pourras télécharger les certificats.",
        "Kontaktperson Kunde": "Personne de contact client",
        "Zertifikate für Kurs {course} wurden generiert!": "Les certificats pour le cours {course} ont été générés !",
        "Möchtest du die Teilnahmebestätigungen trotzdem generieren?": "Veux-tu quand même générer les attestations de participation ?",
        "Die Zertifikate werden im Hintergrund vorbereitet. Bitte habe einen Moment Geduld.": "Les certificats sont en cours de préparation en arrière-plan. Merci de patienter un instant.",
        "Teilnahmebestätigungen generieren": "Générer les attestations de participation",
        "Der angegebene Freigabelink wird noch nicht unterstützt.": "Le lien de partage indiqué n'est pas encore pris en charge.",
        "Persönlicher Zugangscode (QR) anzeigen": "Afficher le code d'accès personnel (QR)",
        "Persönliche Zugangscodes (QR) als PDF": "Codes d'accès personnels (QR) en PDF",
        "Persönlicher Zugang": "Accès personnel",
        "QR Code": "Code QR",
        "Persönlicher eLearning Zugang {name}": "Accès personnel eLearning {name}",
        "Das Dokument wird im Hintergrund generiert. Du wirst benachrichtigt, sobald es fertig ist.": "Le document est en cours de génération en arrière-plan. Tu seras notifié·e dès qu'il sera prêt.",
        "Die Zugangs-QR-Codes für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "Les codes QR d'accès pour le cours {course} ont été générés et sont disponibles en téléchargement.",
        "Das eLearning steht für dich bereitsteht und du kannst ab sofort mit dem Lernen beginnen. Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning est disponible pour toi et tu peux commencer à apprendre dès maintenant. L'eLearning dure environ {duration}. À la fin de l'eLearning, il y a un bref contrôle des connaissances. Il vaut donc la peine de ne pas simplement cliquer sur la théorie !",
        "eLearning {customerName}": "eLearning {customerName}",
        "Gültig bis {expire}": "Valable jusqu'au {expire}",
        "eLearning Zugang {customerName}": "Accès eLearning {customerName}",
        "Viel Erfolg!": "Bonne chance !",
        "eLearning QR-Zugänge generieren": "Générer les accès QR eLearning",
        "Die QR-Zugänge werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du sie herunterladen kannst.": "Les accès QR sont en cours de génération en arrière-plan. Tu seras notifié par e-mail dès que tu pourras les télécharger.",
        "QR Code wird geladen": "Le code QR est en cours de chargement",
        "QR-Code drucken": "Imprimer le code QR",
        "QR-Code mit Smartphone Kamera scannen": "Scanner le code QR avec l'appareil photo du smartphone",
        "QR Zugänge für Kurs {course} wurden generiert!": "Les accès QR pour le cours {course} ont été générés !",
        "Teilnahmebestätigungen per Mail zustellen": "Envoyer les confirmations de participation par e-mail",
        "Teilnahmebestätigungen an Teilnehmende versenden": "Envoyer des confirmations de participation aux participants",
        "Teil 1: eLearning": "Partie 1 : eLearning",
        "Teil 2: Präsenzkurs": "Partie 2 : Cours en présentiel",
        "Super, du bist erfolgreich für den Erste Hilfe Kurs angemeldet – wir freuen uns! 🎉": "Super, tu es inscrit avec succès au cours de premiers secours – nous nous réjouissons ! 🎉",
        "Das <strong>eLearning</strong> ist ab sofort für dich freigeschaltet – du kannst direkt loslegen:": "L'<strong>eLearning</strong> est désormais activé pour toi – tu peux commencer immédiatement :",
        "<strong>Bitte beachte:</strong> Das eLearning muss bis spätestens vor dem Präsenzkurs am <strong>{courseDate}</strong> abgeschlossen sein. Es ist die Grundlage für den praktischen Teil des Kurses.": "<strong>Merci de noter :</strong> L'eLearning doit être terminé au plus tard avant le cours en présentiel du <strong>{courseDate}</strong>. Il constitue la base de la partie pratique du cours.",
        "Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning dure environ {duration}. À la fin de l'eLearning, il y a un bref contrôle des connaissances. Il vaut donc la peine de ne pas simplement cliquer sur la théorie !",
        "eLearning URL": "URL eLearning",
        "kopieren": "copier",
        "eLearning QR-Zugänge generieren und E-Mail an ({email}) senden": "Générer les accès QR eLearning et envoyer un e-mail à ({email})",
        "<strong>ACHTUNG:</strong> Du bist als eine andere Person angemeldet. Die E-Mail wird aber an die E-Mail-Adresse der aktuell angemeldeten Person gesendet.": "<strong>ATTENTION :</strong> Tu es connecté en tant qu'une autre personne. L'e-mail sera cependant envoyé à l'adresse e-mail de la personne actuellement connectée.",
        "Teilnahmebestätigungen generieren und E-Mail an ({email}) senden": "Générer les attestations de participation et envoyer un e-mail à ({email})",
        "Programm": "Programme",
        "Teilnahmebestätigungen an Teilnehmer:innen versenden": "Envoyer les attestations de participation aux participant·e·s",
        "Unternehmen": "Entreprise",
        "Kundenbereiche": "Espaces clients",
        "Offerte": "Offre",
        "Benutzer:innen": "Utilisateur·trice·s",
        "Kontakte": "Contacts",
        "Kursanfragen": "Demandes de cours",
        "Kontaktanfragen": "Demandes de contact",
        "Erste Hilfe eLearning": "eLearning Premiers secours",
        "Die Eingabe ist ungültig.": "La saisie est invalide.",
        "Zu viele Versuche. Bitte versuche es später erneut.": "Trop de tentatives. Merci de réessayer plus tard.",
        "Teilnehmer:in aus Kundenbereich löschen": "Supprimer le/la participant·e de l'espace client",
        "Standard": "Standard",
        "Ist der Standard Shop": "Est le shop standard",
        "Ist aktiv": "Est actif",
        "Kurs Zuweisung": "Attribution de cours",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails.": "Dans ton espace personnel my.sanio, tu trouveras tous les détails de la commande.",
        "Zum my.sanio": "Vers my.sanio",
        "Bestellnummer": "Numéro de commande",
        "Datum & Uhrzeit": "Date et heure",
        "Lizenz": "Licence",
        "Zugriffszeitraum": "Période d'accès",
        "Hi {name}! 🎉": "Salut {name} ! 🎉",
        "Zahlungsart": "Mode de paiement",
        "inkl. {taxPercentage}% MwSt": "TVA {taxPercentage}% incl.",
        "Du kannst diesen/diese Teilnehmer:in nicht mehr bearbeiten, da ein verknüpfter Kurs bereits begonnen hat oder abgeschlossen ist.": "Vous ne pouvez plus modifier ce participant car un cours lié a déjà commencé ou est terminé.",
        "Der Kurs hat bereits begonnen.": "Le cours a déjà commencé.",
        "Vielen Dank für deine Anmeldung!": "Merci pour ton inscription !",
        "Du erhältst in Kürze eine Bestätigung per E-Mail mit allen wichtigen Infos zum Kurs. Bitte wirf auch einen Blick in deinen Spam-Ordner, falls keine Mail eintrifft. 📩": "Tu recevras prochainement une confirmation par e-mail avec toutes les informations importantes concernant le cours. Pense également à vérifier ton dossier spam si tu ne reçois pas d'e-mail. 📩",
        "Deine Anmeldung ist bei uns eingegangen. Alle weiteren Informationen zum Kurs erhältst du zu einem späteren Zeitpunkt. 📩": "Ton inscription nous est bien parvenue. Tu recevras toutes les autres informations sur le cours ultérieurement. 📩",
        "Du musst nichts mitbringen. Wir empfehlen dir praktische und bequeme Kleidung zu tragen, die genügend Bewegungsfreiheit bietet. Denn während des Kurses führen wir praktische Übungen auf dem Boden durch, welche teilweise physisch etwas anspruchsvoll sind. 😊": "Tu n'as rien à apporter. Nous te recommandons de porter des vêtements pratiques et confortables offrant une liberté de mouvement suffisante. En effet, pendant le cours, nous effectuons des exercices pratiques au sol qui sont parfois un peu exigeants physiquement. 😊",
        "<strong>Bei Fragen oder Abmeldungen vor dem Kurstag</strong> wende dich bitte direkt an {name}:": "<strong>Si tu as des questions ou si tu veux annuler ton inscription avant le jour du cours</strong>, adresse-toi directement à {name} :",
        "Leider bist du nicht berechtigt, ein Zertifikat für diesen Kurs zu erhalten.": "Malheureusement, tu n'es pas autorisé à recevoir un certificat pour ce cours.",
        "Sanio": "Sanio",
        "Am Kurstag selbst, z.B. bei Verspätung oder kurzfristiger Abmeldung, erreichst du uns schriftlich via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.": "Le jour du cours, par ex. en cas de retard ou de désistement de dernière minute, tu peux nous contacter par écrit via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.",
        "Empfänger": "Destinataire",
        "1 Lizenz zur Selbstnutzung": "1 licence pour usage personnel",
        "{count} Geschenk ({type})": "{count} Cadeau ({type})",
        "digital": "numérique",
        "Anzahl Lizenzen": "Nombre de licences",
        "Für {recipient} von {giver}": "Pour {recipient} de {giver}",
        "Unbekannt": "Inconnu",
        " 🎁": "Utiliser la licence cadeau 🎁",
        "Produktgutschein": "Bon cadeau produit",
        "Gutschein {number} herunterladen": "Télécharger le bon {number}",
        "Gutschein-Link {number} kopieren (inkl. Code)": "Copier le lien du bon cadeau {number} (code incl.)",
        "Eingelöst": "Utilisé",
        "Gutschein oder Rabatt einlösen": "Utiliser un bon cadeau ou une réduction",
        "Trage hier deinen Rabattcode für diesen Kurs ein.": "Saisis ici ton code de réduction pour ce cours.",
        "Rabatt entfernen": "Retirer la réduction",
        "Code ungültig": "Code non valide",
        "Dieser Code ist nur für eLearning Geschenke gültig.": "Ce code est uniquement valable pour les cadeaux eLearning.",
        "Hast du ein eLearning geschenkt bekommen? Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Tu as reçu un eLearning en cadeau ? Utilise alors ton bon cadeau sous {redeemUrl}.",
        "Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Alors utilise ton bon sous {redeemUrl}.",
        "Rabatt": "Rabais",
        "Code": "Code",
        "Produktgutschein erfassen": "Saisir un bon produit",
        "Kunde & Produkt": "Client & produit",
        "Kunde auswählen": "Sélectionner un client",
        "Produkt wählen": "Choisir un produit",
        "Shop-Konfiguration": "Configuration de la boutique",
        "Shop auswählen": "Sélectionner une boutique",
        "Anzahl Gutscheine": "Nombre de bons",
        "Geschenkinformationen": "Informations sur le cadeau",
        "Empfänger:in": "Destinataire",
        "Von (Absender:in)": "De (expéditeur/expéditrice)",
        "Nachricht an die/den Beschenkte:n (optional)": "Message au/à la bénéficiaire (facultatif)",
        "Persönliche Beschriftung auf dem Gutschein hinzufügen": "Ajouter une inscription personnelle sur le bon",
        "Produktgutscheine erstellen": "Créer des bons produit",
        "Produktgutscheine wurden erstellt.": "Les bons produit ont été créés.",
        "Produktgutscheine": "Bons produit",
        "Versandart": "Mode d'envoi",
        "Digital & Versand": "Numérique & envoi",
        "Von {sender}": "De {sender}",
        "Empfänger:in (optional)": "Destinataire (facultatif)",
        "Von (Absender:in, optional)": "De (expéditeur/expéditrice, facultatif)",
        "{who} hat dir eine Lizenz für dieses eLearning geschenkt 🎉": "{who} t'a offert une licence pour cet eLearning 🎉",
        "Viel Spass beim Lernen, {name}! 🎉": "Bon apprentissage, {name} ! 🎉",
        "Nur digital": "Uniquement numérique",
        "Produkt": "Produit",
        "Gutschein wurde erstellt.": "Le bon a été créé.",
        "Gutschein wurde aktualisiert.": "Le bon a été mis à jour.",
        "Gutschein wurde gelöscht.": "Le bon a été supprimé.",
        "📅 Erinnerung an deinen Kurs morgen": "🗓️ Rappel de ton cours demain",
        "manuell via admin": "manuellement via admin",
        "systemgeneriert": "généré par le système",
        "Kundenservice": "Service client",
        "PDF": "PDF",
        "Physisch": "Physique",
        "Rabattgutschein": "Bon de réduction",
        "Wertgutschein": "Bon d'achat",
        "Verwendet": "Utilisé",
        "Abgelaufen": "Expiré",
        "Formatierung kann von effektiv versendeter Nachricht abweichen.": "Le formatage peut différer du message effectivement envoyé.",
        "Absender Nummer:": "Numéro de l'expéditeur :",
        "Quadratisches Produktbild": "Image produit carrée",
        "Gutschein-Konfiguration": "Configuration du bon",
        "Shop-Beschreibung": "Description boutique",
        "Beschreibung die im Shop beim Kauf angezeigt wird": "Description affichée dans la boutique lors de l'achat",
        "Shop-Bedingungen": "Conditions boutique",
        "Bedingungen die im Shop beim Kauf angezeigt werden": "Conditions affichées dans la boutique lors de l'achat",
        "Einlöse-Beschreibung": "Description d'utilisation",
        "Beschreibung die beim Einlösen des Gutscheins angezeigt wird": "Description affichée lors de l'utilisation du bon",
        "Einlöse-Anweisungen": "Instructions d'utilisation",
        "Anweisungen die beim Einlösen des Gutscheins angezeigt werden": "Instructions affichées lors de l'utilisation du bon",
        "Im Shop verfügbar": "Disponible dans la boutique",
        "Gutschein Anwendungen": "Applications du bon",
        "Verfügbar": "Disponible",
        "Pro Benutzer": "Par utilisateur",
        "Keine Verwendungen": "Aucune utilisation",
        "Dieser Gutschein wurde noch nicht verwendet.": "Ce bon n'a pas encore été utilisé.",
        "Bestellung": "Commande",
        "Wert": "Valeur",
        "Suche Code …": "Rechercher un code…",
        "Erstellt am": "Créé le",
        "Rabattgutscheine": "Bons de réduction",
        "Kunde wählen": "Sélectionner un client",
        "Gutscheine": "Bons",
        "Rabattgutschein erfassen": "Saisir un bon de réduction",
        "Suche Code oder Name …": "Rechercher un code ou un nom…",
        "Gültig bis": "Valable jusqu'au",
        "Kunden": "Clients",
        "Grundinformationen": "Informations de base",
        "Gutschein für": "Bon pour",
        "Ursprung": "Origine",
        "Rabattwert": "Valeur de réduction",
        "Rabatt-Typ": "Type de réduction",
        "Betrag in Rappen oder Prozentpunkte x100 (z.B. 1500 = 15.00%)": "Montant en centimes ou points de pourcentage x100 (p. ex. 1500 = 15.00%)",
        "Anwendungen": "Utilisations",
        "Beschränkte Anzahl": "Nombre limité",
        "Anwendungen pro Benutzer": "Utilisations par utilisateur",
        "Rabattgutschein bearbeiten": "Modifier le bon de réduction",
        "Gutschein Details": "Détails du bon",
        "Max. Verwendungen": "Utilisations max.",
        "Max. pro Nutzer:in": "Max. par utilisateur·trice",
        "Dies ist eine kurze Erinnerung: Du leitest morgen den Kurs {courseType}, {courseDuration} bei {company}.": "Ceci est un bref rappel : demain, tu diriges le cours {courseType}, {courseDuration} chez {company}.",
        "Kurszeiten:": "Horaires du cours :",
        "Ort:": "Lieu :",
        "Bitte sei 30 Minuten vor Kursbeginn vor Ort und überprüfe, ob du alles Material dabeihast.": "Merci d'arriver sur place 30 minutes avant le début du cours et de vérifier que tu as tout le matériel nécessaire.",
        "Alle weiteren Informationen zum Kurs und zu den Teilnehmenden findest du hier:": "Toutes les autres informations sur le cours et les participant·e·s se trouvent ici :",
        "Bei Fragen oder Problemen kannst du dich gerne an Tanja wenden.": "Si tu as des questions ou des problèmes, n'hésite pas à contacter Tanja.",
        "Danke für deinen Einsatz!": "Merci pour ton engagement !",
        "Gutschein {code}": "Bon {code}",
        "Gutschein {code} ({value})": "Bon d'achat {code} ({value})",
        "Gutschein {code} ({value}%)": "Bon d'achat {code} ({value}%)",
        "Absender:": "Expéditeur :",
        "Einlösen unter:": "Utiliser sous :",
        "Code als QR": "Code en QR",
        "Aktion": "Action",
        "Offen": "Ouvert",
        "Benutzer": "Utilisateur",
        "Suchen": "Rechercher",
        "Inaktiv": "Inactif",
        "Gesendet:": "Envoyé à",
        "Kanal:": "Canal",
        "Empfänger:": "Destinataire :",
        "Gutscheincode ist ungültig.": "Le code du bon est invalide.",
        "Dieser Gutschein kann nur für das Produkt {name} verwendet werden.": "Ce bon ne peut être utilisé que pour le produit {name}.",
        "Alle Produkte": "Tous les produits",
        "Optional. Ohne Auswahl gilt der Gutschein für alle Produkte. Ein fester Betrag wird je Stück des gewählten Produkts abgezogen.": "Facultatif. Sans sélection, le bon s'applique à tous les produits. Un montant fixe est déduit pour chaque unité du produit choisi.",
        "Gutschein {number}": "Bon d'achat {number}",
        "Mit dem Einlösen akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "En utilisant ce bon, j'accepte les {tos}. J'ai lu et compris la {privacyPolicy}.",
        "Gutschein einlösen": "Utiliser le bon",
        "Du besitzt bereits eine aktive Lizenz für diesen Kurs. Eine weitere Einlösung ist nicht möglich.": "Tu possèdes déjà une licence active pour ce cours. Il n'est pas possible d'en utiliser une autre.",
        "Andere Lizenz einlösen": "Utiliser une autre licence",
        "Schön, dass du dich für unser Erste Hilfe eLearning entschieden hast! 😊": "Nous sommes ravis que tu aies choisi notre eLearning de premiers secours ! 😊",
        "Hast du ein eLearning geschenkt bekommen?": "As-tu reçu un eLearning en cadeau ?",
        "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.": "Une erreur s'est produite. Veuillez réessayer.",
        "Menge": "Quantité",
        "Jede Lizenz berechtigt zu einem Jahr Nutzung des eLearnings.": "Chaque licence donne droit à une année d'utilisation de l'eLearning.",
        "Abschluss": "Conclusion",
        "Ungültiger Anmeldeversuch.": "Tentative de connexion non valide.",
        "Preisberechnung fehlgeschlagen": "Calcul du prix échoué",
        "Über uns": "À propos de nous",
        "Kontakt": "Contact",
        "AGBs": "CGV",
        "Datenschutz": "Protection des données",
        "Impressum": "Mentions légales",
        "Rechnungsadresse bearbeiten": "Modifier l'adresse de facturation",
        "Strasse": "Rue",
        "PLZ": "NPA",
        "Ort": "Localité",
        "E-Mail und Telefonnummer können nur im Profil bearbeitet werden.": "L'adresse e-mail et le numéro de téléphone ne peuvent être modifiés que dans le profil.",
        "Benötigen Sie Hilfe?": "Avez-vous besoin d'aide ?",
        "Wir helfen Ihnen gerne per E-Mail oder Telefon": "Nous nous ferons un plaisir de vous aider par e-mail ou par téléphone",
        "Telefon": "Téléphone",
        "Ihre Bestellung": "Votre commande",
        "Gesamtbetrag": "Montant total",
        "Zwischensumme": "Sous-total",
        "Jetzt kaufen": "Acheter maintenant",
        "Mögliche Zahlungsarten": "Modes de paiement possibles",
        "Uups, Ihre Bestellung konnte nicht abgeschlossen werden.": "Oups, votre commande n'a pas pu être finalisée.",
        "Sie haben die Zahlung abgebrochen. Bitte versuchen Sie es erneut.": "Vous avez annulé le paiement. Veuillez réessayer.",
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.": "Une erreur s'est produite. Veuillez réessayer.",
        "Wir haben deine Bestellung erhalten 🥳": "Nous avons reçu ta commande 🥳",
        "Zahlung wird verarbeitet": "Paiement en cours de traitement",
        "Dein Zugang zum eLearning ist jetzt bereit. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Ton accès à l'eLearning est maintenant prêt. Dans ton espace personnel <strong>my.sanio</strong> tu trouveras tous les détails de ta commande ainsi que l'accès direct au cours. Bon apprentissage ! 🚑💡",
        "Zu my.sanio": "Vers my.sanio",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist bereits eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Tu peux télécharger les bons d'achat en PDF ou copier le lien d'activation direct. Le code est déjà inclus – parfait pour l'envoi par WhatsApp, e-mail ou SMS.",
        "Deine Geschenklizenz 🎁": "Ta licence cadeau 🎁",
        "Deine Geschenklizenzen 🎁": "Tes licences cadeaux 🎁",
        "Deine Geschenklizenz findest du unten in den Bestelldetails. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Ta licence cadeau se trouve ci-dessous dans les détails de commande. Tu peux également y télécharger le PDF à offrir. Tu peux aussi simplement copier le lien vers la page d'activation – le code est déjà inclus. Idéal pour WhatsApp, e-mail ou SMS.",
        "Deine Geschenklizenzen findest du unten in den Bestelldetails. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Tes licences cadeaux se trouvent ci-dessous dans les détails de commande. Tu peux également y télécharger les PDF à offrir. Tu peux aussi simplement copier les liens vers la page d'activation – les codes sont déjà inclus. Idéal pour WhatsApp, e-mail ou SMS.",
        "Bestelldetails": "Détails de commande",
        "Lizenzen": "Licences",
        "Geschenklizenzen": "Licences cadeaux",
        "Link wurde kopiert.": "Le lien a été copié.",
        "Link konnte nicht kopiert werden.": "Le lien n'a pas pu être copié.",
        "Übersicht": "Aperçu",
        "Deine Angaben": "Tes informations",
        "Geschenklizenz Übersicht": "Aperçu de la licence cadeau",
        "Neu bei Sanio?": "Nouveau chez Sanio ?",
        "Erstellen Sie Ihr Sanio-Konto und los geht's!": "Créez votre compte Sanio et c'est parti !",
        "Jetzt Konto erstellen": "Créer un compte maintenant",
        "Haben Sie schon ein Sanio Konto?": "Vous avez déjà un compte Sanio ?",
        "Melden Sie sich mit Ihrer E-Mail oder Handynummer an und schon geht's los!": "Connectez-vous avec votre e-mail ou numéro de portable et c'est parti !",
        "E-Mail oder Handynummer": "E-mail ou numéro de portable",
        "Wird verarbeitet...": "Traitement en cours...",
        "Zum verschenken": "À offrir",
        "Wird auf Geschenklizenz gedruckt": "Sera imprimé sur la licence cadeau",
        "Wenn Sie diese angeben, können Sie sich später auch per SMS einloggen.": "Si vous l'indiquez, vous pourrez aussi vous connecter par SMS plus tard.",
        "Handynummer (optional)": "Numéro de portable (facultatif)",
        "Nr.": "No",
        "Erstelle dein Sanio-Konto": "Crée ton compte Sanio",
        "Erstellen Sie Ihr Sanio-Konto": "Créez votre compte Sanio",
        "Sie sind bereits bei Sanio?": "Vous êtes déjà chez Sanio ?",
        "Du hast bereits ein Konto?": "Tu as déjà un compte ?",
        "Geschenklizenz eingelöst": "Licence cadeau utilisée",
        "Geschenklizenz einlösen 🎁": "Utiliser une licence cadeau 🎁",
        "Geschenklizenz für": "Licence cadeau pour",
        "Geschenklizenz personalisieren": "Personnaliser la licence cadeau",
        "Geschenklizenz von": "Licence cadeau de",
        "Geschenklizenz": "Licence cadeau",
        "Geschenklizenzen personalisieren": "Personnaliser les licences cadeaux",
        "Ihr Name für alle übernehmen": "Reprendre votre nom pour tous",
        "Ihr Name": "Votre nom",
        "Name des Empfängers": "Nom du destinataire",
        "Digital & Physisch (per Post)": "Digital & Physique (par courrier)",
        "Nur digital (PDF)": "Uniquement digital (PDF)",
        "Deine Gutscheine": "Tes bons",
        "Lizenz aktiviert": "Licence activée",
        "Jemand": "Quelqu'un",
        "Wie schön, du wurdest beschenkt 🎉": "Quelle joie, tu as reçu un cadeau 🎉",
        "Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Utilisez votre code et découvrez ce qui vous attend.",
        "Wie viele Lizenzen möchten Sie kaufen? ": "Combien de licences souhaitez-vous acheter ? ",
        "Wird gespeichert...": "Enregistrement en cours...",
        "Nicht {name}?": "Pas {name} ?",
        "Hausnummer": "Numéro",
        "Fehler": "Erreur",
        "Weiter": "Continuer",
        "Registrieren": "S'inscrire",
        "1 Lizenz zum Verschenken ({type})|{count} Lizenzen zum Verschenken ({type})": "1 licence à offrir ({type})|{count} licences à offrir ({type})",
        "Sie sind eingeloggt als: {name}": "Vous êtes connecté en tant que : {name}",
        "Als Firma können Sie keine Lizenz für sich selbst kaufen. Sie können nur Geschenklizenzen kaufen.": "En tant qu'entreprise, vous ne pouvez pas acheter de licence pour vous-même. Vous ne pouvez acheter que des licences cadeaux.",
        "Als Firma registrieren": "S'inscrire en tant qu'entreprise",
        "Firma muss ausgefüllt werden, wenn Sie sich als Firma registrieren möchten.": "Le champ Entreprise doit être rempli si vous souhaitez vous inscrire en tant qu'entreprise.",
        "Firma": "Entreprise",
        "Shop-Kund:in wurde erfolgreich erstellt.": "Shop-client:e a été créé avec succès.",
        "Shop-Kund:in erfassen": "Saisir le client de la boutique",
        "Shop-Kund:in bearbeiten": "Modifier le client de la boutique",
        "Shop-Kund:in wurde erfolgreich aktualisiert.": "Shop-client:e a été mis à jour avec succès.",
        "Shop-Kund:in wurde erfolgreich gelöscht.": "Shop-client:e a été supprimé avec succès.",
        "Shop-Kund:innen": "Clients de la boutique",
        "Shop-Kund:innen erfassen": "Saisir les clients de la boutique",
        "Shop-Kund:in": "Client·e boutique",
        "Für wen sind die Lizenzen?": "Pour qui sont les licences ?",
        "Eine Lizenz für mich, andere zum Verschenken": "Une licence pour moi, les autres à offrir",
        "Alle Lizenzen zum Verschenken": "Toutes les licences à offrir",
        "Sie besitzen bereits eine aktive Lizenz für diesen Kurs. Sie können nur Geschenklizenzen kaufen.": "Vous possédez déjà une licence active pour ce cours. Vous ne pouvez acheter que des licences cadeaux.",
        "Für wen ist die Lizenz?": "Pour qui est la licence ?",
        "Für mich": "Pour moi",
        "Geschenkt von": "Offert par",
        "Für alle übernehmen": "Appliquer pour tous",
        "Wird geprüft.": "Vérification en cours.",
        "Eingelöst von": "Utilisé par",
        "Eingelöst am": "Utilisé le",
        "Deine Geschenklizenz findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Tu trouveras ta licence cadeau dans les <a href=\"{orderLink}\">détails de commande de my.sanio</a>. Tu peux également y télécharger le PDF à offrir. Alternativement, tu peux simplement copier le lien vers la page d'utilisation – le code est déjà inclus. Idéal pour WhatsApp, e-mail ou SMS.",
        "Deine Geschenklizenzen findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Tu trouveras tes licences cadeaux dans les <a href=\"{orderLink}\">détails de commande de my.sanio</a>. Tu peux également y télécharger les PDF à offrir. Alternativement, tu peux simplement copier les liens vers la page d'utilisation – les codes sont déjà inclus. Idéal pour WhatsApp, e-mail ou SMS.",
        "Geschenklizenz eingelöst, eLearning bereit": "Licence cadeau utilisée, eLearning prêt",
        "Ihre Kosten": "Vos frais",
        "Deaktivieren": "Désactiver",
        "Ausstehend": "En attente",
        "Rabatt (Code: {code})": "Rabais (Code : {code})",
        "Dein Zugang zum eLearning ist jetzt freigeschaltet.": "Ton accès à l'eLearning est maintenant activé.",
        "Gutschein für {name}": "Bon d'achat pour {name}",
        "Dauer": "Durée",
        "{attribute} ist keine gültige Sprache.": "{attribute} n'est pas une langue valide.",
        "Produktgutschein wurde aktualisiert.": "Le bon produit a été mis à jour.",
        "Gutschein wurde deaktiviert.": "Le bon a été désactivé.",
        "Ein Gutschein mit diesem Code existiert bereits im Status Aktiv oder Ausstehend. Bitte deaktivieren Sie den bestehenden Gutschein oder verwenden Sie einen anderen Code.": "Un bon avec ce code existe déjà au statut Actif ou En attente. Veuillez désactiver le bon existant ou utiliser un autre code.",
        "Test": "Test",
        "Dieser Code ist ein Produktgutschein und kann hier nicht eingelöst werden.": "Ce code est un bon produit et ne peut pas être utilisé ici.",
        "Gutscheincode ist noch nicht gültig.": "Le code du bon n'est pas encore valide.",
        "Gutscheincode wurde bereits verwendet.": "Le code du bon a déjà été utilisé.",
        "Gutscheincode ist abgelaufen.": "Le code du bon a expiré.",
        "Produktgutschein bearbeiten": "Modifier le bon produit",
        "Absender:in": "Expéditeur·rice",
        "Speichern...": "Enregistrement...",
        "Gültig ab": "Valide dès",
        "Bezeichnung": "Désignation",
        "Betrag in Franken (z.B. 20 = CHF 20.-)": "Montant en francs (p. ex. 20 = CHF 20.-)",
        "Firma (optional)": "Entreprise (facultatif)",
        "Um das Lernen persönlicher und praxisnäher zu gestalten, sprechen wir dich ab hier direkt in der Du-Form an. Schön, dass du dich für unseren Erste Hilfe Online Kurs entschieden hast! 😊": "Pour rendre l'apprentissage plus personnel et plus proche de la pratique, nous te tutoyons à partir d'ici. Bienvenue dans notre cours en ligne de premiers secours ! 😊",
        "In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🧑‍🏫💡": "Dans ton espace personnel <strong>my.sanio</strong> tu trouveras tous les détails de la commande ainsi que l'accès direct au cours. Bon apprentissage ! 🧑‍🏫💡",
        "Einzellizenz (für eine:n Benutzer:in)": "Licence individuelle (pour un·e utilisateur·trice)",
        "Zirka": "Environ",
        "Ein Geschenk von": "Un cadeau de",
        "Gutscheincode": "Code du bon",
        "Optionen öffnen": "Ouvrir les options",
        "Prozent als ganze Zahl (z.B. 15 = 15%)": "Pourcentage en nombre entier (p. ex. 15 = 15%)",
        "💌 Zusätzlich wirst du in den nächsten Tagen die gedruckten Gutscheine per Post erhalten.": "💌 De plus, tu recevras les bons imprimés par courrier postal dans les prochains jours.",
        "Gutschein": "Bon cadeau",
        "Geschenkgutschein deaktivieren?": "Désactiver le bon cadeau ?",
        "Möchtest du den Gutschein wirklich deaktivieren?": "Veux-tu vraiment désactiver le bon ?",
        "Gutschein deaktivieren": "Désactiver le bon",
        "Rabattcode deaktivieren?": "Désactiver le code de réduction",
        "Möchtest du den Rabattcode wirklich deaktivieren?": "Veux-tu vraiment désactiver le code de réduction ?",
        "Rabattcode deaktivieren": "Désactiver le code de réduction",
        "Sie haben bereits eine aktive Lizenz für dieses Produkt. Sie können nur Geschenklizenzen kaufen.": "Vous disposez déjà d'une licence active pour ce produit. Vous ne pouvez acheter que des licences cadeaux.",
        "Füge deine individuelle E-Mail-Adresse (keine allgemeine info@-Adresse) ein, um eine Anmeldebestätigung und ein Erinnerungsmail zu erhalten.": "Indiquez votre adresse e-mail personnelle (pas d'adresse générique info@) pour recevoir une confirmation d'inscription et un e-mail de rappel.",
        "Gib für die Korrespondenz deine persönliche E-Mail-Adresse an (keine allgemeine Adresse wie info@).": "Indique ton adresse e-mail personnelle pour la correspondance (pas une adresse générale comme info@).",
        "Selbstnutzung": "Utilisation personnelle",
        "Als Geschenk": "En cadeau",
        "Teilnahmebestätigung versendet am {date}": "Attestation de participation envoyée le {date}",
        "Abschlussquiz bestanden am {date}": "Quiz final réussi le {date}",
        "Abschlussquiz zuletzt nicht bestanden am {date}": "Quiz final non réussi en dernier lieu le {date}",
        "Abschlussquiz noch offen": "Quiz final encore en attente",
        "Abschlussquiz im letzten eLearning bestanden am {date}": "Quiz final du dernier e-learning réussi le {date}",
        "Abschlussquiz im letzten eLearning zuletzt nicht bestanden am {date}": "Quiz final du dernier e-learning non réussi en dernier lieu le {date}",
        "Deaktivierte Gutscheine können nicht bearbeitet werden.": "Les bons désactivés ne peuvent pas être modifiés.",
        "Die E-Mail-Adresse ist bereits in diesem Login-Bereich vorhanden.": "L'adresse e-mail existe déjà dans cet espace de connexion.",
        "Referenzierte Entität kann nicht gefunden werden.": "L'entité référencée est introuvable.",
        "Die Bestellung wurde archiviert.": "La commande a été archivée.",
        "Die Bestellung wurde wiederhergestellt.": "La commande a été restaurée.",
        "Abschlussquiz im letzten eLearning noch offen": "Quiz final du dernier e-learning encore en attente",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung für die folgenden Personen nicht generiert werden:": "Certains participant·e·s qui ont suivi le cours n'ont pas encore terminé l'e-learning. Par conséquent, l'attestation ne peut pas être générée pour les personnes suivantes :",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Certains participant·e·s qui ont suivi le cours n'ont pas encore terminé l'e-learning. Par conséquent, l'attestation ne peut pas être envoyée par e-mail aux personnes suivantes :",
        "Für einige Teilnehmer:innen, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Pour certains participant·e·s, aucune adresse e-mail n'est disponible. Par conséquent, l'attestation ne peut pas être envoyée par e-mail aux personnes suivantes :",
        "Kurszusammenfassung": "Résumé du cours",
        "Lädt...": "Chargement...",
        "nicht ausgewählt": "non sélectionné",
        "Ja": "Oui",
        "Nein": "Non",
        "Versendet": "Envoyé",
        "Tage vor Kursbeginn": "Jours avant le début du cours",
        "Tage": "Jours",
        "bei bestandenem eLearning-Abschlussquiz": "en cas de réussite du quiz final e-learning",
        "Beim Kurs Abschluss an Teilnehmer mit Status «teilgenommen» und hinterlegter E-Mail-Adresse.": "À la fin du cours, aux participants ayant le statut «participé» et une adresse e-mail enregistrée.",
        "Im eLearning öffnen": "Ouvrir dans l'e-learning",
        "Schliessen": "Fermer",
        "Fehler beim Laden der Zusammenfassung": "Erreur lors du chargement du résumé",
        "Rechnung in bexio öffnen": "Ouvrir la facture dans bexio",
        "{attribute} is keine gültige Sprache.": "{attribute} n'est pas une langue valide.",
        "Feedbacks": "Feedbacks",
        "E-Learning / Online": "E-learning / en ligne",
        "Zeitraum": "Période",
        "Als Excel herunterladen": "Télécharger en Excel",
        "Bewertung": "Évaluation",
        "Antworten": "Réponses",
        "Teilnehmer:in": "Participant·e",
        "Keine Feedbacks für diese Freigabe.": "Aucun retour pour cette version.",
        "Der Kursstatus wurde aktualisiert.": "Le statut du cours a été mis à jour.",
        "Der Status von {count} Kurs wurde aktualisiert.|Der Status von {count} Kursen wurde aktualisiert.": "Le statut de {count} cours a été mis à jour.|Le statut de {count} cours a été mis à jour.",
        "Mindestens einer der ausgewählten Kurse wurde nicht gefunden.": "Au moins un des cours sélectionnés est introuvable.",
        "Statuswechsel ist nur möglich, wenn alle ausgewählten Kurse denselben Status haben.": "Un changement de statut n'est possible que si tous les cours sélectionnés ont le même statut.",
        "\"{course}\": {message}": "« {course} » : {message}",
        "{count} Kurs ausgewählt|{count} Kurse ausgewählt": "{count} cours sélectionné|{count} cours sélectionnés",
        "Statuswechsel nicht möglich, da die ausgewählten Kurse unterschiedliche Status haben.": "Changement de statut impossible car les cours sélectionnés ont des statuts différents.",
        "Auswahlmodus beenden": "Quitter le mode sélection",
        "Auswahlmodus": "Mode sélection",
        "Möchtest du den Status von {count} Kurs wirklich ändern?|Möchtest du den Status von {count} Kursen wirklich ändern?": "Veux-tu vraiment modifier le statut de {count} cours ?|Veux-tu vraiment modifier le statut de {count} cours ?",
        "Alle Kurse in dieser Liste auswählen": "Sélectionner tous les cours de cette liste",
        "Kurstyp wurde erfolgreich erstellt.": "Le type de cours a été créé avec succès.",
        "System-Kurstypen können nicht gelöscht werden.": "Les types de cours système ne peuvent pas être supprimés.",
        "Der Kurstyp kann nicht gelöscht werden, da er bereits verwendet wird.": "Le type de cours ne peut pas être supprimé car il est déjà utilisé.",
        "Kurstyp wurde erfolgreich gelöscht.": "Le type de cours a été supprimé avec succès.",
        "Der OAuth-Client wurde widerrufen.": "Le client OAuth a été révoqué.",
        "Anmeldungen sind für diesen Kurs nicht möglich (Status \"{status}\").": "Les inscriptions ne sont pas possibles pour ce cours (statut \"{status}\").",
        "Der Kurs kann nicht von \"{from}\" auf \"{to}\" gesetzt werden.": "Le cours ne peut pas passer de \"{from}\" à \"{to}\".",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange Systemprüfungen fehlschlagen: {checks}": "Le cours ne peut pas être défini sur \"Prêt\" tant que des vérifications système échouent : {checks}",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange keine Termine definiert sind. E-Learning-Kurse sind hiervon ausgenommen.": "Le cours ne peut pas être marqué comme « Prêt » sans dates définies. Les cours e-learning en sont exemptés.",
        "Bestanden": "Réussi",
        "Fehlgeschlagen": "Échoué",
        "Übersprungen": "Ignoré",
        "Tippen zum Suchen": "Appuyer pour rechercher",
        "Keine Einträge gefunden.": "Aucune entrée trouvée.",
        "Keine Unternehmen gefunden.": "Aucune entreprise trouvée.",
        "Keine Kunden gefunden.": "Aucun client trouvé.",
        "Kunde suchen…": "Rechercher un client…",
        "Dieser Kurs hat fehlgeschlagene Systemprüfungen!": "Ce cours a des vérifications système qui ont échoué !",
        "Kursstatus ändern": "Modifier le statut du cours",
        "Angemeldet": "Inscrit",
        "Teilgenommen": "A participé",
        "Entschuldigt abwesend": "Absent excusé",
        "Unentschuldigt abwesend": "Absent non excusé",
        "Produktgruppe ist aktiv": "Le groupe de produits est actif",
        "Produktgruppe ist nicht aktiv": "Le groupe de produits n'est pas actif",
        "Kurstyp erstellen": "Créer un type de cours",
        "Systemprüfungen": "Vérifications système",
        "Zuletzt geprüft": "Dernière vérification",
        "Noch keine Prüfungen durchgeführt.": "Aucune vérification effectuée pour le moment.",
        "Wird geprüft...": "Vérification en cours...",
        "Jetzt prüfen": "Vérifier maintenant",
        "Keine Prüfungsergebnisse vorhanden. Klicke auf \"Jetzt prüfen\" um die Systemprüfungen auszuführen.": "Aucun résultat de vérification disponible. Clique sur \"Vérifier maintenant\" pour effectuer les vérifications système.",
        "abhängig": "dépendant",
        "Hinweis: Für den Versand der Anmeldebestätigung ist in jeder Zeile der Datei eine gültige E-Mail-Adresse erforderlich.": "Remarque : pour l'envoi de la confirmation d'inscription, une adresse e-mail valide est requise dans chaque ligne du fichier.",
        "Im Anhang findest du die von dir importierte Datei.": "Tu trouveras en pièce jointe le fichier que tu as importé.",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert und am Kurs angemeldet.": "Les lignes suivantes ont malgré tout été importées et inscrites au cours en raison d'une attribution ambiguë.",
        "Aargau": "Argovie",
        "Als Firma können Sie keine Lizenz einlösen.": "En tant qu'entreprise, vous ne pouvez pas activer de licence.",
        "Als Firma können Sie keine Lizenz einlösen. Sie können nur Geschenklizenzen kaufen.": "En tant qu'entreprise, vous ne pouvez pas activer de licence. Vous pouvez uniquement acheter des licences cadeaux.",
        "Amt": "Office",
        "Anmeldungen sind für diesen Kurs derzeit nicht möglich.": "Les inscriptions ne sont actuellement pas possibles pour ce cours.",
        "Appenzell Ausserrhoden": "Appenzell Rhodes-Extérieures",
        "Appenzell Innerrhoden": "Appenzell Rhodes-Intérieures",
        "Auswahl als Excel exportieren": "Exporter la sélection au format Excel",
        "Basel-Landschaft": "Bâle-Campagne",
        "Basel-Stadt": "Bâle-Ville",
        "Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten. Bitte versuche es später erneut.": "Une erreur s'est produite lors de l'utilisation du code cadeau. Merci de réessayer ultérieurement.",
        "Bern": "Berne",
        "Bezahlstatus": "Statut de paiement",
        "Bezahlt": "Payé",
        "Bis": "Jusqu'à",
        "Bitte geben Sie die Empfänger-Informationen für die Geschenklizenzen ein.": "Veuillez saisir les informations du destinataire pour les licences cadeaux.",
        "Bitte melde dich an, um fortzufahren.": "Merci de te connecter pour continuer.",
        "Bitte wählen Sie aus, für wen die Lizenz(en) bestimmt sind.": "Veuillez sélectionner à qui la ou les licence(s) sont destinées.",
        "Bitte wählen Sie eine Versandart aus.": "Veuillez sélectionner un mode d'envoi.",
        "Das Kapitel wurde gelöscht.": "Le chapitre a été supprimé.",
        "Das Produkt für diesen Gutschein wurde nicht gefunden.": "Le produit pour ce bon n'a pas été trouvé.",
        "Das Profil wurde erfolgreich aktualisiert.": "Le profil a été mis à jour avec succès.",
        "Das Themengebiet wurde aktualisieren.": "Le domaine thématique a été mis à jour.",
        "Das Themengebiet wurde erstellt. 🎉": "Le domaine thématique a été créé. 🎉",
        "Datei erfolgreich aktualisiert.": "Fichier mis à jour avec succès.",
        "Datei erfolgreich erstellt! 🎉": "Fichier créé avec succès ! 🎉",
        "Datei wurde gelöscht.": "Le fichier a été supprimé.",
        "Dein Zugang zum eLearning ist jetzt aktiviert. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Details und den direkten Kurszugang. Viel Erfolg beim Lernen! 🚑💡": "Votre accès à l'eLearning est maintenant activé. Dans votre espace personnel <strong>my.sanio</strong>, vous trouverez tous les détails et l'accès direct au cours. Bonne chance pour votre apprentissage ! 🚑💡",
        "Deine Online Kurse": "Vos cours en ligne",
        "Deine Sanio ID": "Votre identifiant Sanio",
        "Der Kurs wurde aktualisieren.": "Le cours a été mis à jour.",
        "Der Kurs wurde erstellt. 🎉": "Le cours a été créé. 🎉",
        "Der Kurs wurde gelöscht.": "Le cours a été supprimé.",
        "Der Nachname ist erforderlich.": "Le nom de famille est obligatoire.",
        "Der Ort ist erforderlich.": "La localité est obligatoire.",
        "Der Teilnehmer wurde vom Kurs entfernt!": "Le participant a été retiré du cours !",
        "Der Vorname ist erforderlich.": "Le prénom est obligatoire.",
        "Die Anmeldefrist ist leider abgelaufen.": "Le délai d'inscription est malheureusement dépassé.",
        "Die Handynummer ist optional. Wenn Sie diese angeben, können Sie sich später auch per per SMS einloggen.": "Le numéro de portable est facultatif. Si vous l'indiquez, vous pourrez vous connecter ultérieurement également par SMS.",
        "Die Karte wurde gelöscht.": "La carte a été supprimée.",
        "Die PLZ ist erforderlich.": "Le NPA est obligatoire.",
        "Die Story wurde dupliziert.": "Le parcours a été dupliqué.",
        "Die Story wurde gelöscht.": "Le parcours a été supprimé.",
        "Die Strasse ist erforderlich.": "La rue est obligatoire.",
        "Die Übersetzungen werden nun exportiert.": "Les traductions sont en cours d'exportation.",
        "Die Übersetzungen werden nun importiert.": "Les traductions sont en cours d'importation.",
        "Dieser Code ist kein Rabattcode, sondern schaltet dein eLearning direkt frei. Du kannst ihn jetzt sofort im Einlöse-Bereich nutzen - ohne erneutes Login oder weitere Schritte.": "Ce code n'est pas un code de réduction, mais débloque directement ton eLearning. Tu peux l'utiliser dès maintenant dans la zone d'activation - sans nouvelle connexion ni étapes supplémentaires.",
        "Dieser Geschenkcode ist ungültig oder wurde bereits eingelöst.": "Ce code cadeau est invalide ou a déjà été utilisé.",
        "Dieser Geschenkcode wurde bereits eingelöst.": "Ce code cadeau a déjà été utilisé.",
        "Digital & physisch per Post": "Digital & physique par poste",
        "Direktion": "Direction",
        "Dokumente": "Documents",
        "Du hast keine Berechtigung, diesen Teilnehmer zu sehen.": "Tu n'as pas l'autorisation de voir ce participant.",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist schon eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Tu peux télécharger les bons d'achat au format PDF ou copier le lien d'activation direct. Le code est déjà inséré – parfait pour l'envoi par WhatsApp, e-mail ou SMS.",
        "Du kannst diese:n Teilnehmer:in nicht mehr bearbeiten. Bitte wende dich an deine Ansprechperson bei Sanio.": "Tu ne peux plus modifier ce/cette participant·e. Merci de te tourner vers ta personne de contact chez Sanio.",
        "E-Learning-Kurs suchen…": "Rechercher un cours eLearning…",
        "Empfänger ändern": "Modifier le destinataire",
        "Filter zurücksetzen": "Réinitialiser les filtres",
        "Filtern": "Filtrer",
        "Freiburg": "Fribourg",
        "Funktion": "Fonction",
        "Geburtsdatum": "Date de naissance",
        "Geburtsdatum (TT.MM.JJJJ)": "Date de naissance (JJ.MM.AAAA)",
        "Genf": "Genève",
        "Geschenklizenz einlösen": "Activer une licence cadeau",
        "Glarus": "Glaris",
        "Graubünden": "Grisons",
        "Gutschein gefunden!": "Bon trouvé !",
        "Gutschein jetzt einlösen": "Utiliser le bon maintenant",
        "Gutscheine werden vorbereitet": "Les bons sont en cours de préparation",
        "Hier dein persönlicher Zugang, um dich im shop.sanio einzuloggen:": "Voici ton accès personnel pour te connecter sur shop.sanio :",
        "Instruktor:in": "Instructeur·trice",
        "Jura": "Jura",
        "Kaufbeleg / Rechnung als PDF": "Justificatif d'achat / Facture au format PDF",
        "Keine Feedbacks für die aktuellen Filter.": "Aucun feedback pour les filtres actuels.",
        "Klasse": "Classe",
        "Klassenstufe": "Niveau scolaire",
        "Kontext": "Contexte",
        "Kundenberater": "Conseiller clientèle",
        "Kundenportal Gruppenadmin": "Portail client Admin de groupe",
        "Kundenportal Superadmin": "Portail client Superadmin",
        "Kurs abgeschlossen, Prüfung ausstehend": "Cours terminé, examen en attente",
        "Kurs suchen…": "Rechercher un cours…",
        "Kursfortschritt": "Progression du cours",
        "Kurszugang nicht gefunden.": "Accès au cours introuvable.",
        "Luzern": "Lucerne",
        "Mein Profil": "Mon profil",
        "Meine Bestellungen": "Mes commandes",
        "Melde dich mit deiner Handynummer oder E-Mail an und schon geht’s los!": "Inscris-toi avec ton numéro de mobile ou ton e-mail et c'est parti !",
        "MidnightSports": "MidnightSports",
        "Mindestens ein Empfänger muss angegeben werden.": "Au moins un destinataire doit être indiqué.",
        "MiniMove": "MiniMove",
        "Name des Empfängers darf maximal 255 Zeichen lang sein.": "Le nom du destinataire peut comporter au maximum 255 caractères.",
        "Name des Empfängers ist erforderlich.": "Le nom du destinataire est obligatoire.",
        "Name des Schenkers darf maximal 255 Zeichen lang sein.": "Le nom du donateur peut comporter au maximum 255 caractères.",
        "Name des Schenkers ist erforderlich.": "Le nom du donateur est obligatoire.",
        "Neuenburg": "Neuchâtel",
        "Nicht Bezahlt": "Non payé",
        "Nidwalden": "Nidwald",
        "Obwalden": "Obwald",
        "OpenSunday": "OpenSunday",
        "Prüfung bestanden": "Examen réussi",
        "Sanio Kundenportal": "Portail clients Sanio",
        "Schaffhausen": "Schaffhouse",
        "Schuleinheit": "Unité scolaire",
        "Schwyz": "Schwyz",
        "Shop Kunde ID": "ID client boutique",
        "Solothurn": "Soleure",
        "St. Gallen": "Saint-Gall",
        "Standort": "Site",
        "Standort/Fachbereich": "Site/Domaine",
        "Store": "Boutique",
        "Super Admin": "Super Admin",
        "Teilnahmebestätigung als PDF": "Attestation de participation au format PDF",
        "Teilnehmer": "Participant",
        "Teilnehmer nicht gefunden.": "Participant non trouvé.",
        "Teilnehmer:in konnte nicht hinzugefügt werden": "Le participant n'a pas pu être ajouté",
        "Teilnehmer:in wurde erfolgreich angemeldet.": "Le participant a été inscrit avec succès.",
        "Teilnehmer:in wurde erfolgreich hinzugefügt": "Le participant a été ajouté avec succès",
        "Tessin": "Tessin",
        "Thurgau": "Thurgovie",
        "Ungültige Auswahl für Lizenzempfänger.": "Sélection non valide pour le destinataire de la licence.",
        "Ungültige Versandart ausgewählt.": "Mode d'envoi non valide sélectionné.",
        "Uri": "Uri",
        "Von": "De",
        "Waadt": "Vaud",
        "Wallis": "Valais",
        "Zug": "Zoug",
        "Zyklus": "Cycle",
        "Zürich": "Zurich",
        "andere": "autre",
        "bearbeitungsbedürftig": "nécessite modification",
        "my.sanio Kunde": "Client my.sanio",
        "n/A": "n/A",
        "nicht übersetzt": "non traduit",
        "🤔 Es sind keine Kurse geplant": "🤔 Aucun cours prévu",
        "Archivierte Kurse": "Cours archivés",
        "Abgemeldet: Teilnahme abgelehnt": "Désinscrit : Participation refusée",
        "Abgemeldet: Vorzeitig storniert": "Désinscrit : Annulation anticipée",
        "Abgemeldet: Entschuldigt": "Désinscrit : Excusé",
        "Abgemeldet: Unentschuldigt": "Désinscrit : Non excusé",
        "Warteliste": "Liste d'attente",
        "entschuldigt": "excusé",
        "unentschuldigt": "non excusé",
        "{firstName} {lastName} war {reason} abwesend weil: {note}": "{firstName} {lastName} était absent {reason} car : {note}",
        "errors.503.status_prefix": "État actuel du système :",
        "Kursort": "Lieu du cours",
        "Kursleitung": "Direction du cours",
        "Kurssprache:": "Langue du cours :",
        "Kurs-ID:": "ID du cours :",
        "Neu": "Nouveau",
        "Die Kursinformationen wurden versendet.": "Les informations du cours ont été envoyées.",
        "Änderungen zu deinem Kurs": "Modifications concernant ton cours",
        "Kurszuteilung": "Attribution de cours",
        "Du wurdest von einem Kurs entfernt": "Tu as été retiré d'un cours",
        "Der Kurs muss bereit sein.": "Le cours doit être prêt.",
        "Diese Person ist keine Kursleitung.": "Cette personne n'est pas moniteur de cours.",
        "Diese Kursleitung ist keinem Termin dieses Kurses zugeteilt.": "Ce moniteur n'est attribué à aucune date de ce cours.",
        "Der Kurs ist bereits vorbei und kann nicht auf \"Bereit\" gesetzt werden. Der Kurs würde innert wenigen Augenblicken auf \"Durchgeführt\" gestellt werden.": "Le cours est déjà terminé et ne peut pas être mis sur \"Prêt\". Le cours serait mis sur \"Effectué\" dans quelques instants.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange Anwesenheiten fehlen.": "Le cours ne peut pas être mis sur \"Terminé\" tant que des présences manquent.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange anwesende Teilnehmende das E-Learning nicht bestanden haben.": "Le cours ne peut pas être mis sur \"Terminé\" tant que des participants présents n'ont pas réussi l'e-learning.",
        "Kurstyp": "Type de cours",
        "Datum/Zeit": "Date/Heure",
        "Kontaktperson": "Personne de contact",
        "Kontaktaufnahme": "Prise de contact",
        "Infos zu Kontaktaufnahme": "Infos sur la prise de contact",
        "Beschreibung Kursleitung": "Description du moniteur",
        "Präsentation": "Présentation",
        "Präsentieren": "Présenter",
        "Kurspräsentation": "Présentation du cours",
        "Weitere Links": "Autres liens",
        "Auswahl entfernen: {option}": "Retirer la sélection : {option}",
        "Keine Optionen gefunden": "Aucune option trouvée",
        "Abgelehnt am": "Refusé le",
        "Bestätigt am": "Confirmé le",
        "Mail versendet, Bestätigung offen": "Mail envoyé, confirmation en attente",
        "Modus": "Mode",
        "Typ & Dauer": "Type & durée",
        "Belegung": "Occupation",
        "Materialset": "Set de matériel",
        "Fehlende Kursleitung": "Direction du cours manquante",
        "Initialer Mailversand offen": "Envoi initial du mail en attente",
        "Nicht versendete Kursleitungs-Infos vorhanden": "Infos de direction du cours non envoyées disponibles",
        "Kontaktperson für Kursleitung": "Personne de contact pour la direction du cours",
        "Infos offen": "Infos en attente",
        "Infos veraltet": "Infos obsolètes",
        "Kursleitungs-Infos senden": "Envoyer les infos de direction du cours",
        "Diese Kursleitung hat die initialen Kursinformationen noch nicht erhalten.": "Cette direction du cours n'a pas encore reçu les informations initiales du cours.",
        "Diese Kursleitung hat noch nicht alle aktuellen Kursinformationen erhalten.": "Cette direction du cours n'a pas encore reçu toutes les informations actuelles du cours.",
        "Zu versendende Änderungen": "Modifications à envoyer",
        "Alt": "Ancien",
        "Senden": "Envoyer",
        "Automatischer Versand bei Abschluss ist in den E-Mail-Einstellungen deaktiviert.": "L'envoi automatique à la clôture est désactivé dans les paramètres e-mail.",
        "Abwesend": "Absent",
        "Abwesenheit erfassen": "Saisir une absence",
        "Wie war {name} abwesend?": "Comment {name} était-il/elle absent(e) ?",
        "Notiz (optional)": "Note (facultatif)",
        "Grund der Abwesenheit": "Motif de l'absence",
        "Wird eine Notiz erfasst, wird automatisch ein Kommentar zum Kurs hinzugefügt.": "Si une note est saisie, un commentaire sera automatiquement ajouté au cours.",
        "Abschliessen": "Clôturer",
        "Es gab Änderungen zu deinem zugeteilten Kurs:": "Des modifications ont été apportées au cours qui t'a été attribué :",
        "Folgende Informationen wurden aktualisiert:": "Les informations suivantes ont été mises à jour :",
        "Bitte prüfe die aktuellen Kursdetails und bestätige uns, dass du den Kurs weiterhin leiten kannst.": "Merci de vérifier les détails actuels du cours et de nous confirmer que tu peux toujours animer le cours.",
        "Kursinfos prüfen und bestätigen": "Vérifier et confirmer les informations du cours",
        "Kurszuteilung bestätigen": "Confirmer l'attribution du cours",
        "Du wurdest von folgendem Kurs entfernt.": "Tu as été retiré(e) du cours suivant.",
        "Die Absage für deinen Kalender findest du im Anhang. Weitere Informationen zum Kurs findest du": "L'annulation pour ton calendrier se trouve en pièce jointe. Tu trouveras de plus amples informations sur le cours",
        "Du wurdest folgendem Kurs zugeteilt 🎉": "Tu as été attribué(e) au cours suivant 🎉",
        "Bitte 30 Minuten vor Kursstart am Kursort eintreffen. Prüfe die Kursinformationen und bestätige uns, dass du den Kurs leiten kannst.": "Merci d'arriver sur le lieu du cours 30 minutes avant le début. Vérifie les informations du cours et confirme-nous que tu peux l'animer.",
        "Die Kalenderdatei findest du im Anhang.": "Tu trouveras le fichier de calendrier en pièce jointe.",
        "Termin {n}": "Créneau {n}",
        "Termin {n} entfernen": "Supprimer le créneau {n}",
        "eine Kursleiter:in": "un·e formateur·rice",
        "{count} Kursleiter:innen": "{count} formateur·rices",
        "eine Springer:in": "un·e remplaçant·e",
        "{count} Springer:innen": "{count} remplaçant·es",
        "{count} ohne Materialset": "{count} sans set de matériel",
        "Zeit und Personal festlegen": "Définir l'horaire et le personnel",
        "Materialset fehlt": "Set de matériel manquant",
        "Pro Termin Kursleiter:innen und optional Springer festlegen. Materialset und Abholhinweis werden pro Kursleiter:in zugewiesen.": "Définis les formateur·rices et éventuellement des remplaçant·es par créneau. Le set de matériel et la note de retrait sont définis par formateur·rice.",
        "Noch keine Termine": "Aucun créneau pour le moment",
        "Füge den ersten Kurstermin hinzu.": "Ajoute le premier créneau du cours.",
        "Termin hinzufügen": "Ajouter un créneau",
        "Kursleiter:innen": "Formateur·rices",
        "Noch keine Kursleiter:in zugewiesen.": "Aucun·e formateur·rice assigné·e.",
        "Abholhinweis": "Note de retrait",
        "Aktionen": "Actions",
        "fehlt": "manquant",
        "Kursleiter:in bearbeiten": "Modifier le/la formateur·rice",
        "Kursleiter:in entfernen": "Retirer le/la formateur·rice",
        "Als Kursleiter:in übernehmen": "Promouvoir en formateur·rice",
        "Kursleiter:in zuweisen": "Assigner un·e formateur·rice",
        "Kursleiter:in": "Formateur·rice",
        "Kursleiter:in auswählen": "Sélectionner un·e formateur·rice",
        "Materialset auswählen": "Sélectionner un set de matériel",
        "optional": "facultatif",
        "z. B. Lager West, Schlüssel bei Empfang": "p. ex. Entrepôt Ouest, clé à la réception",
        "Zuweisen": "Assigner",
        "Bitte eine Kursleiter:in auswählen.": "Veuillez sélectionner un·e formateur·rice.",
        "Springer": "Remplaçant",
        "Springereinsatz": "Mission de remplaçant",
        "Änderungen zu deinem Springereinsatz": "Modifications concernant ta mission de remplaçant",
        "Springer auswählen": "Sélectionner un remplaçant",
        "Springer-Infos senden": "Envoyer les informations au remplaçant",
        "Springer bestätigt": "Remplaçant confirmé",
        "Springer noch nicht bestätigt": "Remplaçant pas encore confirmé",
        "Vielen Dank, dass du dich als Springer:in für diesen Kurs zur Verfügung stellst! 🙌": "Merci de te tenir à disposition en tant que remplaçant·e pour ce cours ! 🙌",
        "Falls die regulär eingeteilte Kursleitung kurzfristig ausfällt, würden wir dich gerne einsetzen.": "Si la direction de cours régulièrement prévue est absente à court terme, nous souhaiterions faire appel à toi.",
        "Aktuell musst du nichts unternehmen.": "Actuellement, tu n'as rien à entreprendre.",
        "Bitte halte dir den Termin frei und stelle sicher, dass du kurzfristig erreichbar bist. Sollte ein Einsatz nötig werden, melden wir uns so früh wie möglich bei dir.": "Veuillez garder la date libre et t'assurer d'être joignable à court terme. Si une intervention devient nécessaire, nous te contacterons aussi tôt que possible.",
        "Weitere Informationen zum Kurs findest du": "Tu trouveras d'autres informations sur le cours",
        "Bitte beachte die aktualisierten Kursinformationen.": "Veuillez prendre note des informations de cours actualisées.",
        "Diese Person hat die initialen Kursinformationen noch nicht erhalten.": "Cette personne n'a pas encore reçu les informations initiales du cours.",
        "Diese Person hat noch nicht alle aktuellen Kursinformationen erhalten.": "Cette personne n'a pas encore reçu toutes les informations actuelles du cours.",
        "Bitte Kurszuteilung bestätigen": "Veuillez confirmer l'attribution du cours",
        "Springer:in auswählen": "Sélectionner un·e remplaçant·e",
        "Springer:in bearbeiten": "Modifier le/la remplaçant·e",
        "Springer:in zuweisen": "Attribuer un·e remplaçant·e",
        "Entwurf": "Brouillon",
        "Angefragt": "Demandé",
        "Zuteilung bestätigt": "Attribution confirmée",
        "Zuteilung abgelehnt": "Attribution refusée",
        "Zuteilung bestätigen": "Confirmer l’attribution",
        "Zuteilung ablehnen": "Refuser l’attribution",
        "Du hast diese Kurszuteilung abgelehnt.": "Tu as refusé cette attribution de cours.",
        "Speichern & weitere Person hinzufügen": "Enregistrer & ajouter une autre personne",
        "Alle {count} Teilnehmer:innen anzeigen": "Afficher les {count} participant·e·s",
        "{shown} von {total}": "{shown} sur {total}",
        "Weitere Treffer werden geladen…": "Chargement des autres résultats…",
        "Nachfassen": "Suivi",
        "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.": "Veux-tu ouvrir le cours pour un suivi ? Le cours reste fermé.",
        "Aktuell können nur Teilnehmende hinzugefügt oder entfernt werden. Andere Kursdetails können nicht bearbeitet werden.": "Actuellement, seuls des participants peuvent être ajoutés ou supprimés. Aucun autre détail du cours ne peut être modifié.",
        "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.": "Actuellement, des participants peuvent être ajoutés ou supprimés et les présences peuvent être modifiées. Aucun autre détail du cours ne peut être modifié.",
        "Folien am Griff ziehen, um ihre Reihenfolge zu ändern.": "Fais glisser les diapositives par la poignée pour modifier leur ordre.",
        "{count} Folien ausgewählt": "{count} diapositives sélectionnées",
        "Alle {count} Folien auswählen": "Sélectionner les {count} diapositives",
        "Alle Folien sind ausgewählt": "Toutes les diapositives sont sélectionnées",
        "Auswahl aufheben": "Effacer la sélection",
        "Folie verschieben": "Déplacer la diapositive",
        "Folie auswählen": "Sélectionner la diapositive",
        "Folie {position} auswählen": "Sélectionner la diapositive {position}",
        "Kursleiter:innen-Notiz vorhanden": "Note de présentation disponible",
        "Keine Notizen": "Aucune note",
        "Folien löschen": "Supprimer les diapositives",
        "Möchtest du die {count} ausgewählten Folien wirklich löschen?": "Veux-tu vraiment supprimer les {count} diapositives sélectionnées ?",
        "Folienbibliothek": "Bibliothèque de diapositives",
        "Folien, Sprachversionen und Tags verwalten": "Gérer les diapositives, les versions linguistiques et les tags",
        "Foliensatz importieren": "Importer un jeu de diapositives",
        "Noch keine Folien importiert.": "Aucune diapositive importée.",
        "Importiere einen Foliensatz, um deine Folienbibliothek aufzubauen.": "Importe un jeu de diapositives pour créer ta bibliothèque.",
        "Folien werden importiert…": "Les diapositives sont en cours d’importation…",
        "Folienbibliothek-Einstellungen": "Paramètres de la bibliothèque de diapositives",
        "Kurspräsentation aus Folienbibliothek": "Présentation de cours depuis la bibliothèque",
        "Der Foliensatz wird importiert.": "Le jeu de diapositives est en cours d’importation.",
        "Der Upload ist fehlgeschlagen.": "Le téléversement a échoué.",
        "Der Upload ist unvollständig. Bitte erneut versuchen.": "Le téléversement est incomplet. Veuillez réessayer.",
        "Die Datei muss eine PDF-Datei sein.": "Le fichier doit être un PDF.",
        "Einzelne Folien müssen genau eine PDF-Seite enthalten.": "Chaque diapositive doit contenir exactement une page PDF.",
        "Diese PDF-Datei kann nicht gelesen werden. Exportiere sie bitte erneut als PDF 1.4.": "Ce fichier PDF ne peut pas être lu. Exporte-le à nouveau au format PDF 1.4.",
        "Folientitel": "Titre de la diapositive",
        "Foliensätze": "Jeux de diapositives",
        "Folienbibliotheken nach Kurstyp verwalten": "Gérer les bibliothèques de diapositives par type de cours",
        "Foliensatz hinzufügen": "Ajouter un jeu de diapositives",
        "Noch keine Foliensätze vorhanden.": "Aucun jeu de diapositives disponible.",
        "Foliensatz: Folien, Sprachversionen und Tags verwalten": "Jeu de diapositives : gérer les diapositives, langues et tags",
        "Alle Foliensätze": "Tous les jeux de diapositives",
        "Foliensatz": "Jeu de diapositives",
        "Verwendung": "Utilisation",
        "Kurse, die Folien aus diesem Foliensatz verwenden": "Cours qui utilisent des diapositives de ce jeu",
        "Dieser Foliensatz wird in keinem Kurs verwendet.": "Ce jeu de diapositives n’est utilisé dans aucun cours.",
        "Für diesen Kurstyp ist noch kein Foliensatz vorhanden.": "Aucun jeu de diapositives n’existe encore pour ce type de cours.",
        "Foliensatz erstellen": "Créer un jeu de diapositives",
        "Der Foliensatz wurde erstellt.": "Le jeu de diapositives a été créé.",
        "Mindestens eine Folie gehört nicht zu diesem Foliensatz.": "Au moins une diapositive n’appartient pas à ce jeu.",
        "Mindestens eine Folie gehört nicht zu dieser Präsentation.": "Au moins une diapositive n’appartient pas à cette présentation.",
        "Mindestens ein Tag gehört nicht zum Foliensatz dieses Kurstyps.": "Au moins un tag n’appartient pas au jeu de diapositives de ce type de cours.",
        "Folienpakete": "Paquets de diapositives",
        "Folienpaket": "Paquet de diapositives",
        "Folienpakete für Kurstypen verwalten": "Gérer les paquets de diapositives par type de cours",
        "Folienpaket hinzufügen": "Ajouter un paquet de diapositives",
        "Noch keine Folienpakete vorhanden.": "Aucun paquet de diapositives disponible.",
        "Alle Folienpakete": "Tous les paquets de diapositives",
        "Das Folienpaket wurde erstellt.": "Le paquet de diapositives a été créé.",
        "Das Folienpaket wurde gelöscht.": "Le paquet de diapositives a été supprimé.",
        "Ohne Tag-Auswahl werden alle Folien einbezogen.": "Sans sélection de tags, toutes les diapositives sont incluses.",
        "Dieses Folienpaket enthält noch keine Folien.": "Ce paquet de diapositives ne contient pas encore de diapositives.",
        "Keine Folien passen zu den gewählten Tags.": "Aucune diapositive ne correspond aux tags choisis.",
        "Optional Tags und Sprachen auswählen. Ohne Tags werden alle Folien einbezogen. Die erzeugten PDFs sind unabhängige Kopien.": "Sélectionne éventuellement des tags et des langues. Sans tags, toutes les diapositives sont incluses. Les PDF générés sont des copies indépendantes.",
        "Präsentation bearbeiten": "Modifier la présentation",
        "Folienpaket löschen": "Supprimer le paquet de diapositives",
        "Möchtest du das Folienpaket «{name}» wirklich löschen? Die Folien werden entfernt. Bereits erstellte Kurspräsentationen bleiben erhalten.": "Veux-tu vraiment supprimer le paquet de diapositives « {name} » ? Les diapositives seront supprimées. Les présentations de cours déjà créées sont conservées.",
        "Foliensatz umbenennen": "Renommer le jeu de diapositives",
        "Der Foliensatz wurde umbenannt.": "Le jeu de diapositives a été renommé.",
        "Für diesen Kurstyp ist noch kein Folienpaket vorhanden.": "Aucun paquet de diapositives n’existe encore pour ce type de cours.",
        "Folienpaket erstellen": "Créer un paquet de diapositives",
        "Folienpaket wählen": "Choisir un paquet de diapositives",
        "Name und Datum einfügen": "Insérer le nom et la date",
        "Name auf der Folie": "Nom sur la diapositive",
        "Kurspräsentation entfernen": "Supprimer la présentation du cours",
        "Kurspräsentation wirklich entfernen?": "Vraiment supprimer la présentation du cours ?",
        "Die Kurspräsentation wurde entfernt.": "La présentation du cours a été supprimée.",
        "Das Folienpaket gehört nicht zum Kurstyp dieses Kurses.": "Le paquet de diapositives n’appartient pas au type de ce cours.",
        "Mindestens ein Tag gehört nicht zum gewählten Folienpaket.": "Au moins un tag n’appartient pas au paquet de diapositives choisi.",
        "Tags suchen oder neu erstellen…": "Rechercher ou créer des tags…",
        "„{name}“ erstellen": "Créer « {name} »",
        "{name} entfernen": "Retirer {name}",
        "Tag konnte nicht erstellt werden.": "Le tag n’a pas pu être créé.",
        "Tag bearbeiten": "Modifier le tag",
        "Farbe": "Couleur",
        "Tag wurde aktualisiert.": "Le tag a été mis à jour.",
        "Deutsch (Fallback)": "Allemand (langue de secours)",
        "Deutsch bestimmt die Anzahl Folien. Weitere Sprachen werden ab Seite 1 zugeordnet und dürfen weniger Seiten enthalten.": "L’allemand détermine le nombre de diapositives. Les autres langues sont associées à partir de la page 1 et peuvent contenir moins de pages.",
        "PDF, maximal 350 MB pro Sprache. Der Import wird im Hintergrund verarbeitet.": "PDF, 350 Mo maximum par langue. L’importation est traitée en arrière-plan.",
        "Ersetzen": "Remplacer",
        "Tags bearbeiten": "Modifier les tags",
        "Zum Bearbeiten klicken": "Cliquer pour modifier",
        "Zurück zum Foliensatz": "Retour au jeu de diapositives",
        "Vorhanden": "Disponible",
        "Fehlt": "Manquant",
        "PDF ersetzen": "Remplacer le PDF",
        "PDF hinzufügen": "Ajouter un PDF",
        "Tags suchen…": "Rechercher des tags…",
        "{selected} von {total} passenden Folien ausgewählt": "{selected} diapositives sélectionnées sur {total}",
        "Alle passenden Folien auswählen": "Sélectionner toutes les diapositives correspondantes",
        "Tags auswählen": "Sélectionner des tags",
        "Sprachen erzeugen": "Générer les langues",
        "{available}/{total} Folie verfügbar|{available}/{total} Folien verfügbar": "{available}/{total} diapositive disponible|{available}/{total} diapositives disponibles",
        "Nicht alle gewählten Folien sind in jeder Sprache vorhanden.": "Toutes les diapositives sélectionnées ne sont pas disponibles dans chaque langue.",
        "{count} fehlend|{count} fehlend": "{count} manquante|{count} manquantes",
        "Wird erstellt…": "Création…",
        "Kurspräsentation erstellen": "Créer la présentation du cours",
        "Jetzt zu Presio senden": "Envoyer maintenant vers Presio",
        "Folie": "Diapositive",
        "Fehlende Übersetzungen": "Traductions manquantes",
        "Fehlende Folien überspringen": "Ignorer les diapositives manquantes",
        "Deutsche Folie verwenden": "Utiliser la diapositive allemande",
        "Folienvorschau": "Aperçu des diapositives",
        "{count} Folie wird für diese Sprache erzeugt.|{count} Folien werden für diese Sprache erzeugt.": "{count} diapositive sera générée pour cette langue.|{count} diapositives seront générées pour cette langue.",
        "Wähle Tags aus, um die passenden Folien zu sehen.": "Sélectionnez des tags pour afficher les diapositives correspondantes.",
        "Alle passenden Folien wurden entfernt.": "Toutes les diapositives correspondantes ont été retirées.",
        "Folie entfernen": "Retirer la diapositive",
        "Wird in dieser Sprache übersprungen": "Ignorée dans cette langue",
        "Deutsch als Fallback": "Allemand comme langue de secours",
        "Erstellt": "Créée",
        "{processed} von {total} Folie|{processed} von {total} Folien": "{processed} sur {total} diapositive|{processed} sur {total} diapositives",
        "Die Folien werden zusammengeführt.": "Les diapositives sont en cours de fusion.",
        "Präsentation wird erstellt": "La présentation est en cours de création",
        "Du kannst diese Seite verlassen, die Erstellung läuft im Hintergrund weiter.": "Tu peux quitter cette page, la création se poursuit en arrière-plan.",
        "Präsentation erstellt": "Présentation créée",
        "Die PDFs stehen zum Herunterladen bereit.": "Les PDF sont prêts à être téléchargés.",
        "Erstellung abgebrochen": "Création annulée",
        "Erstellung fehlgeschlagen": "La création a échoué",
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.": "Une erreur s'est produite. Merci de réessayer.",
        "Zuletzt erstellte Version": "Dernière version créée",
        "Die Erstellung wurde abgebrochen.": "La création a été annulée.",
        "Mindestens eine ausgewählte Folie gehört nicht zur aktuellen Tag-Auswahl.": "Au moins une diapositive sélectionnée ne correspond pas à la sélection de tags actuelle.",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Präsentieren würde eine veraltete Version zeigen.": "La présentation actuelle n'a pas encore été envoyée à Presio. Présenter afficherait une version obsolète.",
        "FEHLT": "MANQUE",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Bitte bei Admin melden.": "La présentation actuelle n'est pas encore dans Presio. Merci de le signaler à l'administration.",
        "Der Versand an Presio ist fehlgeschlagen.": "L'envoi vers Presio a échoué.",
        "Die Präsentation wird gerade an Presio gesendet. Bitte versuche es in einem Moment erneut.": "La présentation est en cours d'envoi vers Presio. Merci de réessayer dans un instant.",
        "Die Kurspräsentation konnte nicht erstellt werden.": "La présentation du cours n'a pas pu être créée.",
        "Die Kurspräsentation konnte nicht an Presio gesendet werden.": "La présentation du cours n'a pas pu être envoyée à Presio.",
        "Die Kurspräsentation für {course} konnte nicht erstellt werden.": "La présentation du cours {course} n'a pas pu être créée.",
        "Die Kurspräsentation für {course} ({language}) konnte nicht an Presio gesendet werden.": "La présentation du cours {course} ({language}) n'a pas pu être envoyée à Presio.",
        "Kurs öffnen": "Ouvrir le cours",
        "PDF herunterladen": "Télécharger le PDF",
        "Kursleiter:innen-Notiz bearbeiten": "Modifier la note de présentation",
        "Diese Notiz wird der Kursleitung beim Präsentieren in Presio angezeigt.": "Cette note est affichée à la personne formatrice pendant la présentation dans Presio.",
        "Notiz aus Folienbibliothek verwenden": "Utiliser la note de la bibliothèque de diapositives",
        "Kursspezifisch": "Spécifique au cours",
        "Mindestens eine Notiz gehört nicht zu den ausgewählten Folien.": "Au moins une note n’appartient pas aux diapositives sélectionnées.",
        "Die Präsentation konnte nicht gestartet werden. Bitte versuche es in einem Moment erneut.": "La présentation n'a pas pu être démarrée. Merci de réessayer dans un instant.",
        "Die Präsentation wird an Presio gesendet.": "La présentation est en cours d'envoi vers Presio.",
        "Wird an Presio gesendet…": "Envoi vers Presio…",
        "deine Zeit": "votre heure",
        "Nicht gesetzt": "Non définie",
        "Dieses Produkt kann nicht bestellt werden.": "Ce produit ne peut pas être commandé.",
        "Dein Warenkorb ist leer.": "Ton panier est vide.",
        "Dein Warenkorb enthält Produkte, die nicht mehr bestellt werden können. Bitte entferne sie.": "Ton panier contient des produits qui ne peuvent plus être commandés. Merci de les retirer.",
        "Der Status kann nicht von «{from}» auf «{to}» geändert werden.": "Le statut ne peut pas passer de «{from}» à «{to}».",
        "Stück": "pièces",
        "Abholung im Büro": "Retrait au bureau",
        "Versand": "Envoi",
        "Verpackt": "Emballée",
        "Erledigt": "Terminée",
        "Das Produkt wurde bereits bestellt und kann nicht gelöscht werden. Deaktiviere es stattdessen.": "Le produit a déjà été commandé et ne peut pas être supprimé. Désactive-le plutôt.",
        "Die Kategorie enthält noch Produkte und kann nicht gelöscht werden.": "La catégorie contient encore des produits et ne peut pas être supprimée.",
        "Die Kategorie wurde erstellt.": "La catégorie a été créée.",
        "Die Kategorie wurde aktualisiert.": "La catégorie a été mise à jour.",
        "Die Kategorie wurde gelöscht.": "La catégorie a été supprimée.",
        "Der Status wurde auf «{status}» geändert.": "Le statut a été changé en «{status}».",
        "Das Produkt wurde erstellt.": "Le produit a été créé.",
        "Das Produkt wurde aktualisiert.": "Le produit a été mis à jour.",
        "Das Produkt wurde gelöscht.": "Le produit a été supprimé.",
        "Das Produkt wurde in den Warenkorb gelegt.": "Le produit a été ajouté au panier.",
        "Der Warenkorb wurde aktualisiert.": "Le panier a été mis à jour.",
        "Das Produkt wurde aus dem Warenkorb entfernt.": "Le produit a été retiré du panier.",
        "Vielen Dank! Deine Bestellung ist eingegangen.": "Merci ! Ta commande a bien été reçue.",
        "Warenkorb": "Panier",
        "Shop": "Shop",
        "Weiter einkaufen": "Continuer mes achats",
        "Material auswählen": "Choisir du matériel",
        "Dieses Produkt kann nicht mehr bestellt werden.": "Ce produit ne peut plus être commandé.",
        "Entfernen": "Retirer",
        "Zur Bestellung": "Passer la commande",
        "Bestellung abschliessen": "Finaliser la commande",
        "Zurück zum Warenkorb": "Retour au panier",
        "Lieferung": "Livraison",
        "Details": "Détails",
        "Benötigt bis": "Nécessaire d'ici le",
        "Bemerkung": "Remarque",
        "Deine Bestellung": "Ta commande",
        "Bestellung absenden": "Envoyer la commande",
        "Material bestellen": "Commander du matériel",
        "Wähle das Kursmaterial aus, das du für deine Kurse benötigst.": "Choisis le matériel dont tu as besoin pour tes cours.",
        "Aktuell kann kein Material bestellt werden.": "Aucun matériel ne peut être commandé pour le moment.",
        "In den Warenkorb": "Ajouter au panier",
        "{quantity} im Warenkorb": "{quantity} dans le panier",
        "Menge verringern": "Diminuer la quantité",
        "Menge erhöhen": "Augmenter la quantité",
        "Entferne die nicht mehr bestellbaren Artikel, um fortzufahren.": "Retire les articles qui ne peuvent plus être commandés pour continuer.",
        "Storniert": "Annulée",
        "Storniert am": "Annulée le",
        "Stornieren": "Annuler",
        "Bestellung stornieren": "Annuler la commande",
        "Möchtest du diese Bestellung wirklich stornieren?": "Veux-tu vraiment annuler cette commande ?",
        "Deine Bestellung wurde storniert.": "Ta commande a été annulée.",
        "Diese Bestellung wurde am {date} storniert.": "Cette commande a été annulée le {date}.",
        "Diese Bestellung wird bereits bearbeitet und kann nicht mehr direkt storniert werden.": "Cette commande est déjà en cours de traitement et ne peut plus être annulée directement.",
        "Begründung": "Motif",
        "Stornierungsanfrage": "Demande d'annulation",
        "Stornierungsanfragen": "Demandes d'annulation",
        "Stornierungsanfrage senden": "Envoyer une demande d'annulation",
        "Stornierungsanfrage vom {date}": "Demande d'annulation du {date}",
        "Stornierungsanfrage gesendet am {date}. Wir melden uns bei dir.": "Demande d'annulation envoyée le {date}. Nous reviendrons vers toi.",
        "Stornierung angefragt": "Annulation demandée",
        "Stornierung bestätigen": "Confirmer l'annulation",
        "Anfrage ablehnen": "Refuser la demande",
        "Abgelehnte Stornierungsanfrage": "Demande d'annulation refusée",
        "Deine Bestellung wird bereits bearbeitet. Bitte begründe, warum du sie stornieren möchtest.": "Ta commande est déjà en cours de traitement. Explique-nous pourquoi tu souhaites l'annuler.",
        "Deine Stornierungsanfrage wurde gesendet.": "Ta demande d'annulation a été envoyée.",
        "Deine Stornierungsanfrage wurde abgelehnt.": "Ta demande d'annulation a été refusée.",
        "Die Stornierungsanfrage wurde abgelehnt.": "La demande d'annulation a été refusée.",
        "Für diese Bestellung kann keine Stornierungsanfrage gesendet werden.": "Aucune demande d'annulation ne peut être envoyée pour cette commande.",
        "Für diese Bestellung gibt es keine offene Stornierungsanfrage.": "Il n'y a aucune demande d'annulation ouverte pour cette commande.",
        "Zum Shop": "Vers le shop",
        "Du hast noch kein Material bestellt.": "Tu n'as encore commandé aucun matériel.",
        "Bestellung {number}": "Commande {number}",
        "{count} Artikel": "{count} articles",
        "Artikel": "Articles",
        "Bestellt am": "Commandé le",
        "Kategorie erstellen": "Créer une catégorie",
        "Kategorie bearbeiten": "Modifier la catégorie",
        "Interner Shop – Kategorien": "Shop interne – Catégories",
        "Kategorien": "Catégories",
        "Materialbestellungen": "Commandes de matériel",
        "Als «{status}» markieren": "Marquer comme «{status}»",
        "Produkt erstellen": "Créer un produit",
        "Interner Shop – Produkte": "Shop interne – Produits",
        "Kategorie": "Catégorie",
        "Einheit": "Unité",
        "Wird im Shop neben der Menge angezeigt, zum Beispiel Stück.": "Affichée dans la boutique à côté de la quantité, par exemple pièces.",
        "Aktiv (bestellbar)": "Actif (commandable)",
        "Bild": "Image",
        "Das Feld {field} wird für die Teilnehmenden-Erkennung benötigt und kann nicht archiviert werden.": "Le champ {field} est nécessaire pour identifier les participant·e·s et ne peut pas être archivé.",
        "Übernimm zuerst die bestehende Feldkonfiguration, bevor du Felder hinzufügst.": "Reprends d'abord la configuration des champs existante avant d'ajouter des champs.",
        "Für diesen Login-Bereich sind bereits Felder konfiguriert.": "Des champs sont déjà configurés pour cet espace de connexion.",
        "Die Reihenfolge enthält Felder, die nicht zu diesem Login-Bereich gehören.": "L'ordre contient des champs qui n'appartiennent pas à cet espace de connexion.",
        "Bezeichnung (Deutsch)": "Libellé (allemand)",
        "Feldtyp": "Type de champ",
        "Import-Spalte": "Colonne d'import",
        "Option (Deutsch)": "Option (allemand)",
        "Öffentliche Anmeldung": "Inscription publique",
        "Persönliche Angaben": "Informations personnelles",
        "B2B-Portal": "Portail B2B",
        "in.sanio": "in.sanio",
        "Import / Export": "Import / Export",
        "Übersichten": "Aperçus",
        "Kursdetail": "Détail du cours",
        "Text": "Texte",
        "Mehrzeiliger Text": "Texte multiligne",
        "Auswahl": "Sélection",
        "Das Feld {field} darf nicht in «{context}» verwendet werden.": "Le champ {field} ne peut pas être utilisé dans «{context}».",
        "Eine Auswahl braucht mindestens eine aktive Option.": "Une sélection nécessite au moins une option active.",
        "Die Import-Spalte {name} wird bereits von einem anderen Feld verwendet.": "La colonne d'import {name} est déjà utilisée par un autre champ.",
        "Feld wurde archiviert.": "Le champ a été archivé.",
        "Feld wurde wiederhergestellt.": "Le champ a été restauré.",
        "Einstellungen wurden gespeichert.": "Les paramètres ont été enregistrés.",
        "Reihenfolge wurde gespeichert.": "L'ordre a été enregistré.",
        "Die bestehende Feldkonfiguration wurde übernommen.": "La configuration des champs existante a été reprise.",
        "Feld wurde hinzugefügt.": "Le champ a été ajouté.",
        "Feld wurde gespeichert.": "Le champ a été enregistré.",
        "Der Schlüssel {key} ist bereits vergeben.": "La clé {key} est déjà utilisée.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten und muss mit einem Buchstaben beginnen.": "La clé ne peut contenir que des lettres minuscules, des chiffres et des tirets bas, et doit commencer par une lettre.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten.": "La clé ne peut contenir que des lettres minuscules, des chiffres, des traits d'union et des tirets bas.",
        "Technischer Schlüssel": "Clé technique",
        "Schlüssel": "Clé",
        "Entschuldige, ich helfe nur Sanio-Mitarbeitenden mit einem passenden Benutzerkonto.": "Désolé, je ne peux aider que les collaborateurs et collaboratrices de Sanio disposant d'un compte utilisateur correspondant.",
        "Da ist leider etwas schiefgelaufen. Bitte versuche es später nochmals.": "Malheureusement, une erreur s'est produite. Veuillez réessayer plus tard.",
        "Darf ich einen Cursor-Agent einen Bugfix-Pull-Request vorbereiten lassen?": "Puis-je demander à un agent Cursor de préparer une pull request de correction ?",
        "Darf ich die Aktion {tool} ausführen?": "Puis-je exécuter l'action {tool} ?",
        "Freigeben": "Approuver",
        "Ablehnen": "Refuser",
        "Freigegeben von {name}.": "Approuvé par {name}.",
        "Abgelehnt von {name}.": "Refusé par {name}.",
        "Diese Freigabe ist nicht mehr gültig.": "Cette approbation n'est plus valable.",
        "Du darfst diese Aktion nicht freigeben.": "Tu n'es pas autorisé·e à approuver cette action.",
        "{server} ist jetzt mit Henry verbunden.": "{server} est maintenant connecté à Henry.",
        "Repository": "Dépôt",
        "Linear-Ticket": "Ticket Linear",
        "Neue Datei hochladen": "Téléverser un nouveau fichier",
        "oder per Drag & Drop hierher ziehen": "ou glissez-déposez-le ici",
        "Datei {current} von {total} wird hochgeladen…": "Téléversement du fichier {current} sur {total}…",
        "Die Datei {name} hat einen ungültigen Dateityp.": "Le fichier {name} a un type de fichier non valide.",
        "Video-Folie hinzufügen": "Ajouter une diapositive vidéo",
        "YouTube-URL": "URL YouTube",
        "Laser": "Laser",
        "Zeichnen": "Dessiner",
        "Beamer": "Projecteur",
        "Zuschauer-Link": "Lien du public",
        "Handy koppeln": "Associer le téléphone",
        "Offline vorbereiten": "Préparer hors ligne",
        "Wird vorbereitet…": "Préparation…",
        "Präsentation wird geladen…": "Chargement de la présentation…",
        "Die Präsentation konnte nicht geladen werden.": "La présentation n'a pas pu être chargée.",
        "Verbunden": "Connecté",
        "Nur lokal verbunden": "Connecté localement uniquement",
        "Beendet": "Terminée",
        "Offline bereit": "Prête hors ligne",
        "Beamer öffnen": "Ouvrir le projecteur",
        "Aktuelle Folie": "Diapositive actuelle",
        "Präsentationswerkzeuge": "Outils de présentation",
        "Nächste Folie": "Diapositive suivante",
        "Ende der Präsentation": "Fin de la présentation",
        "Kleinere Schrift": "Texte plus petit",
        "Grössere Schrift": "Texte plus grand",
        "Folien": "Diapositives",
        "Video pausieren": "Mettre la vidéo en pause",
        "Video abspielen": "Lire la vidéo",
        "Folie {number}": "Diapositive {number}",
        "Werkzeugleiste verschieben": "Déplacer la barre d'outils",
        "Letzten Strich rückgängig machen": "Annuler le dernier trait",
        "Zeichnungen auf dieser Folie löschen": "Effacer les dessins de cette diapositive",
        "Zeiger (kein Werkzeug)": "Pointeur (aucun outil)",
        "Laserpointer": "Pointeur laser",
        "Markieren": "Surligner",
        "Präsentation beenden?": "Terminer la présentation ?",
        "Die Verbindung zu allen Zuschauern wird getrennt.": "Tous les spectateurs seront déconnectés.",
        "Notizen zu dieser Folie hinzufügen…": "Ajouter des notes pour cette diapositive…",
        "Klicken, um die Notizen zu bearbeiten": "Cliquer pour modifier les notes",
        "Klicken, um Notizen hinzuzufügen.": "Cliquer pour ajouter des notes.",
        "Folien pro Sprache": "Diapositives par langue",
        "{count} von {total} Folien in dieser Sprache": "{count} sur {total} diapositives dans cette langue",
        "Notizen vergrössern": "Agrandir les notes",
        "Notizen verkleinern": "Réduire les notes",
        "Teilnehmende scannen den QR-Code, um die Folien live auf ihrem Gerät mitzuverfolgen.": "Les participant·e·s scannent le code QR pour suivre les diapositives en direct sur leur appareil.",
        "Scanne den QR-Code mit deinem Handy, um die Präsentation damit zu steuern und deine Notizen zu sehen.": "Scanne le code QR avec ton téléphone pour piloter la présentation et voir tes notes.",
        "Präsentation beenden": "Terminer la présentation",
        "Diese Präsentation ist beendet.": "Cette présentation est terminée.",
        "Du bist abgemeldet": "Tu es déconnecté",
        "Deine Sitzung ist abgelaufen. Melde dich erneut an.": "Ta session a expiré. Connecte-toi à nouveau.",
        "Zur Anmeldung": "Vers la connexion",
        "Notizen": "Notes",
        "Timer": "Minuteur",
        "Start": "Démarrer",
        "Pause": "Pause",
        "Video": "Vidéo",
        "Ton aus": "Couper le son",
        "Ton an": "Activer le son",
        "Diese Folie ist in dieser Sprache nicht verfügbar.": "Cette diapositive n’est pas disponible dans cette langue.",
        "Der YouTube-Link ist ungültig.": "Le lien YouTube est invalide.",
        "Mindestens ein YouTube-Link ist erforderlich.": "Au moins un lien YouTube est requis.",
        "Für diesen Kurs gibt es noch keine Präsentation.": "Ce cours n’a pas encore de présentation.",
        "Diese Folie gehört nicht zur Präsentation.": "Cette diapositive ne fait pas partie de la présentation.",
        "Der Laserpunkt ist ungültig.": "Le point laser est invalide.",
        "Die Abspielposition ist ungültig.": "La position de lecture est invalide.",
        "Video-Folie wurde hinzugefügt.": "Diapositive vidéo ajoutée.",
        "Diese Notiz wird der Kursleitung beim Präsentieren angezeigt.": "Cette note est affichée à la personne formatrice pendant la présentation.",
        "messages": {
            "communication": {
                "notifications": {
                    "status": {
                        "sending": "En cours d’envoi…",
                        "skipped": "Sauté",
                        "sent": "Envoyé",
                        "failed": "Échoué"
                    },
                    "channel": {
                        "database": "Base de données",
                        "twilio": "SMS",
                        "mail": "E-mail",
                        "whatsapp": "WhatsApp"
                    }
                }
            },
            "feedback": {
                "moods": {
                    "negative": "Négatif",
                    "neutral": "Neutre",
                    "positive": "Positif"
                }
            },
            "elearning": {
                "stories": {
                    "status": {
                        "draft": "En cours",
                        "review": "Saisi",
                        "translation": "En traduction",
                        "done": "Terminé",
                        "in-review": "Revue",
                        "review-done": "Corrigé"
                    },
                    "subject_focus": {
                        "adults": "Adultes",
                        "teenagers": "Adolescents (10-15)",
                        "children": "Enfants (4-9)",
                        "babies": "Bébés (0-3)"
                    },
                    "subject_focus_list": {
                        "adults": "Adultes",
                        "teenagers": "Adolescents (10-15)",
                        "children": "Enfants (4-9)",
                        "babies": "Bébés (0-3)"
                    }
                },
                "online_course": {
                    "status": {
                        "in_progress": "En cours",
                        "test": "En révision",
                        "online": "En ligne",
                        "inactive": "Inactif",
                        "archived": "Archivé"
                    },
                    "type": {
                        "customer": "Client",
                        "marketing": "Marketing",
                        "content_test": "Test de contenu",
                        "demo": "Démo",
                        "internal": "Interne"
                    }
                }
            },
            "shop": {
                "products": {
                    "type": {
                        "service": "Service",
                        "goods": "Marchandise"
                    },
                    "status": {
                        "active": "Actif",
                        "inactive": "Inactif",
                        "archived": "Archivé"
                    }
                },
                "orders": {
                    "status": {
                        "shipped": "Utilisé",
                        "pending": "En attente",
                        "paid": "Payé",
                        "completed": "Terminé",
                        "new": "Nouveau"
                    }
                },
                "invoices": {
                    "status": {
                        "paid": "Payé",
                        "overpaid": "Surpayé",
                        "partially_paid": "Partiellement payé",
                        "overdue": "En retard",
                        "cancelled": "Annulée",
                        "refunded": "Remboursé",
                        "partially_refunded": "Partiellement remboursé",
                        "new": "Nouveau"
                    }
                },
                "vouchers": {
                    "status": {
                        "pending": "En attente",
                        "active": "Actif",
                        "used": "Utilisé",
                        "expired": "Expiré",
                        "inactive": "Inactif"
                    }
                },
                "payments": {
                    "status": {
                        "pending": "En attente",
                        "paid": "Payé",
                        "failed": "Échoué",
                        "refunded": "Remboursé",
                        "partially-refunded": "Partiellement remboursé",
                        "refund-pending": "Remboursement en attente"
                    }
                }
            },
            "course_overview": {
                "modes": {
                    "presence": "Cours en présentiel",
                    "elearning": "eLearning",
                    "blended-learning": "Blended learning"
                },
                "groups": {
                    "past_unclosed": "Passés et pas encore clôturés",
                    "running": "Cours en cours",
                    "starting_this_week": "Commence dans les 7 prochains jours",
                    "future": "Cours futurs"
                },
                "collapse_group": "Replier le groupe",
                "expand_group": "Déplier le groupe"
            },
            "course_management": {
                "status": {
                    "draft": "Brouillon",
                    "ready": "Prêt",
                    "to_be_moved": "En cours de déplacement",
                    "running": "En cours",
                    "conducted": "Effectué",
                    "completed": "Terminé",
                    "cancelled": "Annulé",
                    "archived": "Archivé",
                    "follow_up": "Suivi"
                },
                "transition_actions": {
                    "reset_to_draft": "Revenir au brouillon",
                    "reopen": "Rouvrir le cours",
                    "not_ready": "Plus prêt",
                    "mark_ready": "Marquer le cours comme prêt",
                    "mark_to_be_moved": "Marquer le cours à déplacer",
                    "complete": "Clôturer le cours",
                    "cancel": "Annuler le cours",
                    "archive": "Archiver le cours",
                    "follow_up": "Suivi",
                    "revert_completion": "Annuler la clôture"
                },
                "transition_confirmations": {
                    "reset_to_draft": "Veux-tu remettre le cours en « Brouillon » ? Les inscriptions ne seront plus possibles par la suite.",
                    "complete": "Veux-tu clôturer le cours ? Cela déclenchera l'envoi des confirmations de cours, à condition qu'une adresse e-mail soit enregistrée pour les participants.",
                    "cancel": "Veux-tu vraiment annuler le cours ?",
                    "archive": "Veux-tu archiver le cours ?",
                    "follow_up": "Veux-tu ouvrir le cours pour un suivi ? Le cours reste fermé.",
                    "reopen": "Veux-tu rouvrir le cours annulé ?",
                    "revert_completion": "Veux-tu annuler la clôture ? Le cours sera remis sur « Réalisé ». Les confirmations et certificats déjà envoyés ne seront pas renvoyés lors d'une nouvelle clôture."
                },
                "transition_warnings": {
                    "follow_up_restrictions": "Actuellement, des participants peuvent être ajoutés ou supprimés et les présences peuvent être modifiées. Aucun autre détail du cours ne peut être modifié.",
                    "blended_pending_elearning": "Lors de la clôture, seules les personnes présentes ayant déjà réussi l’eLearning recevront une confirmation de cours. Les autres personnes présentes recevront automatiquement leur confirmation dès qu’elles auront réussi l’eLearning.",
                    "no_confirmations_both": "AUCUNE confirmation de cours ne sera envoyée lors de la clôture, car le générateur de confirmations de participation et le paramètre « Envoyer automatiquement les confirmations de cours lors de la clôture » sont désactivés. Active les deux dans les paramètres du cours si les participants doivent recevoir une confirmation.",
                    "no_confirmations_certificate_generator": "AUCUNE confirmation de cours ne sera envoyée lors de la clôture, car le générateur de confirmations de participation est désactivé. Active-le dans les paramètres du cours si les participants doivent recevoir une confirmation.",
                    "no_confirmations_mail_setting": "AUCUNE confirmation de cours ne sera envoyée lors de la clôture, car le paramètre « Envoyer automatiquement les confirmations de cours lors de la clôture » est désactivé dans les paramètres de messagerie. Active-le si les participants doivent recevoir une confirmation."
                }
            },
            "general": {
                "duration": {
                    "days": "un jour|{count} jours",
                    "months": "un mois|{count} mois",
                    "years": "un an|{count} ans"
                }
            },
            "invoices": {
                "status": {
                    "new": "Nouveau",
                    "paid": "Payé",
                    "overpaid": "Surpayé",
                    "partially_paid": "Partiellement payé",
                    "overdue": "En retard",
                    "cancelled": "Annulé",
                    "refunded": "Remboursé",
                    "partially_refunded": "Partiellement remboursé"
                }
            }
        }
    },
    "it": {
        "Anmelden": "Registrarsi",
        "E-Mail": "E-mail",
        "Passwort": "Password",
        "Passwort vergessen?": "Password dimenticata?",
        "Eine Woche lang angemeldet bleiben": "Rimanere connessi per una settimana",
        "Wie schön, du wurdest beschenkt! Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Che bello, hai ricevuto un regalo! Inserisci qui il tuo codice e scopri cosa ti aspetta.",
        "Code eingeben und persönlichen Zugang aktivieren": "Inserisci il codice e attiva l'accesso personale",
        "Code eingeben": "Inserisci il codice",
        "Einlösen": "Riscatta",
        "Code entfernen": "Rimuovi codice",
        "Benötigst du Hilfe?": "Hai bisogno di aiuto?",
        "Wir helfen dir gerne per E-Mail oder Telefon.": "Siamo felici di aiutarti via e-mail o telefono.",
        "Deine Lizenz": "La tua licenza",
        "Bitte gib deinen Geschenkcode ein.": "Inserisci il tuo codice regalo.",
        "Dieser Geschenkcode konnte nicht gefunden werden.": "Questo codice regalo non è stato trovato.",
        "Etwas ist schiefgelaufen. Bitte versuche es erneut.": "Qualcosa è andato storto. Riprova.",
        "Code gültig für {product}": "Codice valido per {product}",
        "Für {name}": "Per {name}",
        "Willkommen bei": "Benvenuto/a a",
        "Passwort zurücksetzen": "Reimpostare la password",
        "Zurück zur Anmeldung": "Torna all'accesso",
        "Zurück zum Kurs": "Torna al corso",
        "Fenster auf den Beamer ziehen und die Anzeige auf Erweitert stellen.": "Trascina la finestra sul proiettore e imposta lo schermo su Estendi.",
        "Vollbild": "Schermo intero",
        "Vollbild beenden": "Esci da schermo intero",
        "Radierer": "Gomma",
        "Rückgängig": "Annulla",
        "Leeren": "Svuota",
        "Zuschauer-QR": "QR pubblico",
        "QR ausblenden": "Nascondi QR",
        "Weisse Seite": "Pagina bianca",
        "Sprache wählbar": "Lingua selezionabile",
        "Präsentation anpassen": "Adatta la presentazione",
        "Die Präsentation wird gerade erstellt oder vorgeführt.": "La presentazione è in creazione o in corso.",
        "Die Kurspräsentation wird neu erstellt.": "La presentazione del corso viene ricreata.",
        "Die Vorlage wurde gespeichert.": "Il modello è stato salvato.",
        "Die Vorlage wurde gelöscht.": "Il modello è stato eliminato.",
        "Vorlage laden": "Carica modello",
        "Vorlage speichern": "Salva modello",
        "Vorlage löschen": "Elimina modello",
        "Name der Vorlage": "Nome del modello",
        "Link anfordern": "Richiedi il link",
        "zurück": "indietro",
        "Liste exportieren": "Esporta l'elenco",
        "Anmeldungen": "Registrazioni",
        "Abmeldungen": "Disdette",
        "Vorname": "Nome",
        "Nachname": "Cognome",
        "Kurssprache": "Lingua del corso",
        "Beschreibung": "Descrizione",
        "Link ist aktiv": "Il collegamento è attivo",
        "Kurs freigeben": "Condividi il corso",
        "Willkommen": "Benvenuto/a",
        "Teilnehmende": "Partecipanti",
        "Sortieren nach": "Ordina per",
        "Datum": "Data",
        "Adresse": "Indirizzo",
        "Plätze frei": "Posti liberi",
        "ausgebucht": "al completo",
        "Weitere Person anmelden": "Registrare una persona aggiuntiva",
        "An-/Abmeldung": "Registrazione/disdetta",
        "Ja, ich nehme teil": "Sì, partecipo",
        "Nein, ich bin verhindert": "No, sono impossibilitato",
        "allgemeinen Geschäftsbedingungen": "Termini e condizioni generali",
        "Datenschutzerklärung": "Informativa sulla privacy",
        "Absenden": "Inviare",
        "Fragen oder Probleme?": "Domande o problemi?",
        "Hallo": "Ciao",
        "Anmeldebestätigung": "Conferma d'iscrizione",
        "Erste Hilfe Kurs": "Corso di Primo Soccorso",
        "Vielen Dank für deine Anmeldung zum Erste Hilfe Kurs. Hier nochmals die wichtigsten Infos": "Grazie per esserti iscritto al corso di Primo Soccorso. Ecco ancora una volta le informazioni più importanti",
        "Liebe Grüsse": "Cordiali saluti",
        "Dein Sanio-Team": "Il tuo Team Sanio",
        "Copyright": "Copyright",
        "Umbuchungsbestätigung": "Conferma di modifica della prenotazione",
        "Terminerinnerung": "Promemoria dell'appuntamento",
        "Deutsch": "Tedesco",
        "Französisch": "Francese",
        "Italienisch": "Italiano",
        "Englisch": "Inglese",
        "Spanisch": "Spagnolo",
        "Portugiesisch": "Portoghese",
        "Kurse": "Corsi",
        "Impersonation beenden": "Terminare l'impersonificazione",
        "Du bist als diese Person angemeldet.": "Hai effettuato l'accesso come questa persona.",
        "Zur Teilnehmer:in": "Apri partecipante",
        "Zum Shop-Kunden": "Apri cliente shop",
        "course_manuals": "Istruzioni per il corso",
        "employment": "Posizione",
        "Instructors": "Istruttori del corso",
        "insurance": "Assicurazione",
        "INSURANCE_FLAT": "Tassa di amministrazione",
        "Kontaktdaten": "Dettagli di contatto",
        "Kontaktaufnahme: In Abklärung": "Contatto: in fase di chiarimento",
        "Kontaktaufnahme erforderlich": "Contatto necessario",
        "Keine Kontaktaufnahme erforderlich": "Nessun contatto necessario",
        "Noch offen": "In sospeso",
        "In Kurs verschieben": "Spostare nel corso",
        "lessons": "Lezioni di guida",
        "locations": "Luoghi",
        "Mitarbeitende": "Collaboratori",
        "Kursübersicht": "Panoramica del corso",
        "Zurück zum Login": "Torna al login",
        "Passwort bestätigen": "Confermare la password",
        "Dashboard": "Pannello di controllo",
        "In welchen Kurs soll {participantName} verschoben werden?": "In quale corso dovrebbe essere spostato {participantName}?",
        "Mehr anzeigen": "Mostra di più",
        "Gesamten Text anzeigen": "Mostra tutto il testo",
        "Weniger anzeigen": "Mostra meno",
        "{participantName} in Kurs {courseName} verschieben?": "Spostare {participantName} nel corso {courseName}?",
        "Zum Kurs": "Al corso",
        "Umbuchungsbestätigung senden": "Inviare la conferma di modifica della prenotazione",
        "Es wird keine Umbuchungsbestätigung gesendet, da der Kurs beendet ist.": "Nessuna conferma di cambio verrà inviata perché il corso è terminato.",
        "Zurück": "Indietro",
        "Verschieben": "Spostare",
        "Willkommen {name} 👋": "Benvenuto/a {name} 👋",
        "Die Datei {fileName} wurde {statusHint} importiert.": "Il file {fileName} è stato importato {statusHint}.",
        "erfolgreich": "con successo",
        "exams": "Esami",
        "Fehlermeldung": "Messaggio di errore",
        "Folgende Zeilen konnten aufgrund ungültiger (<span class=\"text-red\">rot markiert</span>) Daten nicht importiert werden:": "Le righe seguenti non possono essere importate a causa di dati non validi (<span class=\"text-red\"></span>contrassegnati in rosso):",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert.": "Le righe seguenti sono state comunque importate a causa di un'assegnazione poco chiara.",
        "Handynummer": "Numero di cellulare",
        "app": "App di teoria",
        "absences": "Assenze",
        "comments": "Commenti",
        "course_documents": "Documenti del corso",
        "All": "Tutti",
        "Spalte": "Colonna",
        "students": "Alunni",
        "Teachers": "Istruttori di guida",
        "Teilnehmerübersicht öffnen": "Aprire la panoramica dei partecipanti",
        "teilweise": "in parte",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "L'{attribute} è già apparso in una fuga di dati. Selezionarne un altro {attribute}.",
        "The {attribute} must contain at least one letter.": "{attribute} deve essere composto da almeno un carattere.",
        "The {attribute} must contain at least one number.": "{attribute} dev'essere composto da almeno un numero.",
        "The {attribute} must contain at least one symbol.": "{attribute} dev'essere composto da almeno un carattere speciale.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "{attribute} dev'essere composto da almeno una lettera maiuscola e una minuscola.",
        "vku": "Corsi di teoria di guida",
        "voice_status_end": "Terminato",
        "voice_status_missed": "Mancato",
        "voice_status_out-of-office": "Fuori ufficio",
        "voice_status_queue": "Coda",
        "voice_status_start": "Inizio",
        "voice_status_taken": "in dialogo",
        "voice_status_voicemail": "Messaggio vocale",
        "Zeile": "Linea",
        "Ähnliche TN": "Partecipante simile",
        "Es existieren keine Daten.": "Non esistono dati.",
        "Abbrechen": "Interrompere",
        "Applikation autorisieren": "Autorizzare l'applicazione",
        "{name} autorisieren": "Autorizzare {name}",
        "Diese Applikation möchte auf deinen MCP-Server zugreifen.": "Questa applicazione richiede l'accesso al tuo server MCP.",
        "Angemeldet als": "Accesso effettuato come",
        "Berechtigungen": "Autorizzazioni",
        "Autorisieren": "Autorizza",
        "Autorisieren...": "Autorizzazione...",
        "Du wirst zu {name} zurückgeleitet, sobald du autorisiert hast.": "Verrai reindirizzato a {name} dopo l'autorizzazione.",
        "Abmelden": "Disconnettersi",
        "certificates.not-yet-known": "Non ancora noto",
        "certificates.sanio": "Conferma di partecipazione Sanio",
        "certificates.src": "Certificato SRC",
        "Email": "E-mail",
        "voice_status_initiated": "Benvenuto/a",
        "Diese Anmeldemaske wurde deaktiviert.": "Questa schermata di accesso è stata disattivata.",
        "errors.4xx.title": "Errore imprevisto",
        "errors.4xx.head": "Ops...",
        "errors.4xx.hint": "Si è verificato un errore. La tua richiesta non può essere elaborata. Per favore, controlla i tuoi dati inseriti o riprova più tardi. L'errore ci è stato segnalato.",
        "errors.5xx.title": "Errore interno del server",
        "errors.5xx.head": "Oh oh...",
        "errors.5xx.hint": "Si è verificato un errore imprevisto. Torna alla pagina iniziale o riprova più tardi. L'errore ci è stato segnalato.",
        "errors.401.title": "Accesso negato",
        "errors.401.head": "Ops…",
        "errors.401.hint": "Non sei autorizzato ad accedere a questa pagina. Effettua il login e riprova.",
        "errors.403.title": "Accesso negato",
        "errors.403.head": "Ops…",
        "errors.403.hint": "Accesso negato. Non sei autorizzato a visitare questa pagina. Se ritieni che si tratti di un errore, contattaci.",
        "errors.404.title": "Pagina non trovata",
        "errors.404.head": "Ops...",
        "errors.404.hint": "La pagina richiamata non esiste. Torna indietro o fai clic sul pulsante per tornare alla pagina iniziale.",
        "errors.500.title": "Errore interno del server",
        "errors.500.head": "Oh oh...",
        "errors.504.head": "Timeout…",
        "errors.504.hint": "La richiesta è durata troppo a lungo. Si prega di riprovare più tardi. L'errore è stato segnalato.",
        "errors.back-to-start": "Alla pagina iniziale",
        "errors.500.hint": "Si è verificato un errore imprevisto. Torna alla pagina iniziale o riprova più tardi. L'errore è stato segnalato.",
        "errors.503.title": "Modalità di manutenzione",
        "errors.503.head": "Un momento per favore...",
        "errors.503.hint": "Stiamo effettuando una manutenzione per apportare miglioramenti e correzioni di bug per migliorare l'esperienza dell'utente. Si prega di riprovare a breve. Grazie per la comprensione.",
        "errors.503.hint2": "In caso di urgenza, potete contattarci via e-mail all'indirizzo <a href=\"mailto:contact@sanio.ch\">contact@sanio.ch</a> o telefonicamente al numero <a href=\"tel:+41315212409\">031 521 24 09</a>.",
        "errors.504.title": "Timeout",
        "Fehler beim Laden der Kurse": "Errore nel caricamento dei corsi",
        "Du wurdest in den Kurs «{courseName}» umgebucht.": "Sei stato spostato nel corso \"{courseName}\".",
        "Hier die neuen Infos:": "Ecco le nuove informazioni:",
        "Wenn du Fragen hast, melde dich bitte direkt bei {name} unter:": "Per qualsiasi domanda puoi contattare direttamente {name}:",
        "oder": "o",
        "Kursort:": "Sede del corso:",
        "Kursdaten": "Date del corso",
        "Bald ist es soweit und der Kurs «{courseName}» findet statt.": "Presto parteciperai al \"{courseName}\".",
        "Kurs-ID": "ID del corso",
        "Hier nochmals die wichtigsten Infos:": "Ecco di nuovo le informazioni più importanti:",
        "Du wurdest erfolgreich am Kurs «{courseName}» angemeldet 🎉": "L'iscrizione al corso \"{courseName}\" è stata effettuata con successo 🎉",
        "Zum Kalender hinzufügen": "Aggiungi al calendario",
        "Es wurde keine E-Mail-Adresse oder Handynummer angegeben.": "Non è stato fornito alcun indirizzo e-mail o numero di cellulare.",
        "Die E-Mail-Adresse ist ungültig.": "L'indirizzo e-mail non è valido",
        "Die Handynummer ist ungültig.": "Il numero di cellulare non è valido.",
        "Der Code ist ungültig.": "Il codice non è valido.",
        "Vielen Dank für deine Anmeldung zum Kurs. Hier nochmals die wichtigsten Infos:": "Grazie per esserti iscritto al corso di Primo Soccorso. Ecco ancora una volta le informazioni più importanti:",
        "Der Kurs wurde dupliziert 🎉": "Il corso è stato duplicato 🎉",
        "Kurs": "Corso",
        "Text wurde in die Zwischenablage kopiert": "Il testo è stato copiato negli appunti",
        "Text konnte nicht in die Zwischenablage kopiert werden": "Non è stato possibile copiare il testo negli appunti",
        "Der Katalog wurde erstellt.": "È stato creato il catalogo.",
        "Der Katalog wurde aktualisiert.": "Il catalogo è stato aggiornato.",
        "Der Katalog wurde entfernt.": "Il catalogo è stato rimosso.",
        "Das Thema wurde erstellt.": "Il modulo è stato creato.",
        "Das Thema wurde aktualisiert.": "Il modulo è stato aggiornato.",
        "Das Thema wurde entfernt.": "Il modulo è stato rimosso.",
        "Story wurde erfolgreich kopiert 🎉": "La storia è stata copiata con successo 🎉",
        "Geschlecht": "Genere",
        "Eine Variante|{count} Varianten": "Una variante|{count} Varianti",
        "Für diesen Kunden steht der eLearning Bereich nicht zur Verfügung.": "L'area eLearning non è disponibile per questo cliente.",
        "Männlich": "Maschile",
        "Weiblich": "Femminile",
        "Divers": "Altro",
        "Projektstandort": "Sede del progetto",
        "Wohnkanton": "Cantone di residenza",
        "Sanio Logo": "Logo Sanio",
        "hier": "qui",
        "Hallo {name} 👋": "Ciao {name} 👋",
        "Hier sind nochmals die wichtigsten Details:": "Ti inviamo nuovamente i dettagli più importanti:",
        "Teilnehmer:innen": "Partecipanti",
        "Name": "Nome",
        "Letzter Kurs": "Ultimo corso",
        "Nächster Kurs": "Il prossimo corso",
        "Hinzufügen": "Aggiungi",
        "Exportieren": "Esportare",
        "Keinem Kurs zugeordnet": "Non assegnato a nessun corso",
        "Suchbegriff": "Termine di ricerca",
        "Dein Sanio Team": "Il tuo Team Sanio",
        "Alle": "Tutti",
        "Hier geht es zu unseren <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">allgemeinen Geschäftsbedingungen</a> und zu unserer <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">Datenschutzerklärung</a>.": "Qui trovi i nostri <a href=\"https://www.sanio.ch/allgemeine-geschaeftsbedingungen/\" target=\"_blank\">termini e condizioni generali</a> e la nostra <a href=\"https://www.sanio.ch/datenschutz/\" target=\"_blank\">informativa sulla privacy</a>.",
        "Falls du keine weiteren E-Mails von dieser Liste erhalten möchtest, kannst du dich <a href=\"{unsubscribeListUrl}\" target=\"_blank\">hier</a> abmelden.": "Se non desideri più ricevere e-mail da questa lista, puoi annullare l'iscrizione <a href=\"{unsubscribeListUrl}\" target=\"_blank\">qui</a>.",
        "Möchtest du gar keine Angebote mehr von uns erhalten? Dann kannst du dich <a href=\"{unsubscribeUrl}\" target=\"_blank\">hier</a> abmelden.": "Non vuoi più ricevere offerte da parte nostra? Puoi annullare l'iscrizione <a href=\"{unsubscribeUrl}\" target=\"_blank\">qui</a>.",
        "Ungruppierte Kurse": "Corsi non raggruppati",
        "Es wurden mehrere Konten für diese Angaben gefunden. Bitte wähle den gewünschten Kunden aus.": "Sono stati trovati più account per questi dati. Per favore, seleziona il cliente desiderato.",
        "Teilnehmer:in abmelden / aus Kurs entfernen": "Disconnettere il/la partecipante / rimuovere dal corso",
        "Anmeldebestätigung erneut zustellen": "Inoltrare nuovamente la conferma della registrazione",
        "Einladung zum eLearning": "Invito all'eLearning",
        "Wir freuen uns, dir mitzuteilen, dass das eLearning für dich nun bereitsteht! Du kannst ab sofort mit dem Lernen beginnen. 🎉": "Siamo lieti di informarti che l’eLearning è ora disponibile! Puoi iniziare subito a imparare! 🎉",
        "Bis zum <strong>{courseName}</strong> am <strong>{courseStart}</strong> in <strong>{coursePlace}</strong> musst du das eLearning unbedingt abgeschlossen haben. Es dient als Grundlage für den praktischen Kurs.": "Entro il <strong>{courseName}</strong> al <strong>{courseStart}</strong> presso <strong>{coursePlace}</strong> devi assolutamente aver completato l'eLearning. Serve come base per il corso pratico.",
        "Du kannst das eLearning entweder in einem Durchgang oder in mehreren Etappen absolvieren.": "È possibile dompletare l’eLearning in un’unica sessione o in più sessioni.",
        "Am Ende gibt es eine kurze Lernkontrolle. Daher lohnt es sich, die Inhalte aufmerksam durchzuarbeiten!": "Alla fine c'è una breve verifica di apprendimento. Pertanto, vale la pena studiare attentamente i contenuti!",
        "Möchtest du den/die Teilnehmer:in wirklich vom Kurs abmelden / aus dem Kurs entfernen?": "Vuoi davvero disiscrivere il/la partecipante dal corso / rimuovere dal corso?",
        "Abmelden / entfernen": "Disconnettere / rimuovere",
        "Willst du wirklich eine eLearning Einladung verschicken?": "Volete davvero inviare un invito eLearning?",
        "Einladung verschicken": "Inviare l'invito",
        "Willst du wirklich die Anmeldebestätigung erneut zustellen?": "Vuoi davvero inviare nuovamente la conferma di registrazione?",
        "Bestätigung erneut verschicken": "Inviare nuovamente la conferma",
        "Teilnehmer:in abmelden": "Annullare l'iscrizione del/della partecipante",
        "Bemerkungen": "Osservazioni",
        "Wert fehlt!": "Valore mancante!",
        "{0} Es wurden keine Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.|{1} Es wurde ein:e Teilnehmer:in angelegt und {totalUpdated} aktualisiert.|[2,*] Es wurden {count} Teilnehmer:innen angelegt und {totalUpdated} aktualisiert.": "{0} Non sono stati creati partecipanti e {totalUpdated} sono stati aggiornati.|{1} È stato creato un partecipante e aggiornati {totalUpdated}.|[2,*] Sono stati creati {count} partecipanti e aggiornati {totalUpdated}.",
        "Zu Kursgruppe hinzufügen": "Aggiungi al corso/gruppo",
        "Wie schwierig war für dich die Lernkontrolle am Ende?": "Quanto è stata difficile per te la verifica finale d'apprendimento?",
        "Überspringen": "Saltare",
        "Neue Kursgruppe erstellen": "Crea un nuovo gruppo",
        "Möchtest du den Kurs wirklich endgültig löschen? Diese Aktion kann nicht rückgängig gemacht werden.": "Vuoi davvero cancellare il corso definitivamente? Questa operazione è irreversibile.",
        "Möchtest du den Kurs wirklich archivieren? Der Kurs ist danach nicht mehr sichtbar, kann aber durch einen Admin wiederhergestellt werden.": "Vuoi davvero archiviare il corso? Il corso non sarà più visibile, ma potrà essere ripristinato da un amministratore.",
        "Freigabelink löschen": "Eliminare il link di condivisione",
        "Möchtest du den Freigabelink wirklich löschen?": "Vuoi davvero eliminare il link di condivisione?",
        "Archivieren": "Archiviare",
        "Endgültig löschen": "Cancellare definitivamente",
        "Gruppe löschen": "Cancellare il gruppo",
        "Möchtest du diese Gruppe wirklich löschen?": "Vuoi davvero cancellare questo gruppo?",
        "Kurs aus Gruppe entfernen": "Rimuovere il corso dal gruppo",
        "Kurs duplizieren": "Duplicare il corso",
        "Kurs archivieren": "Archiviare il corso",
        "Kurs löschen": "Cancellare il corso",
        "Der Freigabelink wurde gelöscht! 🎉": "Il link di condivisione è stato cancellato! 🎉",
        "Link teilen": "Condividere il link",
        "Gruppe bearbeiten": "Modificare il gruppo",
        "Neue:n Teilnehmer:in anmelden": "Registrare nuovi partecipanti",
        "nimmt teil": "partecipa",
        "Ähnliche Teilnehmer:innen": "Partecipanti simili",
        "Ein unerwarteter Fehler ist aufgetreten": "Si è verificato un errore imprevisto",
        "Bereits in diesem Kurs vorhanden": "Già presente in questo corso",
        "Es wurden keine ähnlichen Teilnehmer:innen gefunden.": "Non sono stati trovati partecipanti simili.",
        "Fülle das Formular aus und die Suche wird gestartet.": "Compila il modulo e la ricerca avrà inizio.",
        "Suche ähnliche Teilnehmer:innen...": "Cerca partecipanti simili...",
        "eLearning nicht gefunden": "eLearning non trovato",
        "Wie hat dir das eLearning allgemein gefallen?": "Cosa ne pensi dell'eLearning in generale?",
        "🤩 Sehr gut!": "🤩 Molto bene!",
        "😊 Gut": "😊 Buono",
        "😐 Ok": "😐 Ok",
        "😕 Nicht so gut": "😕 Non così bene",
        "😩 Schlecht": "😩 Male",
        "Bitte wähle eine Antwort aus.": "Seleziona una risposta.",
        "Wie verständlich waren für dich die Lerninhalte?": "Quanto è stato comprensibile per te il contenuto dell‘eLearning?",
        "🤩 Sehr verständlich!": "🤩 Molto comprensibile!",
        "😊 Verständlich": "😊 Comprensibile",
        "😕 Nicht so verständlich": "😕 Non così comprensibile",
        "😩 Gar nicht verständlich": "😩 Per niente comprensibile",
        "🤩 Sehr einfach!": "🤩 Molto semplici!",
        "😊 einfach": "😊 semplici",
        "😐 Nicht so einfach": "😐 Non così facili",
        "😕 Schwierig": "😕 Difficili",
        "😩 Sehr schwierig": "😩 Molto difficili",
        "Wie beurteilst du die Benutzerfreundlichkeit des eLearnings?": "Come valuti la facilità d'uso dell'eLearning?",
        "🤩 Super einfache Bedienung!": "🤩 Funzionamento semplicissimo!",
        "😊 Einfach zu bedienen": "😊 Facile da usare",
        "😐 Teilweise etwas mühsam": "😐 A volte un po' impegnativo",
        "😩 Richtig mühsame Bedienung": "😩 Utilizzo davvero impegnativo",
        "Warum war die Lernkontrolle für dich einfach?": "Perché la verifica d'apprendimento è stata facile per te?",
        "Warum war die Lernkontrolle für dich schwierig?": "Perché la verifica d'apprendimento è stata difficile per te?",
        "Wie können wir das eLearning verbessern? Was hat dir gefehlt?": "Come possiamo migliorare l'eLearning? Cosa ti è mancato?",
        "Würdest du das eLearning weiterempfehlen?": "Consiglieresti l'eLearning ad altri?",
        "🤩 Ja klar!": "🤩 Sì, certo!",
        "😊 Ja, wahrscheinlich schon": "😊 Sì, probabilmente",
        "😐 Weiss nicht recht": "😐 Non saprei",
        "😕 Eher nicht": "😕 Tendenzialmente no",
        "😩 Nein, auf keinen Fall": "😩 No, assolutamente no",
        "Vielen Dank für deine Antworten!": "Grazie mille per le tue risposte!",
        "Cool hast du dir die Zeit genommen!": "Fantastico che ti sei preso/a il tempo!",
        "Fehler beim Laden der Suchergebnisse": "Errore nel caricamento dei risultati della ricerca",
        "Speichern": "Salva",
        "Jetzt mit dem eLearning starten": "Inizia adesso con l’eLearning",
        "Zu Kurs zugeordnet": "Assegnato al corso",
        "Teilnehmer:innen {company}": "Partecipanti {company}",
        "{firstname}, eLearning für den Kurs von {company} nicht vergessen!": "{firstname}, non dimenticare l'eLearning per il corso di {company}!",
        "Dein my.sanio Verifizierungscode": "Il tuo codice di verifica my.sanio",
        "AGB und Datenschutz müssen akzeptiert werden.": "Le CG e l’informativa sulla privacy devono essere accettate.",
        "Der Kurs ist leider bereits ausgebucht.": "Purtroppo, il corso è già al completo.",
        "Ich akzeptiere die {tos} und habe die {privacyPolicy} gelesen und verstanden.": "Accetto i {tos} e ho letto e compreso la {privacyPolicy}.",
        "🚫 Wir konnten dich leider nicht am Kurs anmelden.": "🚫 Purtroppo, non siamo riusciti a iscriverti al corso.",
        "Persönliche Daten": "Dati personali",
        "Zukünftige Kurse": "Corsi futuri",
        "{name} ist noch für keine Kurse angemeldet.": "{name} non è ancora iscritto/a a nessun corso.",
        "Abgeschlossene Kurse": "Corsi conclusi",
        "Handlung nötig": "Azione richiesta",
        "eLearning": "eLearning",
        "Fortschritt:": "Progresso:",
        "Dauer:": "Durata:",
        "Kommunikation": "Comunicazione",
        "Kanal": "Canale",
        "unbekannter Betreff": "Oggetto sconosciuto",
        "Zeit": "Tempo",
        "Status": "Stato",
        "Inhalt": "Contenuto",
        "Von:": "Da:",
        "An:": "A:",
        "CC:": "CC:",
        "BCC:": "CCN:",
        "Antwort an:": "Risposta a:",
        "Anhänge": "Allegati",
        "Profil": "Profilo",
        "Nicht dargestellte Kursdaten": "Dati del corso non visualizzati",
        "Benutzerbild": "Immagine dell’utente",
        "Meine Kurse": "I miei corsi",
        "Dashboard Instruktor:innen": "Pannello di controllo degli istruttori",
        "Wenn wir für diese E-Mail Adresse ein Konto gefunden haben, erhältst du in Kürze eine E-Mail mit einem Link zum Einloggen (Bitte überprüfe auch deinen Spam-Ordner).": "Se troviamo un account per questo indirizzo email, riceverai a breve un'email con un link per accedere (per favore controlla anche la tua cartella spam).",
        "Jetzt einloggen": "Accedi ora",
        "Link zum Einloggen": "Link per il login",
        "Teilnahme-Status erfolgreich aktualisiert.": "Stato di partecipazione aggiornato con successo.",
        "Team": "Team",
        "Anwesenheit": "Presenza",
        "Anwesenheiten fehlen!": "Presenze mancanti!",
        "Anwesenheiten vollständig": "Presenze complete",
        "Materialset fehlt!": "Set di materiale mancante!",
        "Materialset: {name}": "Set di materiale: {name}",
        "Materialset zugewiesen": "Set di materiale assegnato",
        "Hinweis zu Materialset beachten": "Prestare attenzione all’indicazione sul set di materiale",
        "Nur für bereite Kurse relevant": "Rilevante solo per corsi pronti",
        "Nur für laufende oder durchgeführte Kurse relevant": "Rilevante solo per corsi in corso o svolti",
        "Präsentation fehlt!": "Presentazione mancante!",
        "Präsentation vorhanden": "Presentazione disponibile",
        "Gemäss Kursleitung anwesend": "Presente secondo l’istruttore",
        "Gemäss Kursleitung abwesend": "Assente secondo l’istruttore",
        "🧘 Du hast diese Woche keine Kurse.": "🧘 Non hai corsi questa settimana.",
        "🌴 Du hast keine zukünftigen Kurse.": "🌴 Non hai corsi futuri.",
        "😌 Du hast keine abgeschlossenen Kurse.": "😌 Non hai corsi conclusi.",
        "Diese Woche": "Questa settimana",
        "und": "e",
        "Geschäftsführerin Sanio AG": "CEO Sanio AG",
        "Zertifikat": "Certificato",
        "Teilnahmebestätigung": "Conferma di partecipazione",
        "Kursleitung:": "Responsabile del corso:",
        "Dieses Zertifikat ist bis am {date} gültig.": "Questo certificato è valido fino al {date}.",
        "Eine Auffrischung der Erste Hilfe Grundlagen alle 2 Jahre wird empfohlen.": "Ogni 2 anni si raccomanda un corso di aggiornamento sulle nozioni di base del primo soccorso.",
        "Download fehlgeschlagen.": "Download fallito.",
        "Generiere Teilnahmebestätigungen...": "Genera certificati di partecipazione...",
        "Teilnahmebestätigungen wurden erfolgreich generiert und heruntergeladen.": "Le conferme di partecipazione sono state generate e scaricate con successo.",
        "Fehler beim Erstellen der Teilnahmebestätigungen.": "Errore durante la creazione delle conferme di partecipazione.",
        "Generiere Teilnahmebestätigung...": "Generare la conferma di partecipazione...",
        "Teilnahmebestätigung wurde erfolgreich generiert und heruntergeladen.": "La conferma di partecipazione è stata generata e scaricata con successo.",
        "Download wird gestartet...": "Il download sta per iniziare…",
        "Download erfolgreich abgeschlossen.": "Download completato con successo.",
        "Teilnahmebestätigungen als PDF": "Conferma di partecipazione in formato PDF",
        "Teilnahmebestätigungen als ZIP": "Conferma della partecipazione come ZIP",
        "Fehler beim Erstellen der Teilnahmebestätigung.": "Errore durante la creazione della conferma di partecipazione.",
        "Teilnehmerliste exportieren": "Esporta l'elenco partecipanti",
        "wurde erstellt": "è stato creato",
        "kommentierte": "ha commentato",
        "Schreibe deinen Kommentar...": "Scrivi il tuo commento...",
        "Zurücksetzen": "Reimpostare",
        "Kommentieren": "Commentare",
        "Kommentar bearbeiten": "Modificare commento",
        "Bearbeiten": "Modificare",
        "Löschen": "Eliminare",
        "Aktivität": "Attività",
        "Teilnehmer:in hinzufügen": "Aggiungi un partecipante",
        "Für die Kursteilnahme sind nur Vor- und Nachname erforderlich. Weitere Angaben sind freiwillig.": "Per la partecipazione al corso sono obbligatori solo nome e cognome. Le altre informazioni sono facoltative.",
        "Teilnehmer:in bereits im System?": "Partecipante già nel sistema?",
        "Passende Personen werden während der Eingabe automatisch hier angezeigt. Bitte übernimm bestehende Personen, anstatt sie neu anzulegen.": "Le persone corrispondenti vengono mostrate qui automaticamente durante l'inserimento. Riutilizza le persone esistenti invece di crearne di nuove.",
        "Teilnahmebestätigung herunterladen": "Scarica la conferma di partecipazione",
        "Teilnehmer abgleichen": "Sincronizzare i partecipanti",
        "Dieses Objekt": "Questo oggetto",
        "Der Kurs ist ausgebucht.": "Il corso è al completo.",
        "abgeschlossen": "completato",
        "Der Kurs ist bereits beendet.": "Il corso è già terminato.",
        "{availableSpots} Plätze frei": "{availableSpots} posti disponibili",
        "Es sind keine anderen Kurse verfügbar.": "Non sono disponibili altri corsi.",
        "Teilnehmer wurde in neuen Kurs verschoben.": "Il/la partecipante è stato/a spostato/a in un nuovo corso.",
        "Beendete Kurse können nicht mehr bearbeitet werden.": "I corsi conclusi non possono più essere modificati.",
        "certificates.none": "Nessun certificato",
        "Der Benutzer wurde erfolgreich erstellt.": "L'utente è stato creato con successo.",
        "vollständig": "completo",
        "Nachrichtenverlauf": "Cronologia dei messaggi",
        "Teilnehmer wurde gelöscht!": "Il partecipante è stato rimosso!",
        "Kursgruppe erfolgreich aktualisiert 🎉": "Gruppo di corsi aggiornato con successo 🎉",
        "Der Kurs wurde gespeichert 🎉": "Il corso è stato salvato 🎉",
        "Der Kundenbereich wurde eröffnet! 🎉": "L'area clienti è stata aperta! 🎉",
        "Kurstyp wurde erfolgreich aktualisiert.": "Il tipo di corso è stato aggiornato con successo.",
        "Kurse wurden der Gruppe hinzugefügt.": "I corsi sono stati aggiunti al gruppo.",
        "Der Import wurde gestartet und wird im Hintergrund ausgeführt.": "L'importazione è stata avviata e viene eseguita in background.",
        "Der Benutzer wurde erfolgreich gelöscht.": "L'utente è stato eliminato con successo.",
        "Teilnehmer:in anzeigen": "Mostra partecipanti",
        "Die Offerte wurde erstellt.": "L'offerta è stata preparata.",
        "Teilnehmer erfolgreich gespeichert!": "Partecipante salvato con successo!",
        "Der Kundenbereich wurde gespeichert! 🎉": "L'area clienti è stata salvata! 🎉",
        "Kursgruppe wurde gelöscht!": "Il gruppo di corsi è stato cancellato!",
        "Kursgruppe erfolgreich erstellt 🎉": "Gruppo di corsi creato con successo 🎉",
        "Möchtest du das Element wirklich löschen?": "Si vuole davvero eliminare l'elemento?",
        "Auswählen": "Selezionare",
        "Kurs erstellen": "Creare un corso",
        "Mail Statusinformationen wurden aktualisiert.": "Le informazioni sullo stato della posta sono state aggiornate.",
        "Das Unternehmen wurde erstellt.": "L'azienda è stata creata.",
        "Der Kontakt wurde erstellt.": "Il contatto è stato creato.",
        "Teilnehmer wurde in den neuen Kurs verschoben.": "Il partecipante è stato spostato nel nuovo corso.",
        "Der Kurs wurde erfolgreich gelöscht!": "Il corso è stato cancellato con successo!",
        "Kurstypen": "Tipi di corso",
        "Keine Daten gefunden.": "Non sono stati trovati dati.",
        "Kurstyp bearbeiten": "Modifica del tipo di corso",
        "Kurs hat noch nicht begonnen.": "Il corso non è ancora iniziato.",
        "Kurs ist abgeschlossen.": "Il corso è completato.",
        "Kurs ist abgesagt.": "Il corso è annullato.",
        "Kurs ist archiviert.": "Il corso è archiviato.",
        "Kurs bearbeiten": "Elabora il corso",
        "HINWEIS:": "AVVISO:",
        "Das Angebot wurde aktualisiert.": "L'offerta è stata aggiornata.",
        "Das Angebot wurde entfernt.": "L'offerta è stata rimossa.",
        "Nachricht wurde erneut zugestellt 🎉": "Il messaggio è stato consegnato di nuovo 🎉",
        "Das Login wurde erstellt! 🎉": "Il login è stato creato! 🎉",
        "Das Login wurde gelöscht! 🎉": "Il login è stato cancellato! 🎉",
        "Nachricht wurde verschickt 🎉": "Il messaggio è stato inviato 🎉",
        "Geteilter Link gelöscht!": "Il link condiviso è stato eliminato!",
        "Der Kurs wurde gespeichert": "Il corso è stato salvato",
        "Der Kurs wurde erfolgreich archiviert!": "Il corso è stato archiviato con successo!",
        "Teilnehmer:in erfolgreich abgemeldet.": "Partecipante cancellato con successo.",
        "Der Benutzer wurde erfolgreich aktualisiert.": "L'utente è stato aggiornato con successo.",
        "Die Weiterleitung wurde erstellt!": "Il corso è stato archiviato con successo!",
        "Die Weiterleitung wurde aktualisiert!": "L'inoltro è stato aggiornato!",
        "Die Weiterleitung wurde gelöscht!": "L'inoltro è stato cancellato!",
        "Das Unternehmen wurde aktualisiert.": "L'azienda è stata aggiornata.",
        "Das Unternehmen wurde gelöscht!": "L'azienda è stata cancellata!",
        "Das Unternehmen kann nicht gelöscht werden, solange noch ein Kundenbereich existiert.": "L'azienda non può essere eliminata finché esiste ancora un'area clienti.",
        "Der Kontakt wurde aktualisiert.": "Il contatto è stato aggiornato.",
        "Der Kontakt wurde entfernt.": "Il contatto è stato rimosso.",
        "Der Kommentar wurde gespeichert.": "Il commento è stato salvato.",
        "Der Kommentar wurde aktualisiert.": "Il commento è stato aggiornato.",
        "Der Kommentar wurde entfernt.": "Il commento è stato rimosso.",
        "Link für gesamte Kursliste kopieren": "Copiare il link per l'elenco completo dei corsi",
        "Link für diese Kursgruppe kopieren": "Copiare il link per questo gruppo di corsi",
        "Willkommen im": "Benvenuto/a al",
        "Instruktor:innen Bereich": "Area Istruttori",
        "Der Login-Link ist ungültig oder abgelaufen.": "Il link di accesso non è valido o è scaduto.",
        "weiter": "continua",
        "+{more} weitere": "+{more} ulteriori",
        "Notfallnummer (für Kurse)": "Numero di emergenza (per i corsi)",
        "Telefonzeiten": "Orari di reperibilità telefonica",
        "Montag bis Freitag": "Da lunedì a venerdì",
        "9.00 bis 12.00 Uhr": "dalle 9.00 alle 12.00",
        "13.00 bis 16.00 Uhr": "dalle 13.00 alle 16.00",
        "Link für diesen Kurs kopieren": "Copiare il link per questo corso",
        "Link für Anmeldung teilen": "Condividi il link per la registrazione",
        "🤔 Es sind keine Kurse geplant.": "🤔 Non sono previsti corsi.",
        "Suchen...": "Ricerca...",
        "Kursinstruktor:in": "Istruttore/istruttrice del corso",
        "Management": "Gestione",
        "Büro": "Ufficio",
        "Teilnahmebestätigung Erste Hilfe Kurs": "Conferma della partecipazione al corso di primo soccorso",
        "Zertifikat BLS AED SRC Kurs": "Certificato del corso BLS AED SRC",
        "Die Datei findest du im Anhang dieser E-Mail.": "Il file è allegato a questa e-mail.",
        "Herzlichen Glückwunsch und weiterhin viel Erfolg!": "Congratulazioni e ti auguriamo ancora tanto successo!",
        "Schule": "Scuola",
        "Berufsschule": "Scuola professionale",
        "Gymnasium": "Liceo",
        "Kita": "Asilo nido",
        "Betrieb": "Operatività",
        "Vereine": "Associazioni",
        "Sonstiges": "Varie",
        "Wir freuen uns, dir dein Zertifikat für den <strong>{courseName}</strong> zu übermitteln.": "Siamo lieti di inviarti il tuo certificato per il <strong>{courseName}</strong>.",
        "Wir freuen uns, dir deine Teilnahmebestätigung für den <strong>{courseName}</strong> zu übermitteln.": "Saremo lieti di inviarti la tua conferma di partecipazione al <strong>{courseName}</strong>.",
        "Zertifikate werden nun generiert und an die Teilnehmer:innen verschickt 🎉": "I certificati sono stati generati e inviati ai partecipanti 🎉",
        "Zertifikat wird nun generiert und an den/die Teilnehmer:in verschickt 🎉": "Il certificato viene generato e inviato al partecipante 🎉",
        "Bestätigung zustellen": "Inviare la conferma",
        "Teilnahmebestätigung per Mail versenden": "Inviare la conferma di partecipazione via e-mail",
        "Willst du wirklich die Teilnahmebestätigung per Mail versenden?": "Vuoi davvero inviare la conferma di partecipazione via e-mail?",
        "Teilnahmebestätigungen per Mail zustellen": "Inviare le conferme di partecipazione via e-mail",
        "Möchtest du die Teilnahmebestätigungen an alle Teilnehmer:innen zustellen?": "Vuoi inviare la conferma di partecipazione a tutti i partecipanti?",
        "ACHTUNG:": "ATTENZIONE:",
        "Für einige Teilnehmer:innen, die Anspruch auf eine Teilnahmebestätigung haben, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Per alcuni partecipanti che hanno diritto a una conferma di partecipazione, non è disponibile alcun indirizzo e-mail. Pertanto, la conferma non può essere inviata via e-mail alle seguenti persone:",
        "Du bekommst von uns einen Link per E-Mail zugesendet, um dein Passwort zurückzusetzen. Bitte gib deine E-Mail-Adresse ein, die du zum Login im Sanio Kundenportal verwendest.": "Riceverai un link via e-mail per reimpostare la password. Inserisci l'indirizzo e-mail che hai utilizzato per accedere al portale clienti di Sanio.",
        "Sanio Kundenbereich": "Area clienti Sanio",
        "Liebe Geschäftskund:innen, unser Portal für die Kursverwaltung hat einen neuen Namen. Das {portalName} erreicht ihr ab sofort unter {sanioPortalLink}.": "Cari clienti commerciali, il nostro portale per la gestione dei corsi ha un nuovo nome. Ora è possibile raggiungere il {portalName} all'indirizzo {sanioPortalLink}.",
        "Hier dein persönlicher Zugang, um dich im Sanio Kundenportal einzuloggen:": "Ecco il tuo accesso personale per accedere al portale clienti Sanio:",
        "Hier dein persönlicher Zugang, um dich im Sanio Instruktor:innen Bereich einzuloggen:": "Ecco il tuo accesso personale per effettuare il login nell’area istruttori di Sanio:",
        "Teilnahmebestätigungen herunterladen": "Scaricare le conferme di partecipazione",
        "Hier dein persönlicher Zugang, um dich im my.sanio einzuloggen:": "Ecco il tuo accesso personale per effettuare il login su my.sanio:",
        "Wichtige Hinweise:": "Avvisi importanti:",
        "Der Link kann nur einmal verwendet werden.": "Il link può essere utilizzato una sola volta.",
        "Er ist zeitlich begrenzt gültig.": "È valido per un periodo di tempo limitato.",
        "Falls das Login nicht funktioniert, kannst du jederzeit einen neuen Link auf der <a href=\"{loginPageUrl}\">Anmeldeseite</a> anfordern.": "Se il login non funziona, puoi richiedere un nuovo link in qualsiasi momento sulla <a href=\"{loginPageUrl}\">pagina di accesso</a>.",
        "in Planung": "in pianificazione",
        "Füge eine persönliche E-Mail-Adresse ein, damit der:die Teilnehmer:in alle kursbezogenen Mitteilungen (z. B. Anmeldebestätigung, Erinnerung, Teilnahmebestätigung) direkt per Mail erhält.": "Inserisci un indirizzo e-mail personale in modo che il/la partecipante riceva tutte le comunicazioni relative al corso (ad es. conferma dell'iscrizione, promemoria, conferma della partecipazione) direttamente via e-mail.",
        "am <strong>{date}</strong>": "il <strong>{date}</strong>",
        "am <strong>{dateStart}</strong> und <strong>{dateEnd}</strong>": "il <strong>{dateStart}</strong> e <strong>{dateEnd}</strong>",
        "vom <strong>{dateStart}</strong> bis <strong>{dateEnd}</strong>": "dalle <strong>{dateStart}</strong> alle <strong>{dateEnd}</strong>",
        "Dein Sanio-Verifizierungscode": "Il tuo codice di verifica Sanio",
        "Dein Verifizierungscode lautet: <strong>{code}</strong>": "Il codice di verifica è: <strong>{code}</strong>",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im Sanio Kundenportal mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Se è stata salvata una password, il contatto può accedere al portale clienti Sanio con email e password. Altrimenti, verrà inviato un link di accesso.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im team.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Se è stata impostata una password, il contatto può accedere a team.sanio con il proprio indirizzo e-mail e la password. Altrimenti, viene inviato un link di accesso.",
        "Ist ein Passwort hinterlegt, kann sich der Kontakt im my.sanio mit E-Mail und Passwort anmelden. Ansonsten wird ein Anmeldelink verschickt.": "Se è stata impostata una password, il contatto può accedere a my.sanio con il proprio indirizzo e-mail e la password. Altrimenti, viene inviato un link di accesso.",
        "Allgemeine Informationen": "Informazioni generali",
        "Rechte": "Diritti",
        "Rollen": "Ruoli",
        "Rollen auswählen": "Selezionare i ruoli",
        "Authentifizierung": "Autenticazione",
        "Passwort (optional)": "Password (opzionale)",
        "Wechseln": "Cambiare",
        "Sprache": "Lingua",
        "Benutzeroberfläche": "Interfaccia utente",
        "total": "totale",
        "übersetzt": "Tradotto",
        "Es gab ein technisches Problem.": "C'è stato un problema tecnico.",
        "ausstehend": "pendente",
        "Übersetzungsstatistiken werden geladen": "Vengono caricate le statistiche di traduzione",
        "Übersetzungsstatistiken konnten nicht geladen werden.": "Non è stato possibile caricare le statistiche di traduzione.",
        "Mögliche Gründe:": "Possibili motivi:",
        "Die Story wurde noch nicht ins Weblate übertragen.": "La storia non è ancora stata trasferita su Weblate.",
        "Übersetzungsstatistiken": "Statistiche di traduzione",
        "Du musst die AGB akzeptieren!": "È necessario accettare i termini e le condizioni generali!",
        "Falls du Excel für den Import verwendest, achte darauf, dass Spalten wie z.B. das Geburtsdatum als Text formatiert sind.": "Se utilizzi Excel per l'importazione, assicurati che colonne come la data di nascita siano formattate come testo.",
        "Du musst die AGB akzeptieren, um fortfahren zu können.": "Per continuare è necessario accettare i termini e le condizioni generali.",
        "Bitte gib eine gültige Handynummer ein.": "Inserisci un numero di cellulare valido.",
        "Möchtest du die Variante wirklich duplizieren?": "Vuoi davvero duplicare la variante?",
        "Es gibt bereits {count} ähnliche:n Teilnehmer:in. Schalte das Matching aus um den Teilnehmer trotzdem zu erstellen.": "Ci sono già {count} partecipanti simili. Disattiva il matching per creare comunque il partecipante.",
        "Vielen Dank! Wir haben deine Angaben erhalten.": "Grazie mille! Abbiamo ricevuto i tuoi dati.",
        "Deine Ansprechperson:": "La tua persona di contatto:",
        "Deine Ansprechpersonen:": "Le tue persone di contatto:",
        "Preis": "Prezzo",
        "Produkt erfassen": "Inserire il prodotto",
        "Produkt bearbeiten": "Modifica del prodotto",
        "Produktstatus": "Stato del prodotto",
        "Preis in CHF": "Prezzo in CHF",
        "MwSt. in Prozent": "IVA in percentuale",
        "Produktmedien": "Media del prodotto",
        "Produktbild": "Immagine del prodotto",
        "Produkte": "Prodotti",
        "Produkt wurde erstellt.": "Il prodotto è stato creato.",
        "Produkt wurde aktualisiert.": "Il prodotto è stato aggiornato.",
        "Produktgruppen": "Gruppi di prodotti",
        "Produktgruppe erfassen": "Inserire il gruppo di prodotti",
        "Produktgruppe bearbeiten": "Modifica del gruppo di prodotti",
        "Es gibt noch keine Einträge.": "Non ci sono ancora voci.",
        "Medien": "Media",
        "Produktgruppenbild": "Immagine del gruppo di prodotti",
        "Produktgruppe wurde erstellt.": "È stato creato un gruppo di prodotti.",
        "Produktgruppe wurde aktualisiert.": "Il gruppo di prodotti è stato aggiornato.",
        "Produktgruppe": "Gruppo di prodotti",
        "Produkte werden im Hintergrund aktualisiert.": "I prodotti vengono aggiornati in background.",
        "Jetzt aktualisieren": "Aggiornare ora",
        "Die Produktdaten werden aus Bexio regelmässig importiert und mit den bestehenden abgeglichen.": "I dati dei prodotti vengono regolarmente importati da Bexio e sincronizzati con i dati esistenti.",
        "Kürzel (Slug)": "Abbreviazione (Slug)",
        "Produktart (Bexio)": "Tipo di prodotto (Bexio)",
        "Shop wurde erstellt.": "È stato creato il negozio.",
        "Shop wurde aktualisiert.": "Il negozio è stato aggiornato.",
        "Shop wurde gelöscht.": "Il negozio è stato cancellato.",
        "Shop erfassen": "Entra nel negozio",
        "Shop bearbeiten": "Modifica negozio",
        "Shops": "Negozi",
        "Aktiv": "Attivo",
        "Produktgruppen auswählen": "Selezionare i gruppi di prodotti",
        "Titel": "Titolo",
        "Mit der Registrierung akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Con la registrazione, accetto i {tos}. Ho letto e compreso la {privacyPolicy}.",
        "Es muss eine gültige Handynummer angegeben werden.": "È necessario fornire un numero di cellulare valido.",
        "inkl. {taxPercentage}% MwSt.": "incl. {taxPercentage}% di IVA.",
        "Preis (inkl. {taxPercentage}% MwSt)": "Prezzo (incl. {taxPercentage}% IVA)",
        "Bestelldatum: {orderDate}": "Data ordine: {orderDate}",
        "Bestellnummer: {orderReference}": "Numero d'ordine: {orderReference}",
        "Keine Teilnehmenden|ein:e Teilnehmer:in|{capacity} Teilnehmende": "Nessun partecipante|Un/a partecipante|{capacity} partecipanti",
        "Kursmodi": "Modalità del corso",
        "Die Anmeldefrist ist abgelaufen.": "Il termine d‘iscrizione è scaduto.",
        "Kunde": "Cliente",
        "Termine": "Date",
        "Kein Datum definiert": "Nessuna data definita",
        "Anmeldefrist abgelaufen": "Termine di registrazione scaduto",
        "Anmeldefrist:": "Termine d'iscrizione:",
        "Anmeldefrist": "Termine d‘iscrizione",
        "Der Link wurde in die Zwischenablage kopiert! 🎉": "Il link è stato copiato negli appunti! 🎉",
        "Link": "Link",
        "eLearning öffnen": "Aprire l‘eLearning",
        "Du hast dich erfolgreich für das Erste Hilfe eLearning von {customer} angemeldet! 🎉": "Ti sei registrato con successo per l'eLearning sul Primo Soccorso di {customer}! 🎉",
        "Es steht dir nun zur Verfügung und du kannst ab sofort mit dem Lernen beginnen.": "Ora è a tua disposizione e puoi iniziare subito a imparare.",
        "Starte jetzt dein Erste Hilfe eLearning! 🚀": "Inizia subito l'eLearning sul primo soccorso! 🚀",
        "Nachricht konnte nicht erneut zugestellt werden!": "Il messaggio non può essere inviato nuovamente!",
        "Möchtest du die Teilnahmebestätigungen herunterladen?": "Vuoi scaricare i certificati di partecipazione?",
        "Das eLearning dauert rund {onlineCourseDuration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning dura circa {onlineCourseDuration}. Alla fine dell'eLearning è prevista una breve verifica dell'apprendimento. Vale quindi la pena di non limitarsi a cliccare sulla teoria!",
        "Du hast das Erste Hilfe eLearning von {customer} erfolgreich abgeschlossen – grossartig!": "Avete completato con successo l'eLearning sul primo soccorso di {customer} - ottimo!",
        "Danke, dass du dich für Erste Hilfe weitergebildet hast. Bleib sicher!": "Grazie per aver approfondito la tua formazione nel Primo Soccorso. Rimani al sicuro!",
        "Der Kommentar konnte nicht gespeichert werden.": "Non è stato possibile salvare il commento.",
        "{firstname}, dein Erste Hilfe eLearning von {company} wartet auf dich! ⏳": "{firstname}, il tuo eLearning sul Primo Soccorso di {company} ti sta aspettando! ⏳",
        "{firstname}, starte jetzt dein Erste Hilfe eLearning! 🚀": "{firstname}, inizia subito il tuo eLearning sul primo soccorso! 🚀",
        "Glückwunsch, {firstname}! Dein Erste Hilfe eLearning von {company} ist abgeschlossen 🎓": "Congratulazioni, {firstname}! Il vostro corso di primo soccorso di {company} è completo 🎓",
        "{firstname}, dein Zugang zum Erste Hilfe eLearning von {company} ist da!": "{firstname}, il tuo accesso al First Aid eLearning di {company} è qui!",
        "Twint": "Twint",
        "Visa": "Visa",
        "MasterCard": "MasterCard",
        "PostFinance Pay": "PostFinance Pay",
        "Rechnung": "Fattura",
        "Vorkasse": "Pagamento anticipato",
        "Keine Zahlung erforderlich": "Nessun pagamento richiesto",
        "Wie waren die Aufgaben in den Notfällen für dich?": "Come sono stati per te i compiti nelle emergenze?",
        "Es wird Zeit, mit dem eLearning zu beginnen! Bitte schliesse es bis zum Kursbeginn am <strong>{courseStart}</strong>, ab, da es die wichtige Grundlage für unseren Kurs bildet. Plane dafür etwa {duration} ein, damit du gut vorbereitet bist und das Beste aus dem Kurs mitnehmen kannst. Wir freuen uns auf dich!": "È ora di iniziare l'eLearning! Vi preghiamo di completarlo entro l'inizio del corso all'indirizzo <strong>{courseStart}</strong>, poiché costituisce la base importante del nostro corso. Lasciate circa {duration} per questo, in modo che siate ben preparati e possiate ottenere il massimo dal corso. Non vediamo l'ora di vedervi!",
        "Viel Erfolg! 🚀": "Buona fortuna! 🚀",
        "Du hast bereits {courseProgress}% vom Erste Hilfe eLearning geschafft – super! 🎉": "Hai già completato il {courseProgress}% dell'eLearning sul Primo Soccorso - ottimo! 🎉",
        "Bleib dran und lerne weiter, damit du den Kurs erfolgreich abschliessen kannst.": "Continuate a lavorare e a imparare, così da completare il corso con successo.",
        "Weiterlernen": "Continua a imparare",
        "Keine Kursleitung definiert": "Nessuna gestione del corso definita",
        "Wir freuen uns, dir deine Teilnahmebestätigung für diesen Onlinekurs zu übermitteln. Die Datei findest du im Anhang dieser E-Mail.": "Siamo lieti di inviarti la conferma di partecipazione a questo corso online. Trovi il file allegato a questa e-mail.",
        "hat am <strong>{dateText}</strong> am {durationText} {courseTypeName} {guideline} teilgenommen.": "il <strong>{dateText}</strong> ha partecipato al {durationText} {courseTypeName} {guideline}.",
        "hat am <strong>{dateText}</strong> das {durationText} {courseTypeName} {guideline} erfolgreich abgeschlossen.": "ha completato con successo il {durationText} {courseTypeName} {guideline} il <strong>{dateText}</strong>.",
        "{minutes}-minütige": "{minutes}-minuti",
        "{hours}-stündige": "{hours}-ora",
        "{hours}-stündigen": "{hours}-ora",
        "Teilnehmerliste importieren": "Importa elenco partecipanti",
        "Sortierung": "Ordinamento",
        "Die Teilnehmer:innen haben eine Anmeldebestätigung erhalten.": "I partecipanti hanno ricevuto una conferma d'iscrizione.",
        "Folgende Zeilen konnten aufgrund ungültiger Daten (<span class=\"text-red\">rot markiert</span>) nicht importiert werden:": "Le seguenti righe non hanno potuto essere importate a causa di dati non validi (<span class=\"text-red\">evidenziate in rosso</span>):",
        "Teilnehmer:innen wurden {statusHint} aus Datei {fileName} in Kurs {course} importiert.": "I partecipanti sono stati importati {statusHint} dal file {fileName} nel corso {course}.",
        "Kategorie-Label": "Etichetta categoria",
        "Die Teilnehmer:innen aus der Datei \"{fileName}\"\" wurden {statusHint} im Kurs {course} erfasst.": "I partecipanti del file \"{fileName}\" sono stati inseriti {statusHint} nel corso {course}.",
        "Es wurden total:": "In totale sono stati:",
        "<strong>{count}</strong> neu angelegt": "<strong>{count}</strong> creati",
        "<strong>{count}</strong> aktualisiert": "<strong>{count}</strong> aggiornati",
        "<strong>{count}</strong> am Kurs angemeldet": "<strong>{count}</strong> iscritti al corso",
        "Der Kurs ist nicht verfügbar.": "Il corso non è disponibile.",
        "Dieser Kurs ist noch nicht bereit für Anmeldungen!": "Questo corso non è ancora pronto per le iscrizioni!",
        "Abteilung": "Reparto",
        "Stationäre Wohngruppen": "Gruppi abitativi stazionari",
        "Betriebe": "Aziende",
        "Bildung": "Formazione",
        "Andere": "Altro",
        "Die Anmeldebestätigungen werden an die Teilnehmer:innen verschickt 🎉": "Le conferme d'iscrizione vengono inviate ai partecipanti 🎉",
        "Anmeldebestätigungen verschicken": "Invia conferme d'iscrizione",
        "Anmeldebestätigungen per Mail zustellen": "Invia conferme d'iscrizione via e-mail",
        "Bestätigungen zustellen": "Consegnare conferme",
        "ACHTUNG": "ATTENZIONE",
        "Verifizierungscode eingeben": "Inserire il codice di verifica",
        "Wir haben einen 6-stelligen Code an {maskedIdentifier} geschickt.": "Abbiamo inviato un codice a 6 cifre a {maskedIdentifier}.",
        "Keinen Code erhalten?": "Non hai ricevuto il codice?",
        "Erneut senden": "Inviare di nuovo",
        "E-Mail konnte nicht korrekt zugestellt werden": "L'e-mail non è stata consegnata correttamente",
        "Bestätigen": "Confermare",
        "Bestellung: {id}": "Ordine: {id}",
        "Bezahlstatus: {status}": "Stato pagamento: {status}",
        "Wenn wir nicht wissen, wer du bist, kann es sein, dass wir dich nach deiner <strong>Sanio ID</strong> fragen. Du findest diese hier:": "Se non sappiamo chi sei, potremmo chiederti il tuo <strong>Sanio ID</strong>. Lo trovi qui:",
        "Mit dem Kauf akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Con l'acquisto accetto le {tos}. Ho letto e compreso la {privacyPolicy}.",
        "Lade weitere Kurse": "Carica altri corsi",
        "Keine weiteren Kurse gefunden.": "Nessun altro corso trovato.",
        "Kurs suchen": "Cerca corso",
        "Kein Kurs ausgewählt": "Nessun corso selezionato",
        "Kurs auswählen": "Selezionare il corso",
        "Ausgewählter Kurs": "Corso selezionato",
        "Zugriffsdauer in Tagen": "Durata dell'accesso in giorni",
        "Willkommen in deinem persönlichen Bereich, {name}! Hier findest du alle deine gebuchten Online-Kurse, deine Bestellungen und kannst dein Profil verwalten. Viel Spass beim Lernen!": "Benvenuto nella tua area personale, {name}! Qui troverai tutti i tuoi corsi online prenotati, i tuoi ordini e potrai gestire il tuo profilo. Divertiti a imparare!",
        "Jetzt eLearning starten": "Inizia l'eLearning ora",
        "Leider stehen dir im Moment keine Online-Kurse zur Verfügung. Bitte kontaktiere uns, wenn du Fragen hast.": "Purtroppo al momento non hai corsi online disponibili. Contattaci se hai domande.",
        "Bestellungen": "Ordini",
        "Online Kurse": "Corsi online",
        "Zertifikate können für diesen Kurs nicht generiert werden.": "Non è possibile generare certificati per questo corso.",
        "Zertifikate können nicht automatisch verschickt werden, wenn der Zertifikat-Generator nicht aktiviert ist!": "I certificati non possono essere inviati automaticamente se il generatore di certificati non è attivato!",
        "Erneut senden ({timeTillResend} s)": "Invia nuovamente ({timeTillResend} s)",
        "Benötigst Du Hilfe?": "Hai bisogno di aiuto?",
        "Wir helfen Dir gerne per E-Mail oder Telefon": "Ti aiutiamo volentieri via e-mail o telefono",
        "Erste Hilfe lernen. Wo du willst. Wann du willst.": "Impara il primo soccorso. Dove vuoi. Quando vuoi.",
        "Den Beleg zu deiner Bestellung findest du im Anhang.": "La ricevuta del tuo ordine si trova in allegato.",
        "Bestellbestätigung für {orderNumber}": "Conferma dell'ordine per {orderNumber}",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Nella tua area personale my.sanio trovi tutti i dettagli dell'ordine e l'accesso diretto al corso. Buono studio! 🚑💡",
        "Wir haben deine Zahlung erhalten und dein Zugang zum eLearning ist jetzt freigeschaltet.": "Abbiamo ricevuto il tuo pagamento e il tuo accesso all'eLearning è ora attivo.",
        "Danke für deine Bestellung, {name}! 🎉": "Grazie per il suo ordine, {name}! 🎉",
        "Rechnungsadresse": "Indirizzo di fatturazione",
        "Lieferadresse": "Indirizzo di consegna",
        "Abweichende Lieferadresse": "Indirizzo di consegna diverso",
        "Optional. Empfohlen, wenn Gutscheine per Post verschickt werden.": "Facoltativo. Consigliato se i buoni vengono spediti per posta.",
        "Der Vorname der Lieferadresse ist erforderlich.": "Il nome dell'indirizzo di consegna è obbligatorio.",
        "Der Nachname der Lieferadresse ist erforderlich.": "Il cognome dell'indirizzo di consegna è obbligatorio.",
        "Die Strasse der Lieferadresse ist erforderlich.": "La via dell'indirizzo di consegna è obbligatoria.",
        "Die Hausnummer der Lieferadresse ist erforderlich.": "Il numero civico dell'indirizzo di consegna è obbligatorio.",
        "Die PLZ der Lieferadresse ist erforderlich.": "Il CAP dell'indirizzo di consegna è obbligatorio.",
        "Der Ort der Lieferadresse ist erforderlich.": "La località dell'indirizzo di consegna è obbligatoria.",
        "Wir konnten dich mit diesen Angaben nicht anmelden.": "Non siamo riusciti ad accederti con questi dati.",
        "Bestellbestätigung": "Conferma d'ordine",
        "Exportieren als CSV": "Esporta come CSV",
        "Exportieren als Excel": "Esporta come Excel",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr in einen anderen Kurs verschoben werden.": "Il/la partecipante ha già iniziato l'eLearning e non può più essere spostato/a in un altro corso.",
        "Der/die Teilnehmer:in hat bereits mit dem eLearning begonnen und kann nicht mehr abgemeldet werden.": "Il/la partecipante ha già iniziato l'eLearning e non può più essere cancellato/a.",
        "Du hast dich für das Erste Hilfe eLearning angemeldet, aber noch nicht gestartet. Nutze die Chance, dein Wissen aufzufrischen.": "Ti sei iscritto/a all'eLearning di primo soccorso, ma non hai ancora iniziato. Cogli l'occasione per aggiornare le tue conoscenze.",
        "Kontaktperson Kunde": "Persona di contatto cliente",
        "Die Zertifikate werden im Hintergrund vorbereitet. Bitte habe einen Moment Geduld.": "I certificati vengono preparati in background. Attendi un momento.",
        "Die Zertifikate werden im Hintergrund vorbereitet. Sie erhalten eine Benachrichtigung, sobald die Zertifikate zum Download bereitstehen.": "I certificati vengono preparati in background. Riceverai una notifica non appena i certificati saranno pronti per il download.",
        "Die Zertifikate für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "I certificati per il corso {course} sono stati generati e sono pronti per il download.",
        "Jetzt herunterladen": "Scarica ora",
        "Zertifikate für Kurs {course} wurden generiert!": "I certificati per il corso {course} sono stati generati!",
        "Die Zertifikate werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du die Zertifikate herunterladen kannst.": "I certificati vengono generati in background. Riceverai una notifica via e-mail non appena potrai scaricare i certificati.",
        "Möchtest du die Teilnahmebestätigungen trotzdem generieren?": "Vuoi generare comunque le conferme di partecipazione?",
        "Teilnahmebestätigungen generieren": "Genera conferme di partecipazione",
        "Der angegebene Freigabelink wird noch nicht unterstützt.": "Il link di condivisione indicato non è ancora supportato.",
        "Persönlicher Zugangscode (QR) anzeigen": "Mostra codice di accesso personale (QR)",
        "Persönliche Zugangscodes (QR) als PDF": "Codici di accesso personali (QR) come PDF",
        "Persönlicher eLearning Zugang {name}": "Accesso eLearning personale {name}",
        "Das Dokument wird im Hintergrund generiert. Du wirst benachrichtigt, sobald es fertig ist.": "Il documento viene generato in background. Riceverai una notifica non appena sarà pronto.",
        "Persönlicher Zugang": "Accesso personale",
        "Die Zugangs-QR-Codes für den Kurs {course} wurden generiert und stehen zum Herunterladen bereit.": "I codici QR di accesso per il corso {course} sono stati generati e sono pronti per il download.",
        "Das eLearning steht für dich bereitsteht und du kannst ab sofort mit dem Lernen beginnen. Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning è pronto per voi e potete iniziare a imparare immediatamente. L'eLearning dura circa {duration}. Alla fine dell'eLearning è prevista una breve verifica dell'apprendimento. Quindi vale la pena di non limitarsi a fare clic sulla teoria!",
        "eLearning {customerName}": "eLearning {customerName}",
        "QR Code": "Codice QR",
        "Gültig bis {expire}": "Valido fino a {expire}",
        "eLearning Zugang {customerName}": "Accesso eLearning {customerName}",
        "Viel Erfolg!": "Buona fortuna!",
        "eLearning QR-Zugänge generieren": "Genera accessi QR eLearning",
        "Die QR-Zugänge werden im Hintergrund generiert. Du wirst per E-Mail benachrichtigt, sobald du sie herunterladen kannst.": "Gli accessi QR vengono generati in background. Riceverai una notifica via e-mail non appena potrai scaricarli.",
        "QR Code wird geladen": "Codice QR in caricamento",
        "QR-Code mit Smartphone Kamera scannen": "Scansiona il codice QR con la fotocamera dello smartphone",
        "QR-Code drucken": "Stampa codice QR",
        "QR Zugänge für Kurs {course} wurden generiert!": "Gli accessi QR per il corso {course} sono stati generati!",
        "Teilnahmebestätigungen an Teilnehmende versenden": "Inviare conferme di partecipazione ai partecipanti",
        "eLearning URL": "URL eLearning",
        "kopieren": "copia",
        "Super, du bist erfolgreich für den Erste Hilfe Kurs angemeldet – wir freuen uns! 🎉": "Perfetto, sei registrato con successo al corso di primo soccorso – siamo felici! 🎉",
        "Teil 1: eLearning": "Parte 1: eLearning",
        "Das <strong>eLearning</strong> ist ab sofort für dich freigeschaltet – du kannst direkt loslegen:": "<strong>L'eLearning</strong> è ora attivato per voi - potete iniziare subito:",
        "<strong>Bitte beachte:</strong> Das eLearning muss bis spätestens vor dem Präsenzkurs am <strong>{courseDate}</strong> abgeschlossen sein. Es ist die Grundlage für den praktischen Teil des Kurses.": "<strong>Nota bene:</strong> L'eLearning deve essere completato al più tardi prima del corso faccia a faccia, che si terrà a <strong>{courseDate}</strong>. È la base per la parte pratica del corso.",
        "Das eLearning dauert rund {duration}. Am Ende des eLearnings gibt es eine kurze Lernkontrolle. Es lohnt sich also, die Theorie nicht einfach durchzuklicken!": "L'eLearning dura circa {duration}. Alla fine dell'eLearning è prevista una breve verifica dell'apprendimento. Vale quindi la pena di non limitarsi a cliccare sulla teoria!",
        "Teil 2: Präsenzkurs": "Parte 2: Corso in presenza",
        "eLearning QR-Zugänge generieren und E-Mail an ({email}) senden": "Generare accessi QR eLearning e inviare e-mail a ({email})",
        "<strong>ACHTUNG:</strong> Du bist als eine andere Person angemeldet. Die E-Mail wird aber an die E-Mail-Adresse der aktuell angemeldeten Person gesendet.": "<strong>ATTENZIONE:</strong> Sei registrato come un'altra persona. L'e-mail verrà però inviata all'indirizzo e-mail della persona attualmente connessa.",
        "Teilnahmebestätigungen generieren und E-Mail an ({email}) senden": "Generare conferme di partecipazione e inviare e-mail a ({email})",
        "Programm": "Programma",
        "Teilnahmebestätigungen an Teilnehmer:innen versenden": "Inviare conferme di partecipazione ai partecipanti",
        "Unternehmen": "Azienda",
        "Kundenbereiche": "Aree clienti",
        "Offerte": "Offerta",
        "Benutzer:innen": "Utenti",
        "Kontakte": "Contatti",
        "Kursanfragen": "Richieste di corsi",
        "Kontaktanfragen": "Richieste di contatto",
        "Erste Hilfe eLearning": "eLearning primo soccorso",
        "Die Eingabe ist ungültig.": "L'immissione non è valida.",
        "Standard": "Standard",
        "Zu viele Versuche. Bitte versuche es später erneut.": "Troppi tentativi. Riprova più tardi.",
        "Teilnehmer:in aus Kundenbereich löschen": "Eliminare il/la partecipante dall'area clienti",
        "Ist aktiv": "È attivo",
        "Ist der Standard Shop": "È lo shop standard",
        "Kurs Zuweisung": "Assegnazione corso",
        "In deinem persönlichen Bereich my.sanio findest du alle Bestelldetails.": "Nella tua area personale my.sanio trovi tutti i dettagli dell'ordine.",
        "Zum my.sanio": "Vai a my.sanio",
        "Bestellnummer": "Numero d'ordine",
        "Datum & Uhrzeit": "Data e ora",
        "Lizenz": "Licenza",
        "Zugriffszeitraum": "Periodo di accesso",
        "Hi {name}! 🎉": "Ciao {name} 🎉",
        "Zahlungsart": "Metodo di pagamento",
        "inkl. {taxPercentage}% MwSt": "incl. {taxPercentage}% IVA",
        "Du kannst diesen/diese Teilnehmer:in nicht mehr bearbeiten, da ein verknüpfter Kurs bereits begonnen hat oder abgeschlossen ist.": "Non puoi più modificare questo/questa partecipante, poiché un corso collegato è già iniziato o è concluso.",
        "Der Kurs hat bereits begonnen.": "Il corso è già iniziato.",
        "Vielen Dank für deine Anmeldung!": "Grazie per la tua iscrizione!",
        "Du erhältst in Kürze eine Bestätigung per E-Mail mit allen wichtigen Infos zum Kurs. Bitte wirf auch einen Blick in deinen Spam-Ordner, falls keine Mail eintrifft. 📩": "Riceverai a breve una conferma via e-mail con tutte le informazioni importanti sul corso. Controlla anche la cartella spam, nel caso non arrivi nessuna e-mail. 📩",
        "Deine Anmeldung ist bei uns eingegangen. Alle weiteren Informationen zum Kurs erhältst du zu einem späteren Zeitpunkt. 📩": "La tua iscrizione ci è pervenuta. Riceverai tutte le ulteriori informazioni sul corso in un secondo momento. 📩",
        "Du musst nichts mitbringen. Wir empfehlen dir praktische und bequeme Kleidung zu tragen, die genügend Bewegungsfreiheit bietet. Denn während des Kurses führen wir praktische Übungen auf dem Boden durch, welche teilweise physisch etwas anspruchsvoll sind. 😊": "Non devi portare niente. Ti consigliamo di indossare abbigliamento pratico e comodo che offra sufficiente libertà di movimento. Durante il corso infatti eseguiamo esercizi pratici a terra, che a volte sono fisicamente un po' impegnativi. 😊",
        "<strong>Bei Fragen oder Abmeldungen vor dem Kurstag</strong> wende dich bitte direkt an {name}:": "<strong>Per domande o cancellazioni prima del giorno del corso</strong> si prega di contattare direttamente {name}:",
        "Leider bist du nicht berechtigt, ein Zertifikat für diesen Kurs zu erhalten.": "Purtroppo non sei autorizzato/a a ricevere un certificato per questo corso.",
        "Sanio": "Sanio",
        "Am Kurstag selbst, z.B. bei Verspätung oder kurzfristiger Abmeldung, erreichst du uns schriftlich via <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.": "Il giorno stesso del corso, ad es. in caso di ritardo o disdetta all'ultimo momento, puoi contattarci per iscritto tramite <a href=\"https://wa.me/{whatsappNumber}\">WhatsApp</a>.",
        "Empfänger": "Destinatario",
        "1 Lizenz zur Selbstnutzung": "1 licenza per uso personale",
        "{count} Geschenk ({type})": "{count} Regalo ({type})",
        "digital": "digitale",
        "Anzahl Lizenzen": "Numero di licenze",
        "Für {recipient} von {giver}": "Per {recipient} da {giver}",
        "Unbekannt": "Sconosciuto",
        " 🎁": "Riscattare la licenza regalo 🎁",
        "Produktgutschein": "Buono prodotto",
        "Gutschein {number} herunterladen": "Scaricare il buono {number}",
        "Gutschein-Link {number} kopieren (inkl. Code)": "Copiare il link del buono {number} (compreso il codice)",
        "Gutschein oder Rabatt einlösen": "Riscatta buono o sconto",
        "Trage hier deinen Rabattcode für diesen Kurs ein.": "Inserisci qui il tuo codice sconto per questo corso.",
        "Rabatt entfernen": "Rimuovi sconto",
        "Code ungültig": "Codice non valido",
        "Dieser Code ist nur für eLearning Geschenke gültig.": "Questo codice è valido solo per regali eLearning.",
        "Hast du ein eLearning geschenkt bekommen? Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Hai ricevuto un eLearning in regalo? Allora riscatta il tuo buono su {redeemUrl}.",
        "Dann löse deinen Gutschein bitte unter {redeemUrl} ein.": "Allora riscattate il vostro voucher su {redeemUrl}.",
        "Rabatt": "Sconto",
        "Code": "Codice",
        "Produktgutschein erfassen": "Registra buono prodotto",
        "Kunde & Produkt": "Cliente & Prodotto",
        "Kunde auswählen": "Seleziona cliente",
        "Produkt wählen": "Scegli prodotto",
        "Shop-Konfiguration": "Configurazione shop",
        "Shop auswählen": "Seleziona shop",
        "Anzahl Gutscheine": "Numero di buoni",
        "Geschenkinformationen": "Informazioni regalo",
        "Empfänger:in": "Destinatario/a",
        "Von (Absender:in)": "Da (mittente)",
        "Nachricht an die/den Beschenkte:n (optional)": "Messaggio al/alla destinatario/a (opzionale)",
        "Persönliche Beschriftung auf dem Gutschein hinzufügen": "Aggiungi una dedica personale sul buono",
        "Produktgutscheine erstellen": "Crea buoni prodotto",
        "Produktgutscheine wurden erstellt.": "I buoni prodotto sono stati creati.",
        "Produktgutscheine": "Buoni prodotto",
        "Versandart": "Modalità di spedizione",
        "Digital & Versand": "Digitale e spedizione",
        "Von {sender}": "Dal {sender}",
        "Empfänger:in (optional)": "Destinatario (opzionale)",
        "Von (Absender:in, optional)": "Da (mittente, opzionale)",
        "{who} hat dir eine Lizenz für dieses eLearning geschenkt 🎉": "{who} vi ha concesso la licenza per questo eLearning 🎉",
        "Viel Spass beim Lernen, {name}! 🎉": "Divertiti a imparare, {name}! 🎉",
        "Nur digital": "Solo digitale",
        "Produkt": "Prodotto",
        "Gutschein wurde erstellt.": "Il buono è stato creato.",
        "Gutschein wurde aktualisiert.": "Il buono è stato aggiornato.",
        "Gutschein wurde gelöscht.": "Il buono è stato eliminato.",
        "📅 Erinnerung an deinen Kurs morgen": "🗓️ Promemoria per il tuo corso di domani",
        "manuell via admin": "manualmente via admin",
        "systemgeneriert": "generato dal sistema",
        "Kundenservice": "Servizio clienti",
        "PDF": "PDF",
        "Physisch": "Fisico",
        "Rabattgutschein": "Buono sconto",
        "Wertgutschein": "Buono regalo",
        "Verwendet": "Utilizzato",
        "Abgelaufen": "Scaduto",
        "Formatierung kann von effektiv versendeter Nachricht abweichen.": "La formattazione può differire dal messaggio effettivamente inviato.",
        "Absender Nummer:": "Numero mittente:",
        "Quadratisches Produktbild": "Immagine prodotto quadrata",
        "Gutschein-Konfiguration": "Configurazione buono",
        "Shop-Beschreibung": "Descrizione shop",
        "Beschreibung die im Shop beim Kauf angezeigt wird": "Descrizione visualizzata nello shop durante l'acquisto",
        "Shop-Bedingungen": "Condizioni shop",
        "Bedingungen die im Shop beim Kauf angezeigt werden": "Condizioni visualizzate nello shop durante l'acquisto",
        "Einlöse-Beschreibung": "Descrizione riscatto",
        "Beschreibung die beim Einlösen des Gutscheins angezeigt wird": "Descrizione visualizzata durante il riscatto del buono",
        "Einlöse-Anweisungen": "Istruzioni per il riscatto",
        "Anweisungen die beim Einlösen des Gutscheins angezeigt werden": "Istruzioni visualizzate durante il riscatto del buono",
        "Im Shop verfügbar": "Disponibile nello shop",
        "Gutschein Anwendungen": "Applicazioni buono",
        "Verfügbar": "Disponibile",
        "Pro Benutzer": "Per utente",
        "Keine Verwendungen": "Nessun utilizzo",
        "Dieser Gutschein wurde noch nicht verwendet.": "Questo buono non è ancora stato utilizzato.",
        "Bestellung": "Ordine",
        "Wert": "Valore",
        "Suche Code …": "Cerca codice …",
        "Erstellt am": "Creato il",
        "Rabattgutscheine": "Buoni sconto",
        "Kunde wählen": "Seleziona cliente",
        "Gutscheine": "Buoni",
        "Rabattgutschein erfassen": "Inserisci buono sconto",
        "Suche Code oder Name …": "Cerca codice o nome …",
        "Gültig bis": "Valido fino al",
        "Kunden": "Clienti",
        "Grundinformationen": "Informazioni di base",
        "Gutschein für": "Buono per",
        "Ursprung": "Origine",
        "Rabattwert": "Valore sconto",
        "Rabatt-Typ": "Tipo di sconto",
        "Betrag in Rappen oder Prozentpunkte x100 (z.B. 1500 = 15.00%)": "Importo in centesimi o punti percentuali x100 (es. 1500 = 15.00%)",
        "Anwendungen": "Utilizzi",
        "Beschränkte Anzahl": "Numero limitato",
        "Anwendungen pro Benutzer": "Utilizzi per utente",
        "Rabattgutschein bearbeiten": "Modifica buono sconto",
        "Gutschein Details": "Dettagli buono",
        "Max. Verwendungen": "Max. utilizzi",
        "Max. pro Nutzer:in": "Max. per utente",
        "Dies ist eine kurze Erinnerung: Du leitest morgen den Kurs {courseType}, {courseDuration} bei {company}.": "Questo è un rapido promemoria: domani insegnerai il corso {courseType}, {courseDuration} presso {company}.",
        "Kurszeiten:": "Orari del corso:",
        "Ort:": "Luogo:",
        "Bitte sei 30 Minuten vor Kursbeginn vor Ort und überprüfe, ob du alles Material dabeihast.": "Si prega di essere sul posto 30 minuti prima dell'inizio del corso e verificare di avere tutto il materiale.",
        "Alle weiteren Informationen zum Kurs und zu den Teilnehmenden findest du hier:": "Tutte le ulteriori informazioni sul corso e sui partecipanti le trovi qui:",
        "Bei Fragen oder Problemen kannst du dich gerne an Tanja wenden.": "In caso di domande o problemi puoi rivolgerti a Tanja.",
        "Danke für deinen Einsatz!": "Grazie per il tuo impegno!",
        "Gutschein {code}": "Buono {code}",
        "Gutschein {code} ({value})": "Buono {code} ({value})",
        "Gutschein {code} ({value}%)": "Buono {code} ({value}%)",
        "Absender:": "Mittente:",
        "Einlösen unter:": "Riscattare su:",
        "Code als QR": "Codice come QR",
        "Aktion": "Azione",
        "Offen": "Aperto",
        "Benutzer": "Utente",
        "Suchen": "Cerca",
        "Inaktiv": "Inattivo",
        "Gesendet:": "Inviato",
        "Kanal:": "Canale",
        "Empfänger:": "Destinatario:",
        "Eingelöst": "Riscattato",
        "Gutscheincode ist ungültig.": "Il codice coupon non è valido.",
        "Dieser Gutschein kann nur für das Produkt {name} verwendet werden.": "Questo buono può essere utilizzato solo per il prodotto {name}.",
        "Alle Produkte": "Tutti i prodotti",
        "Optional. Ohne Auswahl gilt der Gutschein für alle Produkte. Ein fester Betrag wird je Stück des gewählten Produkts abgezogen.": "Facoltativo. Senza selezione, il buono vale per tutti i prodotti. Un importo fisso viene detratto per ogni unità del prodotto scelto.",
        "Gutschein {number}": "Buono {number}",
        "Mit dem Einlösen akzeptiere ich die {tos}. Die {privacyPolicy} habe ich gelesen und verstanden.": "Riscattando, accetto i {tos}. Ho letto e compreso la {privacyPolicy}.",
        "Gutschein einlösen": "Riscatta coupon",
        "Du besitzt bereits eine aktive Lizenz für diesen Kurs. Eine weitere Einlösung ist nicht möglich.": "Possiedi già una licenza attiva per questo corso. Non è possibile riscattarne un'altra.",
        "Andere Lizenz einlösen": "Riscatta un'altra licenza",
        "Schön, dass du dich für unser Erste Hilfe eLearning entschieden hast! 😊": "Siamo lieti che tu abbia scelto il nostro eLearning di primo soccorso! 😊",
        "Hast du ein eLearning geschenkt bekommen?": "Hai ricevuto in regalo un eLearning?",
        "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.": "Si è verificato un errore. La preghiamo di riprovare.",
        "Menge": "Quantità",
        "Jede Lizenz berechtigt zu einem Jahr Nutzung des eLearnings.": "Ogni licenza dà diritto a un anno di utilizzo dell'eLearning.",
        "Abschluss": "Conclusione",
        "Ungültiger Anmeldeversuch.": "Tentativo di accesso non valido.",
        "Preisberechnung fehlgeschlagen": "Calcolo del prezzo non riuscito",
        "Über uns": "Chi siamo",
        "Kontakt": "Contatto",
        "AGBs": "CGC",
        "Datenschutz": "Protezione dei dati",
        "Impressum": "Colophon",
        "Rechnungsadresse bearbeiten": "Modifica indirizzo di fatturazione",
        "Strasse": "Via",
        "PLZ": "CAP",
        "Ort": "Località",
        "E-Mail und Telefonnummer können nur im Profil bearbeitet werden.": "E-mail e numero di telefono possono essere modificati solo nel profilo.",
        "Benötigen Sie Hilfe?": "Ha bisogno di aiuto?",
        "Wir helfen Ihnen gerne per E-Mail oder Telefon": "Saremo lieti di aiutarla via e-mail o telefono",
        "Telefon": "Telefono",
        "Ihre Bestellung": "Il suo ordine",
        "Gesamtbetrag": "Importo totale",
        "Zwischensumme": "Subtotale",
        "Jetzt kaufen": "Acquista ora",
        "Mögliche Zahlungsarten": "Metodi di pagamento disponibili",
        "Uups, Ihre Bestellung konnte nicht abgeschlossen werden.": "Ops, il suo ordine non ha potuto essere completato.",
        "Sie haben die Zahlung abgebrochen. Bitte versuchen Sie es erneut.": "Ha annullato il pagamento. La preghiamo di riprovare.",
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.": "Si è verificato un errore. La preghiamo di riprovare.",
        "Wir haben deine Bestellung erhalten 🥳": "Abbiamo ricevuto il tuo ordine 🥳",
        "Zahlung wird verarbeitet": "Pagamento in elaborazione",
        "Dein Zugang zum eLearning ist jetzt bereit. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🚑💡": "Il tuo accesso all'eLearning è ora pronto. Nella tua area personale <strong>my.sanio</strong> trovi tutti i dettagli dell'ordine e l'accesso diretto al corso. Buon apprendimento! 🚑💡",
        "Zu my.sanio": "Vai a my.sanio",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist bereits eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Puoi scaricare i buoni regalo in formato PDF o copiare il link diretto per il riscatto. Il codice è già inserito – perfetto per l'invio tramite WhatsApp, e-mail o SMS.",
        "Deine Geschenklizenz 🎁": "La tua licenza regalo 🎁",
        "Deine Geschenklizenzen 🎁": "Le tue licenze regalo 🎁",
        "Deine Geschenklizenz findest du unten in den Bestelldetails. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "La tua licenza regalo si trova qui sotto nei dettagli dell'ordine. Lì puoi anche scaricare il PDF da regalare. In alternativa, copia semplicemente il link alla pagina di riscatto – il codice è già incluso. Ideale per WhatsApp, e-mail o SMS.",
        "Deine Geschenklizenzen findest du unten in den Bestelldetails. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Le tue licenze regalo si trovano qui sotto nei dettagli dell'ordine. Lì puoi anche scaricare i PDF da regalare. In alternativa, copia semplicemente i link alla pagina di riscatto – i codici sono già inclusi. Ideale per WhatsApp, e-mail o SMS.",
        "Bestelldetails": "Dettagli ordine",
        "Lizenzen": "Licenze",
        "Geschenklizenzen": "Licenze regalo",
        "Link wurde kopiert.": "Link copiato.",
        "Link konnte nicht kopiert werden.": "Impossibile copiare il link.",
        "Übersicht": "Panoramica",
        "Deine Angaben": "I tuoi dati",
        "Geschenklizenz Übersicht": "Panoramica licenza regalo",
        "Neu bei Sanio?": "Nuovo su Sanio?",
        "Erstellen Sie Ihr Sanio-Konto und los geht's!": "Crei il suo account Sanio e si parte!",
        "Jetzt Konto erstellen": "Crea account ora",
        "Haben Sie schon ein Sanio Konto?": "Ha già un account Sanio?",
        "Melden Sie sich mit Ihrer E-Mail oder Handynummer an und schon geht's los!": "Si registri con la sua e-mail o numero di cellulare e si parte!",
        "E-Mail oder Handynummer": "E-mail o numero di cellulare",
        "Wird verarbeitet...": "Elaborazione in corso...",
        "Zum verschenken": "Da regalare",
        "Wird auf Geschenklizenz gedruckt": "Stampa su licenza regalo in corso",
        "Wenn Sie diese angeben, können Sie sich später auch per SMS einloggen.": "Se la fornisce, in seguito potrà effettuare il login anche tramite SMS.",
        "Handynummer (optional)": "Numero di cellulare (opzionale)",
        "Nr.": "N.",
        "Erstelle dein Sanio-Konto": "Crea il tuo account Sanio",
        "Erstellen Sie Ihr Sanio-Konto": "Crei il Suo account Sanio",
        "Sie sind bereits bei Sanio?": "Ha già un account Sanio?",
        "Du hast bereits ein Konto?": "Hai già un account?",
        "Geschenklizenz eingelöst": "Licenza regalo riscattata",
        "Geschenklizenz einlösen 🎁": "Riscatta licenza regalo 🎁",
        "Geschenklizenz für": "Licenza regalo per",
        "Geschenklizenz personalisieren": "Personalizza licenza regalo",
        "Geschenklizenz von": "Licenza regalo da",
        "Geschenklizenz": "Licenza regalo",
        "Geschenklizenzen personalisieren": "Personalizza licenze regalo",
        "Ihr Name für alle übernehmen": "Applicare il Suo nome per tutti",
        "Ihr Name": "Il Suo nome",
        "Name des Empfängers": "Nome del destinatario",
        "Digital & Physisch (per Post)": "Digitale e Fisico (per posta)",
        "Nur digital (PDF)": "Solo digitale (PDF)",
        "Deine Gutscheine": "I tuoi buoni",
        "Lizenz aktiviert": "Licenza attivata",
        "Jemand": "Qualcuno",
        "Wie schön, du wurdest beschenkt 🎉": "Che bello, hai ricevuto un regalo 🎉",
        "Löse deinen Code ein und erfahre, was für dich bereitsteht.": "Riscatta il tuo codice e scopri cosa ti aspetta.",
        "Wie viele Lizenzen möchten Sie kaufen? ": "Quante licenze desidera acquistare? ",
        "Wird gespeichert...": "Salvataggio in corso...",
        "Nicht {name}?": "Non {name}?",
        "Hausnummer": "Numero civico",
        "Fehler": "Errore",
        "Weiter": "Prossimo",
        "Registrieren": "Registrati",
        "1 Lizenz zum Verschenken ({type})|{count} Lizenzen zum Verschenken ({type})": "1 licenza da regalare ({type})|{count} licenze da regalare ({type})",
        "Sie sind eingeloggt als: {name}": "Hai effettuato l'accesso come: {name}",
        "Shop-Kund:in wurde erfolgreich erstellt.": "Cliente shop creato con successo.",
        "Shop-Kund:in erfassen": "Registrare cliente shop",
        "Shop-Kund:in bearbeiten": "Modificare cliente shop",
        "Shop-Kund:in wurde erfolgreich aktualisiert.": "Cliente shop aggiornato con successo.",
        "Shop-Kund:in wurde erfolgreich gelöscht.": "Cliente shop eliminato con successo.",
        "Shop-Kund:innen": "Clienti shop",
        "Shop-Kund:innen erfassen": "Registrare clienti shop",
        "Shop-Kund:in": "Cliente shop",
        "Als Firma können Sie keine Lizenz für sich selbst kaufen. Sie können nur Geschenklizenzen kaufen.": "In qualità di azienda non può acquistare una licenza per sé stesso. Può acquistare solo licenze regalo.",
        "Als Firma registrieren": "Registrarsi come azienda",
        "Firma muss ausgefüllt werden, wenn Sie sich als Firma registrieren möchten.": "Il campo azienda deve essere compilato se desidera registrarsi come azienda.",
        "Firma": "Azienda",
        "Für wen sind die Lizenzen?": "Per chi sono le licenze?",
        "Eine Lizenz für mich, andere zum Verschenken": "Una licenza per me, altre da regalare",
        "Alle Lizenzen zum Verschenken": "Tutte le licenze da regalare",
        "Sie besitzen bereits eine aktive Lizenz für diesen Kurs. Sie können nur Geschenklizenzen kaufen.": "Possiedi già una licenza attiva per questo corso. Puoi acquistare solo licenze regalo.",
        "Für wen ist die Lizenz?": "Per chi è la licenza?",
        "Für mich": "Per me",
        "Geschenkt von": "Regalato da",
        "Für alle übernehmen": "Applica a tutti",
        "Wird geprüft.": "Verifica in corso.",
        "Eingelöst von": "Riscattato da",
        "Eingelöst am": "Riscattato il",
        "Deine Geschenklizenz findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch das PDF zum Verschenken herunterladen. Alternativ kopierst du einfach den Link zur Einlöse-Seite – der Code ist bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Trovi la tua licenza regalo nei <a href=\"{orderLink}\">dettagli dell'ordine su my.sanio</a>. Lì puoi anche scaricare il PDF da regalare. In alternativa, copia semplicemente il link alla pagina di riscatto – il codice è già incluso. Ideale per WhatsApp, e-mail o SMS.",
        "Deine Geschenklizenzen findest du in den <a href=\"{orderLink}\">Bestelldetails im my.sanio</a>. Dort kannst du auch die PDFs zum Verschenken herunterladen. Alternativ kopierst du einfach die Links zur Einlöse-Seite – die Codes sind bereits enthalten. Ideal für WhatsApp, E-Mail oder SMS.": "Trovi le tue licenze regalo nei <a href=\"{orderLink}\">dettagli dell'ordine su my.sanio</a>. Lì puoi anche scaricare i PDF da regalare. In alternativa, copia semplicemente i link alla pagina di riscatto – i codici sono già inclusi. Ideale per WhatsApp, e-mail o SMS.",
        "Geschenklizenz eingelöst, eLearning bereit": "Licenza regalo riscattata, eLearning pronto",
        "Ihre Kosten": "I Suoi costi",
        "Absender:in": "Mittente",
        "Gutschein wurde deaktiviert.": "Il buono è stato disattivato.",
        "Produktgutschein bearbeiten": "Modifica buono prodotto",
        "Ausstehend": "In sospeso",
        "Dieser Code ist ein Produktgutschein und kann hier nicht eingelöst werden.": "Questo codice è un buono prodotto e non può essere utilizzato qui.",
        "Gutscheincode ist noch nicht gültig.": "Il codice buono non è ancora valido.",
        "Gutscheincode wurde bereits verwendet.": "Il codice buono è già stato utilizzato.",
        "Gutscheincode ist abgelaufen.": "Il codice buono è scaduto.",
        "{attribute} ist keine gültige Sprache.": "{attribute} non è un linguaggio valido.",
        "Ein Gutschein mit diesem Code existiert bereits im Status Aktiv oder Ausstehend. Bitte deaktivieren Sie den bestehenden Gutschein oder verwenden Sie einen anderen Code.": "Esiste già un buono con questo codice con stato Attivo o In sospeso. Disattivi il buono esistente oppure utilizzi un altro codice.",
        "Test": "Test",
        "Rabatt (Code: {code})": "Sconto (Codice: {code})",
        "Optionen öffnen": "Apri opzioni",
        "Deaktivieren": "Disattiva",
        "Speichern...": "Salvataggio...",
        "Gültig ab": "Valido dal",
        "Bezeichnung": "Denominazione",
        "Betrag in Franken (z.B. 20 = CHF 20.-)": "Importo in franchi (es. 20 = CHF 20.-)",
        "Firma (optional)": "Azienda (facoltativo)",
        "Um das Lernen persönlicher und praxisnäher zu gestalten, sprechen wir dich ab hier direkt in der Du-Form an. Schön, dass du dich für unseren Erste Hilfe Online Kurs entschieden hast! 😊": "Per rendere l'apprendimento più personale e pratico, da qui in poi ci rivolgiamo a te dandoti del tu. Siamo lieti che tu abbia scelto il nostro corso online di Primo Soccorso! 😊",
        "💌 Zusätzlich wirst du in den nächsten Tagen die gedruckten Gutscheine per Post erhalten.": "💌 Inoltre, nei prossimi giorni riceverai i buoni stampati per posta.",
        "Dein Zugang zum eLearning ist jetzt freigeschaltet.": "Il tuo accesso all'eLearning è ora attivo.",
        "Einzellizenz (für eine:n Benutzer:in)": "Licenza singola (per un utente)",
        "Gutschein für {name}": "Buono per {name}",
        "Gutschein": "Buono",
        "Dauer": "Durata",
        "In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Bestelldetails sowie den direkten Zugang zum Kurs. Viel Erfolg beim Lernen! 🧑‍🏫💡": "Nella tua area personale <strong>my.sanio</strong> trovi tutti i dettagli dell'ordine e l'accesso diretto al corso. Buon apprendimento! 🧑‍🏫💡",
        "Produktgutschein wurde aktualisiert.": "Il buono prodotto è stato aggiornato.",
        "Prozent als ganze Zahl (z.B. 15 = 15%)": "Percentuale come numero intero (es. 15 = 15%)",
        "Zirka": "Circa",
        "Ein Geschenk von": "Un regalo di",
        "Gutscheincode": "Codice buono",
        "Geschenkgutschein deaktivieren?": "Disattivare il buono regalo?",
        "Möchtest du den Gutschein wirklich deaktivieren?": "Vuoi davvero disattivare il buono?",
        "Gutschein deaktivieren": "Disattiva buono",
        "Rabattcode deaktivieren?": "Disattivare il codice sconto?",
        "Möchtest du den Rabattcode wirklich deaktivieren?": "Vuoi davvero disattivare il codice sconto?",
        "Rabattcode deaktivieren": "Disattiva codice sconto",
        "Sie haben bereits eine aktive Lizenz für dieses Produkt. Sie können nur Geschenklizenzen kaufen.": "Ha già una licenza attiva per questo prodotto. Può acquistare solo licenze regalo.",
        "Füge deine individuelle E-Mail-Adresse (keine allgemeine info@-Adresse) ein, um eine Anmeldebestätigung und ein Erinnerungsmail zu erhalten.": "Inserisci il tuo indirizzo e-mail personale (non un indirizzo generico info@) per ricevere una conferma di registrazione e un'e-mail di promemoria.",
        "Gib für die Korrespondenz deine persönliche E-Mail-Adresse an (keine allgemeine Adresse wie info@).": "Indica il tuo indirizzo e-mail personale per la corrispondenza (non un indirizzo generale come info@).",
        "Selbstnutzung": "Uso personale",
        "Als Geschenk": "Come regalo",
        "Teilnahmebestätigung versendet am {date}": "Conferma di partecipazione inviata il {date}",
        "Abschlussquiz bestanden am {date}": "Quiz finale superato il {date}",
        "Abschlussquiz zuletzt nicht bestanden am {date}": "Quiz finale fallito l'ultima volta il {date}",
        "Abschlussquiz noch offen": "Quiz finale ancora aperto",
        "Abschlussquiz im letzten eLearning bestanden am {date}": "Quiz finale dell'ultimo eLearning superato il {date}",
        "Abschlussquiz im letzten eLearning zuletzt nicht bestanden am {date}": "Il quiz finale dell'ultimo corso di eLearning non è stato superato il giorno {date}.",
        "Deaktivierte Gutscheine können nicht bearbeitet werden.": "I buoni disattivati non possono essere modificati.",
        "Die E-Mail-Adresse ist bereits in diesem Login-Bereich vorhanden.": "L'indirizzo e-mail è già presente in quest'area di accesso.",
        "Referenzierte Entität kann nicht gefunden werden.": "Impossibile trovare l'entità referenziata.",
        "Die Bestellung wurde archiviert.": "L'ordine è stato archiviato.",
        "Die Bestellung wurde wiederhergestellt.": "L'ordine è stato ripristinato.",
        "Abschlussquiz im letzten eLearning noch offen": "Quiz finale nell'ultimo eLearning ancora aperto",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung für die folgenden Personen nicht generiert werden:": "Alcuni partecipanti che hanno frequentato il corso non hanno ancora completato l'eLearning. Pertanto non è possibile generare la conferma per le seguenti persone:",
        "Einige Teilnehmer:innen, die den Kurs besucht haben, haben das eLearning noch nicht abgeschlossen. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Alcuni partecipanti che hanno frequentato il corso non hanno ancora completato l'eLearning. Pertanto non è possibile inviare per e-mail la conferma alle seguenti persone:",
        "Für einige Teilnehmer:innen, liegt keine E-Mail-Adresse vor. Daher kann die Bestätigung an die folgenden Personen nicht per Mail zugestellt werden:": "Per alcuni partecipanti non è presente alcun indirizzo e-mail. Pertanto non è possibile inviare per e-mail la conferma alle seguenti persone:",
        "Kurszusammenfassung": "Riepilogo del corso",
        "Lädt...": "Caricamento...",
        "nicht ausgewählt": "non selezionato",
        "Ja": "Sì",
        "Nein": "No",
        "Versendet": "Inviato",
        "Tage vor Kursbeginn": "Giorni prima dell'inizio del corso",
        "Tage": "Giorni",
        "bei bestandenem eLearning-Abschlussquiz": "in caso di superamento del quiz finale eLearning",
        "Beim Kurs Abschluss an Teilnehmer mit Status «teilgenommen» und hinterlegter E-Mail-Adresse.": "Al termine del corso, ai partecipanti con stato «partecipato» e un indirizzo e-mail registrato.",
        "Im eLearning öffnen": "Apri nell'eLearning",
        "Schliessen": "Chiudi",
        "Fehler beim Laden der Zusammenfassung": "Errore durante il caricamento del riepilogo",
        "Rechnung in bexio öffnen": "Apri fattura in bexio",
        "{attribute} is keine gültige Sprache.": "{attribute} non è un linguaggio valido.",
        "Feedbacks": "Feedback",
        "E-Learning / Online": "E-Learning / Online",
        "Zeitraum": "Periodo",
        "Als Excel herunterladen": "Scarica come Excel",
        "Bewertung": "Valutazione",
        "Antworten": "Risposte",
        "Teilnehmer:in": "Partecipante",
        "Keine Feedbacks für diese Freigabe.": "Nessun feedback per questa abilitazione.",
        "Der Kursstatus wurde aktualisiert.": "Lo stato del corso è stato aggiornato.",
        "Der Status von {count} Kurs wurde aktualisiert.|Der Status von {count} Kursen wurde aktualisiert.": "Lo stato di {count} corso è stato aggiornato.|Lo stato di {count} corsi è stato aggiornato.",
        "Mindestens einer der ausgewählten Kurse wurde nicht gefunden.": "Almeno uno dei corsi selezionati non è stato trovato.",
        "Statuswechsel ist nur möglich, wenn alle ausgewählten Kurse denselben Status haben.": "Il cambio di stato è possibile solo se tutti i corsi selezionati hanno lo stesso stato.",
        "\"{course}\": {message}": "\"{course}\": {message}",
        "{count} Kurs ausgewählt|{count} Kurse ausgewählt": "{count} corso selezionato|{count} corsi selezionati",
        "Statuswechsel nicht möglich, da die ausgewählten Kurse unterschiedliche Status haben.": "Cambio di stato non possibile perché i corsi selezionati hanno stati diversi.",
        "Auswahlmodus beenden": "Esci dalla modalità di selezione",
        "Auswahlmodus": "Modalità di selezione",
        "Möchtest du den Status von {count} Kurs wirklich ändern?|Möchtest du den Status von {count} Kursen wirklich ändern?": "Vuoi davvero modificare lo stato di {count} corso?|Vuoi davvero modificare lo stato di {count} corsi?",
        "Alle Kurse in dieser Liste auswählen": "Seleziona tutti i corsi in questo elenco",
        "Kurstyp wurde erfolgreich erstellt.": "Tipo di corso creato con successo.",
        "System-Kurstypen können nicht gelöscht werden.": "I tipi di corso di sistema non possono essere eliminati.",
        "Der Kurstyp kann nicht gelöscht werden, da er bereits verwendet wird.": "Il tipo di corso non può essere eliminato perché è già in uso.",
        "Kurstyp wurde erfolgreich gelöscht.": "Tipo di corso eliminato con successo.",
        "Der OAuth-Client wurde widerrufen.": "Il client OAuth è stato revocato.",
        "Anmeldungen sind für diesen Kurs nicht möglich (Status \"{status}\").": "Le iscrizioni non sono possibili per questo corso (stato \"{status}\").",
        "Der Kurs kann nicht von \"{from}\" auf \"{to}\" gesetzt werden.": "Il corso non può essere impostato da \"{from}\" a \"{to}\".",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange Systemprüfungen fehlschlagen: {checks}": "Il corso non può essere impostato su \"Pronto\" finché i controlli di sistema non vengono superati: {checks}",
        "Der Kurs kann nicht auf \"Bereit\" gesetzt werden, solange keine Termine definiert sind. E-Learning-Kurse sind hiervon ausgenommen.": "Il corso non può essere impostato su \"Pronto\" senza date definite. I corsi e-learning sono esclusi.",
        "Bestanden": "Superato",
        "Fehlgeschlagen": "Non superato",
        "Übersprungen": "Saltato",
        "Tippen zum Suchen": "Tocca per cercare",
        "Keine Einträge gefunden.": "Nessuna voce trovata.",
        "Keine Unternehmen gefunden.": "Nessuna azienda trovata.",
        "Keine Kunden gefunden.": "Nessun cliente trovato.",
        "Kunde suchen…": "Cerca cliente…",
        "Dieser Kurs hat fehlgeschlagene Systemprüfungen!": "Questo corso presenta controlli di sistema non superati!",
        "Kursstatus ändern": "Modificare stato del corso",
        "Angemeldet": "Iscritto",
        "Teilgenommen": "Partecipato",
        "Entschuldigt abwesend": "Assente giustificato",
        "Unentschuldigt abwesend": "Assente ingiustificato",
        "Produktgruppe ist aktiv": "Il gruppo di prodotti è attivo",
        "Produktgruppe ist nicht aktiv": "Il gruppo di prodotti non è attivo",
        "Kurstyp erstellen": "Creare tipo di corso",
        "Systemprüfungen": "Controlli di sistema",
        "Zuletzt geprüft": "Ultimo controllo",
        "Noch keine Prüfungen durchgeführt.": "Nessun controllo ancora effettuato.",
        "Wird geprüft...": "Controllo in corso...",
        "Jetzt prüfen": "Controlla ora",
        "Keine Prüfungsergebnisse vorhanden. Klicke auf \"Jetzt prüfen\" um die Systemprüfungen auszuführen.": "Nessun risultato di controllo disponibile. Clicca su \"Controlla ora\" per eseguire i controlli di sistema.",
        "abhängig": "dipendente",
        "Hinweis: Für den Versand der Anmeldebestätigung ist in jeder Zeile der Datei eine gültige E-Mail-Adresse erforderlich.": "Nota: per l'invio della conferma di iscrizione è necessario un indirizzo e-mail valido in ogni riga del file.",
        "Im Anhang findest du die von dir importierte Datei.": "In allegato trovi il file da te importato.",
        "Folgende Zeilen wurden aufgrund unklarer Zuordnung trotzdem importiert und am Kurs angemeldet.": "Le seguenti righe sono state comunque importate e iscritte al corso a causa di un'assegnazione poco chiara.",
        "Aargau": "Argovia",
        "Als Firma können Sie keine Lizenz einlösen.": "Come azienda non può riscattare una licenza.",
        "Als Firma können Sie keine Lizenz einlösen. Sie können nur Geschenklizenzen kaufen.": "Come azienda non può riscattare una licenza. Può solo acquistare licenze regalo.",
        "Amt": "Ufficio",
        "Anmeldungen sind für diesen Kurs derzeit nicht möglich.": "Le iscrizioni non sono attualmente possibili per questo corso.",
        "Appenzell Ausserrhoden": "Appenzello Esterno",
        "Appenzell Innerrhoden": "Appenzello Interno",
        "Auswahl als Excel exportieren": "Esporta selezione come Excel",
        "Basel-Landschaft": "Basilea Campagna",
        "Basel-Stadt": "Basilea Città",
        "Beim Einlösen des Geschenkcodes ist ein Fehler aufgetreten. Bitte versuche es später erneut.": "Si è verificato un errore durante il riscatto del codice regalo. Riprova più tardi.",
        "Bern": "Berna",
        "Bezahlstatus": "Stato di pagamento",
        "Bezahlt": "Pagato",
        "Bis": "Fino a",
        "Bitte geben Sie die Empfänger-Informationen für die Geschenklizenzen ein.": "Inserisca le informazioni del destinatario per le licenze regalo.",
        "Bitte melde dich an, um fortzufahren.": "Effettua l'accesso per continuare.",
        "Bitte wählen Sie aus, für wen die Lizenz(en) bestimmt sind.": "Selezioni per chi è destinata la/e licenza/e.",
        "Bitte wählen Sie eine Versandart aus.": "Selezioni un metodo di spedizione.",
        "Das Kapitel wurde gelöscht.": "Il capitolo è stato eliminato.",
        "Das Produkt für diesen Gutschein wurde nicht gefunden.": "Il prodotto per questo buono non è stato trovato.",
        "Das Profil wurde erfolgreich aktualisiert.": "Il profilo è stato aggiornato con successo.",
        "Das Themengebiet wurde aktualisieren.": "L'area tematica è stata aggiornata.",
        "Das Themengebiet wurde erstellt. 🎉": "L'area tematica è stata creata. 🎉",
        "Datei erfolgreich aktualisiert.": "File aggiornato con successo.",
        "Datei erfolgreich erstellt! 🎉": "File creato con successo! 🎉",
        "Datei wurde gelöscht.": "Il file è stato eliminato.",
        "Dein Zugang zum eLearning ist jetzt aktiviert. In deinem persönlichen Bereich <strong>my.sanio</strong> findest du alle Details und den direkten Kurszugang. Viel Erfolg beim Lernen! 🚑💡": "Il tuo accesso all'eLearning è ora attivato. Nella tua area personale <strong>my.sanio</strong> trovi tutti i dettagli e l'accesso diretto al corso. Buono studio! 🚑💡",
        "Deine Online Kurse": "I tuoi corsi online",
        "Deine Sanio ID": "Il tuo Sanio ID",
        "Der Kurs wurde aktualisieren.": "Il corso è stato aggiornato.",
        "Der Kurs wurde erstellt. 🎉": "Il corso è stato creato. 🎉",
        "Der Kurs wurde gelöscht.": "Il corso è stato eliminato.",
        "Der Nachname ist erforderlich.": "Il cognome è obbligatorio.",
        "Der Ort ist erforderlich.": "La località è obbligatoria.",
        "Der Teilnehmer wurde vom Kurs entfernt!": "Il partecipante è stato rimosso dal corso!",
        "Der Vorname ist erforderlich.": "Il nome è obbligatorio.",
        "Die Anmeldefrist ist leider abgelaufen.": "Il termine di iscrizione è purtroppo scaduto.",
        "Die Handynummer ist optional. Wenn Sie diese angeben, können Sie sich später auch per per SMS einloggen.": "Il numero di cellulare è facoltativo. Se lo indica, potrà in seguito effettuare il login anche via SMS.",
        "Die Karte wurde gelöscht.": "La carta è stata eliminata.",
        "Die PLZ ist erforderlich.": "Il CAP è obbligatorio.",
        "Die Story wurde dupliziert.": "La storia è stata duplicata.",
        "Die Story wurde gelöscht.": "La storia è stata eliminata.",
        "Die Strasse ist erforderlich.": "La via è obbligatoria.",
        "Die Übersetzungen werden nun exportiert.": "Le traduzioni vengono ora esportate.",
        "Die Übersetzungen werden nun importiert.": "Le traduzioni vengono ora importate.",
        "Dieser Code ist kein Rabattcode, sondern schaltet dein eLearning direkt frei. Du kannst ihn jetzt sofort im Einlöse-Bereich nutzen - ohne erneutes Login oder weitere Schritte.": "Questo codice non è un codice sconto, ma attiva direttamente il tuo eLearning. Puoi utilizzarlo subito nell'area di riscatto - senza nuovo login o ulteriori passaggi.",
        "Dieser Geschenkcode ist ungültig oder wurde bereits eingelöst.": "Questo codice regalo non è valido o è già stato riscattato.",
        "Dieser Geschenkcode wurde bereits eingelöst.": "Questo codice regalo è già stato riscattato.",
        "Digital & physisch per Post": "Digitale e fisico per posta",
        "Direktion": "Direzione",
        "Dokumente": "Documenti",
        "Du hast keine Berechtigung, diesen Teilnehmer zu sehen.": "Non hai l'autorizzazione per visualizzare questo partecipante.",
        "Du kannst die Gutscheine als PDF herunterladen oder den direkten Einlöse-Link kopieren. Der Code ist schon eingefügt – perfekt zum Versenden per WhatsApp, E-Mail oder SMS.": "Puoi scaricare i buoni come PDF o copiare il link diretto di riscatto. Il codice è già inserito – perfetto per l'invio tramite WhatsApp, e-mail o SMS.",
        "Du kannst diese:n Teilnehmer:in nicht mehr bearbeiten. Bitte wende dich an deine Ansprechperson bei Sanio.": "Non puoi più modificare questo/questa partecipante. Rivolgiti alla tua persona di contatto presso Sanio.",
        "E-Learning-Kurs suchen…": "Cerca corso eLearning…",
        "Empfänger ändern": "Modifica destinatario",
        "Filter zurücksetzen": "Reimposta filtri",
        "Filtern": "Filtra",
        "Freiburg": "Friburgo",
        "Funktion": "Funzione",
        "Geburtsdatum": "Data di nascita",
        "Geburtsdatum (TT.MM.JJJJ)": "Data di nascita (GG.MM.AAAA)",
        "Genf": "Ginevra",
        "Geschenklizenz einlösen": "Riscatta licenza regalo",
        "Glarus": "Glarona",
        "Graubünden": "Grigioni",
        "Gutschein gefunden!": "Buono trovato!",
        "Gutschein jetzt einlösen": "Riscatta il buono ora",
        "Gutscheine werden vorbereitet": "I buoni sono in preparazione",
        "Hier dein persönlicher Zugang, um dich im shop.sanio einzuloggen:": "Ecco il tuo accesso personale per effettuare il login su shop.sanio:",
        "Instruktor:in": "Istruttore/Istruttrice",
        "Jura": "Giura",
        "Kaufbeleg / Rechnung als PDF": "Ricevuta d'acquisto / Fattura come PDF",
        "Keine Feedbacks für die aktuellen Filter.": "Nessun feedback per i filtri attuali.",
        "Klasse": "Classe",
        "Klassenstufe": "Anno scolastico",
        "Kontext": "Contesto",
        "Kundenberater": "Consulente clienti",
        "Kundenportal Gruppenadmin": "Portale clienti Amministratore di gruppo",
        "Kundenportal Superadmin": "Superadmin portale clienti",
        "Kurs abgeschlossen, Prüfung ausstehend": "Corso completato, esame in sospeso",
        "Kurs suchen…": "Cerca corso…",
        "Kursfortschritt": "Avanzamento del corso",
        "Kurszugang nicht gefunden.": "Accesso al corso non trovato.",
        "Luzern": "Lucerna",
        "Mein Profil": "Il mio profilo",
        "Meine Bestellungen": "I miei ordini",
        "Melde dich mit deiner Handynummer oder E-Mail an und schon geht’s los!": "Accedi con il tuo numero di cellulare o e-mail e inizia subito!",
        "MidnightSports": "MidnightSports",
        "Mindestens ein Empfänger muss angegeben werden.": "Deve essere indicato almeno un destinatario.",
        "MiniMove": "MiniMove",
        "Name des Empfängers darf maximal 255 Zeichen lang sein.": "Il nome del destinatario può contenere al massimo 255 caratteri.",
        "Name des Empfängers ist erforderlich.": "Il nome del destinatario è obbligatorio.",
        "Name des Schenkers darf maximal 255 Zeichen lang sein.": "Il nome del donatore può contenere al massimo 255 caratteri.",
        "Name des Schenkers ist erforderlich.": "Il nome del donatore è obbligatorio.",
        "Neuenburg": "Neuchâtel",
        "Nicht Bezahlt": "Non pagato",
        "Nidwalden": "Nidvaldo",
        "Obwalden": "Obvaldo",
        "OpenSunday": "OpenSunday",
        "Prüfung bestanden": "Esame superato",
        "Sanio Kundenportal": "Portale clienti Sanio",
        "Schaffhausen": "Sciaffusa",
        "Schuleinheit": "Unità scolastica",
        "Schwyz": "Svitto",
        "Shop Kunde ID": "ID cliente shop",
        "Solothurn": "Soletta",
        "St. Gallen": "San Gallo",
        "Standort": "Sede",
        "Standort/Fachbereich": "Sede/Settore",
        "Store": "Store",
        "Super Admin": "Super Admin",
        "Teilnahmebestätigung als PDF": "Conferma di partecipazione come PDF",
        "Teilnehmer": "Partecipante",
        "Teilnehmer nicht gefunden.": "Partecipante non trovato.",
        "Teilnehmer:in konnte nicht hinzugefügt werden": "Il/la partecipante non ha potuto essere aggiunto/a",
        "Teilnehmer:in wurde erfolgreich angemeldet.": "Il/la partecipante è stato/a iscritto/a con successo.",
        "Teilnehmer:in wurde erfolgreich hinzugefügt": "Il/la partecipante è stato/a aggiunto/a con successo",
        "Tessin": "Ticino",
        "Thurgau": "Turgovia",
        "Ungültige Auswahl für Lizenzempfänger.": "Selezione non valida per il destinatario della licenza.",
        "Ungültige Versandart ausgewählt.": "Modalità di spedizione non valida selezionata.",
        "Uri": "Uri",
        "Von": "Da",
        "Waadt": "Vaud",
        "Wallis": "Vallese",
        "Zug": "Zugo",
        "Zyklus": "Ciclo",
        "Zürich": "Zurigo",
        "andere": "altro",
        "bearbeitungsbedürftig": "richiede elaborazione",
        "my.sanio Kunde": "Cliente my.sanio",
        "n/A": "n/d",
        "nicht übersetzt": "non tradotto",
        "🤔 Es sind keine Kurse geplant": "🤔 Non sono previsti corsi",
        "Archivierte Kurse": "Corsi archiviati",
        "Warteliste": "Lista d'attesa",
        "entschuldigt": "giustificato",
        "unentschuldigt": "ingiustificato",
        "{firstName} {lastName} war {reason} abwesend weil: {note}": "{firstName} {lastName} è stato assente {reason} perché: {note}",
        "Abgemeldet: Teilnahme abgelehnt": "Disiscritto: Partecipazione rifiutata",
        "Abgemeldet: Vorzeitig storniert": "Disiscritto: Annullato anticipatamente",
        "Abgemeldet: Entschuldigt": "Disiscritto: Giustificato",
        "Abgemeldet: Unentschuldigt": "Disiscritto: Non giustificato",
        "errors.503.status_prefix": "Stato attuale del sistema:",
        "Kursort": "Luogo del corso",
        "Kursleitung": "Istruttore",
        "Kurssprache:": "Lingua del corso:",
        "Kurs-ID:": "ID corso:",
        "Neu": "Nuovo",
        "Die Kursinformationen wurden versendet.": "Le informazioni sul corso sono state inviate.",
        "Änderungen zu deinem Kurs": "Modifiche al tuo corso",
        "Kurszuteilung": "Assegnazione del corso",
        "Du wurdest von einem Kurs entfernt": "Sei stato rimosso da un corso",
        "Der Kurs muss bereit sein.": "Il corso deve essere pronto.",
        "Diese Person ist keine Kursleitung.": "Questa persona non è un istruttore del corso.",
        "Diese Kursleitung ist keinem Termin dieses Kurses zugeteilt.": "Questo istruttore non è assegnato a nessuna data di questo corso.",
        "Der Kurs ist bereits vorbei und kann nicht auf \"Bereit\" gesetzt werden. Der Kurs würde innert wenigen Augenblicken auf \"Durchgeführt\" gestellt werden.": "Il corso è già terminato e non può essere impostato su \"Pronto\". Il corso verrebbe impostato su \"Svolto\" entro pochi istanti.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange Anwesenheiten fehlen.": "Il corso non può essere impostato su \"Completato\" finché mancano presenze.",
        "Der Kurs kann nicht auf \"Abgeschlossen\" gesetzt werden, solange anwesende Teilnehmende das E-Learning nicht bestanden haben.": "Il corso non può essere impostato su \"Completato\" finché i partecipanti presenti non hanno superato l'e-learning.",
        "Kurstyp": "Tipo di corso",
        "Datum/Zeit": "Data/Ora",
        "Kontaktperson": "Persona di contatto",
        "Kontaktaufnahme": "Contatto",
        "Infos zu Kontaktaufnahme": "Informazioni per il contatto",
        "Beschreibung Kursleitung": "Descrizione istruttore",
        "Präsentation": "Presentazione",
        "Präsentieren": "Presenta",
        "Kurspräsentation": "Presentazione del corso",
        "Weitere Links": "Altri link",
        "Auswahl entfernen: {option}": "Rimuovi selezione: {option}",
        "Keine Optionen gefunden": "Nessuna opzione trovata",
        "Abgelehnt am": "Rifiutato il",
        "Bestätigt am": "Confermato il",
        "Mail versendet, Bestätigung offen": "Mail inviata, conferma in sospeso",
        "Modus": "Modalità",
        "Typ & Dauer": "Tipo e durata",
        "Belegung": "Occupazione",
        "Materialset": "Set di materiali",
        "Fehlende Kursleitung": "Istruttore mancante",
        "Initialer Mailversand offen": "Invio iniziale mail in sospeso",
        "Nicht versendete Kursleitungs-Infos vorhanden": "Informazioni istruttore non inviate presenti",
        "Kontaktperson für Kursleitung": "Persona di contatto per l'istruttore",
        "Infos offen": "Informazioni in sospeso",
        "Infos veraltet": "Informazioni obsolete",
        "Kursleitungs-Infos senden": "Invia informazioni istruttore",
        "Diese Kursleitung hat die initialen Kursinformationen noch nicht erhalten.": "Questo istruttore non ha ancora ricevuto le informazioni iniziali del corso.",
        "Diese Kursleitung hat noch nicht alle aktuellen Kursinformationen erhalten.": "Questo istruttore non ha ancora ricevuto tutte le informazioni aggiornate del corso.",
        "Zu versendende Änderungen": "Modifiche da inviare",
        "Alt": "Vecchio",
        "Senden": "Invia",
        "Automatischer Versand bei Abschluss ist in den E-Mail-Einstellungen deaktiviert.": "L'invio automatico al completamento è disattivato nelle impostazioni e-mail.",
        "Abwesend": "Assente",
        "Abwesenheit erfassen": "Registra assenza",
        "Wie war {name} abwesend?": "In che modo {name} era assente?",
        "Notiz (optional)": "Nota (opzionale)",
        "Grund der Abwesenheit": "Motivo dell'assenza",
        "Wird eine Notiz erfasst, wird automatisch ein Kommentar zum Kurs hinzugefügt.": "Se viene inserita una nota, verrà automaticamente aggiunto un commento al corso.",
        "Abschliessen": "Completa",
        "Es gab Änderungen zu deinem zugeteilten Kurs:": "Ci sono state modifiche al corso a te assegnato:",
        "Folgende Informationen wurden aktualisiert:": "Le seguenti informazioni sono state aggiornate:",
        "Bitte prüfe die aktuellen Kursdetails und bestätige uns, dass du den Kurs weiterhin leiten kannst.": "Verifica i dettagli aggiornati del corso e confermaci che puoi continuare a tenere il corso.",
        "Kursinfos prüfen und bestätigen": "Verifica e conferma le informazioni del corso",
        "Kurszuteilung bestätigen": "Conferma l'assegnazione del corso",
        "Du wurdest von folgendem Kurs entfernt.": "Sei stato rimosso dal seguente corso.",
        "Die Absage für deinen Kalender findest du im Anhang. Weitere Informationen zum Kurs findest du": "La cancellazione per il tuo calendario si trova in allegato. Ulteriori informazioni sul corso le trovi",
        "Du wurdest folgendem Kurs zugeteilt 🎉": "Sei stato assegnato al seguente corso 🎉",
        "Bitte 30 Minuten vor Kursstart am Kursort eintreffen. Prüfe die Kursinformationen und bestätige uns, dass du den Kurs leiten kannst.": "Si prega di presentarsi sul luogo del corso 30 minuti prima dell'inizio. Verifica le informazioni del corso e confermaci che puoi condurre il corso.",
        "Die Kalenderdatei findest du im Anhang.": "Il file del calendario si trova in allegato.",
        "Termin {n}": "Slot {n}",
        "Termin {n} entfernen": "Rimuovi slot {n}",
        "eine Kursleiter:in": "un/una istruttore/istruttrice",
        "{count} Kursleiter:innen": "{count} istruttori/istruttrici",
        "eine Springer:in": "un/una riserva",
        "{count} Springer:innen": "{count} riserve",
        "{count} ohne Materialset": "{count} senza set di materiale",
        "Zeit und Personal festlegen": "Imposta orario e personale",
        "Materialset fehlt": "Set di materiale mancante",
        "Pro Termin Kursleiter:innen und optional Springer festlegen. Materialset und Abholhinweis werden pro Kursleiter:in zugewiesen.": "Assegna istruttori e, se necessario, riserve per ogni slot. Set di materiale e nota di ritiro sono definiti per istruttore.",
        "Noch keine Termine": "Nessuno slot ancora",
        "Füge den ersten Kurstermin hinzu.": "Aggiungi il primo slot del corso.",
        "Termin hinzufügen": "Aggiungi slot",
        "Kursleiter:innen": "Istruttori/istruttrici",
        "Noch keine Kursleiter:in zugewiesen.": "Nessun istruttore assegnato.",
        "Abholhinweis": "Nota di ritiro",
        "Aktionen": "Azioni",
        "fehlt": "mancante",
        "Kursleiter:in bearbeiten": "Modifica istruttore/istruttrice",
        "Kursleiter:in entfernen": "Rimuovi istruttore/istruttrice",
        "Als Kursleiter:in übernehmen": "Promuovi a istruttore/istruttrice",
        "Kursleiter:in zuweisen": "Assegna istruttore/istruttrice",
        "Kursleiter:in": "Istruttore/istruttrice",
        "Kursleiter:in auswählen": "Seleziona istruttore/istruttrice",
        "Materialset auswählen": "Seleziona set di materiale",
        "optional": "opzionale",
        "z. B. Lager West, Schlüssel bei Empfang": "es. Magazzino Ovest, chiave alla reception",
        "Zuweisen": "Assegna",
        "Bitte eine Kursleiter:in auswählen.": "Seleziona un istruttore/un'istruttrice.",
        "Springer": "Sostituto",
        "Springereinsatz": "Impiego come sostituto",
        "Änderungen zu deinem Springereinsatz": "Modifiche al tuo impiego come sostituto",
        "Springer auswählen": "Seleziona sostituto",
        "Springer-Infos senden": "Invia informazioni sostituto",
        "Springer bestätigt": "Sostituto confermato",
        "Springer noch nicht bestätigt": "Sostituto non ancora confermato",
        "Vielen Dank, dass du dich als Springer:in für diesen Kurs zur Verfügung stellst! 🙌": "Grazie mille per renderti disponibile come sostituto/a per questo corso! 🙌",
        "Falls die regulär eingeteilte Kursleitung kurzfristig ausfällt, würden wir dich gerne einsetzen.": "Nel caso in cui il docente regolarmente assegnato dovesse mancare all'ultimo momento, vorremmo impiegarti.",
        "Aktuell musst du nichts unternehmen.": "Al momento non devi intraprendere nulla.",
        "Bitte halte dir den Termin frei und stelle sicher, dass du kurzfristig erreichbar bist. Sollte ein Einsatz nötig werden, melden wir uns so früh wie möglich bei dir.": "Ti preghiamo di tenerti libero/a per la data e di assicurarti di essere raggiungibile a breve termine. Se fosse necessario un impiego, ti contatteremo il prima possibile.",
        "Weitere Informationen zum Kurs findest du": "Ulteriori informazioni sul corso le trovi",
        "Bitte beachte die aktualisierten Kursinformationen.": "Ti preghiamo di prendere nota delle informazioni aggiornate sul corso.",
        "Diese Person hat die initialen Kursinformationen noch nicht erhalten.": "Questa persona non ha ancora ricevuto le informazioni iniziali sul corso.",
        "Diese Person hat noch nicht alle aktuellen Kursinformationen erhalten.": "Questa persona non ha ancora ricevuto tutte le informazioni aggiornate sul corso.",
        "Bitte Kurszuteilung bestätigen": "Conferma l'assegnazione del corso",
        "Springer:in auswählen": "Seleziona sostituto/a",
        "Springer:in bearbeiten": "Modifica sostituto/a",
        "Springer:in zuweisen": "Assegna sostituto/a",
        "Entwurf": "Bozza",
        "Angefragt": "Richiesto",
        "Zuteilung bestätigt": "Assegnazione confermata",
        "Zuteilung abgelehnt": "Assegnazione rifiutata",
        "Zuteilung bestätigen": "Conferma assegnazione",
        "Zuteilung ablehnen": "Rifiuta assegnazione",
        "Du hast diese Kurszuteilung abgelehnt.": "Hai rifiutato questa assegnazione al corso.",
        "Speichern & weitere Person hinzufügen": "Salva e aggiungi un'altra persona",
        "Alle {count} Teilnehmer:innen anzeigen": "Mostra tutti i {count} partecipanti",
        "{shown} von {total}": "{shown} di {total}",
        "Weitere Treffer werden geladen…": "Caricamento degli altri risultati…",
        "Nachfassen": "Integrazione",
        "Möchtest du den Kurs zum Nachfassen öffnen? Der Kurs bleibt geschlossen.": "Vuoi aprire il corso per un’integrazione? Il corso rimane chiuso.",
        "Aktuell können nur Teilnehmende hinzugefügt oder entfernt werden. Andere Kursdetails können nicht bearbeitet werden.": "Attualmente è possibile solo aggiungere o rimuovere partecipanti. Non è possibile modificare altri dettagli del corso.",
        "Aktuell können Teilnehmende hinzugefügt oder entfernt und Anwesenheiten bearbeitet werden. Andere Kursdetails können nicht bearbeitet werden.": "Attualmente è possibile aggiungere o rimuovere partecipanti e modificare le presenze. Non è possibile modificare altri dettagli del corso.",
        "Folien am Griff ziehen, um ihre Reihenfolge zu ändern.": "Trascina le diapositive dalla maniglia per modificarne l’ordine.",
        "{count} Folien ausgewählt": "{count} diapositive selezionate",
        "Alle {count} Folien auswählen": "Seleziona tutte le {count} diapositive",
        "Alle Folien sind ausgewählt": "Tutte le diapositive sono selezionate",
        "Auswahl aufheben": "Cancella selezione",
        "Folie verschieben": "Sposta diapositiva",
        "Folie auswählen": "Seleziona diapositiva",
        "Folie {position} auswählen": "Seleziona diapositiva {position}",
        "Kursleiter:innen-Notiz vorhanden": "Nota per la presentazione disponibile",
        "Keine Notizen": "Nessuna nota",
        "Folien löschen": "Elimina diapositive",
        "Möchtest du die {count} ausgewählten Folien wirklich löschen?": "Vuoi davvero eliminare le {count} diapositive selezionate?",
        "Folienbibliothek": "Libreria di diapositive",
        "Folien, Sprachversionen und Tags verwalten": "Gestisci diapositive, versioni linguistiche e tag",
        "Foliensatz importieren": "Importa set di diapositive",
        "Noch keine Folien importiert.": "Nessuna diapositiva importata.",
        "Importiere einen Foliensatz, um deine Folienbibliothek aufzubauen.": "Importa un set di diapositive per creare la tua libreria.",
        "Folien werden importiert…": "Le diapositive sono in fase di importazione…",
        "Folienbibliothek-Einstellungen": "Impostazioni della libreria di diapositive",
        "Kurspräsentation aus Folienbibliothek": "Presentazione del corso dalla libreria",
        "Der Foliensatz wird importiert.": "Il set di diapositive è in fase di importazione.",
        "Der Upload ist fehlgeschlagen.": "Il caricamento non è riuscito.",
        "Der Upload ist unvollständig. Bitte erneut versuchen.": "Il caricamento è incompleto. Riprova.",
        "Die Datei muss eine PDF-Datei sein.": "Il file deve essere un PDF.",
        "Einzelne Folien müssen genau eine PDF-Seite enthalten.": "Le singole diapositive devono contenere esattamente una pagina PDF.",
        "Diese PDF-Datei kann nicht gelesen werden. Exportiere sie bitte erneut als PDF 1.4.": "Questo file PDF non può essere letto. Esportalo di nuovo come PDF 1.4.",
        "Folientitel": "Titolo della diapositiva",
        "Foliensätze": "Set di diapositive",
        "Folienbibliotheken nach Kurstyp verwalten": "Gestisci le librerie di diapositive per tipo di corso",
        "Foliensatz hinzufügen": "Aggiungi set di diapositive",
        "Noch keine Foliensätze vorhanden.": "Nessun set di diapositive disponibile.",
        "Foliensatz: Folien, Sprachversionen und Tags verwalten": "Set di diapositive: gestisci diapositive, lingue e tag",
        "Alle Foliensätze": "Tutti i set di diapositive",
        "Foliensatz": "Set di diapositive",
        "Verwendung": "Utilizzo",
        "Kurse, die Folien aus diesem Foliensatz verwenden": "Corsi che usano diapositive di questo set",
        "Dieser Foliensatz wird in keinem Kurs verwendet.": "Questo set di diapositive non è usato in nessun corso.",
        "Für diesen Kurstyp ist noch kein Foliensatz vorhanden.": "Non esiste ancora un set di diapositive per questo tipo di corso.",
        "Foliensatz erstellen": "Crea set di diapositive",
        "Der Foliensatz wurde erstellt.": "Il set di diapositive è stato creato.",
        "Mindestens eine Folie gehört nicht zu diesem Foliensatz.": "Almeno una diapositiva non appartiene a questo set.",
        "Mindestens eine Folie gehört nicht zu dieser Präsentation.": "Almeno una diapositiva non appartiene a questa presentazione.",
        "Mindestens ein Tag gehört nicht zum Foliensatz dieses Kurstyps.": "Almeno un tag non appartiene al set di diapositive di questo tipo di corso.",
        "Folienpakete": "Pacchetti di diapositive",
        "Folienpaket": "Pacchetto di diapositive",
        "Folienpakete für Kurstypen verwalten": "Gestisci i pacchetti di diapositive per tipo di corso",
        "Folienpaket hinzufügen": "Aggiungi pacchetto di diapositive",
        "Noch keine Folienpakete vorhanden.": "Nessun pacchetto di diapositive disponibile.",
        "Alle Folienpakete": "Tutti i pacchetti di diapositive",
        "Das Folienpaket wurde erstellt.": "Il pacchetto di diapositive è stato creato.",
        "Das Folienpaket wurde gelöscht.": "Il pacchetto di diapositive è stato eliminato.",
        "Ohne Tag-Auswahl werden alle Folien einbezogen.": "Senza selezione di tag, vengono incluse tutte le diapositive.",
        "Dieses Folienpaket enthält noch keine Folien.": "Questo pacchetto di diapositive non contiene ancora diapositive.",
        "Keine Folien passen zu den gewählten Tags.": "Nessuna diapositiva corrisponde ai tag selezionati.",
        "Optional Tags und Sprachen auswählen. Ohne Tags werden alle Folien einbezogen. Die erzeugten PDFs sind unabhängige Kopien.": "Seleziona eventualmente tag e lingue. Senza tag vengono incluse tutte le diapositive. I PDF generati sono copie indipendenti.",
        "Präsentation bearbeiten": "Modifica presentazione",
        "Folienpaket löschen": "Elimina pacchetto di diapositive",
        "Möchtest du das Folienpaket «{name}» wirklich löschen? Die Folien werden entfernt. Bereits erstellte Kurspräsentationen bleiben erhalten.": "Vuoi davvero eliminare il pacchetto di diapositive «{name}»? Le diapositive verranno rimosse. Le presentazioni del corso già create restano disponibili.",
        "Foliensatz umbenennen": "Rinomina set di diapositive",
        "Der Foliensatz wurde umbenannt.": "Il set di diapositive è stato rinominato.",
        "Für diesen Kurstyp ist noch kein Folienpaket vorhanden.": "Non esiste ancora un pacchetto di diapositive per questo tipo di corso.",
        "Folienpaket erstellen": "Crea pacchetto di diapositive",
        "Folienpaket wählen": "Scegli un pacchetto di diapositive",
        "Name und Datum einfügen": "Inserisci nome e data",
        "Name auf der Folie": "Nome sulla diapositiva",
        "Kurspräsentation entfernen": "Rimuovi la presentazione del corso",
        "Kurspräsentation wirklich entfernen?": "Rimuovere davvero la presentazione del corso?",
        "Die Kurspräsentation wurde entfernt.": "La presentazione del corso è stata rimossa.",
        "Das Folienpaket gehört nicht zum Kurstyp dieses Kurses.": "Il pacchetto di diapositive non appartiene al tipo di questo corso.",
        "Mindestens ein Tag gehört nicht zum gewählten Folienpaket.": "Almeno un tag non appartiene al pacchetto di diapositive selezionato.",
        "Tags suchen oder neu erstellen…": "Cerca o crea tag…",
        "„{name}“ erstellen": "Crea «{name}»",
        "{name} entfernen": "Rimuovi {name}",
        "Tag konnte nicht erstellt werden.": "Non è stato possibile creare il tag.",
        "Tag bearbeiten": "Modifica tag",
        "Farbe": "Colore",
        "Tag wurde aktualisiert.": "Il tag è stato aggiornato.",
        "Deutsch (Fallback)": "Tedesco (fallback)",
        "Deutsch bestimmt die Anzahl Folien. Weitere Sprachen werden ab Seite 1 zugeordnet und dürfen weniger Seiten enthalten.": "Il tedesco determina il numero di diapositive. Le altre lingue vengono associate dalla pagina 1 e possono contenere meno pagine.",
        "PDF, maximal 350 MB pro Sprache. Der Import wird im Hintergrund verarbeitet.": "PDF, massimo 350 MB per lingua. L’importazione viene elaborata in background.",
        "Ersetzen": "Sostituisci",
        "Tags bearbeiten": "Modifica tag",
        "Zum Bearbeiten klicken": "Fai clic per modificare",
        "Zurück zum Foliensatz": "Torna al set di diapositive",
        "Vorhanden": "Disponibile",
        "Fehlt": "Mancante",
        "PDF ersetzen": "Sostituisci PDF",
        "PDF hinzufügen": "Aggiungi PDF",
        "Tags suchen…": "Cerca tag…",
        "{selected} von {total} passenden Folien ausgewählt": "{selected} diapositive selezionate su {total}",
        "Alle passenden Folien auswählen": "Seleziona tutte le diapositive corrispondenti",
        "Tags auswählen": "Seleziona i tag",
        "Sprachen erzeugen": "Genera le lingue",
        "{available}/{total} Folie verfügbar|{available}/{total} Folien verfügbar": "{available}/{total} diapositiva disponibile|{available}/{total} diapositive disponibili",
        "Nicht alle gewählten Folien sind in jeder Sprache vorhanden.": "Non tutte le diapositive selezionate sono disponibili in ogni lingua.",
        "{count} fehlend|{count} fehlend": "{count} mancante|{count} mancanti",
        "Wird erstellt…": "Creazione in corso…",
        "Kurspräsentation erstellen": "Crea la presentazione del corso",
        "Jetzt zu Presio senden": "Invia ora a Presio",
        "Folie": "Diapositiva",
        "Fehlende Übersetzungen": "Traduzioni mancanti",
        "Fehlende Folien überspringen": "Ignora le diapositive mancanti",
        "Deutsche Folie verwenden": "Usa la diapositiva tedesca",
        "Folienvorschau": "Anteprima delle diapositive",
        "{count} Folie wird für diese Sprache erzeugt.|{count} Folien werden für diese Sprache erzeugt.": "Verrà generata {count} diapositiva per questa lingua.|Verranno generate {count} diapositive per questa lingua.",
        "Wähle Tags aus, um die passenden Folien zu sehen.": "Seleziona i tag per visualizzare le diapositive corrispondenti.",
        "Alle passenden Folien wurden entfernt.": "Tutte le diapositive corrispondenti sono state rimosse.",
        "Folie entfernen": "Rimuovi diapositiva",
        "Wird in dieser Sprache übersprungen": "Ignorata in questa lingua",
        "Deutsch als Fallback": "Tedesco come fallback",
        "Erstellt": "Creata",
        "{processed} von {total} Folie|{processed} von {total} Folien": "{processed} di {total} diapositiva|{processed} di {total} diapositive",
        "Die Folien werden zusammengeführt.": "Le diapositive vengono unite.",
        "Präsentation wird erstellt": "La presentazione è in fase di creazione",
        "Du kannst diese Seite verlassen, die Erstellung läuft im Hintergrund weiter.": "Puoi lasciare questa pagina, la creazione continua in background.",
        "Präsentation erstellt": "Presentazione creata",
        "Die PDFs stehen zum Herunterladen bereit.": "I PDF sono pronti per il download.",
        "Erstellung abgebrochen": "Creazione annullata",
        "Erstellung fehlgeschlagen": "Creazione non riuscita",
        "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.": "Si è verificato un errore. Riprova.",
        "Zuletzt erstellte Version": "Ultima versione creata",
        "Die Erstellung wurde abgebrochen.": "La creazione è stata annullata.",
        "Mindestens eine ausgewählte Folie gehört nicht zur aktuellen Tag-Auswahl.": "Almeno una diapositiva selezionata non appartiene alla selezione di tag corrente.",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Präsentieren würde eine veraltete Version zeigen.": "La presentazione attuale non è ancora stata inviata a Presio. Presentare mostrerebbe una versione obsoleta.",
        "FEHLT": "MANCA",
        "Die aktuelle Kurspräsentation ist noch nicht in Presio. Bitte bei Admin melden.": "La presentazione attuale non è ancora in Presio. Segnalalo all'amministrazione.",
        "Der Versand an Presio ist fehlgeschlagen.": "L'invio a Presio non è riuscito.",
        "Die Präsentation wird gerade an Presio gesendet. Bitte versuche es in einem Moment erneut.": "La presentazione è in fase di invio a Presio. Riprova tra un momento.",
        "Die Kurspräsentation konnte nicht erstellt werden.": "Non è stato possibile creare la presentazione del corso.",
        "Die Kurspräsentation konnte nicht an Presio gesendet werden.": "Non è stato possibile inviare la presentazione del corso a Presio.",
        "Die Kurspräsentation für {course} konnte nicht erstellt werden.": "Non è stato possibile creare la presentazione del corso {course}.",
        "Die Kurspräsentation für {course} ({language}) konnte nicht an Presio gesendet werden.": "Non è stato possibile inviare la presentazione del corso {course} ({language}) a Presio.",
        "Kurs öffnen": "Apri il corso",
        "PDF herunterladen": "Scarica il PDF",
        "Kursleiter:innen-Notiz bearbeiten": "Modifica la nota di presentazione",
        "Diese Notiz wird der Kursleitung beim Präsentieren in Presio angezeigt.": "Questa nota viene mostrata alla persona docente durante la presentazione in Presio.",
        "Notiz aus Folienbibliothek verwenden": "Usa la nota dalla libreria delle diapositive",
        "Kursspezifisch": "Specifico del corso",
        "Mindestens eine Notiz gehört nicht zu den ausgewählten Folien.": "Almeno una nota non appartiene alle diapositive selezionate.",
        "Die Präsentation konnte nicht gestartet werden. Bitte versuche es in einem Moment erneut.": "Non è stato possibile avviare la presentazione. Riprova tra un istante.",
        "Die Präsentation wird an Presio gesendet.": "La presentazione è in fase di invio a Presio.",
        "Wird an Presio gesendet…": "Invio a Presio…",
        "deine Zeit": "la tua ora",
        "Nicht gesetzt": "Non impostata",
        "Dieses Produkt kann nicht bestellt werden.": "Questo prodotto non può essere ordinato.",
        "Dein Warenkorb ist leer.": "Il tuo carrello è vuoto.",
        "Dein Warenkorb enthält Produkte, die nicht mehr bestellt werden können. Bitte entferne sie.": "Il tuo carrello contiene prodotti che non possono più essere ordinati. Rimuovili.",
        "Der Status kann nicht von «{from}» auf «{to}» geändert werden.": "Lo stato non può essere cambiato da «{from}» a «{to}».",
        "Stück": "pezzi",
        "Abholung im Büro": "Ritiro in ufficio",
        "Versand": "Spedizione",
        "Verpackt": "Imballato",
        "Erledigt": "Evaso",
        "Das Produkt wurde bereits bestellt und kann nicht gelöscht werden. Deaktiviere es stattdessen.": "Il prodotto è già stato ordinato e non può essere eliminato. Disattivalo invece.",
        "Die Kategorie enthält noch Produkte und kann nicht gelöscht werden.": "La categoria contiene ancora prodotti e non può essere eliminata.",
        "Die Kategorie wurde erstellt.": "La categoria è stata creata.",
        "Die Kategorie wurde aktualisiert.": "La categoria è stata aggiornata.",
        "Die Kategorie wurde gelöscht.": "La categoria è stata eliminata.",
        "Der Status wurde auf «{status}» geändert.": "Lo stato è stato cambiato in «{status}».",
        "Das Produkt wurde erstellt.": "Il prodotto è stato creato.",
        "Das Produkt wurde aktualisiert.": "Il prodotto è stato aggiornato.",
        "Das Produkt wurde gelöscht.": "Il prodotto è stato eliminato.",
        "Das Produkt wurde in den Warenkorb gelegt.": "Il prodotto è stato aggiunto al carrello.",
        "Der Warenkorb wurde aktualisiert.": "Il carrello è stato aggiornato.",
        "Das Produkt wurde aus dem Warenkorb entfernt.": "Il prodotto è stato rimosso dal carrello.",
        "Vielen Dank! Deine Bestellung ist eingegangen.": "Grazie! Il tuo ordine è stato ricevuto.",
        "Warenkorb": "Carrello",
        "Shop": "Shop",
        "Weiter einkaufen": "Continua gli acquisti",
        "Material auswählen": "Scegli il materiale",
        "Dieses Produkt kann nicht mehr bestellt werden.": "Questo prodotto non può più essere ordinato.",
        "Entfernen": "Rimuovi",
        "Zur Bestellung": "Procedi all'ordine",
        "Bestellung abschliessen": "Completa l'ordine",
        "Zurück zum Warenkorb": "Torna al carrello",
        "Lieferung": "Consegna",
        "Details": "Dettagli",
        "Benötigt bis": "Necessario entro il",
        "Bemerkung": "Osservazione",
        "Deine Bestellung": "Il tuo ordine",
        "Bestellung absenden": "Invia l'ordine",
        "Material bestellen": "Ordina materiale",
        "Wähle das Kursmaterial aus, das du für deine Kurse benötigst.": "Scegli il materiale di cui hai bisogno per i tuoi corsi.",
        "Aktuell kann kein Material bestellt werden.": "Al momento non è possibile ordinare materiale.",
        "In den Warenkorb": "Aggiungi al carrello",
        "{quantity} im Warenkorb": "{quantity} nel carrello",
        "Menge verringern": "Diminuisci la quantità",
        "Menge erhöhen": "Aumenta la quantità",
        "Entferne die nicht mehr bestellbaren Artikel, um fortzufahren.": "Rimuovi gli articoli che non possono più essere ordinati per continuare.",
        "Storniert": "Annullato",
        "Storniert am": "Annullato il",
        "Stornieren": "Annulla",
        "Bestellung stornieren": "Annulla l'ordine",
        "Möchtest du diese Bestellung wirklich stornieren?": "Vuoi davvero annullare questo ordine?",
        "Deine Bestellung wurde storniert.": "Il tuo ordine è stato annullato.",
        "Diese Bestellung wurde am {date} storniert.": "Questo ordine è stato annullato il {date}.",
        "Diese Bestellung wird bereits bearbeitet und kann nicht mehr direkt storniert werden.": "Questo ordine è già in lavorazione e non può più essere annullato direttamente.",
        "Begründung": "Motivazione",
        "Stornierungsanfrage": "Richiesta di annullamento",
        "Stornierungsanfragen": "Richieste di annullamento",
        "Stornierungsanfrage senden": "Invia richiesta di annullamento",
        "Stornierungsanfrage vom {date}": "Richiesta di annullamento del {date}",
        "Stornierungsanfrage gesendet am {date}. Wir melden uns bei dir.": "Richiesta di annullamento inviata il {date}. Ti risponderemo al più presto.",
        "Stornierung angefragt": "Annullamento richiesto",
        "Stornierung bestätigen": "Conferma annullamento",
        "Anfrage ablehnen": "Rifiuta richiesta",
        "Abgelehnte Stornierungsanfrage": "Richiesta di annullamento rifiutata",
        "Deine Bestellung wird bereits bearbeitet. Bitte begründe, warum du sie stornieren möchtest.": "Il tuo ordine è già in lavorazione. Spiega perché desideri annullarlo.",
        "Deine Stornierungsanfrage wurde gesendet.": "La tua richiesta di annullamento è stata inviata.",
        "Deine Stornierungsanfrage wurde abgelehnt.": "La tua richiesta di annullamento è stata rifiutata.",
        "Die Stornierungsanfrage wurde abgelehnt.": "La richiesta di annullamento è stata rifiutata.",
        "Für diese Bestellung kann keine Stornierungsanfrage gesendet werden.": "Per questo ordine non è possibile inviare una richiesta di annullamento.",
        "Für diese Bestellung gibt es keine offene Stornierungsanfrage.": "Per questo ordine non c'è nessuna richiesta di annullamento aperta.",
        "Zum Shop": "Al negozio",
        "Du hast noch kein Material bestellt.": "Non hai ancora ordinato materiale.",
        "Bestellung {number}": "Ordine {number}",
        "{count} Artikel": "{count} articoli",
        "Artikel": "Articoli",
        "Bestellt am": "Ordinato il",
        "Kategorie erstellen": "Crea categoria",
        "Kategorie bearbeiten": "Modifica categoria",
        "Interner Shop – Kategorien": "Negozio interno – Categorie",
        "Kategorien": "Categorie",
        "Materialbestellungen": "Ordini di materiale",
        "Als «{status}» markieren": "Segna come «{status}»",
        "Produkt erstellen": "Crea prodotto",
        "Interner Shop – Produkte": "Negozio interno – Prodotti",
        "Kategorie": "Categoria",
        "Einheit": "Unità",
        "Wird im Shop neben der Menge angezeigt, zum Beispiel Stück.": "Mostrata nello shop accanto alla quantità, per esempio pezzi.",
        "Aktiv (bestellbar)": "Attivo (ordinabile)",
        "Bild": "Immagine",
        "Das Feld {field} wird für die Teilnehmenden-Erkennung benötigt und kann nicht archiviert werden.": "Il campo {field} è necessario per identificare i partecipanti e non può essere archiviato.",
        "Übernimm zuerst die bestehende Feldkonfiguration, bevor du Felder hinzufügst.": "Adotta prima la configurazione dei campi esistente prima di aggiungere campi.",
        "Für diesen Login-Bereich sind bereits Felder konfiguriert.": "Per quest'area di accesso sono già configurati dei campi.",
        "Die Reihenfolge enthält Felder, die nicht zu diesem Login-Bereich gehören.": "L'ordine contiene campi che non appartengono a quest'area di accesso.",
        "Bezeichnung (Deutsch)": "Denominazione (tedesco)",
        "Feldtyp": "Tipo di campo",
        "Import-Spalte": "Colonna di importazione",
        "Option (Deutsch)": "Opzione (tedesco)",
        "Öffentliche Anmeldung": "Iscrizione pubblica",
        "Persönliche Angaben": "Dati personali",
        "B2B-Portal": "Portale B2B",
        "in.sanio": "in.sanio",
        "Import / Export": "Importazione / Esportazione",
        "Übersichten": "Panoramiche",
        "Kursdetail": "Dettaglio del corso",
        "Text": "Testo",
        "Mehrzeiliger Text": "Testo su più righe",
        "Auswahl": "Selezione",
        "Das Feld {field} darf nicht in «{context}» verwendet werden.": "Il campo {field} non può essere utilizzato in «{context}».",
        "Eine Auswahl braucht mindestens eine aktive Option.": "Una selezione richiede almeno un'opzione attiva.",
        "Die Import-Spalte {name} wird bereits von einem anderen Feld verwendet.": "La colonna di importazione {name} è già utilizzata da un altro campo.",
        "Feld wurde archiviert.": "Il campo è stato archiviato.",
        "Feld wurde wiederhergestellt.": "Il campo è stato ripristinato.",
        "Einstellungen wurden gespeichert.": "Le impostazioni sono state salvate.",
        "Reihenfolge wurde gespeichert.": "L'ordine è stato salvato.",
        "Die bestehende Feldkonfiguration wurde übernommen.": "La configurazione dei campi esistente è stata adottata.",
        "Feld wurde hinzugefügt.": "Il campo è stato aggiunto.",
        "Feld wurde gespeichert.": "Il campo è stato salvato.",
        "Der Schlüssel {key} ist bereits vergeben.": "La chiave {key} è già in uso.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten und muss mit einem Buchstaben beginnen.": "La chiave può contenere solo lettere minuscole, numeri e trattini bassi e deve iniziare con una lettera.",
        "Der Schlüssel darf nur Kleinbuchstaben, Zahlen, Bindestriche und Unterstriche enthalten.": "La chiave può contenere solo lettere minuscole, numeri, trattini e trattini bassi.",
        "Technischer Schlüssel": "Chiave tecnica",
        "Schlüssel": "Chiave",
        "Entschuldige, ich helfe nur Sanio-Mitarbeitenden mit einem passenden Benutzerkonto.": "Mi dispiace, posso aiutare solo i collaboratori e le collaboratrici di Sanio con un account utente corrispondente.",
        "Da ist leider etwas schiefgelaufen. Bitte versuche es später nochmals.": "Purtroppo qualcosa è andato storto. Riprova più tardi.",
        "Darf ich einen Cursor-Agent einen Bugfix-Pull-Request vorbereiten lassen?": "Posso far preparare a un agente Cursor una pull request di correzione?",
        "Darf ich die Aktion {tool} ausführen?": "Posso eseguire l'azione {tool}?",
        "Freigeben": "Approva",
        "Ablehnen": "Rifiuta",
        "Freigegeben von {name}.": "Approvato da {name}.",
        "Abgelehnt von {name}.": "Rifiutato da {name}.",
        "Diese Freigabe ist nicht mehr gültig.": "Questa approvazione non è più valida.",
        "Du darfst diese Aktion nicht freigeben.": "Non sei autorizzato/a ad approvare questa azione.",
        "{server} ist jetzt mit Henry verbunden.": "{server} è ora collegato a Henry.",
        "Repository": "Repository",
        "Linear-Ticket": "Ticket Linear",
        "Neue Datei hochladen": "Carica nuovo file",
        "oder per Drag & Drop hierher ziehen": "o trascinalo qui",
        "Datei {current} von {total} wird hochgeladen…": "Caricamento del file {current} di {total}…",
        "Die Datei {name} hat einen ungültigen Dateityp.": "Il file {name} ha un tipo di file non valido.",
        "Video-Folie hinzufügen": "Aggiungi diapositiva video",
        "YouTube-URL": "URL YouTube",
        "Laser": "Laser",
        "Zeichnen": "Disegna",
        "Beamer": "Proiettore",
        "Zuschauer-Link": "Link del pubblico",
        "Handy koppeln": "Associa il telefono",
        "Offline vorbereiten": "Prepara offline",
        "Wird vorbereitet…": "Preparazione…",
        "Präsentation wird geladen…": "Caricamento della presentazione…",
        "Die Präsentation konnte nicht geladen werden.": "Non è stato possibile caricare la presentazione.",
        "Verbunden": "Connesso",
        "Nur lokal verbunden": "Connesso solo localmente",
        "Beendet": "Terminata",
        "Offline bereit": "Pronta offline",
        "Beamer öffnen": "Apri proiettore",
        "Aktuelle Folie": "Diapositiva attuale",
        "Präsentationswerkzeuge": "Strumenti di presentazione",
        "Nächste Folie": "Diapositiva successiva",
        "Ende der Präsentation": "Fine della presentazione",
        "Kleinere Schrift": "Testo più piccolo",
        "Grössere Schrift": "Testo più grande",
        "Folien": "Diapositive",
        "Video pausieren": "Metti in pausa il video",
        "Video abspielen": "Riproduci video",
        "Folie {number}": "Diapositiva {number}",
        "Werkzeugleiste verschieben": "Sposta barra degli strumenti",
        "Letzten Strich rückgängig machen": "Annulla l'ultimo tratto",
        "Zeichnungen auf dieser Folie löschen": "Cancella i disegni su questa diapositiva",
        "Zeiger (kein Werkzeug)": "Puntatore (nessuno strumento)",
        "Laserpointer": "Puntatore laser",
        "Markieren": "Evidenzia",
        "Präsentation beenden?": "Terminare la presentazione?",
        "Die Verbindung zu allen Zuschauern wird getrennt.": "Tutti gli spettatori verranno disconnessi.",
        "Notizen zu dieser Folie hinzufügen…": "Aggiungi note per questa diapositiva…",
        "Klicken, um die Notizen zu bearbeiten": "Clicca per modificare le note",
        "Klicken, um Notizen hinzuzufügen.": "Clicca per aggiungere note.",
        "Folien pro Sprache": "Diapositive per lingua",
        "{count} von {total} Folien in dieser Sprache": "{count} di {total} diapositive in questa lingua",
        "Notizen vergrössern": "Ingrandisci le note",
        "Notizen verkleinern": "Riduci le note",
        "Teilnehmende scannen den QR-Code, um die Folien live auf ihrem Gerät mitzuverfolgen.": "I partecipanti scansionano il codice QR per seguire le diapositive in diretta sul proprio dispositivo.",
        "Scanne den QR-Code mit deinem Handy, um die Präsentation damit zu steuern und deine Notizen zu sehen.": "Scansiona il codice QR con il tuo telefono per controllare la presentazione e vedere le tue note.",
        "Präsentation beenden": "Termina la presentazione",
        "Diese Präsentation ist beendet.": "Questa presentazione è terminata.",
        "Du bist abgemeldet": "Sei disconnesso",
        "Deine Sitzung ist abgelaufen. Melde dich erneut an.": "La tua sessione è scaduta. Accedi di nuovo.",
        "Zur Anmeldung": "Vai all’accesso",
        "Notizen": "Note",
        "Timer": "Timer",
        "Start": "Avvia",
        "Pause": "Pausa",
        "Video": "Video",
        "Ton aus": "Disattiva audio",
        "Ton an": "Attiva audio",
        "Diese Folie ist in dieser Sprache nicht verfügbar.": "Questa diapositiva non è disponibile in questa lingua.",
        "Der YouTube-Link ist ungültig.": "Il link YouTube non è valido.",
        "Mindestens ein YouTube-Link ist erforderlich.": "È necessario almeno un link YouTube.",
        "Für diesen Kurs gibt es noch keine Präsentation.": "Questo corso non ha ancora una presentazione.",
        "Diese Folie gehört nicht zur Präsentation.": "Questa diapositiva non appartiene alla presentazione.",
        "Der Laserpunkt ist ungültig.": "Il punto laser non è valido.",
        "Die Abspielposition ist ungültig.": "La posizione di riproduzione non è valida.",
        "Video-Folie wurde hinzugefügt.": "Diapositiva video aggiunta.",
        "Diese Notiz wird der Kursleitung beim Präsentieren angezeigt.": "Questa nota viene mostrata alla persona docente durante la presentazione.",
        "messages": {
            "feedback": {
                "moods": {
                    "positive": "Positivo",
                    "negative": "Negativo",
                    "neutral": "Neutro"
                }
            },
            "communication": {
                "notifications": {
                    "channel": {
                        "database": "Banca dati",
                        "twilio": "SMS",
                        "mail": "Email",
                        "whatsapp": "WhatsApp"
                    },
                    "status": {
                        "sent": "Inviato",
                        "sending": "In fase di invio…",
                        "skipped": "Saltato",
                        "failed": "Fallito"
                    }
                }
            },
            "elearning": {
                "stories": {
                    "status": {
                        "done": "Finito",
                        "draft": "In corso",
                        "review": "Registrato",
                        "translation": "In traduzione",
                        "in-review": "In revisione",
                        "review-done": "Corretto"
                    },
                    "subject_focus": {
                        "adults": "Adulti",
                        "teenagers": "Adolescenti (10-15)",
                        "children": "Bambini (4-9)",
                        "babies": "Neonati (0-3)"
                    },
                    "subject_focus_list": {
                        "adults": "Adulti",
                        "teenagers": "Adolescenti (10-15)",
                        "children": "Bambini (4-9)",
                        "babies": "Neonati (0-3)"
                    }
                },
                "online_course": {
                    "status": {
                        "in_progress": "In corso",
                        "test": "In verifica",
                        "online": "Online",
                        "inactive": "Inattivo",
                        "archived": "Archiviato"
                    },
                    "type": {
                        "customer": "Cliente",
                        "marketing": "Marketing",
                        "content_test": "Test dei contenuti",
                        "demo": "Demo",
                        "internal": "Interno"
                    }
                }
            },
            "shop": {
                "products": {
                    "type": {
                        "service": "Servizio",
                        "goods": "Merci"
                    },
                    "status": {
                        "active": "Attivo",
                        "inactive": "Inattivo",
                        "archived": "Archiviato"
                    }
                },
                "orders": {
                    "status": {
                        "new": "Crea",
                        "pending": "In sospeso",
                        "paid": "Pagato",
                        "shipped": "Usato",
                        "completed": "Completato"
                    }
                },
                "invoices": {
                    "status": {
                        "new": "Crea",
                        "paid": "Pagato",
                        "overpaid": "Pagato in eccesso",
                        "partially_paid": "Parzialmente pagato",
                        "overdue": "Scaduto",
                        "cancelled": "Annullato",
                        "refunded": "Rimborsato",
                        "partially_refunded": "Parzialmente rimborsato"
                    }
                },
                "vouchers": {
                    "status": {
                        "pending": "In attesa",
                        "active": "Attivo",
                        "used": "Usato",
                        "expired": "Scaduto",
                        "inactive": "Inattivo"
                    }
                },
                "payments": {
                    "status": {
                        "pending": "In attesa",
                        "paid": "Pagato",
                        "failed": "Fallito",
                        "refunded": "Rimborsato",
                        "partially-refunded": "Parzialmente rimborsato",
                        "refund-pending": "Rimborso in attesa"
                    }
                }
            },
            "course_overview": {
                "modes": {
                    "presence": "Corsi in presenza",
                    "elearning": "eLearning",
                    "blended-learning": "Blended learning"
                },
                "groups": {
                    "past_unclosed": "Passati e non ancora conclusi",
                    "running": "Corsi attualmente in corso",
                    "starting_this_week": "Inizia nei prossimi 7 giorni",
                    "future": "Corsi futuri"
                },
                "collapse_group": "Comprimi gruppo",
                "expand_group": "Espandi gruppo"
            },
            "course_management": {
                "status": {
                    "draft": "Bozza",
                    "ready": "Pronto",
                    "to_be_moved": "In corso di spostamento",
                    "running": "In corso",
                    "conducted": "Svolto",
                    "completed": "Completato",
                    "cancelled": "Annullato",
                    "archived": "Archiviato",
                    "follow_up": "Integrazione"
                },
                "transition_actions": {
                    "reset_to_draft": "Ripristina bozza",
                    "reopen": "Riapri corso",
                    "not_ready": "Non più pronto",
                    "mark_ready": "Segna corso come pronto",
                    "mark_to_be_moved": "Segna corso da spostare",
                    "complete": "Completa corso",
                    "cancel": "Annulla corso",
                    "archive": "Archivia corso",
                    "follow_up": "Integrazione",
                    "revert_completion": "Annulla completamento"
                },
                "transition_confirmations": {
                    "reset_to_draft": "Vuoi reimpostare il corso su \"Bozza\"? Le iscrizioni non saranno più possibili in seguito.",
                    "complete": "Vuoi completare il corso? Questo attiverà l'invio delle conferme del corso, a condizione che sia stato registrato un indirizzo e-mail per i partecipanti.",
                    "cancel": "Vuoi davvero annullare il corso?",
                    "archive": "Vuoi archiviare il corso?",
                    "follow_up": "Vuoi aprire il corso per un’integrazione? Il corso rimane chiuso.",
                    "reopen": "Vuoi riaprire il corso annullato?",
                    "revert_completion": "Vuoi annullare il completamento? Il corso verrà reimpostato su \"Svolto\". Le conferme e i certificati già inviati non verranno inviati di nuovo al successivo completamento."
                },
                "transition_warnings": {
                    "follow_up_restrictions": "Attualmente è possibile aggiungere o rimuovere partecipanti e modificare le presenze. Non è possibile modificare altri dettagli del corso.",
                    "blended_pending_elearning": "Al completamento, solo i partecipanti presenti che hanno già superato l’eLearning riceveranno una conferma del corso. Gli altri partecipanti presenti riceveranno automaticamente la conferma non appena avranno superato l’eLearning.",
                    "no_confirmations_both": "Al completamento NON verranno inviate conferme del corso, poiché il generatore per le conferme di partecipazione e l'impostazione «Inviare automaticamente le conferme del corso al completamento» sono disattivati. Attiva entrambi nelle impostazioni del corso se i partecipanti devono ricevere una conferma.",
                    "no_confirmations_certificate_generator": "Al completamento NON verranno inviate conferme del corso, poiché il generatore di conferme di partecipazione è disattivato. Attivalo nelle impostazioni del corso se i partecipanti devono ricevere una conferma.",
                    "no_confirmations_mail_setting": "Al completamento NON verranno inviate conferme del corso, poiché l'impostazione «Inviare automaticamente le conferme del corso al completamento» è disattivata nelle impostazioni e-mail. Attivala se i partecipanti devono ricevere una conferma."
                }
            },
            "general": {
                "duration": {
                    "months": "un mese|{count} mesi",
                    "years": "un anno|{count} anni",
                    "days": "un giorno|{count} giorni"
                }
            },
            "invoices": {
                "status": {
                    "new": "Nuovo",
                    "paid": "Pagato",
                    "overpaid": "Sovrapagato",
                    "partially_paid": "Parzialmente pagato",
                    "overdue": "Scaduto",
                    "cancelled": "Annullato",
                    "refunded": "Rimborsato",
                    "partially_refunded": "Parzialmente rimborsato"
                }
            }
        }
    }
}
